/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
import type * as Types from './schema-types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type GetVideoGuidesQueryVariables = Exact<{
  maxResults?: number | null | undefined;
  pageToken?: string | null | undefined;
}>;

export type GetVideoGuidesQuery = {
  videoGuides: {
    nextPageToken: string | null;
    prevPageToken: string | null;
    totalResults: number;
    videos: Array<{
      id: string;
      title: string;
      description: string | null;
      thumbnailUrl: string;
    }>;
  };
};

export type GetConfluencePageOverviewQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetConfluencePageOverviewQuery = {
  confluencePageOverview: Array<{
    id: string;
    title: string | null;
    body: string | null;
    relatedPages: Array<{
      id: string;
      title: string | null;
      body: string | null;
      relatedPages: Array<{
        id: string;
        title: string | null;
        body: string | null;
      }> | null;
    }> | null;
  }>;
};

export type GetConfluencePageDetailQueryVariables = Exact<{
  pageDetailId: string;
}>;

export type GetConfluencePageDetailQuery = {
  confluencePageDetail: {
    id: string;
    title: string | null;
    body: string | null;
  };
};

export type GetAdUsersQueryVariables = Exact<{ [key: string]: never }>;

export type GetAdUsersQuery = {
  adUsers: Array<{
    username: string;
    commonName: string | null;
    company: string | null;
    distinguishedName: string | null;
    givenName: string | null;
    lastLogon: number | null;
    lastLogonTimestamp: string | null;
    lockoutTime: number | null;
    mail: string | null;
    surname: string | null;
    telephoneNumber: string | null;
    title: string | null;
    userPrincipalName: string | null;
    enabled: boolean;
    locked: boolean | null;
    userAccountControl: string | null;
    passwordNeverExpires: boolean;
  }>;
};

export type ValidateUsernameQueryVariables = Exact<{
  username: string;
}>;

export type ValidateUsernameQuery = { validateUsername: boolean };

export type ValidateEmailQueryVariables = Exact<{
  email: string;
}>;

export type ValidateEmailQuery = { validateEmail: boolean };

export type GetAdUserGroupsQueryVariables = Exact<{
  username: string;
}>;

export type GetAdUserGroupsQuery = {
  adUserGroups: Array<{
    name: string | null;
    distinguishedName: string | null;
  }>;
};

export type GetAdUserQueryVariables = Exact<{
  username: string;
}>;

export type GetAdUserQuery = {
  adUser: {
    username: string;
    commonName: string | null;
    company: string | null;
    distinguishedName: string | null;
    givenName: string | null;
    lastLogon: number | null;
    lastLogonTimestamp: string | null;
    lockoutTime: number | null;
    mail: string | null;
    surname: string | null;
    telephoneNumber: string | null;
    title: string | null;
    userPrincipalName: string | null;
    enabled: boolean;
    locked: boolean | null;
    userAccountControl: string | null;
    passwordNeverExpires: boolean;
    adGroups: Array<{
      id: string;
      name: string | null;
      distinguishedName: string | null;
    }> | null;
  };
};

export type UpdateAdUserMutationVariables = Exact<{
  updateAdUserInput: Types.UpdateEntraIdUserInput;
}>;

export type UpdateAdUserMutation = { updateAdUser: boolean };

export type CreateOrganizationalUnitMutationVariables = Exact<{
  ouName: string;
}>;

export type CreateOrganizationalUnitMutation = {
  createOrganizationalUnit: boolean;
};

export type AssignTenantToBiomeUsersMutationVariables = Exact<{
  tenantId: string;
  biomeUserRegion?: Types.BiomeUserRegion | null | undefined;
}>;

export type AssignTenantToBiomeUsersMutation = {
  assignTenantToBiomeUsers: boolean;
};

export type RemoveAdUserMutationVariables = Exact<{
  username: string;
}>;

export type RemoveAdUserMutation = { removeAdUser: boolean };

export type CheckPoliciesQueryVariables = Exact<{
  policyInputs: Array<Types.PolicyRequest> | Types.PolicyRequest;
}>;

export type CheckPoliciesQuery = {
  checkPolicies: Array<{
    id: string | null;
    eft: string | null;
    action: string;
    attribute: string | null;
    entityId: string | null;
    dsmId: string | null;
    resource: string | null;
    workbookGroupId: string | null;
    workbookId: string | null;
    tenantId: string;
  }>;
};

export type GetIdentityProvidersQueryVariables = Exact<{
  identityProviderIds?:
    Array<string | number> | string | number | null | undefined;
}>;

export type GetIdentityProvidersQuery = {
  identityProviders: Array<{
    id: string;
    name: string;
    entityId: string;
    description: string;
    identifierFormat: string;
    firstNameAttribute: string;
    lastNameAttribute: string;
    groupAccessType: Types.IdentityProviderGroupAccessType | null;
    emailAttribute: string;
    provisionUsers: boolean;
    updateUsers: boolean;
    securityGroup: string | null;
    authnContext: string;
    certificate: string;
    entryPoint: string;
    forceAuthentication: boolean;
    enabled: boolean;
    logoutUrl: string | null;
    updateAt: any;
    defaultRoles: Array<{ id: string; name: string }> | null;
    certificates: Array<{
      id: string;
      validityNotAfter: any;
      active: boolean;
    }> | null;
    tenant: { id: string; name: string } | null;
  }>;
};

export type GetIdentityProviderQueryVariables = Exact<{
  entityId: string;
}>;

export type GetIdentityProviderQuery = {
  identityProvider: {
    id: string;
    name: string;
    entityId: string;
    description: string;
    groupAccessType: Types.IdentityProviderGroupAccessType | null;
    identifierFormat: string;
    firstNameAttribute: string;
    lastNameAttribute: string;
    emailAttribute: string;
    provisionUsers: boolean;
    updateUsers: boolean;
    securityGroup: string | null;
    authnContext: string;
    certificate: string;
    entryPoint: string;
    forceAuthentication: boolean;
    enabled: boolean;
    logoutUrl: string | null;
    updateAt: any;
    defaultRoles: Array<{ id: string; name: string }> | null;
    certificates: Array<{
      id: string;
      validityNotAfter: any;
      active: boolean;
    }> | null;
    tenant: { id: string; name: string } | null;
  };
};

export type CreateIdentityProviderMutationVariables = Exact<{
  identityProviderInput: Types.IdentityProviderInput;
}>;

export type CreateIdentityProviderMutation = {
  createIdentityProvider: {
    id: string;
    entityId: string;
    description: string;
    groupAccessType: Types.IdentityProviderGroupAccessType | null;
    identifierFormat: string;
    firstNameAttribute: string;
    lastNameAttribute: string;
    emailAttribute: string;
    updateUsers: boolean;
    authnContext: string;
    provisionUsers: boolean;
    securityGroup: string | null;
    name: string;
    certificate: string;
    entryPoint: string;
    forceAuthentication: boolean;
    enabled: boolean;
    logoutUrl: string | null;
    updateAt: any;
    defaultRoles: Array<{ id: string; name: string }> | null;
    certificates: Array<{
      id: string;
      validityNotAfter: any;
      active: boolean;
    }> | null;
    tenant: { id: string; name: string } | null;
  };
};

export type UpdateIdentityProviderMutationVariables = Exact<{
  updateIdentityProviderInput: Types.UpdateIdentityProviderInput;
}>;

export type UpdateIdentityProviderMutation = {
  updateIdentityProvider: {
    id: string;
    entityId: string;
    description: string;
    groupAccessType: Types.IdentityProviderGroupAccessType | null;
    identifierFormat: string;
    firstNameAttribute: string;
    lastNameAttribute: string;
    emailAttribute: string;
    updateUsers: boolean;
    authnContext: string;
    provisionUsers: boolean;
    securityGroup: string | null;
    name: string;
    certificate: string;
    entryPoint: string;
    forceAuthentication: boolean;
    enabled: boolean;
    logoutUrl: string | null;
    updateAt: any;
    defaultRoles: Array<{ id: string; name: string }> | null;
    certificates: Array<{
      id: string;
      validityNotAfter: any;
      active: boolean;
    }> | null;
    tenant: { id: string; name: string } | null;
  };
};

export type GetLoginRoutesQueryVariables = Exact<{
  identityProvider?: string | number | null | undefined;
}>;

export type GetLoginRoutesQuery = {
  loginRoutes: Array<{
    id: string;
    domain: string;
    enabled: boolean;
    createdAt: any;
    updateAt: any;
    createdById: string | null;
    updateById: string | null;
    identityProvider: { id: string; name: string };
  }>;
};

export type GetLoginRouteQueryVariables = Exact<{
  loginRouteId?: string | number | null | undefined;
  username?: string | null | undefined;
}>;

export type GetLoginRouteQuery = {
  loginRoute: {
    id: string;
    domain: string;
    enabled: boolean;
    createdAt: any;
    updateAt: any;
    createdById: string | null;
    updateById: string | null;
    identityProvider: { id: string; name: string };
  };
};

export type CreateLoginRoutesMutationVariables = Exact<{
  loginInputs: Array<Types.LoginRouteInput> | Types.LoginRouteInput;
}>;

export type CreateLoginRoutesMutation = {
  createLoginRoutes: Array<{
    id: string;
    domain: string;
    enabled: boolean;
    createdAt: any;
    updateAt: any;
    createdById: string | null;
    updateById: string | null;
    identityProvider: { id: string; name: string };
  }>;
};

export type UpdateLoginRouteMutationVariables = Exact<{
  updateLoginRouteInput: Types.UpdateLoginRouteInput;
}>;

export type UpdateLoginRouteMutation = {
  updateLoginRoute: {
    id: string;
    domain: string;
    enabled: boolean;
    createdAt: any;
    updateAt: any;
    createdById: string | null;
    updateById: string | null;
    identityProvider: { id: string; name: string };
  };
};

export type RemoveIdentityProviderMutationVariables = Exact<{
  identityProviderId: string;
}>;

export type RemoveIdentityProviderMutation = {
  removeIdentityProvider: boolean;
};

export type GetIdpCertificateQueryVariables = Exact<{
  identityProviderId: string;
}>;

export type GetIdpCertificateQuery = {
  certificate: {
    id: string;
    createdAt: any;
    issuer: string | null;
    serialNumber: string | null;
    signatureAlgorithm: string | null;
    subject: string | null;
    validityNotAfter: any;
    validityNotBefore: any;
    version: string | null;
    active: boolean;
    createdBy: { firstName: string; lastName: string; username: string } | null;
  };
};

export type ParseAndSaveCertificateMutationVariables = Exact<{
  idpId: string;
}>;

export type ParseAndSaveCertificateMutation = {
  parseAndSaveCertificate: {
    id: string;
    createdAt: any;
    issuer: string | null;
    serialNumber: string | null;
    signatureAlgorithm: string | null;
    subject: string | null;
    validityNotAfter: any;
    validityNotBefore: any;
    version: string | null;
    active: boolean;
    createdBy: { firstName: string; lastName: string; username: string } | null;
  };
};

export type RemoveLoginRouteMutationVariables = Exact<{
  loginRouteId: string;
}>;

export type RemoveLoginRouteMutation = { removeLoginRoute: boolean };

export type TenantFieldsFragment = { id: string };

export type CreateGeneralPoliciesMutationVariables = Exact<{
  policies: Array<Types.GeneralPolicyInput> | Types.GeneralPolicyInput;
}>;

export type CreateGeneralPoliciesMutation = { createGeneralPolicies: boolean };

export type RemoveGeneralPoliciesMutationVariables = Exact<{
  subjectId: string;
  comment: string;
  policyInputs: Array<Types.GeneralPolicyInput> | Types.GeneralPolicyInput;
}>;

export type RemoveGeneralPoliciesMutation = {
  removeGeneralEntityPolicies: boolean;
};

export type CreateCasePoliciesMutationVariables = Exact<{
  policies: Array<Types.CasePolicyInput> | Types.CasePolicyInput;
}>;

export type CreateCasePoliciesMutation = { createCasePolicies: boolean };

export type RemoveCasePoliciesMutationVariables = Exact<{
  subjectId: string;
  comment: string;
  policyInputs?:
    Array<Types.CasePolicyInput> | Types.CasePolicyInput | null | undefined;
}>;

export type RemoveCasePoliciesMutation = { removeCasePolicies: boolean };

export type CreateEntityPoliciesMutationVariables = Exact<{
  policies: Array<Types.EntityPolicyInput> | Types.EntityPolicyInput;
}>;

export type CreateEntityPoliciesMutation = { createEntityPolicies: boolean };

export type RemoveEntityPoliciesMutationVariables = Exact<{
  subjectId: string;
  comment: string;
  policyInputs?:
    Array<Types.EntityPolicyInput> | Types.EntityPolicyInput | null | undefined;
}>;

export type RemoveEntityPoliciesMutation = { removeEntityPolicies: boolean };

export type CreateDsmPoliciesMutationVariables = Exact<{
  policies: Array<Types.DsmPolicyInput> | Types.DsmPolicyInput;
}>;

export type CreateDsmPoliciesMutation = { createDsmPolicies: boolean };

export type CreatePatientListPoliciesMutationVariables = Exact<{
  policies: Array<Types.PatientListPolicyInput> | Types.PatientListPolicyInput;
}>;

export type CreatePatientListPoliciesMutation = {
  createPatientListPolicies: boolean;
};

export type CreateClinicianPoliciesMutationVariables = Exact<{
  policies: Array<Types.ClinicianPolicyInput> | Types.ClinicianPolicyInput;
}>;

export type CreateClinicianPoliciesMutation = {
  createClinicianPolicies: boolean;
};

export type RemoveDsmPoliciesMutationVariables = Exact<{
  subjectId: string;
  comment: string;
  policyInputs?:
    Array<Types.DsmPolicyInput> | Types.DsmPolicyInput | null | undefined;
}>;

export type RemoveDsmPoliciesMutation = { removeDsmPolicies: boolean };

export type RemovePatientListPoliciesMutationVariables = Exact<{
  subjectId: string;
  comment: string;
  policyInputs?:
    | Array<Types.PatientListPolicyInput>
    | Types.PatientListPolicyInput
    | null
    | undefined;
}>;

export type RemovePatientListPoliciesMutation = {
  removePatientListPolicies: boolean;
};

export type RemoveClinicianPoliciesMutationVariables = Exact<{
  subjectId: string;
  comment: string;
  policyInputs?:
    | Array<Types.ClinicianPolicyInput>
    | Types.ClinicianPolicyInput
    | null
    | undefined;
}>;

export type RemoveClinicianPoliciesMutation = {
  removeClinicianPolicies: boolean;
};

export type CreateInitiativePoliciesMutationVariables = Exact<{
  policies: Array<Types.InitiativePolicyInput> | Types.InitiativePolicyInput;
}>;

export type CreateInitiativePoliciesMutation = {
  createInitiativePolicies: boolean;
};

export type RemoveInitiativePoliciesMutationVariables = Exact<{
  subjectId: string;
  comment: string;
  policyInputs?:
    | Array<Types.InitiativePolicyInput>
    | Types.InitiativePolicyInput
    | null
    | undefined;
}>;

export type RemoveInitiativePoliciesMutation = {
  removeInitiativePolicies: boolean;
};

export type CreateStrategyBoardPoliciesMutationVariables = Exact<{
  policies:
    Array<Types.StrategyBoardPolicyInput> | Types.StrategyBoardPolicyInput;
}>;

export type CreateStrategyBoardPoliciesMutation = {
  createStrategyBoardPolicies: boolean;
};

export type RemoveStrategyBoardPoliciesMutationVariables = Exact<{
  subjectId: string;
  comment: string;
  policyInputs?:
    | Array<Types.StrategyBoardPolicyInput>
    | Types.StrategyBoardPolicyInput
    | null
    | undefined;
}>;

export type RemoveStrategyBoardPoliciesMutation = {
  removeStrategyBoardPolicies: boolean;
};

export type CreateDashboardPoliciesMutationVariables = Exact<{
  policies: Array<Types.DashboardPolicyInput> | Types.DashboardPolicyInput;
}>;

export type CreateDashboardPoliciesMutation = {
  createDashboardPolicies: boolean;
};

export type RemoveDashboardPoliciesMutationVariables = Exact<{
  subjectId: string;
  comment: string;
  policyInputs?:
    | Array<Types.DashboardPolicyInput>
    | Types.DashboardPolicyInput
    | null
    | undefined;
}>;

export type RemoveDashboardPoliciesMutation = {
  removeDashboardPolicies: boolean;
};

export type CreateUserPoliciesMutationVariables = Exact<{
  policies: Array<Types.UserPolicyInput> | Types.UserPolicyInput;
}>;

export type CreateUserPoliciesMutation = { createUserPolicies: boolean };

export type RemoveUserPoliciesMutationVariables = Exact<{
  subjectId: string;
  comment: string;
  policyInputs?:
    Array<Types.UserPolicyInput> | Types.UserPolicyInput | null | undefined;
}>;

export type RemoveUserPoliciesMutation = { removeUserPolicies: boolean };

export type CreateAdminPoliciesMutationVariables = Exact<{
  policyInputs: Array<Types.AdminPolicyInput> | Types.AdminPolicyInput;
}>;

export type CreateAdminPoliciesMutation = { createAdminPolicies: boolean };

export type RemoveAdminPoliciesMutationVariables = Exact<{
  subjectId: string;
  comment: string;
  policyInputs?:
    Array<Types.AdminPolicyInput> | Types.AdminPolicyInput | null | undefined;
}>;

export type RemoveAdminPoliciesMutation = { removeAdminPolicies: boolean };

export type GetPoliciesQueryVariables = Exact<{
  enforcerType: string;
  subjects: Array<string> | string;
}>;

export type GetPoliciesQuery = {
  policies: Array<{
    action: string;
    eft: string | null;
    resource: string | null;
    object: string | null;
    attribute: string | null;
    subjectId: string | null;
    dsmId: string | null;
    entityId: string | null;
    tenantId: string;
    workbookId: string | null;
    workbookGroupId: string | null;
  }>;
};

export type GetCommunicationsQueryVariables = Exact<{
  startDate?: any;
  endDate?: any;
  recipientId?: string | null | undefined;
  requesterId?: string | null | undefined;
}>;

export type GetCommunicationsQuery = {
  outboundMessages: Array<{
    id: string;
    sentDate: any;
    subject: string;
    read: boolean;
    trigger: Types.OutboundMessageTrigger;
    link: string | null;
    recipient: {
      id: string;
      fullName: string | null;
      tenant: { name: string };
    };
    requester: { id: string; fullName: string | null };
    outboundMessageDetails: {
      htmlBody: string | null;
      messageEvents: Array<{
        type: string | null;
        receivedAt: string | null;
      }> | null;
    } | null;
  }>;
};

export type GetCommunicationQueryVariables = Exact<{
  outboundMessageId: string;
}>;

export type GetCommunicationQuery = {
  outboundMessage: {
    id: string;
    sentDate: any;
    subject: string;
    read: boolean;
    trigger: Types.OutboundMessageTrigger;
    link: string | null;
    recipient: {
      id: string;
      fullName: string | null;
      tenant: { name: string };
    };
    requester: { id: string; fullName: string | null };
    outboundMessageDetails: {
      htmlBody: string | null;
      messageEvents: Array<{
        type: string | null;
        receivedAt: string | null;
      }> | null;
    } | null;
  };
};

export type MarkAsReadMutationVariables = Exact<{
  messageIds: Array<string> | string;
}>;

export type MarkAsReadMutation = { markAsRead: boolean };

export type SendMessageMutationVariables = Exact<{
  subject: string;
  message: string;
  recipientIds?: Array<string> | string | null | undefined;
  distributionListId?: string | null | undefined;
}>;

export type SendMessageMutation = { sendMessage: Array<boolean> };

export type GetUsersByNotificationTypeQueryVariables = Exact<{
  notificationType: Types.NotificationType;
}>;

export type GetUsersByNotificationTypeQuery = {
  usersByNotificationType: number;
};

export type GetPublicFileQueryVariables = Exact<{
  publicFileId: string;
}>;

export type GetPublicFileQuery = {
  publicFile: {
    category: string;
    id: string;
    extension: string;
    mimeType: string;
    name: string;
    url: string;
    createdAt: any;
    updateAt: any;
    sharedAt: any;
    createdBy: { id: string; fullName: string | null } | null;
    updateBy: { id: string; fullName: string | null } | null;
  };
};

export type GetPublicFilesQueryVariables = Exact<{ [key: string]: never }>;

export type GetPublicFilesQuery = {
  publicFiles: Array<{
    id: string;
    name: string;
    mimeType: string;
    extension: string;
    url: string;
    category: string;
    createdAt: any;
    updateAt: any;
    sharedAt: any;
    createdBy: { id: string; fullName: string | null } | null;
    updateBy: { id: string; fullName: string | null } | null;
  }>;
};

export type GetSharedPublicFilesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetSharedPublicFilesQuery = {
  sharedPublicFiles: Array<{
    id: string;
    name: string;
    mimeType: string;
    extension: string;
    url: string;
    category: string;
    createdAt: any;
    updateAt: any;
    sharedAt: any;
    createdBy: { id: string; fullName: string | null } | null;
    updateBy: { id: string; fullName: string | null } | null;
  }>;
};

export type RemovePublicFileMutationVariables = Exact<{
  removePublicFileId: string;
}>;

export type RemovePublicFileMutation = { removePublicFile: boolean };

export type LogPublicFileAccessMutationVariables = Exact<{
  fileId: string;
  fileName: string;
}>;

export type LogPublicFileAccessMutation = { logPublicFileAccess: boolean };

export type LogContentAccessMutationVariables = Exact<{
  fileName: string;
  url: string;
  source: string;
}>;

export type LogContentAccessMutation = { logContentAccess: boolean };

export type FindPublicFileAccessLogsQueryVariables = Exact<{
  fileId: string;
}>;

export type FindPublicFileAccessLogsQuery = {
  publicFileAccessLogs: Array<{
    relatedData: any;
    type: Types.ActivityLogType;
    id: string;
    createdAt: any;
    createdBy: {
      id: string;
      fullName: string | null;
      username: string;
      email: string;
      tenant: { id: string; code: string };
    } | null;
  }>;
};

export type GetHomepageSectionsQueryVariables = Exact<{ [key: string]: never }>;

export type GetHomepageSectionsQuery = {
  homepageSections: Array<{
    id: string;
    title: string;
    content: string;
    order: number;
  }>;
};

export type GetHomepageSectionQueryVariables = Exact<{
  homepageSectionId: string;
}>;

export type GetHomepageSectionQuery = {
  homepageSection: {
    id: string;
    title: string;
    content: string;
    order: number;
  };
};

export type CreateHomepageSectionMutationVariables = Exact<{
  createHomepageSectionInput: Types.CreateHomepageSectionInput;
}>;

export type CreateHomepageSectionMutation = {
  createHomepageSection: {
    id: string;
    title: string;
    content: string;
    order: number;
  };
};

export type UpdateHomepageSectionsMutationVariables = Exact<{
  inputs:
    Array<Types.UpdateHomepageSectionInput> | Types.UpdateHomepageSectionInput;
}>;

export type UpdateHomepageSectionsMutation = {
  updateHomepageSections: Array<{
    id: string;
    title: string;
    order: number;
    content: string;
  }>;
};

export type RemoveHomepageSectionMutationVariables = Exact<{
  removeHomepageSectionId: string;
}>;

export type RemoveHomepageSectionMutation = { removeHomepageSection: boolean };

export type GetFileQueryVariables = Exact<{
  id: string;
}>;

export type GetFileQuery = {
  file: {
    id: string;
    createdAt: any;
    updateAt: any;
    name: string;
    description: string | null;
    phi: boolean | null;
    mimeType: string;
    extension: string;
    category: string;
    url: string;
    tenantId: string | null;
    createdBy: { id: string; username: string } | null;
    updateBy: { id: string; username: string } | null;
    fileLabel: { id: string; text: string } | null;
    tenant: { id: string; name: string } | null;
    distributionLists: Array<{ name: string; id: string }>;
    users: Array<{
      isDirect: boolean | null;
      distributionLists: Array<{ id: string; name: string }> | null;
      user: {
        id: string;
        fullName: string | null;
        firstName: string;
        username: string;
        email: string;
        enabled: boolean;
      };
    }>;
  };
};

export type GetFileLabelsQueryVariables = Exact<{ [key: string]: never }>;

export type GetFileLabelsQuery = {
  fileLabels: Array<{ id: string; text: string }>;
};

export type GetTenantFilesQueryVariables = Exact<{
  category: Types.FileCategory;
  tenantIds?: Array<string> | string | null | undefined;
}>;

export type GetTenantFilesQuery = {
  tenantFiles: Array<{
    id: string;
    createdAt: any;
    updateAt: any;
    name: string;
    description: string | null;
    phi: boolean | null;
    mimeType: string;
    extension: string;
    category: string;
    url: string;
    tenantId: string | null;
    createdBy: { id: string; username: string } | null;
    updateBy: { id: string; username: string } | null;
    tenant: { id: string; name: string } | null;
    fileLabel: { id: string; text: string } | null;
    distributionLists: Array<{ name: string; id: string }>;
    users: Array<{
      isDirect: boolean | null;
      distributionLists: Array<{ id: string; name: string }> | null;
      user: {
        id: string;
        fullName: string | null;
        firstName: string;
        username: string;
        email: string;
        enabled: boolean;
      };
    }>;
  }>;
};

export type GetUserFilesQueryVariables = Exact<{
  userId?: string | null | undefined;
}>;

export type GetUserFilesQuery = {
  userFiles: Array<{
    id: string;
    name: string;
    phi: boolean | null;
    url: string;
    fileShareDate: any;
    createdAt: any;
    description: string | null;
    category: string;
    fileLabel: { text: string } | null;
  }>;
};

export type DownloadFileMutationVariables = Exact<{
  downloadFileId: string;
}>;

export type DownloadFileMutation = {
  downloadFile: { id: string; url: string };
};

export type GetFileAccessLogsQueryVariables = Exact<{
  fileId: string;
}>;

export type GetFileAccessLogsQuery = {
  fileAccessLogs: Array<{
    relatedData: any;
    type: Types.ActivityLogType;
    id: string;
    createdAt: any;
    createdBy: {
      id: string;
      fullName: string | null;
      username: string;
      email: string;
    } | null;
  }>;
};

export type RemoveFileMutationVariables = Exact<{
  removeFileId: string;
}>;

export type RemoveFileMutation = { removeFile: boolean };

export type GetDistributionListsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetDistributionListsQuery = {
  distributionLists: Array<{
    id: string;
    name: string;
    description: string;
    tenant: { id: string; code: string };
    users: Array<{
      id: string;
      firstName: string;
      lastName: string;
      username: string;
      email: string;
      enabled: boolean;
    }> | null;
    files: Array<{
      id: string;
      name: string;
      description: string | null;
      tenantId: string | null;
      category: string;
      phi: boolean | null;
    }> | null;
  }>;
};

export type GetDistributionListQueryVariables = Exact<{
  distributionListId: string;
}>;

export type GetDistributionListQuery = {
  distributionList: {
    id: string;
    name: string;
    description: string;
    tenant: { id: string; code: string };
    users: Array<{
      id: string;
      firstName: string;
      lastName: string;
      username: string;
      email: string;
      enabled: boolean;
    }> | null;
    files: Array<{
      id: string;
      name: string;
      description: string | null;
      tenantId: string | null;
      category: string;
      phi: boolean | null;
    }> | null;
  };
};

export type CreateDistributionListMutationVariables = Exact<{
  createDistributionListInput: Types.CreateDistributionListInput;
}>;

export type CreateDistributionListMutation = {
  createDistributionList: {
    id: string;
    name: string;
    description: string;
    tenant: { id: string; code: string };
    users: Array<{
      id: string;
      firstName: string;
      lastName: string;
      username: string;
      email: string;
      enabled: boolean;
    }> | null;
    files: Array<{
      id: string;
      name: string;
      description: string | null;
      tenantId: string | null;
      category: string;
      phi: boolean | null;
    }> | null;
  };
};

export type UpdateDistributionListMutationVariables = Exact<{
  updateDistributionListInput: Types.UpdateDistributionListInput;
  fileShareNotification?: Types.FileShareNotification | null | undefined;
}>;

export type UpdateDistributionListMutation = {
  updateDistributionList: {
    id: string;
    name: string;
    description: string;
    tenant: { id: string; code: string };
    users: Array<{
      id: string;
      firstName: string;
      lastName: string;
      username: string;
      email: string;
      enabled: boolean;
      distributionLists: Array<{ id: string; name: string }> | null;
    }> | null;
    files: Array<{
      id: string;
      name: string;
      description: string | null;
      tenantId: string | null;
      category: string;
      phi: boolean | null;
    }> | null;
  };
};

export type ShareFilesWithDistributionListsMutationVariables = Exact<{
  filesShareInput?:
    | Array<Types.UpdateDistributionListInput>
    | Types.UpdateDistributionListInput
    | null
    | undefined;
  fileShareNotification?: Types.FileShareNotification | null | undefined;
}>;

export type ShareFilesWithDistributionListsMutation = {
  shareFilesWithDistributionLists: boolean;
};

export type RemoveDistributionListMutationVariables = Exact<{
  id: string;
}>;

export type RemoveDistributionListMutation = {
  removeDistributionList: boolean;
};

export type GetTenantsQueryVariables = Exact<{
  name?: string | null | undefined;
}>;

export type GetTenantsQuery = {
  tenants: Array<{
    id: string;
    code: string;
    name: string;
    active: boolean;
    subdomain: string | null;
    disableHomepage: boolean;
    contractedDisplayPHI: boolean;
    clinicalOnly: boolean;
    aggregationTenant: boolean;
    deliverableBlinded: boolean;
    rollupMode: Types.AggregationRollupMode | null;
    organizationalUnit: string | null;
    disableBiomedataLogin: boolean;
    usesAnubisUpload: boolean;
    itContact: string | null;
    encryptionKeys: Array<string> | null;
    logo: {
      id: string;
      name: string;
      mimeType: string;
      extension: string;
      category: string;
      url: string;
    } | null;
    banner: {
      id: string;
      name: string;
      mimeType: string;
      extension: string;
      category: string;
      url: string;
    } | null;
    identityProvider: { id: string; enabled: boolean } | null;
  }>;
};

export type GetTenantQueryVariables = Exact<{
  tenantId?: string | null | undefined;
  code?: string | null | undefined;
}>;

export type GetTenantQuery = {
  tenant: {
    id: string;
    code: string;
    name: string;
    active: boolean;
    subdomain: string | null;
    disableHomepage: boolean;
    contractedDisplayPHI: boolean;
    clinicalOnly: boolean;
    aggregationTenant: boolean;
    deliverableBlinded: boolean;
    rollupMode: Types.AggregationRollupMode | null;
    organizationalUnit: string | null;
    disableBiomedataLogin: boolean;
    usesAnubisUpload: boolean;
    projectSponsorId: string | null;
    itContact: string | null;
    encryptionKeys: Array<string> | null;
    projectSponsor: {
      id: string;
      email: string;
      fullName: string | null;
      username: string;
    } | null;
    workbooks: Array<{
      id: number;
      name: string;
      description: string;
      active: boolean;
      diseaseStateModule: { id: number; name: string } | null;
    }> | null;
    logo: {
      id: string;
      name: string;
      mimeType: string;
      extension: string;
      category: string;
      url: string;
    } | null;
    banner: {
      id: string;
      name: string;
      mimeType: string;
      extension: string;
      category: string;
      url: string;
    } | null;
    documents: Array<{
      id: string;
      name: string;
      mimeType: string;
      extension: string;
      category: string;
      url: string;
    }> | null;
    users: Array<{
      id: string;
      fullName: string | null;
      username: string;
      email: string;
    }> | null;
    careEntities: Array<{
      id: string;
      name: string;
      code: string;
      description: string;
      isEngagementEntity: boolean;
      projectSponsor: string | null;
      physicianChampion: string | null;
      invoiceMonth: number | null;
      onboardingCompletedOn: any;
      monthlySponsorTouchbase: boolean;
      reviewDsms: Array<{ id: number; code: string; name: string }>;
      pushOnlyDsms: Array<{ id: number; code: string; name: string }>;
    }> | null;
    roles: Array<{ id: string; name: string; description: string }> | null;
    echoModules: Array<{
      id: string;
      name: string;
      displayName: string;
      description: string;
      active: boolean;
    }> | null;
    offboardingJob: {
      id: string;
      status: Types.TenantOffboardingJobStatus;
      deletionStarted: boolean;
    } | null;
  };
};

export type GetCareEntitiesQueryVariables = Exact<{
  ids?: Array<string> | string | null | undefined;
}>;

export type GetCareEntitiesQuery = {
  careEntities: Array<{
    id: string;
    name: string;
    shortDisplayName: string | null;
    code: string;
    supportedApps: Array<Types.SupportedApps> | null;
    anonymousCode: string | null;
    description: string;
    type: Types.CareEntityType;
    usGeoRegion: Types.UsGeoRegion | null;
    street: string | null;
    city: string | null;
    state: string | null;
    zip: string | null;
    alternateNames: Array<string> | null;
    ids: Array<string> | null;
    noOfBeds: number | null;
    aggregated: boolean;
    teaching: boolean;
    active: boolean;
    includeInBenchmarks: boolean;
    cmsId: string | null;
    cmsIdNotAvailable: boolean;
    reasonForNoCmsId: string | null;
    isEngagementEntity: boolean;
    projectSponsor: string | null;
    physicianChampion: string | null;
    invoiceMonth: number | null;
    onboardingCompletedOn: any;
    monthlySponsorTouchbase: boolean;
    tenants: Array<{ id: string; code: string; name: string }>;
    parents: Array<{
      id: string;
      code: string;
      name: string;
      description: string;
    }> | null;
    children: Array<{
      id: string;
      code: string;
      name: string;
      description: string;
    }> | null;
    memberDsms: Array<{
      childId: string;
      diseaseStateModules: Array<{ id: number; code: string; name: string }>;
    }>;
    diseaseStateModules: Array<{
      id: number;
      code: string;
      name: string;
      description: string;
      supportedApps: Array<Types.SupportedApps> | null;
      type: Types.DsmType;
      datasets: Array<{ id: number; name: string }> | null;
    }>;
    reviewDsms: Array<{ id: number; code: string; name: string }>;
    pushOnlyDsms: Array<{ id: number; code: string; name: string }>;
    excludedDsms: Array<{ id: number; code: string; name: string }>;
  }>;
};

export type GetCareEntitiesLiveQueryVariables = Exact<{
  ids?: Array<string> | string | null | undefined;
}>;

export type GetCareEntitiesLiveQuery = {
  careEntitiesLive: Array<{
    id: string;
    name: string;
    shortDisplayName: string | null;
    code: string;
    supportedApps: Array<Types.SupportedApps> | null;
    anonymousCode: string | null;
    description: string;
    type: Types.CareEntityType;
    usGeoRegion: Types.UsGeoRegion | null;
    street: string | null;
    city: string | null;
    state: string | null;
    zip: string | null;
    alternateNames: Array<string> | null;
    ids: Array<string> | null;
    noOfBeds: number | null;
    aggregated: boolean;
    teaching: boolean;
    active: boolean;
    includeInBenchmarks: boolean;
    cmsId: string | null;
    cmsIdNotAvailable: boolean;
    reasonForNoCmsId: string | null;
    isEngagementEntity: boolean;
    projectSponsor: string | null;
    physicianChampion: string | null;
    invoiceMonth: number | null;
    onboardingCompletedOn: any;
    monthlySponsorTouchbase: boolean;
    tenants: Array<{ id: string; code: string; name: string }>;
    parents: Array<{
      id: string;
      code: string;
      name: string;
      description: string;
    }> | null;
    children: Array<{
      id: string;
      code: string;
      name: string;
      description: string;
    }> | null;
    memberDsms: Array<{
      childId: string;
      diseaseStateModules: Array<{ id: number; code: string; name: string }>;
    }>;
    diseaseStateModules: Array<{
      id: number;
      code: string;
      name: string;
      description: string;
      supportedApps: Array<Types.SupportedApps> | null;
      type: Types.DsmType;
      datasets: Array<{ id: number; name: string }> | null;
    }>;
    reviewDsms: Array<{ id: number; code: string; name: string }>;
    pushOnlyDsms: Array<{ id: number; code: string; name: string }>;
    excludedDsms: Array<{ id: number; code: string; name: string }>;
  }>;
};

export type GetCareEntityArchivedDsmsQueryVariables = Exact<{
  ids?: Array<string> | string | null | undefined;
}>;

export type GetCareEntityArchivedDsmsQuery = {
  careEntitiesLive: Array<{
    id: string;
    archivedDiseaseStateModules: Array<{
      id: number;
      code: string;
      name: string;
      description: string;
      deletedAt: any;
    }>;
  }>;
};

export type GetCareEntityQueryVariables = Exact<{
  careEntityId?: string | null | undefined;
  name?: string | null | undefined;
  code?: string | null | undefined;
  cmsId?: string | null | undefined;
}>;

export type GetCareEntityQuery = {
  careEntity: {
    id: string;
    name: string;
    shortDisplayName: string | null;
    code: string;
    supportedApps: Array<Types.SupportedApps> | null;
    anonymousCode: string | null;
    description: string;
    type: Types.CareEntityType;
    usGeoRegion: Types.UsGeoRegion | null;
    street: string | null;
    city: string | null;
    state: string | null;
    zip: string | null;
    alternateNames: Array<string> | null;
    ids: Array<string> | null;
    noOfBeds: number | null;
    aggregated: boolean;
    teaching: boolean;
    active: boolean;
    includeInBenchmarks: boolean;
    cmsId: string | null;
    cmsIdNotAvailable: boolean;
    reasonForNoCmsId: string | null;
    isEngagementEntity: boolean;
    projectSponsor: string | null;
    physicianChampion: string | null;
    invoiceMonth: number | null;
    onboardingCompletedOn: any;
    monthlySponsorTouchbase: boolean;
    tenants: Array<{ id: string; code: string; name: string }>;
    parents: Array<{
      id: string;
      code: string;
      name: string;
      description: string;
    }> | null;
    children: Array<{
      id: string;
      code: string;
      name: string;
      description: string;
    }> | null;
    memberDsms: Array<{
      childId: string;
      diseaseStateModules: Array<{ id: number; code: string; name: string }>;
    }>;
    diseaseStateModules: Array<{
      id: number;
      code: string;
      name: string;
      description: string;
      supportedApps: Array<Types.SupportedApps> | null;
      type: Types.DsmType;
      datasets: Array<{ id: number; name: string }> | null;
    }>;
    reviewDsms: Array<{ id: number; code: string; name: string }>;
    pushOnlyDsms: Array<{ id: number; code: string; name: string }>;
    excludedDsms: Array<{ id: number; code: string; name: string }>;
  };
};

export type ArchiveCareEntityMutationVariables = Exact<{
  careEntityId: string;
}>;

export type ArchiveCareEntityMutation = { softDeleteCareEntity: boolean };

export type GetUsersQueryVariables = Exact<{
  tenantId?: string | null | undefined;
}>;

export type GetUsersQuery = {
  tenantUsers: Array<{
    id: string;
    username: string;
    firstName: string;
    lastName: string;
    fullName: string | null;
    email: string;
    disableBiomedataLogin: boolean;
    phoneNumber: string | null;
    organizationalUnit: string | null;
    title: string | null;
    adGroups: Array<string> | null;
    root: boolean;
    permanentAccount: boolean;
    submitsData: boolean;
    enableSftp: boolean;
    ccOnboardingEmail: string | null;
    enabled: boolean;
    enabledTime: any;
    status: Types.UserStatus | null;
    passwordNeverExpires: boolean;
    lastLogin: any;
    twoFactor: boolean | null;
    createdAt: any;
    updateAt: any;
    tenant: { id: string; name: string; code: string };
    createdBy: { fullName: string | null } | null;
    updateBy: { fullName: string | null } | null;
  }>;
};

export type GetLastCeDsmRefreshQueryVariables = Exact<{ [key: string]: never }>;

export type GetLastCeDsmRefreshQuery = { lastCeDsmRefresh: any };

export type GetUserAuditQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserAuditQuery = {
  userAudit: Array<{
    userId: string;
    username: string;
    fullName: string | null;
    createdAt: any;
    enabled: boolean;
    submitsData: boolean;
    dataRefreshEmailsEnabled: boolean;
    echoSummaryEmailsEnabled: boolean;
    riskAuditEmailsEnabled: boolean;
    lastLoginDate: any;
    lastRefreshedAt: any;
    accessModifiedAt: any;
    roles: Array<{
      id: string;
      name: string;
      code: string;
      type: Types.RoleType;
      careEntityIds: Array<string>;
      dsmIds: Array<number>;
    }>;
    distributionLists: Array<{ id: string; name: string }>;
    allowedCareEntityDsms: Array<{ dsmId: number; careEntityId: string }>;
  }>;
};

export type GetCurrentUserQueryVariables = Exact<{ [key: string]: never }>;

export type GetCurrentUserQuery = {
  whoami: {
    id: string;
    username: string;
    firstName: string;
    lastName: string;
    fullName: string | null;
    email: string;
    title: string | null;
    organizationalUnit: string | null;
    lastLogin: any;
    submitsData: boolean;
    enableSftp: boolean;
    ccOnboardingEmail: string | null;
    root: boolean;
    permanentAccount: boolean;
    tenant: {
      code: string;
      name: string;
      id: string;
      organizationalUnit: string | null;
    };
    roles: Array<{ id: string; name: string; type: Types.RoleType }> | null;
    homepage: { url: string } | null;
  };
};

export type GetAnubisUploadTenantsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetAnubisUploadTenantsQuery = {
  tenants: Array<{ id: string; usesAnubisUpload: boolean }>;
};

export type GetUserAccountQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserAccountQuery = {
  whoami: {
    id: string;
    username: string;
    firstName: string;
    lastName: string;
    fullName: string | null;
    email: string;
    phoneNumber: string | null;
    title: string | null;
    submitsData: boolean;
    status: Types.UserStatus | null;
    root: boolean;
    otherEmails: Array<{ email: string }> | null;
    tenant: { code: string; name: string; id: string };
    tokens: Array<{
      id: string;
      type: Types.TokenType;
      status: Types.TokenStatus;
      name: string | null;
      expiresAt: any;
    }> | null;
    roles: Array<{
      id: string;
      name: string;
      type: Types.RoleType;
      tenantId: string;
    }> | null;
    notifications: Array<{
      id: string;
      name: string;
      type: Types.NotificationType;
      description: string | null;
    }> | null;
  };
};

export type UpdateUserAccountMutationVariables = Exact<{
  updateUserInput: Types.UpdateUserAccountInput;
}>;

export type UpdateUserAccountMutation = {
  updateUserAccount: {
    firstName: string;
    lastName: string;
    title: string | null;
    username: string;
    email: string;
    phoneNumber: string | null;
    otherEmails: Array<{ email: string }> | null;
    notifications: Array<{
      id: string;
      name: string;
      type: Types.NotificationType;
      description: string | null;
    }> | null;
    tokens: Array<{
      id: string;
      name: string | null;
      type: Types.TokenType;
      status: Types.TokenStatus;
      expiresAt: any;
    }> | null;
  };
};

export type GetUserQueryVariables = Exact<{
  userId?: string | null | undefined;
  username?: string | null | undefined;
}>;

export type GetUserQuery = {
  user: {
    id: string;
    username: string;
    firstName: string;
    lastName: string;
    fullName: string | null;
    description: string | null;
    email: string;
    disableBiomedataLogin: boolean;
    phoneNumber: string | null;
    organizationalUnit: string | null;
    title: string | null;
    adGroups: Array<string> | null;
    root: boolean;
    permanentAccount: boolean;
    submitsData: boolean;
    enableSftp: boolean;
    careEntityCode: string | null;
    ccOnboardingEmail: string | null;
    enabled: boolean;
    enabledTime: any;
    status: Types.UserStatus | null;
    passwordNeverExpires: boolean;
    lastLogin: any;
    twoFactor: boolean | null;
    createdAt: any;
    updateAt: any;
    otherEmails: Array<{ email: string }> | null;
    tenant: { id: string; name: string; code: string };
    roles: Array<{
      id: string;
      name: string;
      type: Types.RoleType;
      description: string;
      tenant: { id: string; code: string };
    }> | null;
    submissions: Array<{
      id: string;
      aggregate: boolean;
      sendReminders: boolean;
      daysAfterDeadline: number;
      ccEmails: string | null;
      userId: string | null;
      parentId: string | null;
      cadence: string;
      careEntity: { id: string; code: string; shortDisplayName: string | null };
      dataset: { id: number; name: string };
    }> | null;
    createdBy: { fullName: string | null } | null;
    updateBy: { fullName: string | null } | null;
    tokens: Array<{
      id: string;
      type: Types.TokenType;
      status: Types.TokenStatus;
      name: string | null;
      expiresAt: any;
    }> | null;
    notifications: Array<{
      id: string;
      name: string;
      type: Types.NotificationType;
      description: string | null;
    }> | null;
    files: Array<{
      isDirect: boolean;
      file: {
        id: string;
        name: string;
        description: string | null;
        tenantId: string | null;
        phi: boolean | null;
        tenant: { id: string; name: string } | null;
      };
      distributionLists: Array<{ id: string; name: string }> | null;
    }> | null;
    distributionLists: Array<{
      id: string;
      name: string;
      tenant: { id: string };
    }> | null;
  };
};

export type GetIsUserLockedQueryVariables = Exact<{
  username: string;
}>;

export type GetIsUserLockedQuery = { userLocked: boolean };

export type GetRolesQueryVariables = Exact<{
  ids?: Array<string> | string | null | undefined;
}>;

export type GetRolesQuery = {
  roles: Array<{
    id: string;
    name: string;
    code: string;
    description: string;
    type: Types.RoleType;
    tenant: { id: string; code: string };
    users: Array<{
      id: string;
      firstName: string;
      lastName: string;
      username: string;
      email: string;
    }> | null;
  }>;
};

export type GetRoleQueryVariables = Exact<{
  roleId: string;
}>;

export type GetRoleQuery = {
  role: {
    id: string;
    name: string;
    code: string;
    description: string;
    type: Types.RoleType;
    tenant: { id: string; code: string };
    users: Array<{
      id: string;
      firstName: string;
      lastName: string;
      username: string;
      email: string;
    }> | null;
  };
};

export type GetTenantWorkbooksQueryVariables = Exact<{
  tenantId: string;
}>;

export type GetTenantWorkbooksQuery = {
  tenantWorkbooks: Array<{
    id: number;
    name: string;
    active: boolean;
    workbookGroup: { id: number; name: string } | null;
    diseaseStateModule: {
      id: number;
      name: string;
      supportedApps: Array<Types.SupportedApps> | null;
    } | null;
    tableauViews: Array<{ id: number; name: string; active: boolean }> | null;
  }>;
};

export type GetDashboardFinderDataQueryVariables = Exact<{
  tenantId: string;
}>;

export type GetDashboardFinderDataQuery = {
  tenantWorkbooks: Array<{
    id: number;
    name: string;
    active: boolean;
    sortOrder: number;
    diseaseStateModuleId: number;
    workbookGroupId: number | null;
    measureIds: Array<number> | null;
    tableauViews: Array<{
      id: number;
      name: string;
      description: string;
      active: boolean;
      workbookId: number;
      sortOrder: number;
      renderInMenu: boolean;
      primaryMeasureIds: Array<number> | null;
      secondaryMeasureIds: Array<number> | null;
    }> | null;
  }>;
};

export type GetTableauWorkbooksQueryVariables = Exact<{
  ids?: Array<number> | number | null | undefined;
}>;

export type GetTableauWorkbooksQuery = {
  workbooks: Array<{
    id: number;
    tableauUri: string;
    name: string;
    description: string;
    tags: Array<Types.Tags> | null;
    sortOrder: number;
    active: boolean;
    measureIds: Array<number> | null;
    diseaseStateModule: { id: number; name: string } | null;
    workbookGroup: { id: number; name: string } | null;
    tenants: Array<{
      id: string;
      code: string;
      name: string;
      active: boolean;
    }> | null;
    tableauViews: Array<{
      id: number;
      name: string;
      description: string;
    }> | null;
  }>;
};

export type CreateWorkbookMutationVariables = Exact<{
  createWorkbookInput: Types.CreateWorkbookInput;
}>;

export type CreateWorkbookMutation = {
  createWorkbook: {
    id: number;
    tableauUri: string;
    name: string;
    description: string;
    tags: Array<Types.Tags> | null;
    sortOrder: number;
    active: boolean;
    measureIds: Array<number> | null;
    diseaseStateModule: { id: number; name: string } | null;
    workbookGroup: { id: number; name: string } | null;
    tenants: Array<{
      id: string;
      code: string;
      name: string;
      active: boolean;
    }> | null;
    tableauViews: Array<{
      id: number;
      name: string;
      description: string;
    }> | null;
  };
};

export type UpdateWorkbookMutationVariables = Exact<{
  updateWorkbookInput: Types.UpdateWorkbookInput;
}>;

export type UpdateWorkbookMutation = {
  updateWorkbook: {
    id: number;
    tableauUri: string;
    name: string;
    description: string;
    tags: Array<Types.Tags> | null;
    sortOrder: number;
    active: boolean;
    measureIds: Array<number> | null;
    diseaseStateModule: { id: number; name: string } | null;
    workbookGroup: { id: number; name: string } | null;
    tenants: Array<{
      id: string;
      code: string;
      name: string;
      active: boolean;
    }> | null;
    tableauViews: Array<{
      id: number;
      name: string;
      description: string;
    }> | null;
  };
};

export type GetWorkbookGroupsQueryVariables = Exact<{ [key: string]: never }>;

export type GetWorkbookGroupsQuery = {
  workbookGroups: Array<{
    id: number;
    name: string;
    description: string;
    sortOrder: number;
    active: boolean;
    renderAsLink: boolean;
    renderInMenu: boolean;
    diseaseStateModuleId: number;
    diseaseStateModule: { id: number; name: string };
    workbooks: Array<{ id: number; name: string; description: string }> | null;
  }>;
};

export type GetWorkbookGroupQueryVariables = Exact<{
  workbookGroupId: number;
}>;

export type GetWorkbookGroupQuery = {
  workbookGroup: {
    id: number;
    name: string;
    description: string;
    sortOrder: number;
    active: boolean;
    renderAsLink: boolean;
    renderInMenu: boolean;
    diseaseStateModuleId: number;
    diseaseStateModule: { id: number; name: string };
    workbooks: Array<{ id: number; name: string; description: string }> | null;
  };
};

export type CreateWorkbookGroupMutationVariables = Exact<{
  createGroupInput: Types.CreateWorkbookGroupInput;
}>;

export type CreateWorkbookGroupMutation = {
  createWorkbookGroup: {
    id: number;
    name: string;
    description: string;
    sortOrder: number;
    active: boolean;
    renderAsLink: boolean;
    renderInMenu: boolean;
    diseaseStateModuleId: number;
    diseaseStateModule: { id: number; name: string };
    workbooks: Array<{ id: number; name: string; description: string }> | null;
  };
};

export type UpdateWorkbookGroupMutationVariables = Exact<{
  updateGroupInput: Types.UpdateWorkbookGroupInput;
}>;

export type UpdateWorkbookGroupMutation = {
  updateWorkbookGroup: {
    id: number;
    name: string;
    description: string;
    sortOrder: number;
    active: boolean;
    renderAsLink: boolean;
    renderInMenu: boolean;
    diseaseStateModuleId: number;
    diseaseStateModule: { id: number; name: string };
    workbooks: Array<{ id: number; name: string; description: string }> | null;
  };
};

export type GetTableauViewQueryVariables = Exact<{
  tableauViewId: number;
}>;

export type GetTableauViewQuery = {
  tableauView: {
    id: number;
    name: string;
    workbookId: number;
    sortOrder: number;
    renderInMenu: boolean;
    workbook: {
      measureIds: Array<number> | null;
      name: string;
      diseaseStateModule: { id: number; code: string; name: string } | null;
      workbookGroup: { id: number; name: string } | null;
    };
  };
};

export type GetAdminTableauViewQueryVariables = Exact<{
  tableauViewId: number;
}>;

export type GetAdminTableauViewQuery = {
  tableauView: {
    id: number;
    name: string;
    description: string;
    tags: Array<string> | null;
    primaryMeasureIds: Array<number> | null;
    secondaryMeasureIds: Array<number> | null;
    sortOrder: number;
    active: boolean;
    renderInMenu: boolean;
    workbook: { id: number; name: string };
  };
};

export type GetTableauViewsQueryVariables = Exact<{ [key: string]: never }>;

export type GetTableauViewsQuery = {
  tableauViews: Array<{
    id: number;
    name: string;
    description: string;
    tags: Array<string> | null;
    primaryMeasureIds: Array<number> | null;
    secondaryMeasureIds: Array<number> | null;
    sortOrder: number;
    active: boolean;
    renderInMenu: boolean;
    workbook: { id: number; name: string };
  }>;
};

export type CreateTableauViewMutationVariables = Exact<{
  createViewInput: Types.CreateTableauViewInput;
}>;

export type CreateTableauViewMutation = {
  createTableauView: {
    id: number;
    name: string;
    description: string;
    tags: Array<string> | null;
    primaryMeasureIds: Array<number> | null;
    secondaryMeasureIds: Array<number> | null;
    sortOrder: number;
    active: boolean;
    renderInMenu: boolean;
    workbook: { id: number; name: string };
  };
};

export type UpdateTableauViewMutationVariables = Exact<{
  updateViewInput: Types.UpdateTableauViewInput;
}>;

export type UpdateTableauViewMutation = { updateTableauView: boolean };

export type GetRelatedDashboardsQueryVariables = Exact<{
  measureIds?: Array<number> | number | null | undefined;
}>;

export type GetRelatedDashboardsQuery = {
  tableauViews: Array<{
    id: number;
    name: string;
    description: string;
    active: boolean;
    workbook: { name: string; diseaseStateModule: { name: string } | null };
  }>;
};

export type GetCitationDashboardQueryVariables = Exact<{
  citationDashboardInput: Types.CitationDashboardInput;
}>;

export type GetCitationDashboardQuery = {
  citationDashboard: {
    id: number;
    name: string;
    workbookName: string | null;
  } | null;
};

export type GetTenantDashboardsQueryVariables = Exact<{
  tenantId: string;
}>;

export type GetTenantDashboardsQuery = {
  tenantWorkbooks: Array<{
    active: boolean;
    diseaseStateModule: { id: number; code: string; name: string } | null;
    tableauViews: Array<{
      id: number;
      name: string;
      active: boolean;
      renderInMenu: boolean;
    }> | null;
  }>;
};

export type GetBookmarksQueryVariables = Exact<{ [key: string]: never }>;

export type GetBookmarksQuery = {
  bookmarks: Array<{
    id: string;
    name: string;
    createdAt: any;
    description: string | null;
    url: string;
  }>;
};

export type GetBookmarkQueryVariables = Exact<{
  bookmarkId: string;
}>;

export type GetBookmarkQuery = {
  bookmark: {
    id: string;
    name: string;
    createdAt: any;
    description: string | null;
    url: string;
  };
};

export type AddFavoriteTableauViewMutationVariables = Exact<{
  tenantId: string;
  viewId: number;
}>;

export type AddFavoriteTableauViewMutation = { addFavorite: boolean };

export type RemoveFavoriteTableauViewMutationVariables = Exact<{
  tenantId: string;
  viewId: number;
}>;

export type RemoveFavoriteTableauViewMutation = { removeFavorite: boolean };

export type CreateBookmarkMutationVariables = Exact<{
  createBookmarkInput: Types.CreateBookmarkInput;
}>;

export type CreateBookmarkMutation = {
  createBookmark: {
    id: string;
    name: string;
    createdAt: any;
    description: string | null;
    url: string;
  };
};

export type CreateBookmarkShortUrlMutationVariables = Exact<{
  originalUrl: string;
}>;

export type CreateBookmarkShortUrlMutation = { createBookmarkShortUrl: string };

export type UpdateBookmarkMutationVariables = Exact<{
  updateBookmarkInput: Types.UpdateBookmarkInput;
}>;

export type UpdateBookmarkMutation = {
  updateBookmark: { id: string; name: string; description: string | null };
};

export type RemoveBookmarkMutationVariables = Exact<{
  removeBookmarkId: string;
}>;

export type RemoveBookmarkMutation = { removeBookmark: boolean };

export type CreateRoleMutationVariables = Exact<{
  createRoleInput: Types.CreateRoleInput;
}>;

export type CreateRoleMutation = {
  createRole: {
    id: string;
    name: string;
    code: string;
    description: string;
    type: Types.RoleType;
    tenant: { id: string; code: string };
    users: Array<{
      id: string;
      firstName: string;
      lastName: string;
      username: string;
      email: string;
    }> | null;
  };
};

export type UpdateRoleMutationVariables = Exact<{
  updateRoleInput: Types.UpdateRoleInput;
}>;

export type UpdateRoleMutation = {
  updateRole: {
    id: string;
    name: string;
    code: string;
    description: string;
    type: Types.RoleType;
    users: Array<{
      id: string;
      firstName: string;
      lastName: string;
      username: string;
      email: string;
    }> | null;
  };
};

export type RemoveRolesMutationVariables = Exact<{
  ids: Array<string> | string;
}>;

export type RemoveRolesMutation = { removeRoles: boolean };

export type CreateUserMutationVariables = Exact<{
  createUserInput: Types.CreateUserInput;
}>;

export type CreateUserMutation = {
  createUser: {
    id: string;
    username: string;
    firstName: string;
    lastName: string;
    fullName: string | null;
    email: string;
    description: string | null;
    disableBiomedataLogin: boolean;
    phoneNumber: string | null;
    organizationalUnit: string | null;
    title: string | null;
    adGroups: Array<string> | null;
    root: boolean;
    permanentAccount: boolean;
    submitsData: boolean;
    enableSftp: boolean;
    careEntityCode: string | null;
    ccOnboardingEmail: string | null;
    enabled: boolean;
    enabledTime: any;
    status: Types.UserStatus | null;
    passwordNeverExpires: boolean;
    lastLogin: any;
    twoFactor: boolean | null;
    createdAt: any;
    updateAt: any;
    otherEmails: Array<{ email: string }> | null;
    tenant: { id: string; name: string; code: string };
    roles: Array<{
      id: string;
      name: string;
      type: Types.RoleType;
      description: string;
      tenant: { id: string; code: string };
    }> | null;
    submissions: Array<{
      id: string;
      aggregate: boolean;
      sendReminders: boolean;
      daysAfterDeadline: number;
      ccEmails: string | null;
      userId: string | null;
      parentId: string | null;
      cadence: string;
      careEntity: { id: string; code: string; shortDisplayName: string | null };
      dataset: { id: number; name: string };
    }> | null;
    createdBy: { fullName: string | null } | null;
    updateBy: { fullName: string | null } | null;
    tokens: Array<{
      id: string;
      type: Types.TokenType;
      status: Types.TokenStatus;
      name: string | null;
      expiresAt: any;
    }> | null;
    notifications: Array<{
      id: string;
      name: string;
      type: Types.NotificationType;
      description: string | null;
    }> | null;
    files: Array<{
      isDirect: boolean;
      file: {
        id: string;
        name: string;
        description: string | null;
        tenantId: string | null;
        phi: boolean | null;
        tenant: { id: string; name: string } | null;
      };
      distributionLists: Array<{ id: string; name: string }> | null;
    }> | null;
    distributionLists: Array<{
      id: string;
      name: string;
      tenant: { id: string };
    }> | null;
  };
};

export type UpdateUserMutationVariables = Exact<{
  updateUserInput: Types.UpdateUserInput;
  fileShareNotification?: Types.FileShareNotification | null | undefined;
}>;

export type UpdateUserMutation = {
  updateUser: {
    id: string;
    username: string;
    firstName: string;
    lastName: string;
    fullName: string | null;
    description: string | null;
    email: string;
    disableBiomedataLogin: boolean;
    phoneNumber: string | null;
    organizationalUnit: string | null;
    title: string | null;
    adGroups: Array<string> | null;
    root: boolean;
    permanentAccount: boolean;
    submitsData: boolean;
    enableSftp: boolean;
    careEntityCode: string | null;
    ccOnboardingEmail: string | null;
    enabled: boolean;
    enabledTime: any;
    status: Types.UserStatus | null;
    passwordNeverExpires: boolean;
    lastLogin: any;
    twoFactor: boolean | null;
    createdAt: any;
    updateAt: any;
    otherEmails: Array<{ email: string }> | null;
    tenant: { id: string; name: string; code: string };
    roles: Array<{
      id: string;
      name: string;
      type: Types.RoleType;
      tenant: { id: string; code: string };
    }> | null;
    submissions: Array<{
      id: string;
      sendReminders: boolean;
      daysAfterDeadline: number;
      ccEmails: string | null;
      userId: string | null;
      cadence: string;
      aggregate: boolean;
      parentId: string | null;
      careEntity: { id: string; code: string; shortDisplayName: string | null };
      dataset: { id: number; name: string };
    }> | null;
    createdBy: { fullName: string | null } | null;
    updateBy: { fullName: string | null } | null;
    tokens: Array<{
      id: string;
      type: Types.TokenType;
      status: Types.TokenStatus;
      name: string | null;
      expiresAt: any;
    }> | null;
    notifications: Array<{
      id: string;
      name: string;
      type: Types.NotificationType;
      description: string | null;
    }> | null;
    files: Array<{
      isDirect: boolean;
      file: {
        id: string;
        name: string;
        description: string | null;
        tenantId: string | null;
        phi: boolean | null;
        tenant: { id: string; name: string } | null;
      };
      distributionLists: Array<{ id: string; name: string }> | null;
    }> | null;
    distributionLists: Array<{
      id: string;
      name: string;
      tenant: { id: string };
    }> | null;
  };
};

export type ShareFilesWithUsersMutationVariables = Exact<{
  userFileShareInputs: Array<Types.UpdateUserInput> | Types.UpdateUserInput;
  fileShareNotification?: Types.FileShareNotification | null | undefined;
}>;

export type ShareFilesWithUsersMutation = { shareFilesWithUsers: boolean };

export type UpdateTenantMutationVariables = Exact<{
  updateTenantInput: Types.UpdateTenantInput;
}>;

export type UpdateTenantMutation = {
  updateTenant: {
    id: string;
    name: string;
    code: string;
    itContact: string | null;
    encryptionKeys: Array<string> | null;
    active: boolean;
    subdomain: string | null;
    disableHomepage: boolean;
    contractedDisplayPHI: boolean;
    clinicalOnly: boolean;
    aggregationTenant: boolean;
    deliverableBlinded: boolean;
    rollupMode: Types.AggregationRollupMode | null;
    organizationalUnit: string | null;
    disableBiomedataLogin: boolean;
    usesAnubisUpload: boolean;
    projectSponsorId: string | null;
    workbooks: Array<{
      id: number;
      name: string;
      description: string;
      active: boolean;
      diseaseStateModule: { id: number; name: string } | null;
    }> | null;
    projectSponsor: {
      id: string;
      email: string;
      fullName: string | null;
      username: string;
    } | null;
    logo: {
      id: string;
      name: string;
      mimeType: string;
      extension: string;
      category: string;
      url: string;
    } | null;
    banner: {
      id: string;
      name: string;
      mimeType: string;
      extension: string;
      category: string;
      url: string;
    } | null;
    documents: Array<{
      id: string;
      name: string;
      mimeType: string;
      extension: string;
      category: string;
      url: string;
    }> | null;
    users: Array<{
      id: string;
      fullName: string | null;
      username: string;
      email: string;
    }> | null;
    careEntities: Array<{
      id: string;
      name: string;
      code: string;
      description: string;
      isEngagementEntity: boolean;
      projectSponsor: string | null;
      physicianChampion: string | null;
      invoiceMonth: number | null;
      onboardingCompletedOn: any;
      monthlySponsorTouchbase: boolean;
      reviewDsms: Array<{ id: number; code: string; name: string }>;
      pushOnlyDsms: Array<{ id: number; code: string; name: string }>;
    }> | null;
    roles: Array<{ id: string; name: string; description: string }> | null;
    echoModules: Array<{
      id: string;
      name: string;
      displayName: string;
      description: string;
      active: boolean;
    }> | null;
    offboardingJob: {
      id: string;
      status: Types.TenantOffboardingJobStatus;
      deletionStarted: boolean;
    } | null;
  };
};

export type CreateTenantMutationVariables = Exact<{
  createTenantInput: Types.CreateTenantInput;
}>;

export type CreateTenantMutation = {
  createTenant: {
    id: string;
    name: string;
    code: string;
    itContact: string | null;
    encryptionKeys: Array<string> | null;
    active: boolean;
    subdomain: string | null;
    disableHomepage: boolean;
    contractedDisplayPHI: boolean;
    clinicalOnly: boolean;
    aggregationTenant: boolean;
    deliverableBlinded: boolean;
    rollupMode: Types.AggregationRollupMode | null;
    organizationalUnit: string | null;
    disableBiomedataLogin: boolean;
    usesAnubisUpload: boolean;
    projectSponsorId: string | null;
    workbooks: Array<{
      id: number;
      name: string;
      description: string;
      active: boolean;
      diseaseStateModule: { id: number; name: string } | null;
    }> | null;
    projectSponsor: {
      id: string;
      email: string;
      fullName: string | null;
      username: string;
    } | null;
    logo: {
      id: string;
      name: string;
      mimeType: string;
      extension: string;
      category: string;
      url: string;
    } | null;
    banner: {
      id: string;
      name: string;
      mimeType: string;
      extension: string;
      category: string;
      url: string;
    } | null;
    documents: Array<{
      id: string;
      name: string;
      mimeType: string;
      extension: string;
      category: string;
      url: string;
    }> | null;
    users: Array<{
      id: string;
      fullName: string | null;
      username: string;
      email: string;
    }> | null;
    careEntities: Array<{
      id: string;
      name: string;
      code: string;
      description: string;
      isEngagementEntity: boolean;
      projectSponsor: string | null;
      physicianChampion: string | null;
      invoiceMonth: number | null;
      onboardingCompletedOn: any;
      monthlySponsorTouchbase: boolean;
      reviewDsms: Array<{ id: number; code: string; name: string }>;
      pushOnlyDsms: Array<{ id: number; code: string; name: string }>;
    }> | null;
    roles: Array<{ id: string; name: string; description: string }> | null;
    echoModules: Array<{
      id: string;
      name: string;
      displayName: string;
      description: string;
      active: boolean;
    }> | null;
    offboardingJob: {
      id: string;
      status: Types.TenantOffboardingJobStatus;
      deletionStarted: boolean;
    } | null;
  };
};

export type UpdateCareEntityMutationVariables = Exact<{
  updateCareEntityInput: Types.UpdateCareEntityInput;
}>;

export type UpdateCareEntityMutation = {
  updateCareEntity: {
    id: string;
    name: string;
    shortDisplayName: string | null;
    code: string;
    supportedApps: Array<Types.SupportedApps> | null;
    anonymousCode: string | null;
    description: string;
    type: Types.CareEntityType;
    usGeoRegion: Types.UsGeoRegion | null;
    street: string | null;
    city: string | null;
    state: string | null;
    zip: string | null;
    alternateNames: Array<string> | null;
    ids: Array<string> | null;
    noOfBeds: number | null;
    aggregated: boolean;
    teaching: boolean;
    active: boolean;
    includeInBenchmarks: boolean;
    cmsId: string | null;
    cmsIdNotAvailable: boolean;
    reasonForNoCmsId: string | null;
    isEngagementEntity: boolean;
    projectSponsor: string | null;
    physicianChampion: string | null;
    invoiceMonth: number | null;
    onboardingCompletedOn: any;
    monthlySponsorTouchbase: boolean;
    tenants: Array<{ id: string; code: string; name: string }>;
    parents: Array<{
      id: string;
      code: string;
      name: string;
      description: string;
    }> | null;
    children: Array<{
      id: string;
      code: string;
      name: string;
      description: string;
    }> | null;
    memberDsms: Array<{
      childId: string;
      diseaseStateModules: Array<{ id: number; code: string; name: string }>;
    }>;
    diseaseStateModules: Array<{
      id: number;
      code: string;
      name: string;
      description: string;
      supportedApps: Array<Types.SupportedApps> | null;
      type: Types.DsmType;
      datasets: Array<{ id: number; name: string }> | null;
    }>;
    reviewDsms: Array<{ id: number; code: string; name: string }>;
    pushOnlyDsms: Array<{ id: number; code: string; name: string }>;
    excludedDsms: Array<{ id: number; code: string; name: string }>;
  };
};

export type CreateCareEntityMutationVariables = Exact<{
  createCareEntityInput: Types.CreateCareEntityInput;
}>;

export type CreateCareEntityMutation = {
  createCareEntity: {
    id: string;
    name: string;
    shortDisplayName: string | null;
    code: string;
    supportedApps: Array<Types.SupportedApps> | null;
    anonymousCode: string | null;
    description: string;
    type: Types.CareEntityType;
    usGeoRegion: Types.UsGeoRegion | null;
    street: string | null;
    city: string | null;
    state: string | null;
    zip: string | null;
    alternateNames: Array<string> | null;
    ids: Array<string> | null;
    noOfBeds: number | null;
    aggregated: boolean;
    teaching: boolean;
    active: boolean;
    includeInBenchmarks: boolean;
    cmsId: string | null;
    cmsIdNotAvailable: boolean;
    reasonForNoCmsId: string | null;
    isEngagementEntity: boolean;
    projectSponsor: string | null;
    physicianChampion: string | null;
    invoiceMonth: number | null;
    onboardingCompletedOn: any;
    monthlySponsorTouchbase: boolean;
    tenants: Array<{ id: string; code: string; name: string }>;
    parents: Array<{
      id: string;
      code: string;
      name: string;
      description: string;
    }> | null;
    children: Array<{
      id: string;
      code: string;
      name: string;
      description: string;
    }> | null;
    memberDsms: Array<{
      childId: string;
      diseaseStateModules: Array<{ id: number; code: string; name: string }>;
    }>;
    diseaseStateModules: Array<{
      id: number;
      code: string;
      name: string;
      description: string;
      supportedApps: Array<Types.SupportedApps> | null;
      type: Types.DsmType;
      datasets: Array<{ id: number; name: string }> | null;
    }>;
    reviewDsms: Array<{ id: number; code: string; name: string }>;
    pushOnlyDsms: Array<{ id: number; code: string; name: string }>;
    excludedDsms: Array<{ id: number; code: string; name: string }>;
  };
};

export type CreateBulkCareEntitiesMutationVariables = Exact<{
  inputs:
    Array<Types.CreateBulkCareEntityInput> | Types.CreateBulkCareEntityInput;
}>;

export type CreateBulkCareEntitiesMutation = {
  createBulkCareEntities: Array<{
    id: string;
    name: string;
    shortDisplayName: string | null;
    code: string;
    supportedApps: Array<Types.SupportedApps> | null;
    anonymousCode: string | null;
    description: string;
    type: Types.CareEntityType;
    usGeoRegion: Types.UsGeoRegion | null;
    street: string | null;
    city: string | null;
    state: string | null;
    zip: string | null;
    alternateNames: Array<string> | null;
    ids: Array<string> | null;
    noOfBeds: number | null;
    aggregated: boolean;
    teaching: boolean;
    active: boolean;
    tenants: Array<{ id: string; code: string; name: string }>;
  }>;
};

export type RemoveCareEntityMutationVariables = Exact<{
  removeCareEntityId: string;
}>;

export type RemoveCareEntityMutation = { removeCareEntity: boolean };

export type GetCareEntityUpdateImpactQueryVariables = Exact<{
  updateCareEntityInput: Types.UpdateCareEntityInput;
}>;

export type GetCareEntityUpdateImpactQuery = {
  careEntityUpdateImpact: {
    childrenAdditionImpact: Array<string> | null;
    memberDsmImpact: Array<string> | null;
    usersImpacted: Array<{
      username: string;
      email: string;
      id: string;
    }> | null;
    childrenRemovalImpact: Array<{ id: string; code: string }> | null;
    dsmAdditionImpact: {
      newRoles: Array<string> | null;
      affectedRoles: Array<{ code: string; id: string }> | null;
    } | null;
    dsmRemovalImpact: {
      submissions: Array<{
        id: string;
        user: { id: string; username: string; email: string } | null;
      }> | null;
      affectedParentRoles: Array<{ id: string; code: string }> | null;
      removedRoles: Array<{ id: string; code: string }> | null;
    } | null;
  };
};

export type GetUserRelationshipTablesQueryVariables = Exact<{
  userId: string;
}>;

export type GetUserRelationshipTablesQuery = {
  userRelationshipTables: Array<string>;
};

export type RemoveUserMutationVariables = Exact<{
  removeUserId: string;
}>;

export type RemoveUserMutation = { removeUser: boolean };

export type SoftDeleteUserMutationVariables = Exact<{
  userId: string;
}>;

export type SoftDeleteUserMutation = { softDeleteUser: boolean };

export type GetDatasetRelationsQueryVariables = Exact<{
  datasetRelationsId: number;
}>;

export type GetDatasetRelationsQuery = { datasetRelations: Array<string> };

export type RemoveDatasetMutationVariables = Exact<{
  removeDatasetId: number;
}>;

export type RemoveDatasetMutation = { removeDataset: boolean };

export type ArchiveDatasetMutationVariables = Exact<{
  archiveDatasetId: number;
}>;

export type ArchiveDatasetMutation = {
  archiveDataset: { id: number; deletedAt: any };
};

export type UnarchiveDatasetMutationVariables = Exact<{
  unarchiveDatasetId: number;
}>;

export type UnarchiveDatasetMutation = {
  unarchiveDataset: { id: number; deletedAt: any };
};

export type GetDiseaseStateModuleQueryVariables = Exact<{
  diseaseStateModuleId: string | number;
}>;

export type GetDiseaseStateModuleQuery = {
  diseaseStateModule: {
    id: number;
    deletedAt: any;
    name: string;
    code: string;
    description: string;
    type: Types.DsmType;
    supportedApps: Array<Types.SupportedApps> | null;
    primaryDatasetId: number | null;
    hideRiskAuditCharts: boolean | null;
    adjustment: Array<string> | null;
    aggregationFn: Array<string> | null;
    tableName: string | null;
    summaryCohortId: number | null;
    supportsMultipleProcedures: boolean;
    clinicalProgram: { id: number; name: string };
    datasets: Array<{
      id: number;
      code: string;
      name: string;
      managingSociety: string;
      isRegistry: boolean;
      description: string;
      supportsReportBuilder: boolean | null;
    }> | null;
    criticalDatasets: Array<{
      id: number;
      code: string;
      name: string;
      managingSociety: string;
      isRegistry: boolean;
      description: string;
    }> | null;
    careEntities: Array<{
      id: string;
      name: string;
      code: string;
      description: string;
    }> | null;
    workbookGroups: Array<{ id: number; name: string }> | null;
    riskMetrics: Array<{
      id: string;
      columnName: string;
      displayName: string;
      measureMetadatas: Array<{ id: number; name: string }> | null;
    }> | null;
    multiProcTables: Array<{
      id: string;
      tableName: string;
      dimensions: Array<{ id: number; label: string }> | null;
      developmentDimensions: Array<{ id: string; label: string }> | null;
    }> | null;
  };
};

export type GetDiseaseStateModulesQueryVariables = Exact<{
  includeArchived?: boolean | null | undefined;
}>;

export type GetDiseaseStateModulesQuery = {
  diseaseStateModules: Array<{
    id: number;
    deletedAt: any;
    name: string;
    code: string;
    description: string;
    type: Types.DsmType;
    supportedApps: Array<Types.SupportedApps> | null;
    hideRiskAuditCharts: boolean | null;
    primaryDatasetId: number | null;
    adjustment: Array<string> | null;
    aggregationFn: Array<string> | null;
    tableName: string | null;
    summaryCohortId: number | null;
    supportsMultipleProcedures: boolean;
    clinicalProgram: { id: number; name: string };
    datasets: Array<{
      id: number;
      code: string;
      name: string;
      managingSociety: string;
      isRegistry: boolean;
      description: string;
      supportsReportBuilder: boolean | null;
    }> | null;
    criticalDatasets: Array<{
      id: number;
      code: string;
      name: string;
      managingSociety: string;
      isRegistry: boolean;
      description: string;
    }> | null;
    careEntities: Array<{
      id: string;
      name: string;
      code: string;
      description: string;
    }> | null;
    workbookGroups: Array<{ id: number; name: string }> | null;
    riskMetrics: Array<{
      id: string;
      columnName: string;
      displayName: string;
      measureMetadatas: Array<{ id: number; name: string }> | null;
    }> | null;
    multiProcTables: Array<{
      id: string;
      tableName: string;
      dimensions: Array<{ id: number; label: string }> | null;
      developmentDimensions: Array<{ id: string; label: string }> | null;
    }> | null;
  }>;
};

export type GetUserDiseaseStateModulesIdsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetUserDiseaseStateModulesIdsQuery = {
  userDiseaseStateModulesIds: Array<number>;
};

export type CreateDiseaseStateModuleMutationVariables = Exact<{
  createDiseaseStateModuleInput: Types.CreateDiseaseStateModuleInput;
}>;

export type CreateDiseaseStateModuleMutation = {
  createDiseaseStateModule: {
    id: number;
    deletedAt: any;
    name: string;
    code: string;
    description: string;
    type: Types.DsmType;
    supportedApps: Array<Types.SupportedApps> | null;
    hideRiskAuditCharts: boolean | null;
    primaryDatasetId: number | null;
    adjustment: Array<string> | null;
    aggregationFn: Array<string> | null;
    tableName: string | null;
    summaryCohortId: number | null;
    clinicalProgram: { id: number; name: string };
    datasets: Array<{
      id: number;
      code: string;
      name: string;
      managingSociety: string;
      isRegistry: boolean;
      description: string;
    }> | null;
    criticalDatasets: Array<{
      id: number;
      code: string;
      name: string;
      managingSociety: string;
      isRegistry: boolean;
      description: string;
    }> | null;
    careEntities: Array<{
      id: string;
      name: string;
      code: string;
      description: string;
    }> | null;
    workbookGroups: Array<{ id: number; name: string }> | null;
    riskMetrics: Array<{
      id: string;
      columnName: string;
      displayName: string;
      measureMetadatas: Array<{ id: number; name: string }> | null;
    }> | null;
    multiProcTables: Array<{
      id: string;
      tableName: string;
      dimensions: Array<{ id: number; label: string }> | null;
      developmentDimensions: Array<{ id: string; label: string }> | null;
    }> | null;
  };
};

export type UpdateDiseaseStateModuleMutationVariables = Exact<{
  updateDiseaseStateModuleInput: Types.UpdateDiseaseStateModuleInput;
}>;

export type UpdateDiseaseStateModuleMutation = {
  updateDiseaseStateModule: {
    id: number;
    deletedAt: any;
    name: string;
    code: string;
    description: string;
    type: Types.DsmType;
    supportedApps: Array<Types.SupportedApps> | null;
    hideRiskAuditCharts: boolean | null;
    primaryDatasetId: number | null;
    adjustment: Array<string> | null;
    aggregationFn: Array<string> | null;
    tableName: string | null;
    summaryCohortId: number | null;
    clinicalProgram: { id: number; name: string };
    datasets: Array<{
      id: number;
      code: string;
      name: string;
      managingSociety: string;
      isRegistry: boolean;
      description: string;
    }> | null;
    criticalDatasets: Array<{
      id: number;
      code: string;
      name: string;
      managingSociety: string;
      isRegistry: boolean;
      description: string;
    }> | null;
    careEntities: Array<{
      id: string;
      name: string;
      code: string;
      description: string;
    }> | null;
    workbookGroups: Array<{ id: number; name: string }> | null;
    riskMetrics: Array<{
      id: string;
      columnName: string;
      displayName: string;
      measureMetadatas: Array<{ id: number; name: string }> | null;
    }> | null;
    multiProcTables: Array<{
      id: string;
      tableName: string;
      dimensions: Array<{ id: number; label: string }> | null;
      developmentDimensions: Array<{ id: string; label: string }> | null;
    }> | null;
  };
};

export type ArchiveDiseaseStateModuleMutationVariables = Exact<{
  archiveDiseaseStateModuleId: string | number;
}>;

export type ArchiveDiseaseStateModuleMutation = {
  archiveDiseaseStateModule: { id: number; deletedAt: any };
};

export type UnarchiveDiseaseStateModuleMutationVariables = Exact<{
  unarchiveDiseaseStateModuleId: string | number;
}>;

export type UnarchiveDiseaseStateModuleMutation = {
  unarchiveDiseaseStateModule: { id: number; deletedAt: any };
};

export type GetSubmissionsQueryVariables = Exact<{ [key: string]: never }>;

export type GetSubmissionsQuery = {
  submissions: Array<{
    id: string;
    cadence: string;
    submitNationalReport: boolean;
    mrnCrosswalkRequired: boolean;
    mrnHarvestRequired: boolean;
    enabled: boolean;
    ccEmails: string | null;
    sendReminders: boolean;
    daysAfterDeadline: number;
    aggregate: boolean;
    parentId: string | null;
    dataset: { id: number; name: string };
    careEntity: {
      id: string;
      code: string;
      name: string;
      shortDisplayName: string | null;
      aggregated: boolean;
      tenants: Array<{ id: string }>;
    };
    user: {
      id: string;
      username: string;
      fullName: string | null;
      tenant: { id: string; name: string };
    } | null;
  }>;
};

export type GetSubmissionQueryVariables = Exact<{
  submissionId: string;
}>;

export type GetSubmissionQuery = {
  submission: {
    id: string;
    cadence: string;
    submitNationalReport: boolean;
    mrnCrosswalkRequired: boolean;
    mrnHarvestRequired: boolean;
    enabled: boolean;
    ccEmails: string | null;
    sendReminders: boolean;
    daysAfterDeadline: number;
    aggregate: boolean;
    parentId: string | null;
    dataset: { id: number; name: string };
    children: Array<{
      id: string;
      careEntity: { id: string; code: string; name: string };
    }> | null;
    user: {
      id: string;
      username: string;
      fullName: string | null;
      tenant: { id: string; name: string };
    } | null;
    careEntity: {
      id: string;
      code: string;
      name: string;
      shortDisplayName: string | null;
      aggregated: boolean;
      tenants: Array<{ id: string }>;
    };
  };
};

export type CreateSubmissionMutationVariables = Exact<{
  createSubmissionInput: Types.CreateSubmissionInput;
}>;

export type CreateSubmissionMutation = {
  createSubmission: {
    id: string;
    cadence: string;
    submitNationalReport: boolean;
    mrnCrosswalkRequired: boolean;
    mrnHarvestRequired: boolean;
    enabled: boolean;
    ccEmails: string | null;
    sendReminders: boolean;
    daysAfterDeadline: number;
    aggregate: boolean;
    parentId: string | null;
    user: {
      id: string;
      username: string;
      fullName: string | null;
      tenant: { id: string; name: string };
    } | null;
    dataset: { id: number; name: string };
    children: Array<{
      id: string;
      careEntity: { id: string; code: string; name: string };
    }> | null;
    careEntity: {
      id: string;
      code: string;
      name: string;
      shortDisplayName: string | null;
      aggregated: boolean;
      tenants: Array<{ id: string }>;
    };
  };
};

export type CreateAggregateSubmissionMutationVariables = Exact<{
  createAggregateSubmissionsInput: Types.CreateAggregateSubmissionsInput;
}>;

export type CreateAggregateSubmissionMutation = {
  createAggregateSubmission: Array<{
    id: string;
    cadence: string;
    submitNationalReport: boolean;
    mrnCrosswalkRequired: boolean;
    mrnHarvestRequired: boolean;
    enabled: boolean;
    aggregate: boolean;
    sendReminders: boolean;
    daysAfterDeadline: number;
    ccEmails: string | null;
    parentId: string | null;
    dataset: { id: number; name: string };
    careEntity: {
      id: string;
      code: string;
      name: string;
      shortDisplayName: string | null;
      aggregated: boolean;
      tenants: Array<{ id: string }>;
    };
    user: {
      id: string;
      username: string;
      fullName: string | null;
      tenant: { id: string; name: string };
    } | null;
    children: Array<{
      id: string;
      careEntity: { id: string; code: string; name: string };
    }> | null;
  }>;
};

export type UpdateSubmissionMutationVariables = Exact<{
  updateSubmissionInput: Types.UpdateSubmissionInput;
}>;

export type UpdateSubmissionMutation = {
  updateSubmission: Array<{
    id: string;
    cadence: string;
    submitNationalReport: boolean;
    mrnCrosswalkRequired: boolean;
    mrnHarvestRequired: boolean;
    enabled: boolean;
    ccEmails: string | null;
    sendReminders: boolean;
    daysAfterDeadline: number;
    aggregate: boolean;
    parentId: string | null;
    children: Array<{
      id: string;
      careEntity: { id: string; code: string; name: string };
    }> | null;
    user: {
      id: string;
      username: string;
      fullName: string | null;
      tenant: { id: string; name: string };
    } | null;
    dataset: { id: number; name: string };
    careEntity: {
      id: string;
      code: string;
      name: string;
      shortDisplayName: string | null;
      aggregated: boolean;
      tenants: Array<{ id: string }>;
    };
  }>;
};

export type RemoveSubmissionMutationVariables = Exact<{
  removeSubmissionId: string;
}>;

export type RemoveSubmissionMutation = { removeSubmission: boolean };

export type GetFavoriteViewsQueryVariables = Exact<{
  tenantId: string;
}>;

export type GetFavoriteViewsQuery = { favoriteViews: Array<{ id: number }> };

export type GetRecentTableauViewsQueryVariables = Exact<{
  tenantId: string;
  take: number;
}>;

export type GetRecentTableauViewsQuery = {
  recentTableauView: Array<{
    id: string;
    viewedAt: any;
    tableauView: { id: number };
  }>;
};

export type CreateRecentTableauViewMutationVariables = Exact<{
  createRecentTableauViewInput: Types.CreateRecentTableauViewInput;
}>;

export type CreateRecentTableauViewMutation = {
  createRecentTableauView: { id: string; viewedAt: any };
};

export type UnlockUserMutationVariables = Exact<{
  username: string;
}>;

export type UnlockUserMutation = { unlockUser: boolean };

export type ChangePasswordMutationVariables = Exact<{
  username: string;
  newPassword: string;
}>;

export type ChangePasswordMutation = { changePassword: boolean };

export type GetOrganizationalUnitsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetOrganizationalUnitsQuery = {
  organizationalUnits: Array<{
    distinguishedName: string;
    subOu: Array<{
      distinguishedName: string;
      subOu: Array<{ distinguishedName: string }> | null;
    }> | null;
  }>;
};

export type GetClinicalProgramsQueryVariables = Exact<{ [key: string]: never }>;

export type GetClinicalProgramsQuery = {
  clinicalPrograms: Array<{
    id: number;
    name: string;
    description: string;
    isAdmin: boolean;
    diseaseStateModules: Array<{
      id: number;
      name: string;
      code: string;
      description: string;
      deletedAt: any;
    }> | null;
  }>;
};

export type GetClinicalProgramQueryVariables = Exact<{
  clinicalProgramId: number;
}>;

export type GetClinicalProgramQuery = {
  clinicalProgram: {
    id: number;
    name: string;
    description: string;
    isAdmin: boolean;
    diseaseStateModules: Array<{
      id: number;
      name: string;
      code: string;
      description: string;
      deletedAt: any;
    }> | null;
  };
};

export type CreateClinicalProgramMutationVariables = Exact<{
  createClinicalProgramInput: Types.CreateClinicalProgramInput;
}>;

export type CreateClinicalProgramMutation = {
  createClinicalProgram: {
    id: number;
    name: string;
    description: string;
    isAdmin: boolean;
    diseaseStateModules: Array<{
      id: number;
      name: string;
      code: string;
      description: string;
      deletedAt: any;
    }> | null;
  };
};

export type UpdateClinicalProgramMutationVariables = Exact<{
  updateClinicalProgramInput: Types.UpdateClinicalProgramInput;
}>;

export type UpdateClinicalProgramMutation = {
  updateClinicalProgram: {
    id: number;
    name: string;
    description: string;
    isAdmin: boolean;
    diseaseStateModules: Array<{
      id: number;
      name: string;
      code: string;
      description: string;
      deletedAt: any;
    }> | null;
  };
};

export type GetDatasetsQueryVariables = Exact<{
  includeArchived?: boolean | null | undefined;
}>;

export type GetDatasetsQuery = {
  datasets: Array<{
    id: number;
    name: string;
    code: string;
    description: string;
    managingSociety: string;
    isRegistry: boolean;
    isAdmin: boolean | null;
    isDropAndLoad: boolean | null;
    isTenantLevel: boolean | null;
    isCrosswalkSource: boolean;
    crosswalkRequired: boolean;
    supportsReportBuilder: boolean | null;
    deletedAt: any;
    diseaseStateModules: Array<{
      id: number;
      name: string;
      code: string;
      description: string;
      deletedAt: any;
    }> | null;
    deadlines: Array<{
      id: string;
      quarterIncluded: string | null;
      quarterSubmissionDeadline: any;
    }> | null;
    datasetVersions: Array<{
      id: string;
      name: string;
      versionNumber: number;
      description: string;
      startDate: any;
      datasetId: number;
    }> | null;
  }>;
};

export type GetDatasetVersionsQueryVariables = Exact<{
  fieldId?: number | null | undefined;
}>;

export type GetDatasetVersionsQuery = {
  datasetVersions: Array<{
    id: string;
    datasetId: number;
    name: string;
    versionNumber: number;
    datasetVersionFields: Array<{
      datasetVersionId: string;
      fieldId: number;
      sequenceNumber: number | null;
    }> | null;
    dataset: {
      id: number;
      name: string;
      datasetVersions: Array<{
        id: string;
        name: string;
        versionNumber: number;
      }> | null;
    };
  }>;
};

export type AddFieldDatasetVersionsMutationVariables = Exact<{
  datasetVersionFieldInputs:
    | Array<Types.CreateDatasetVersionFieldInput>
    | Types.CreateDatasetVersionFieldInput;
}>;

export type AddFieldDatasetVersionsMutation = {
  addFieldDatasetVersions: boolean;
};

export type RemoveFieldDatasetVersionsMutationVariables = Exact<{
  fieldId: number;
}>;

export type RemoveFieldDatasetVersionsMutation = {
  removeFieldDatasetVersions: boolean;
};

export type GetDatasetQueryVariables = Exact<{
  datasetId: number;
}>;

export type GetDatasetQuery = {
  dataset: {
    id: number;
    name: string;
    code: string;
    description: string;
    managingSociety: string;
    isRegistry: boolean;
    isAdmin: boolean | null;
    isDropAndLoad: boolean | null;
    isTenantLevel: boolean | null;
    isCrosswalkSource: boolean;
    crosswalkRequired: boolean;
    supportsReportBuilder: boolean | null;
    deletedAt: any;
    diseaseStateModules: Array<{
      id: number;
      name: string;
      code: string;
      description: string;
      deletedAt: any;
    }> | null;
    deadlines: Array<{
      id: string;
      quarterIncluded: string | null;
      quarterSubmissionDeadline: any;
    }> | null;
    datasetVersions: Array<{
      id: string;
      name: string;
      versionNumber: number;
      description: string;
      startDate: any;
      datasetId: number;
    }> | null;
  };
};

export type CreateDatasetMutationVariables = Exact<{
  createDatasetInput: Types.CreateDatasetInput;
}>;

export type CreateDatasetMutation = {
  createDataset: {
    id: number;
    name: string;
    code: string;
    description: string;
    managingSociety: string;
    isRegistry: boolean;
    isAdmin: boolean | null;
    isDropAndLoad: boolean | null;
    isTenantLevel: boolean | null;
    isCrosswalkSource: boolean;
    crosswalkRequired: boolean;
    supportsReportBuilder: boolean | null;
    deletedAt: any;
    diseaseStateModules: Array<{
      id: number;
      name: string;
      code: string;
      description: string;
      deletedAt: any;
    }> | null;
    deadlines: Array<{
      id: string;
      quarterIncluded: string | null;
      quarterSubmissionDeadline: any;
    }> | null;
    datasetVersions: Array<{
      id: string;
      name: string;
      versionNumber: number;
      description: string;
      startDate: any;
      datasetId: number;
    }> | null;
  };
};

export type UpdateDatasetMutationVariables = Exact<{
  updateDatasetInput: Types.UpdateDatasetInput;
}>;

export type UpdateDatasetMutation = {
  updateDataset: {
    id: number;
    name: string;
    code: string;
    description: string;
    managingSociety: string;
    isRegistry: boolean;
    isAdmin: boolean | null;
    isDropAndLoad: boolean | null;
    isTenantLevel: boolean | null;
    isCrosswalkSource: boolean;
    crosswalkRequired: boolean;
    diseaseStateModules: Array<{
      id: number;
      name: string;
      code: string;
      description: string;
      deletedAt: any;
    }> | null;
    deadlines: Array<{
      id: string;
      quarterIncluded: string | null;
      quarterSubmissionDeadline: any;
    }> | null;
  };
};

export type RevokeTokenMutationVariables = Exact<{
  revokeTokenId: string;
}>;

export type RevokeTokenMutation = { revokeToken: boolean };

export type SetHomepageMutationVariables = Exact<{
  createBookmarkInput: Types.CreateBookmarkInput;
}>;

export type SetHomepageMutation = { setHomepage: boolean };

export type CreateDeadlineMutationVariables = Exact<{
  createDeadlineInput: Types.CreateDeadlineInput;
}>;

export type CreateDeadlineMutation = {
  createDeadline: {
    id: string;
    monthIncluded: string | null;
    monthSubmissionDeadline: any;
    quarterIncluded: string | null;
    quarterSubmissionDeadline: any;
    dataset: { id: number; name: string; code: string };
  };
};

export type UpdateDeadlineMutationVariables = Exact<{
  updateDeadlineInput: Types.UpdateDeadlineInput;
}>;

export type UpdateDeadlineMutation = { updateDeadline: boolean };

export type CreateBulkDeadlinesMutationVariables = Exact<{
  createDeadlineInputs:
    Array<Types.CreateDeadlineInput> | Types.CreateDeadlineInput;
}>;

export type CreateBulkDeadlinesMutation = {
  createBulkDeadlines: Array<{
    id: string;
    monthIncluded: string | null;
    monthSubmissionDeadline: any;
    quarterIncluded: string | null;
    quarterSubmissionDeadline: any;
    dataset: { id: number; name: string; code: string };
  }>;
};

export type GetDeadlinesQueryVariables = Exact<{ [key: string]: never }>;

export type GetDeadlinesQuery = {
  deadlines: Array<{
    id: string;
    monthIncluded: string | null;
    monthSubmissionDeadline: any;
    quarterIncluded: string | null;
    quarterSubmissionDeadline: any;
    dataset: { id: number; name: string; code: string };
  }>;
};

export type GetDeadlineQueryVariables = Exact<{
  deadlineId: string;
}>;

export type GetDeadlineQuery = {
  deadline: {
    id: string;
    monthIncluded: string | null;
    monthSubmissionDeadline: any;
    quarterIncluded: string | null;
    quarterSubmissionDeadline: any;
    dataset: { id: number; name: string; code: string };
  };
};

export type RemoveDeadlineMutationVariables = Exact<{
  removeDeadlineId: string;
}>;

export type RemoveDeadlineMutation = { removeDeadline: boolean };

export type GetExpiringDeadlineForDatasetQueryVariables = Exact<{
  datasetId: number;
}>;

export type GetExpiringDeadlineForDatasetQuery = {
  expiringDeadlineForDataset: { datasetId: number; maxDeadline: any } | null;
};

export type EnableUserMutationVariables = Exact<{
  enableUserInput: Types.EnableUserInput;
  alternativeUserId: string;
}>;

export type EnableUserMutation = { enableUser: boolean };

export type GetEchoAttributesQueryVariables = Exact<{ [key: string]: never }>;

export type GetEchoAttributesQuery = {
  echoAttributes: Array<{
    id: string;
    careEntityId: string;
    caseListModuleName: string;
    maxStudyDate: any;
    count: number;
    echoLatestRefreshDate: any;
  }>;
};

export type GetEchoFindingsQueryVariables = Exact<{
  avStenosis?: string | null | undefined;
  excludeFromAnalysis?: number | null | undefined;
  latestStudyOnRecord?: number | null | undefined;
  caselistModuleName: string;
  careEntityId?: string | null | undefined;
  endDate?: any;
  startDate?: any;
}>;

export type GetEchoFindingsQuery = {
  echoFindings: Array<{
    biomeEncounterId: number;
    caseId: string;
    mrn: string | null;
    biomeCaseUid: string | null;
    biomePatientUid: string | null;
    patientName: string | null;
    gender: string | null;
    race: string | null;
    age: number | null;
    orderDt: any;
    procedureDt: any;
    avStenosis: string | null;
    avStenosisText: string | null;
    mvRegurgitation: string | null;
    avRegurgitation: string | null;
    mvStenosis: string | null;
    pvStenosis: string | null;
    tvRegurgitation: string | null;
    tvStenosis: string | null;
    echoResultText: string | null;
    latestStudyOnRecord: boolean | null;
    biomeUpdateDt: any;
    biomeImportDt: any;
    caselistModuleName: string;
    careEntityId: string | null;
    tenantId: string | null;
    careEntityName: string | null;
    otherValveDisease: string | null;
    followups: Array<{
      id: string;
      biomeCaseUid: string;
      biomePatientUid: string;
      notes: string;
      statusId: string;
      version: number;
      createdAt: any;
      updateAt: any;
      latestStudyOnRecord: boolean;
      updateBy: {
        fullName: string | null;
        title: string | null;
        firstName: string;
        lastName: string;
      } | null;
    }>;
  }>;
};

export type CreateEchoFindingFollowupMutationVariables = Exact<{
  input: Types.EchoFindingFollowupInput;
}>;

export type CreateEchoFindingFollowupMutation = {
  createEchoFindingFollowup: {
    id: string;
    biomeCaseUid: string;
    biomePatientUid: string;
    notes: string;
    statusId: string;
    version: number;
    createdAt: any;
    updateAt: any;
    updateBy: {
      fullName: string | null;
      title: string | null;
      firstName: string;
      lastName: string;
    } | null;
  };
};

export type GetCurrentEchoFollowupOptionsQueryVariables = Exact<{
  caselistModuleName?: string | null | undefined;
}>;

export type GetCurrentEchoFollowupOptionsQuery = {
  currentEchoFollowupOptions: Array<{
    id: string;
    name: string;
    displayName: string;
    displayRank: number;
    isDefault: boolean;
    scope: Types.FollowupOptionScope;
    tenantId: string | null;
    category: string | null;
    hide: boolean;
    careEntities: Array<{ id: string; name: string }> | null;
  }>;
};

export type GetEchoFindingFieldsQueryVariables = Exact<{
  caselistModuleName?: string | null | undefined;
}>;

export type GetEchoFindingFieldsQuery = {
  echoFindingFields: Array<{
    id: string;
    name: string;
    phi: boolean;
    type: string;
    visibility: Types.VisibilityType;
    displayName: string;
    displayRank: number;
    description: string;
    category: Types.EchoFieldCategory;
    trained: boolean;
  }>;
};

export type GetEchoFindingModulesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetEchoFindingModulesQuery = {
  echoFindingModules: Array<{
    id: string;
    displayName: string;
    description: string;
    name: string;
    active: boolean;
    displayRank: number;
  }>;
};

export type GetTenantEchoFindingModulesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetTenantEchoFindingModulesQuery = {
  findAllTenantEchoModules: Array<{
    id: string;
    displayName: string;
    description: string;
    name: string;
    active: boolean;
    displayRank: number;
  }>;
};

export type GetRiskAuditsQueryVariables = Exact<{
  diseaseStateModuleId: number;
  careEntityId?: string | null | undefined;
  endDate?: any;
  startDate?: any;
  flagTypes?: Array<Types.FlagType> | Types.FlagType | null | undefined;
}>;

export type GetRiskAuditsQuery = {
  riskAudits: Array<{
    biomeEncounterId: number;
    auditId: number;
    visitId: number | null;
    careEntityCode: string | null;
    region: string | null;
    encounterId: string | null;
    mrn: string | null;
    registryId: string | null;
    procedure: string | null;
    arrivalDate: any;
    procedureDate: any;
    dischargeDate: any;
    dischargeYear: string | null;
    dischargeQuarter: string | null;
    surgicalYear: string | null;
    surgicalQuarter: string | null;
    diagnosisPOACodeList: string | null;
    visitTiming: string | null;
    riskValue: string | null;
    riskReview: string | null;
    reviewTriggerDescription: string | null;
    keyField: string | null;
    keyFieldValue: string | null;
    volume: number | null;
    biomeETLVersion: string | null;
    physician: string | null;
    mrnOriginal: string | null;
    procedureGroup: string | null;
    pciStatus: string | null;
    pciIndication: string | null;
    drgCode: string | null;
    icd10TriggerCode: string | null;
    directCost: number | null;
    netRevenue: number | null;
    auditFlagSource: string | null;
    tenantCode: string | null;
    biomeUpdateDt: any;
    careEntityId: string | null;
    tenantId: string | null;
    careEntityName: string | null;
    diseaseStateModuleId: string | null;
    flagType: Types.FlagType | null;
    trails: Array<{
      id: string;
      notes: string;
      status: Types.RiskAuditTrailStatus;
      version: number;
      latestStudyOnRecord: boolean;
      updateAt: any;
      updateBy: {
        fullName: string | null;
        title: string | null;
        firstName: string;
        lastName: string;
      } | null;
    }>;
  }>;
};

export type GetRiskAuditAttributesQueryVariables = Exact<{
  diseaseStateModuleId: number;
  careEntityId?: string | null | undefined;
}>;

export type GetRiskAuditAttributesQuery = {
  riskAuditAttributes: {
    biomeLatestRefreshDate: any;
    maxStudyDate: any;
    availableQuarters: Array<string>;
  };
};

export type GetRiskAuditFieldsQueryVariables = Exact<{
  diseaseStateModuleId: number;
}>;

export type GetRiskAuditFieldsQuery = {
  riskAuditFields: Array<{
    id: string;
    name: string;
    phi: boolean;
    type: string;
    visibility: Types.VisibilityType;
    displayRank: number;
    displayName: string;
    description: string;
    category: Types.RiskAuditFieldCategory;
  }>;
};

export type GetRiskAuditOutcomesQueryVariables = Exact<{
  dsmId: number;
  careEntityId: string;
}>;

export type GetRiskAuditOutcomesQuery = {
  riskAuditOutcomes: {
    quarters: Array<string>;
    outcomes: Array<{
      aggLevel: string | null;
      auditId: number;
      biomeUpdateDt: string | null;
      careEntityCode: string | null;
      measureId: number | null;
      measureName: string | null;
      oer: number | null;
      observed: number | null;
      expected: number | null;
      outcomeType: string | null;
      quarter: string | null;
      procedure: string | null;
      recordTiming: string | null;
      registry: string | null;
      tenantCode: string | null;
      tenantId: string | null;
      careEntityId: string | null;
    }>;
  };
};

export type GetRiskAuditChartsDataQueryVariables = Exact<{
  diseaseStateModuleId: number;
  careEntityId?: string | null | undefined;
  startDate?: any;
  endDate?: any;
  flagTypes?: Array<Types.FlagType> | Types.FlagType | null | undefined;
}>;

export type GetRiskAuditChartsDataQuery = {
  riskAuditChartsData: {
    auditFlagTypes: Array<{ count: number; riskValue: string }>;
    auditFlagSummary: Array<{
      riskValue: string;
      totalCount: number;
      statuses: Array<{ count: number; status: Types.RiskAuditTrailStatus }>;
    }>;
    auditStatuses: Array<{
      displayRank: number;
      key: string;
      name: string;
      value: number;
    }>;
  };
};

export type ResetPasswordMutationVariables = Exact<{
  passwordResetInput: Types.PasswordResetInput;
}>;

export type ResetPasswordMutation = { resetPassword: boolean };

export type ResendOnboardingEmailMutationVariables = Exact<{
  userId: string;
}>;

export type ResendOnboardingEmailMutation = { resendOnboardingEmail: boolean };

export type GetAdGroupsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAdGroupsQuery = {
  adGroups: Array<{
    id: string;
    name: string | null;
    distinguishedName: string | null;
  }>;
};

export type CreateActivityLogMutationVariables = Exact<{
  createActivityLogInput: Types.CreateActivityLogInput;
}>;

export type CreateActivityLogMutation = { createActivityLog: boolean };

export type GetActivityLogsQueryVariables = Exact<{
  startDate?: any;
  endDate?: any;
}>;

export type GetActivityLogsQuery = {
  activityLogs: Array<{
    id: string;
    createdAt: any;
    type: Types.ActivityLogType;
    relatedData: any;
    createdBy: { username: string; id: string } | null;
  }>;
};

export type GetUserAccessChangesQueryVariables = Exact<{
  userId: string | number;
}>;

export type GetUserAccessChangesQuery = {
  userAccessChanges: {
    userCreatedAt: any;
    userCreatedByName: string | null;
    changes: Array<{
      id: string;
      event: Types.AccessChangeEvent | null;
      comment: string | null;
      createdAt: any;
      roleNames: Array<string>;
      otherAccessFields: string | null;
      changedByName: string | null;
    }>;
  };
};

export type GetAccessHistoryQueryVariables = Exact<{
  startDate?: any;
  endDate?: any;
}>;

export type GetAccessHistoryQuery = {
  accessHistory: Array<{
    id: string;
    event: Types.AccessChangeEvent | null;
    comment: string;
    createdAt: any;
    subject: Types.Subject | null;
    current: any;
    previous: any;
    createdBy: { id: string; username: string } | null;
    role: { name: string; id: string } | null;
    user: { id: string; username: string } | null;
    distributionList: { id: string; name: string } | null;
  }>;
};

export type GetNotificationsQueryVariables = Exact<{ [key: string]: never }>;

export type GetNotificationsQuery = {
  notifications: Array<{
    id: string;
    name: string;
    type: Types.NotificationType;
    description: string | null;
  }>;
};

export type GenerateStandardRolesMutationVariables = Exact<{
  input: Types.GenerateStandardRolesInput;
}>;

export type GenerateStandardRolesMutation = { generateStandardRoles: boolean };

export type RefreshStandardRolesMutationVariables = Exact<{
  tenantId: string;
  roleIds?: Array<string> | string | null | undefined;
}>;

export type RefreshStandardRolesMutation = { refreshStandardRoles: boolean };

export type JobListFieldsFragment = {
  id: string;
  jobType: Types.JobType;
  status: Types.JobEventType;
  createdAt: any;
  statusTime: any;
  parentId: string | null;
  additionalInfo: any;
  hasProgressTree: boolean;
  createdBy: { fullName: string | null } | null;
  events: Array<{
    id: string;
    occuredAt: any;
    eventType: Types.JobEventType;
    message: string | null;
  }> | null;
};

export type RetryJobMutationVariables = Exact<{
  jobId: string;
}>;

export type RetryJobMutation = { retryJob: string };

export type JobProgressSummaryFieldsFragment = {
  jobId: string;
  overallPercent: number;
  stepsCompleted: number;
  stepsTotal: number;
  status: Types.JobEventType;
};

export type JobProgressNodeFieldsFragment = {
  id: string;
  jobId: string;
  parentStepId: string | null;
  key: string;
  label: string;
  order: number;
  type: Types.JobStepType;
  status: Types.JobStepStatus;
  childJobId: string | null;
  weight: number;
  completedUnits: number;
  totalUnits: number;
  message: string | null;
  error: string | null;
  startedAt: any;
  endedAt: any;
};

export type JobProgressChildTreeFieldsFragment = {
  summary: {
    jobId: string;
    overallPercent: number;
    stepsCompleted: number;
    stepsTotal: number;
    status: Types.JobEventType;
  };
  nodes: Array<{
    id: string;
    jobId: string;
    parentStepId: string | null;
    key: string;
    label: string;
    order: number;
    type: Types.JobStepType;
    status: Types.JobStepStatus;
    childJobId: string | null;
    weight: number;
    completedUnits: number;
    totalUnits: number;
    message: string | null;
    error: string | null;
    startedAt: any;
    endedAt: any;
    children: Array<{
      id: string;
      jobId: string;
      parentStepId: string | null;
      key: string;
      label: string;
      order: number;
      type: Types.JobStepType;
      status: Types.JobStepStatus;
      childJobId: string | null;
      weight: number;
      completedUnits: number;
      totalUnits: number;
      message: string | null;
      error: string | null;
      startedAt: any;
      endedAt: any;
      children: Array<{
        id: string;
        jobId: string;
        parentStepId: string | null;
        key: string;
        label: string;
        order: number;
        type: Types.JobStepType;
        status: Types.JobStepStatus;
        childJobId: string | null;
        weight: number;
        completedUnits: number;
        totalUnits: number;
        message: string | null;
        error: string | null;
        startedAt: any;
        endedAt: any;
      }>;
    }>;
  }>;
};

export type JobProgressNestedTreeFieldsFragment = {
  summary: {
    jobId: string;
    overallPercent: number;
    stepsCompleted: number;
    stepsTotal: number;
    status: Types.JobEventType;
  };
  nodes: Array<{
    id: string;
    jobId: string;
    parentStepId: string | null;
    key: string;
    label: string;
    order: number;
    type: Types.JobStepType;
    status: Types.JobStepStatus;
    childJobId: string | null;
    weight: number;
    completedUnits: number;
    totalUnits: number;
    message: string | null;
    error: string | null;
    startedAt: any;
    endedAt: any;
    childJob: {
      summary: {
        jobId: string;
        overallPercent: number;
        stepsCompleted: number;
        stepsTotal: number;
        status: Types.JobEventType;
      };
      nodes: Array<{
        id: string;
        jobId: string;
        parentStepId: string | null;
        key: string;
        label: string;
        order: number;
        type: Types.JobStepType;
        status: Types.JobStepStatus;
        childJobId: string | null;
        weight: number;
        completedUnits: number;
        totalUnits: number;
        message: string | null;
        error: string | null;
        startedAt: any;
        endedAt: any;
        children: Array<{
          id: string;
          jobId: string;
          parentStepId: string | null;
          key: string;
          label: string;
          order: number;
          type: Types.JobStepType;
          status: Types.JobStepStatus;
          childJobId: string | null;
          weight: number;
          completedUnits: number;
          totalUnits: number;
          message: string | null;
          error: string | null;
          startedAt: any;
          endedAt: any;
          children: Array<{
            id: string;
            jobId: string;
            parentStepId: string | null;
            key: string;
            label: string;
            order: number;
            type: Types.JobStepType;
            status: Types.JobStepStatus;
            childJobId: string | null;
            weight: number;
            completedUnits: number;
            totalUnits: number;
            message: string | null;
            error: string | null;
            startedAt: any;
            endedAt: any;
          }>;
        }>;
      }>;
    } | null;
    children: Array<{
      id: string;
      jobId: string;
      parentStepId: string | null;
      key: string;
      label: string;
      order: number;
      type: Types.JobStepType;
      status: Types.JobStepStatus;
      childJobId: string | null;
      weight: number;
      completedUnits: number;
      totalUnits: number;
      message: string | null;
      error: string | null;
      startedAt: any;
      endedAt: any;
      childJob: {
        summary: {
          jobId: string;
          overallPercent: number;
          stepsCompleted: number;
          stepsTotal: number;
          status: Types.JobEventType;
        };
        nodes: Array<{
          id: string;
          jobId: string;
          parentStepId: string | null;
          key: string;
          label: string;
          order: number;
          type: Types.JobStepType;
          status: Types.JobStepStatus;
          childJobId: string | null;
          weight: number;
          completedUnits: number;
          totalUnits: number;
          message: string | null;
          error: string | null;
          startedAt: any;
          endedAt: any;
          children: Array<{
            id: string;
            jobId: string;
            parentStepId: string | null;
            key: string;
            label: string;
            order: number;
            type: Types.JobStepType;
            status: Types.JobStepStatus;
            childJobId: string | null;
            weight: number;
            completedUnits: number;
            totalUnits: number;
            message: string | null;
            error: string | null;
            startedAt: any;
            endedAt: any;
            children: Array<{
              id: string;
              jobId: string;
              parentStepId: string | null;
              key: string;
              label: string;
              order: number;
              type: Types.JobStepType;
              status: Types.JobStepStatus;
              childJobId: string | null;
              weight: number;
              completedUnits: number;
              totalUnits: number;
              message: string | null;
              error: string | null;
              startedAt: any;
              endedAt: any;
            }>;
          }>;
        }>;
      } | null;
      children: Array<{
        id: string;
        jobId: string;
        parentStepId: string | null;
        key: string;
        label: string;
        order: number;
        type: Types.JobStepType;
        status: Types.JobStepStatus;
        childJobId: string | null;
        weight: number;
        completedUnits: number;
        totalUnits: number;
        message: string | null;
        error: string | null;
        startedAt: any;
        endedAt: any;
        childJob: {
          summary: {
            jobId: string;
            overallPercent: number;
            stepsCompleted: number;
            stepsTotal: number;
            status: Types.JobEventType;
          };
          nodes: Array<{
            id: string;
            jobId: string;
            parentStepId: string | null;
            key: string;
            label: string;
            order: number;
            type: Types.JobStepType;
            status: Types.JobStepStatus;
            childJobId: string | null;
            weight: number;
            completedUnits: number;
            totalUnits: number;
            message: string | null;
            error: string | null;
            startedAt: any;
            endedAt: any;
            children: Array<{
              id: string;
              jobId: string;
              parentStepId: string | null;
              key: string;
              label: string;
              order: number;
              type: Types.JobStepType;
              status: Types.JobStepStatus;
              childJobId: string | null;
              weight: number;
              completedUnits: number;
              totalUnits: number;
              message: string | null;
              error: string | null;
              startedAt: any;
              endedAt: any;
              children: Array<{
                id: string;
                jobId: string;
                parentStepId: string | null;
                key: string;
                label: string;
                order: number;
                type: Types.JobStepType;
                status: Types.JobStepStatus;
                childJobId: string | null;
                weight: number;
                completedUnits: number;
                totalUnits: number;
                message: string | null;
                error: string | null;
                startedAt: any;
                endedAt: any;
              }>;
            }>;
          }>;
        } | null;
      }>;
    }>;
  }>;
};

export type GetJobProgressTreeQueryVariables = Exact<{
  jobId: string;
}>;

export type GetJobProgressTreeQuery = {
  jobProgressTree: {
    summary: {
      jobId: string;
      overallPercent: number;
      stepsCompleted: number;
      stepsTotal: number;
      status: Types.JobEventType;
    };
    nodes: Array<{
      id: string;
      jobId: string;
      parentStepId: string | null;
      key: string;
      label: string;
      order: number;
      type: Types.JobStepType;
      status: Types.JobStepStatus;
      childJobId: string | null;
      weight: number;
      completedUnits: number;
      totalUnits: number;
      message: string | null;
      error: string | null;
      startedAt: any;
      endedAt: any;
      children: Array<{
        id: string;
        jobId: string;
        parentStepId: string | null;
        key: string;
        label: string;
        order: number;
        type: Types.JobStepType;
        status: Types.JobStepStatus;
        childJobId: string | null;
        weight: number;
        completedUnits: number;
        totalUnits: number;
        message: string | null;
        error: string | null;
        startedAt: any;
        endedAt: any;
        childJob: {
          summary: {
            jobId: string;
            overallPercent: number;
            stepsCompleted: number;
            stepsTotal: number;
            status: Types.JobEventType;
          };
          nodes: Array<{
            id: string;
            jobId: string;
            parentStepId: string | null;
            key: string;
            label: string;
            order: number;
            type: Types.JobStepType;
            status: Types.JobStepStatus;
            childJobId: string | null;
            weight: number;
            completedUnits: number;
            totalUnits: number;
            message: string | null;
            error: string | null;
            startedAt: any;
            endedAt: any;
            childJob: {
              summary: {
                jobId: string;
                overallPercent: number;
                stepsCompleted: number;
                stepsTotal: number;
                status: Types.JobEventType;
              };
              nodes: Array<{
                id: string;
                jobId: string;
                parentStepId: string | null;
                key: string;
                label: string;
                order: number;
                type: Types.JobStepType;
                status: Types.JobStepStatus;
                childJobId: string | null;
                weight: number;
                completedUnits: number;
                totalUnits: number;
                message: string | null;
                error: string | null;
                startedAt: any;
                endedAt: any;
                children: Array<{
                  id: string;
                  jobId: string;
                  parentStepId: string | null;
                  key: string;
                  label: string;
                  order: number;
                  type: Types.JobStepType;
                  status: Types.JobStepStatus;
                  childJobId: string | null;
                  weight: number;
                  completedUnits: number;
                  totalUnits: number;
                  message: string | null;
                  error: string | null;
                  startedAt: any;
                  endedAt: any;
                  children: Array<{
                    id: string;
                    jobId: string;
                    parentStepId: string | null;
                    key: string;
                    label: string;
                    order: number;
                    type: Types.JobStepType;
                    status: Types.JobStepStatus;
                    childJobId: string | null;
                    weight: number;
                    completedUnits: number;
                    totalUnits: number;
                    message: string | null;
                    error: string | null;
                    startedAt: any;
                    endedAt: any;
                  }>;
                }>;
              }>;
            } | null;
            children: Array<{
              id: string;
              jobId: string;
              parentStepId: string | null;
              key: string;
              label: string;
              order: number;
              type: Types.JobStepType;
              status: Types.JobStepStatus;
              childJobId: string | null;
              weight: number;
              completedUnits: number;
              totalUnits: number;
              message: string | null;
              error: string | null;
              startedAt: any;
              endedAt: any;
              childJob: {
                summary: {
                  jobId: string;
                  overallPercent: number;
                  stepsCompleted: number;
                  stepsTotal: number;
                  status: Types.JobEventType;
                };
                nodes: Array<{
                  id: string;
                  jobId: string;
                  parentStepId: string | null;
                  key: string;
                  label: string;
                  order: number;
                  type: Types.JobStepType;
                  status: Types.JobStepStatus;
                  childJobId: string | null;
                  weight: number;
                  completedUnits: number;
                  totalUnits: number;
                  message: string | null;
                  error: string | null;
                  startedAt: any;
                  endedAt: any;
                  children: Array<{
                    id: string;
                    jobId: string;
                    parentStepId: string | null;
                    key: string;
                    label: string;
                    order: number;
                    type: Types.JobStepType;
                    status: Types.JobStepStatus;
                    childJobId: string | null;
                    weight: number;
                    completedUnits: number;
                    totalUnits: number;
                    message: string | null;
                    error: string | null;
                    startedAt: any;
                    endedAt: any;
                    children: Array<{
                      id: string;
                      jobId: string;
                      parentStepId: string | null;
                      key: string;
                      label: string;
                      order: number;
                      type: Types.JobStepType;
                      status: Types.JobStepStatus;
                      childJobId: string | null;
                      weight: number;
                      completedUnits: number;
                      totalUnits: number;
                      message: string | null;
                      error: string | null;
                      startedAt: any;
                      endedAt: any;
                    }>;
                  }>;
                }>;
              } | null;
              children: Array<{
                id: string;
                jobId: string;
                parentStepId: string | null;
                key: string;
                label: string;
                order: number;
                type: Types.JobStepType;
                status: Types.JobStepStatus;
                childJobId: string | null;
                weight: number;
                completedUnits: number;
                totalUnits: number;
                message: string | null;
                error: string | null;
                startedAt: any;
                endedAt: any;
                childJob: {
                  summary: {
                    jobId: string;
                    overallPercent: number;
                    stepsCompleted: number;
                    stepsTotal: number;
                    status: Types.JobEventType;
                  };
                  nodes: Array<{
                    id: string;
                    jobId: string;
                    parentStepId: string | null;
                    key: string;
                    label: string;
                    order: number;
                    type: Types.JobStepType;
                    status: Types.JobStepStatus;
                    childJobId: string | null;
                    weight: number;
                    completedUnits: number;
                    totalUnits: number;
                    message: string | null;
                    error: string | null;
                    startedAt: any;
                    endedAt: any;
                    children: Array<{
                      id: string;
                      jobId: string;
                      parentStepId: string | null;
                      key: string;
                      label: string;
                      order: number;
                      type: Types.JobStepType;
                      status: Types.JobStepStatus;
                      childJobId: string | null;
                      weight: number;
                      completedUnits: number;
                      totalUnits: number;
                      message: string | null;
                      error: string | null;
                      startedAt: any;
                      endedAt: any;
                      children: Array<{
                        id: string;
                        jobId: string;
                        parentStepId: string | null;
                        key: string;
                        label: string;
                        order: number;
                        type: Types.JobStepType;
                        status: Types.JobStepStatus;
                        childJobId: string | null;
                        weight: number;
                        completedUnits: number;
                        totalUnits: number;
                        message: string | null;
                        error: string | null;
                        startedAt: any;
                        endedAt: any;
                      }>;
                    }>;
                  }>;
                } | null;
              }>;
            }>;
          }>;
        } | null;
        children: Array<{
          id: string;
          jobId: string;
          parentStepId: string | null;
          key: string;
          label: string;
          order: number;
          type: Types.JobStepType;
          status: Types.JobStepStatus;
          childJobId: string | null;
          weight: number;
          completedUnits: number;
          totalUnits: number;
          message: string | null;
          error: string | null;
          startedAt: any;
          endedAt: any;
          childJob: {
            summary: {
              jobId: string;
              overallPercent: number;
              stepsCompleted: number;
              stepsTotal: number;
              status: Types.JobEventType;
            };
            nodes: Array<{
              id: string;
              jobId: string;
              parentStepId: string | null;
              key: string;
              label: string;
              order: number;
              type: Types.JobStepType;
              status: Types.JobStepStatus;
              childJobId: string | null;
              weight: number;
              completedUnits: number;
              totalUnits: number;
              message: string | null;
              error: string | null;
              startedAt: any;
              endedAt: any;
              childJob: {
                summary: {
                  jobId: string;
                  overallPercent: number;
                  stepsCompleted: number;
                  stepsTotal: number;
                  status: Types.JobEventType;
                };
                nodes: Array<{
                  id: string;
                  jobId: string;
                  parentStepId: string | null;
                  key: string;
                  label: string;
                  order: number;
                  type: Types.JobStepType;
                  status: Types.JobStepStatus;
                  childJobId: string | null;
                  weight: number;
                  completedUnits: number;
                  totalUnits: number;
                  message: string | null;
                  error: string | null;
                  startedAt: any;
                  endedAt: any;
                  children: Array<{
                    id: string;
                    jobId: string;
                    parentStepId: string | null;
                    key: string;
                    label: string;
                    order: number;
                    type: Types.JobStepType;
                    status: Types.JobStepStatus;
                    childJobId: string | null;
                    weight: number;
                    completedUnits: number;
                    totalUnits: number;
                    message: string | null;
                    error: string | null;
                    startedAt: any;
                    endedAt: any;
                    children: Array<{
                      id: string;
                      jobId: string;
                      parentStepId: string | null;
                      key: string;
                      label: string;
                      order: number;
                      type: Types.JobStepType;
                      status: Types.JobStepStatus;
                      childJobId: string | null;
                      weight: number;
                      completedUnits: number;
                      totalUnits: number;
                      message: string | null;
                      error: string | null;
                      startedAt: any;
                      endedAt: any;
                    }>;
                  }>;
                }>;
              } | null;
              children: Array<{
                id: string;
                jobId: string;
                parentStepId: string | null;
                key: string;
                label: string;
                order: number;
                type: Types.JobStepType;
                status: Types.JobStepStatus;
                childJobId: string | null;
                weight: number;
                completedUnits: number;
                totalUnits: number;
                message: string | null;
                error: string | null;
                startedAt: any;
                endedAt: any;
                childJob: {
                  summary: {
                    jobId: string;
                    overallPercent: number;
                    stepsCompleted: number;
                    stepsTotal: number;
                    status: Types.JobEventType;
                  };
                  nodes: Array<{
                    id: string;
                    jobId: string;
                    parentStepId: string | null;
                    key: string;
                    label: string;
                    order: number;
                    type: Types.JobStepType;
                    status: Types.JobStepStatus;
                    childJobId: string | null;
                    weight: number;
                    completedUnits: number;
                    totalUnits: number;
                    message: string | null;
                    error: string | null;
                    startedAt: any;
                    endedAt: any;
                    children: Array<{
                      id: string;
                      jobId: string;
                      parentStepId: string | null;
                      key: string;
                      label: string;
                      order: number;
                      type: Types.JobStepType;
                      status: Types.JobStepStatus;
                      childJobId: string | null;
                      weight: number;
                      completedUnits: number;
                      totalUnits: number;
                      message: string | null;
                      error: string | null;
                      startedAt: any;
                      endedAt: any;
                      children: Array<{
                        id: string;
                        jobId: string;
                        parentStepId: string | null;
                        key: string;
                        label: string;
                        order: number;
                        type: Types.JobStepType;
                        status: Types.JobStepStatus;
                        childJobId: string | null;
                        weight: number;
                        completedUnits: number;
                        totalUnits: number;
                        message: string | null;
                        error: string | null;
                        startedAt: any;
                        endedAt: any;
                      }>;
                    }>;
                  }>;
                } | null;
                children: Array<{
                  id: string;
                  jobId: string;
                  parentStepId: string | null;
                  key: string;
                  label: string;
                  order: number;
                  type: Types.JobStepType;
                  status: Types.JobStepStatus;
                  childJobId: string | null;
                  weight: number;
                  completedUnits: number;
                  totalUnits: number;
                  message: string | null;
                  error: string | null;
                  startedAt: any;
                  endedAt: any;
                  childJob: {
                    summary: {
                      jobId: string;
                      overallPercent: number;
                      stepsCompleted: number;
                      stepsTotal: number;
                      status: Types.JobEventType;
                    };
                    nodes: Array<{
                      id: string;
                      jobId: string;
                      parentStepId: string | null;
                      key: string;
                      label: string;
                      order: number;
                      type: Types.JobStepType;
                      status: Types.JobStepStatus;
                      childJobId: string | null;
                      weight: number;
                      completedUnits: number;
                      totalUnits: number;
                      message: string | null;
                      error: string | null;
                      startedAt: any;
                      endedAt: any;
                      children: Array<{
                        id: string;
                        jobId: string;
                        parentStepId: string | null;
                        key: string;
                        label: string;
                        order: number;
                        type: Types.JobStepType;
                        status: Types.JobStepStatus;
                        childJobId: string | null;
                        weight: number;
                        completedUnits: number;
                        totalUnits: number;
                        message: string | null;
                        error: string | null;
                        startedAt: any;
                        endedAt: any;
                        children: Array<{
                          id: string;
                          jobId: string;
                          parentStepId: string | null;
                          key: string;
                          label: string;
                          order: number;
                          type: Types.JobStepType;
                          status: Types.JobStepStatus;
                          childJobId: string | null;
                          weight: number;
                          completedUnits: number;
                          totalUnits: number;
                          message: string | null;
                          error: string | null;
                          startedAt: any;
                          endedAt: any;
                        }>;
                      }>;
                    }>;
                  } | null;
                }>;
              }>;
            }>;
          } | null;
        }>;
      }>;
      childJob: {
        summary: {
          jobId: string;
          overallPercent: number;
          stepsCompleted: number;
          stepsTotal: number;
          status: Types.JobEventType;
        };
        nodes: Array<{
          id: string;
          jobId: string;
          parentStepId: string | null;
          key: string;
          label: string;
          order: number;
          type: Types.JobStepType;
          status: Types.JobStepStatus;
          childJobId: string | null;
          weight: number;
          completedUnits: number;
          totalUnits: number;
          message: string | null;
          error: string | null;
          startedAt: any;
          endedAt: any;
          childJob: {
            summary: {
              jobId: string;
              overallPercent: number;
              stepsCompleted: number;
              stepsTotal: number;
              status: Types.JobEventType;
            };
            nodes: Array<{
              id: string;
              jobId: string;
              parentStepId: string | null;
              key: string;
              label: string;
              order: number;
              type: Types.JobStepType;
              status: Types.JobStepStatus;
              childJobId: string | null;
              weight: number;
              completedUnits: number;
              totalUnits: number;
              message: string | null;
              error: string | null;
              startedAt: any;
              endedAt: any;
              children: Array<{
                id: string;
                jobId: string;
                parentStepId: string | null;
                key: string;
                label: string;
                order: number;
                type: Types.JobStepType;
                status: Types.JobStepStatus;
                childJobId: string | null;
                weight: number;
                completedUnits: number;
                totalUnits: number;
                message: string | null;
                error: string | null;
                startedAt: any;
                endedAt: any;
                children: Array<{
                  id: string;
                  jobId: string;
                  parentStepId: string | null;
                  key: string;
                  label: string;
                  order: number;
                  type: Types.JobStepType;
                  status: Types.JobStepStatus;
                  childJobId: string | null;
                  weight: number;
                  completedUnits: number;
                  totalUnits: number;
                  message: string | null;
                  error: string | null;
                  startedAt: any;
                  endedAt: any;
                }>;
              }>;
            }>;
          } | null;
          children: Array<{
            id: string;
            jobId: string;
            parentStepId: string | null;
            key: string;
            label: string;
            order: number;
            type: Types.JobStepType;
            status: Types.JobStepStatus;
            childJobId: string | null;
            weight: number;
            completedUnits: number;
            totalUnits: number;
            message: string | null;
            error: string | null;
            startedAt: any;
            endedAt: any;
            childJob: {
              summary: {
                jobId: string;
                overallPercent: number;
                stepsCompleted: number;
                stepsTotal: number;
                status: Types.JobEventType;
              };
              nodes: Array<{
                id: string;
                jobId: string;
                parentStepId: string | null;
                key: string;
                label: string;
                order: number;
                type: Types.JobStepType;
                status: Types.JobStepStatus;
                childJobId: string | null;
                weight: number;
                completedUnits: number;
                totalUnits: number;
                message: string | null;
                error: string | null;
                startedAt: any;
                endedAt: any;
                children: Array<{
                  id: string;
                  jobId: string;
                  parentStepId: string | null;
                  key: string;
                  label: string;
                  order: number;
                  type: Types.JobStepType;
                  status: Types.JobStepStatus;
                  childJobId: string | null;
                  weight: number;
                  completedUnits: number;
                  totalUnits: number;
                  message: string | null;
                  error: string | null;
                  startedAt: any;
                  endedAt: any;
                  children: Array<{
                    id: string;
                    jobId: string;
                    parentStepId: string | null;
                    key: string;
                    label: string;
                    order: number;
                    type: Types.JobStepType;
                    status: Types.JobStepStatus;
                    childJobId: string | null;
                    weight: number;
                    completedUnits: number;
                    totalUnits: number;
                    message: string | null;
                    error: string | null;
                    startedAt: any;
                    endedAt: any;
                  }>;
                }>;
              }>;
            } | null;
            children: Array<{
              id: string;
              jobId: string;
              parentStepId: string | null;
              key: string;
              label: string;
              order: number;
              type: Types.JobStepType;
              status: Types.JobStepStatus;
              childJobId: string | null;
              weight: number;
              completedUnits: number;
              totalUnits: number;
              message: string | null;
              error: string | null;
              startedAt: any;
              endedAt: any;
              childJob: {
                summary: {
                  jobId: string;
                  overallPercent: number;
                  stepsCompleted: number;
                  stepsTotal: number;
                  status: Types.JobEventType;
                };
                nodes: Array<{
                  id: string;
                  jobId: string;
                  parentStepId: string | null;
                  key: string;
                  label: string;
                  order: number;
                  type: Types.JobStepType;
                  status: Types.JobStepStatus;
                  childJobId: string | null;
                  weight: number;
                  completedUnits: number;
                  totalUnits: number;
                  message: string | null;
                  error: string | null;
                  startedAt: any;
                  endedAt: any;
                  children: Array<{
                    id: string;
                    jobId: string;
                    parentStepId: string | null;
                    key: string;
                    label: string;
                    order: number;
                    type: Types.JobStepType;
                    status: Types.JobStepStatus;
                    childJobId: string | null;
                    weight: number;
                    completedUnits: number;
                    totalUnits: number;
                    message: string | null;
                    error: string | null;
                    startedAt: any;
                    endedAt: any;
                    children: Array<{
                      id: string;
                      jobId: string;
                      parentStepId: string | null;
                      key: string;
                      label: string;
                      order: number;
                      type: Types.JobStepType;
                      status: Types.JobStepStatus;
                      childJobId: string | null;
                      weight: number;
                      completedUnits: number;
                      totalUnits: number;
                      message: string | null;
                      error: string | null;
                      startedAt: any;
                      endedAt: any;
                    }>;
                  }>;
                }>;
              } | null;
            }>;
          }>;
        }>;
      } | null;
    }>;
  };
};

export type GetJobQueryVariables = Exact<{
  id: string;
}>;

export type GetJobQuery = {
  job: {
    id: string;
    jobType: Types.JobType;
    status: Types.JobEventType;
    createdAt: any;
    statusTime: any;
    parentId: string | null;
    retriedFromJobId: string | null;
    hasProgressTree: boolean;
    additionalInfo: any;
    createdBy: { fullName: string | null } | null;
    events: Array<{
      id: string;
      occuredAt: any;
      eventType: Types.JobEventType;
      message: string | null;
    }> | null;
    retriedAs: Array<{
      id: string;
      jobType: Types.JobType;
      status: Types.JobEventType;
      createdAt: any;
    }> | null;
  } | null;
};

export type GetDatasetVersionQueryVariables = Exact<{
  datasetVersionId?: string | null | undefined;
  name?: string | null | undefined;
}>;

export type GetDatasetVersionQuery = {
  datasetVersion: {
    id: string;
    name: string;
    versionNumber: number;
    description: string;
    startDate: any;
    dataset: { id: number; code: string; name: string };
    datasetVersionFields: Array<{
      fieldId: number;
      sequenceNumber: number | null;
      datasetVersion: { id: string };
    }> | null;
  };
};

export type CreateDatasetVersionMutationVariables = Exact<{
  createDatasetVersionInput: Types.CreateDatasetVersionInput;
}>;

export type CreateDatasetVersionMutation = {
  createDatasetVersion: {
    id: string;
    name: string;
    versionNumber: number;
    description: string;
    startDate: any;
  };
};

export type UpdateDatasetVersionMutationVariables = Exact<{
  updateDatasetVersionInput: Types.UpdateDatasetVersionInput;
}>;

export type UpdateDatasetVersionMutation = { updateDatasetVersion: boolean };

export type SyncRoleRowLevelSecurityMutationVariables = Exact<{
  roleId: string;
}>;

export type SyncRoleRowLevelSecurityMutation = {
  syncRoleRowLevelSecurity: boolean;
};

export type SyncTenantRowLevelSecurityMutationVariables = Exact<{
  tenantId: string;
}>;

export type SyncTenantRowLevelSecurityMutation = {
  syncTenantRowLevelSecurity: boolean;
};

export type SyncUserRowLevelSecurityMutationVariables = Exact<{
  userId: string;
}>;

export type SyncUserRowLevelSecurityMutation = {
  syncUserRowLevelSecurity: boolean;
};

export type CreateRiskAuditTrailMutationVariables = Exact<{
  input: Types.RiskAuditTrailInput;
}>;

export type CreateRiskAuditTrailMutation = {
  createRiskAuditTrail: {
    id: string;
    version: number;
    notes: string;
    status: Types.RiskAuditTrailStatus;
    latestStudyOnRecord: boolean;
    updateAt: any;
    updateBy: {
      fullName: string | null;
      title: string | null;
      firstName: string;
      lastName: string;
    } | null;
  };
};

export type GetLatestJobsQueryVariables = Exact<{
  input: Types.FindLatestJobsInput;
}>;

export type GetLatestJobsQuery = {
  latestJobs: Array<{
    id: string;
    jobType: Types.JobType;
    status: Types.JobEventType;
    createdAt: any;
    statusTime: any;
    events: Array<{
      eventType: Types.JobEventType;
      message: string | null;
    }> | null;
  }>;
};

export type GetSubmissionPresentationsQueryVariables = Exact<{
  quarters: Array<string> | string;
}>;

export type GetSubmissionPresentationsQuery = {
  submissionPresentations: Array<{
    id: string;
    quarter: string;
    careEntityId: string;
    tenantId: string;
    presentation: {
      id: string;
      name: string;
      diseaseStateModuleId: number | null;
      latestJob: {
        id: string;
        status: Types.JobEventType;
        statusTime: any;
      } | null;
    } | null;
  }>;
};

export type GetPresentationsQueryVariables = Exact<{
  ids?: Array<string> | string | null | undefined;
  tenantId?: string | null | undefined;
}>;

export type GetPresentationsQuery = {
  presentations: Array<{
    id: string;
    name: string;
    description: string;
    tenantId: string;
    diseaseStateModuleId: number | null;
    presentationType: Types.PresentationType | null;
    imagesRefreshedAt: any;
    createdAt: any;
    updateAt: any;
    clonesGenerated: number;
    cropConfig: any;
    clonedFor: Array<string> | null;
    deletedAt: any;
    tenant: { id: string; code: string; name: string };
    refreshJob: { id: string; additionalInfo: any } | null;
    latestJob: { id: string; status: Types.JobEventType } | null;
    slides: Array<{
      id: string;
      title: string;
      subtitle: string | null;
      shareableLink: string | null;
      slideType: Types.SlideType;
      imageStatus: Types.SlideImageStatus;
      order: number;
      imageFetchedAt: any;
      isNative: boolean | null;
      defaultCropConfig: boolean;
      image: { id: string; url: string } | null;
      imageConfig: {
        height: number | null;
        width: number | null;
        x: number | null;
        y: number | null;
      } | null;
      configuredDashboard: { id: number; name: string } | null;
    }> | null;
    createdBy: { id: string; fullName: string | null } | null;
  }>;
};

export type GetPresentationQueryVariables = Exact<{
  presentationId: string;
}>;

export type GetPresentationQuery = {
  presentation: {
    id: string;
    name: string;
    description: string;
    tenantId: string;
    diseaseStateModuleId: number | null;
    presentationType: Types.PresentationType | null;
    imagesRefreshedAt: any;
    createdAt: any;
    updateAt: any;
    clonesGenerated: number;
    cropConfig: any;
    clonedFor: Array<string> | null;
    deletedAt: any;
    tenant: { id: string; code: string; name: string };
    refreshJob: { id: string; additionalInfo: any } | null;
    latestJob: { id: string; status: Types.JobEventType } | null;
    slides: Array<{
      id: string;
      title: string;
      subtitle: string | null;
      shareableLink: string | null;
      slideType: Types.SlideType;
      imageStatus: Types.SlideImageStatus;
      order: number;
      imageFetchedAt: any;
      isNative: boolean | null;
      defaultCropConfig: boolean;
      image: { id: string; url: string } | null;
      imageConfig: {
        height: number | null;
        width: number | null;
        x: number | null;
        y: number | null;
      } | null;
      configuredDashboard: { id: number; name: string } | null;
    }> | null;
    createdBy: { id: string; fullName: string | null } | null;
  };
};

export type CreatePresentationMutationVariables = Exact<{
  input: Types.CreatePresentationInput;
}>;

export type CreatePresentationMutation = {
  createPresentation: {
    id: string;
    name: string;
    description: string;
    tenantId: string;
    diseaseStateModuleId: number | null;
    presentationType: Types.PresentationType | null;
    imagesRefreshedAt: any;
    createdAt: any;
    updateAt: any;
    clonesGenerated: number;
    cropConfig: any;
    clonedFor: Array<string> | null;
    deletedAt: any;
    tenant: { id: string; code: string; name: string };
    refreshJob: { id: string; additionalInfo: any } | null;
    latestJob: { id: string; status: Types.JobEventType } | null;
    slides: Array<{
      id: string;
      title: string;
      subtitle: string | null;
      shareableLink: string | null;
      slideType: Types.SlideType;
      imageStatus: Types.SlideImageStatus;
      order: number;
      imageFetchedAt: any;
      isNative: boolean | null;
      defaultCropConfig: boolean;
      image: { id: string; url: string } | null;
      imageConfig: {
        height: number | null;
        width: number | null;
        x: number | null;
        y: number | null;
      } | null;
      configuredDashboard: { id: number; name: string } | null;
    }> | null;
    createdBy: { id: string; fullName: string | null } | null;
  };
};

export type ClonePresentationForSubmissionMutationVariables = Exact<{
  input: Types.CreatePresentationSubmissionInput;
  useCompleteData?: boolean | null | undefined;
  dashboardEntityIds?: Array<string> | string | null | undefined;
}>;

export type ClonePresentationForSubmissionMutation = {
  clonePresentationForSubmission: boolean;
};

export type UpdatePresentationMutationVariables = Exact<{
  input: Types.UpdatePresentationInput;
}>;

export type UpdatePresentationMutation = { updatePresentation: boolean };

export type DeletePresentationMutationVariables = Exact<{
  deletePresentationId: string;
}>;

export type DeletePresentationMutation = { deletePresentation: boolean };

export type SoftDeletePresentationMutationVariables = Exact<{
  presentationId: string;
}>;

export type SoftDeletePresentationMutation = {
  softDeletePresentation: boolean;
};

export type RestorePresentationMutationVariables = Exact<{
  presentationId: string;
}>;

export type RestorePresentationMutation = { restorePresentation: boolean };

export type CreateSlideMutationVariables = Exact<{
  input: Types.CreateSlideInput;
}>;

export type CreateSlideMutation = {
  createSlide: {
    id: string;
    title: string;
    subtitle: string | null;
    shareableLink: string | null;
    slideType: Types.SlideType;
    imageStatus: Types.SlideImageStatus;
    order: number;
    imageFetchedAt: any;
    isNative: boolean | null;
    defaultCropConfig: boolean;
    configuredDashboard: { name: string; id: number } | null;
    imageConfig: {
      width: number | null;
      height: number | null;
      x: number | null;
      y: number | null;
    } | null;
    presentation: { id: string; name: string; tenantId: string };
    image: { id: string; url: string } | null;
  };
};

export type UpdateSlidesMutationVariables = Exact<{
  presentationId: string;
  inputs: Array<Types.UpdateSlideInput> | Types.UpdateSlideInput;
}>;

export type UpdateSlidesMutation = { updateSlides: boolean };

export type BulkGenerateSlidesMutationVariables = Exact<{
  presentationId: string;
  slidesConfig: Array<Types.BulkSlidesInput> | Types.BulkSlidesInput;
  timezone?: string | null | undefined;
}>;

export type BulkGenerateSlidesMutation = { bulkGenerateSlides: boolean };

export type DeleteSlidesMutationVariables = Exact<{
  deleteSlideIds: Array<string> | string;
  presentationId: string;
}>;

export type DeleteSlidesMutation = { deleteSlides: boolean };

export type ClonePresentationMutationVariables = Exact<{
  presentationId: string;
  name: string;
  inputs: Array<Types.PresentationCloneInput> | Types.PresentationCloneInput;
  useCompleteData?: boolean | null | undefined;
  timezone?: string | null | undefined;
  quarters?: Array<string> | string | null | undefined;
  procedure?:
    Array<Types.ProcedureInput> | Types.ProcedureInput | null | undefined;
}>;

export type ClonePresentationMutation = { clonePresentation: boolean };

export type RefreshPresentationImagesMutationVariables = Exact<{
  presentationId: string;
  slideIds?: Array<string> | string | null | undefined;
  useCompleteData?: boolean | null | undefined;
  timezone?: string | null | undefined;
  missingSlidesOnly?: boolean | null | undefined;
}>;

export type RefreshPresentationImagesMutation = {
  refreshPresentationImages: boolean;
};

export type GetDictionariesQueryVariables = Exact<{ [key: string]: never }>;

export type GetDictionariesQuery = {
  dictionaries: Array<{
    id: string;
    version: string;
    type: Types.DictionaryType;
    dataset: { id: number; code: string; name: string };
  }>;
};

export type GetDictionaryQueryVariables = Exact<{
  dictionaryId: string;
}>;

export type GetDictionaryQuery = {
  dictionary: {
    id: string;
    version: string;
    type: Types.DictionaryType;
    dataset: { id: number; code: string; name: string };
    sections: Array<{
      elements: Array<{
        id: string;
        elementReference: string;
        shortName: string;
        name: string;
        code: string | null;
        codingInstructions: string | null;
        targetValue: string | null;
        definition: { definition: string } | null;
        section: { sectionDisplayName: string };
        parentChildValidations: Array<{
          id: string;
          parent: { id: string; shortName: string };
        }> | null;
        sourceMappings: Array<{
          id: string;
          target: { id: string; shortName: string } | null;
        }> | null;
        referenceTransformations: Array<{
          id: string;
          translation: {
            id: string;
            target: { id: string; shortName: string } | null;
          };
        }> | null;
        derivativeTransformations: Array<{
          id: string;
          translation: {
            id: string;
            target: { id: string; shortName: string } | null;
          };
        }> | null;
      }>;
    }> | null;
  };
};

export type GetSrogQueryVariables = Exact<{
  careEntityCode: string;
  dsmCode?: string | null | undefined;
  searchText?: string | null | undefined;
  filter?: Types.SrogFilter | null | undefined;
  limit?: number | null | undefined;
  offset?: number | null | undefined;
}>;

export type GetSrogQuery = {
  srog: {
    Strength: Array<{
      measureId: number | null;
      name: string;
      hospital: string;
      registry: string;
      cohortId: number | null;
      srogStrength: number | null;
      trendToUse: Types.OpportunityTrend | null;
      atBestPerformance: boolean | null;
      numerator: number | null;
      numeratorIfBest: number | null;
      averageROI: number | null;
      bestROI: number | null;
      srogBucket: Types.SrogBucket;
      systemSortOrder: number | null;
      totalChildCareEntities: number | null;
      dimType: Types.DimType;
      cohortName: string | null;
      aggregated: boolean | null;
      opportunities: Array<{
        at: number;
        numerator: number | null;
        performance: boolean | null;
        roi: number | null;
        summedRoi: number | null;
        los: number | null;
        distanceFrom: number | null;
      }> | null;
    }>;
    Regression: Array<{
      measureId: number | null;
      name: string;
      hospital: string;
      registry: string;
      cohortId: number | null;
      srogStrength: number | null;
      trendToUse: Types.OpportunityTrend | null;
      atBestPerformance: boolean | null;
      numerator: number | null;
      numeratorIfBest: number | null;
      averageROI: number | null;
      bestROI: number | null;
      srogBucket: Types.SrogBucket;
      rareEvent: number | null;
      systemSortOrder: number | null;
      totalChildCareEntities: number | null;
      dimType: Types.DimType;
      cohortName: string | null;
      aggregated: boolean | null;
      opportunities: Array<{
        at: number;
        numerator: number | null;
        performance: boolean | null;
        roi: number | null;
        summedRoi: number | null;
        los: number | null;
        distanceFrom: number | null;
      }> | null;
    }>;
    Opportunity: Array<{
      measureId: number | null;
      name: string;
      hospital: string;
      registry: string;
      cohortId: number | null;
      srogStrength: number | null;
      trendToUse: Types.OpportunityTrend | null;
      atBestPerformance: boolean | null;
      numerator: number | null;
      numeratorIfBest: number | null;
      averageROI: number | null;
      bestROI: number | null;
      srogBucket: Types.SrogBucket;
      rareEvent: number | null;
      systemSortOrder: number | null;
      totalChildCareEntities: number | null;
      dimType: Types.DimType;
      cohortName: string | null;
      aggregated: boolean | null;
      opportunities: Array<{
        at: number;
        numerator: number | null;
        performance: boolean | null;
        roi: number | null;
        summedRoi: number | null;
        los: number | null;
        distanceFrom: number | null;
      }> | null;
    }>;
    Gain: Array<{
      measureId: number | null;
      name: string;
      hospital: string;
      registry: string;
      cohortId: number | null;
      srogStrength: number | null;
      trendToUse: Types.OpportunityTrend | null;
      atBestPerformance: boolean | null;
      numerator: number | null;
      numeratorIfBest: number | null;
      averageROI: number | null;
      bestROI: number | null;
      srogBucket: Types.SrogBucket;
      rareEvent: number | null;
      systemSortOrder: number | null;
      totalChildCareEntities: number | null;
      dimType: Types.DimType;
      cohortName: string | null;
      aggregated: boolean | null;
      opportunities: Array<{
        at: number;
        numerator: number | null;
        performance: boolean | null;
        roi: number | null;
        summedRoi: number | null;
        los: number | null;
        distanceFrom: number | null;
      }> | null;
    }>;
  };
};

export type GetMeasuresQueryVariables = Exact<{ [key: string]: never }>;

export type GetMeasuresQuery = {
  measuresMetadata: Array<{
    id: number;
    name: string;
    description: string | null;
    ncdrMeasureName: string | null;
    registryMeasureId: number | null;
    validationSource: string | null;
    benchmarkExtraction: boolean;
    reportRowId: number | null;
    numeratorUnit: string;
    opportunityType: Array<Types.OpportunityType>;
    publicationSource: Array<Types.PublicationSource> | null;
    accessCategory: Types.AccessCategory;
    rareEvent: boolean;
    summaryInitiativeMeasure: boolean;
    commonMeasureDisplayName: string;
    createdAt: any;
    updateAt: any;
    diseaseStateModule: { id: number; name: string };
    createdBy: { id: string; fullName: string | null } | null;
    updateBy: { id: string; fullName: string | null } | null;
  }>;
};

export type GetPipelineElementsQueryVariables = Exact<{
  ids?: Array<string> | string | null | undefined;
}>;

export type GetPipelineElementsQuery = {
  pipelineElements: Array<{
    id: string;
    documentation: any;
    biomeDictionaryElements: Array<{ id: string }>;
  }>;
};

export type GetElementsQueryVariables = Exact<{
  ids?: Array<string> | string | null | undefined;
}>;

export type GetElementsQuery = {
  elements: Array<{
    id: string;
    shortName: string;
    targetMappings: Array<{
      id: string;
      source: {
        id: string;
        shortName: string;
        name: string;
        elementReference: string;
        section: { id: string; dictionary: { id: string } };
      } | null;
      transformation: {
        id: string;
        referenceCode: string;
        reference: {
          id: string;
          shortName: string;
          name: string;
          elementReference: string;
          section: { id: string; dictionary: { id: string } };
        } | null;
        derivative: {
          id: string;
          shortName: string;
          name: string;
          elementReference: string;
          section: { id: string; dictionary: { id: string } };
        } | null;
      } | null;
    }> | null;
  }>;
};

export type SearchDictionaryElementsQueryVariables = Exact<{
  dictionaryId: string;
  keyword: string;
}>;

export type SearchDictionaryElementsQuery = { searchElements: Array<string> };

export type GetCitationMeasureQueryVariables = Exact<{
  measureId: number;
}>;

export type GetCitationMeasureQuery = {
  measureMetadata: { id: number; name: string; summaryCohortId: number | null };
};

export type GetCitationDimensionQueryVariables = Exact<{
  dimensionId: number;
}>;

export type GetCitationDimensionQuery = {
  dimension: { id: number; kbFieldId: number | null };
};

export type GetMeasureMetadataQueryVariables = Exact<{
  measureId: number;
}>;

export type GetMeasureMetadataQuery = {
  measureMetadata: {
    id: number;
    version: string | null;
    name: string;
    ncdrMeasureName: string | null;
    registryMeasureId: number | null;
    validationSource: string | null;
    benchmarkExtraction: boolean;
    reportRowId: number | null;
    description: string | null;
    numeratorUnit: string;
    accessCategory: Types.AccessCategory;
    opportunityType: Array<Types.OpportunityType>;
    publicationSource: Array<Types.PublicationSource> | null;
    commonMeasureDisplayName: string;
    summaryInitiativeMeasure: boolean;
    rareEvent: boolean;
    tableName: string | null;
    requirements: string | null;
    testCapture: string | null;
    volumeMeasure: boolean | null;
    annualMeasureBaseId: string | null;
    isBenchmark: boolean | null;
    summaryCohortId: number | null;
    excludedCohortIds: Array<number> | null;
    unit: string | null;
    numeratorColumnName: string | null;
    numeratorLegacyDescription: string | null;
    denominatorLegacyDescription: string | null;
    includeColumnName: string | null;
    denominatorColumnName: string | null;
    riskAdjusted: boolean;
    aggregationFn: Array<string> | null;
    aggregationType: Types.SummaryCalculationType | null;
    outcomeType: Types.MeasureOutcomeType | null;
    roiCalcType: Types.SummaryCalculationType | null;
    higherIsBetter: boolean | null;
    dataTypeRequired: Types.MeasureInputDataType | null;
    losROIQualifying: boolean | null;
    adjustment: Array<string> | null;
    commonMeasureQualifying: boolean | null;
    costComponentMeasure: boolean | null;
    createdAt: any;
    updateAt: any;
    history: Array<{ version: string | null; updateAt: any }>;
    numeratorPipelineElement: { id: string } | null;
    includePipelineElement: { id: string } | null;
    denominatorPipelineElement: { id: string } | null;
    riskMetric: { id: string; columnName: string; displayName: string } | null;
    riskMetricPipelineElement: { id: string } | null;
    subjects: Array<{
      id: string;
      link: Types.MeasureLinkType;
      processMeasure: boolean;
      objectMeasure: { id: number; name: string };
    }> | null;
    objects: Array<{
      id: string;
      link: Types.MeasureLinkType;
      processMeasure: boolean;
      subjectMeasure: { id: number; name: string };
    }> | null;
    roiMetrics: Array<{ id: string; fieldName: string; label: string }> | null;
    diseaseStateModule: { id: number; name: string };
    parent: { id: number; name: string } | null;
    children: Array<{
      id: number;
      name: string;
      opportunityType: Array<Types.OpportunityType>;
      commonMeasureDisplayName: string;
      publicationSource: Array<Types.PublicationSource> | null;
      diseaseStateModule: { id: number; name: string };
    }> | null;
    createdBy: { id: string; fullName: string | null } | null;
    updateBy: { id: string; fullName: string | null } | null;
    tableauViews: Array<{
      isPrimary: boolean;
      tableauView: { id: number; name: string };
    }> | null;
  };
};

export type UpdateMeasureMetaDataMutationVariables = Exact<{
  updateMeasureMetadataInput: Types.UpdateMeasureMetadataInput;
}>;

export type UpdateMeasureMetaDataMutation = {
  updateMeasureMetadata: {
    id: number;
    version: string | null;
    name: string;
    ncdrMeasureName: string | null;
    registryMeasureId: number | null;
    validationSource: string | null;
    benchmarkExtraction: boolean;
    reportRowId: number | null;
    description: string | null;
    numeratorUnit: string;
    accessCategory: Types.AccessCategory;
    opportunityType: Array<Types.OpportunityType>;
    publicationSource: Array<Types.PublicationSource> | null;
    commonMeasureDisplayName: string;
    summaryInitiativeMeasure: boolean;
    rareEvent: boolean;
    tableName: string | null;
    requirements: string | null;
    testCapture: string | null;
    volumeMeasure: boolean | null;
    annualMeasureBaseId: string | null;
    isBenchmark: boolean | null;
    summaryCohortId: number | null;
    excludedCohortIds: Array<number> | null;
    unit: string | null;
    numeratorColumnName: string | null;
    includeColumnName: string | null;
    denominatorColumnName: string | null;
    riskAdjusted: boolean;
    aggregationFn: Array<string> | null;
    aggregationType: Types.SummaryCalculationType | null;
    outcomeType: Types.MeasureOutcomeType | null;
    roiCalcType: Types.SummaryCalculationType | null;
    higherIsBetter: boolean | null;
    dataTypeRequired: Types.MeasureInputDataType | null;
    losROIQualifying: boolean | null;
    adjustment: Array<string> | null;
    commonMeasureQualifying: boolean | null;
    costComponentMeasure: boolean | null;
    createdAt: any;
    updateAt: any;
    numeratorPipelineElement: { id: string } | null;
    includePipelineElement: { id: string } | null;
    denominatorPipelineElement: { id: string } | null;
    riskMetric: { id: string; columnName: string; displayName: string } | null;
    riskMetricPipelineElement: { id: string } | null;
    subjects: Array<{ id: string }> | null;
    objects: Array<{ id: string }> | null;
    roiMetrics: Array<{ id: string; fieldName: string }> | null;
    diseaseStateModule: { id: number; name: string };
    createdBy: { id: string; fullName: string | null } | null;
    updateBy: { id: string; fullName: string | null } | null;
    tableauViews: Array<{
      isPrimary: boolean;
      tableauView: { id: number; name: string };
    }> | null;
  };
};

export type CreateMeasureMetadataMutationVariables = Exact<{
  createMeasureMetadataInput: Types.CreateMeasureMetadataInput;
}>;

export type CreateMeasureMetadataMutation = {
  createMeasureMetadata: {
    id: number;
    version: string | null;
    name: string;
    ncdrMeasureName: string | null;
    registryMeasureId: number | null;
    validationSource: string | null;
    benchmarkExtraction: boolean;
    reportRowId: number | null;
    description: string | null;
    numeratorUnit: string;
    accessCategory: Types.AccessCategory;
    opportunityType: Array<Types.OpportunityType>;
    publicationSource: Array<Types.PublicationSource> | null;
    commonMeasureDisplayName: string;
    summaryInitiativeMeasure: boolean;
    rareEvent: boolean;
    tableName: string | null;
    requirements: string | null;
    testCapture: string | null;
    volumeMeasure: boolean | null;
    annualMeasureBaseId: string | null;
    isBenchmark: boolean | null;
    summaryCohortId: number | null;
    excludedCohortIds: Array<number> | null;
    unit: string | null;
    numeratorColumnName: string | null;
    includeColumnName: string | null;
    denominatorColumnName: string | null;
    riskAdjusted: boolean;
    aggregationFn: Array<string> | null;
    aggregationType: Types.SummaryCalculationType | null;
    outcomeType: Types.MeasureOutcomeType | null;
    roiCalcType: Types.SummaryCalculationType | null;
    higherIsBetter: boolean | null;
    dataTypeRequired: Types.MeasureInputDataType | null;
    losROIQualifying: boolean | null;
    adjustment: Array<string> | null;
    commonMeasureQualifying: boolean | null;
    costComponentMeasure: boolean | null;
    createdAt: any;
    updateAt: any;
    numeratorPipelineElement: { id: string } | null;
    includePipelineElement: { id: string } | null;
    denominatorPipelineElement: { id: string } | null;
    riskMetric: { id: string; columnName: string; displayName: string } | null;
    riskMetricPipelineElement: { id: string } | null;
    subjects: Array<{
      id: string;
      link: Types.MeasureLinkType;
      processMeasure: boolean;
      objectMeasure: { id: number; name: string };
    }> | null;
    objects: Array<{
      id: string;
      link: Types.MeasureLinkType;
      processMeasure: boolean;
      subjectMeasure: { id: number; name: string };
    }> | null;
    roiMetrics: Array<{ id: string; fieldName: string }> | null;
    diseaseStateModule: { id: number; name: string };
    createdBy: { id: string; fullName: string | null } | null;
    updateBy: { id: string; fullName: string | null } | null;
    tableauViews: Array<{
      isPrimary: boolean;
      tableauView: { id: number; name: string };
    }> | null;
  };
};

export type GetDimensionSetsByMeasureIdQueryVariables = Exact<{
  measureId: number;
}>;

export type GetDimensionSetsByMeasureIdQuery = {
  dimensionSetsByMeasureId: Array<{
    id: string;
    dimensions: Array<{ id: number; fieldName: string; label: string }>;
  }>;
};

export type GetDimensionListQueryVariables = Exact<{ [key: string]: never }>;

export type GetDimensionListQuery = {
  dimensions: Array<{
    id: number;
    fieldName: string;
    label: string;
    valueMap: any;
    excludeValues: Array<string> | null;
    allMeasures: boolean;
    isGlobal: boolean;
    sourceContinuousField: string | null;
    type: Types.DimensionType;
    priority: number | null;
    class: string;
    oeQualifying: boolean;
    aeQualifying: boolean;
    sortOrder: number;
    sortType: Types.SortType;
    createdAt: any;
    updateAt: any;
    diseaseStateModule: { id: number; code: string; name: string };
    pipelineElement: { id: string } | null;
  }>;
};

export type GetDimensionQueryVariables = Exact<{
  dimensionId: number;
}>;

export type GetDimensionQuery = {
  dimension: {
    id: number;
    version: string | null;
    fieldName: string;
    label: string;
    valueMap: any;
    excludeValues: Array<string> | null;
    allMeasures: boolean;
    isGlobal: boolean;
    sourceContinuousField: string | null;
    type: Types.DimensionType;
    priority: number | null;
    class: string;
    multiProcTableId: string | null;
    oeQualifying: boolean;
    aeQualifying: boolean;
    sortOrder: number;
    sortType: Types.SortType;
    description: string | null;
    requirements: string | null;
    createdAt: any;
    updateAt: any;
    multiProcTable: { id: string; tableName: string } | null;
    dimensionValueSortOrder: Array<{
      id: string;
      valueLabel: string;
      sortOrder: number;
    }> | null;
    diseaseStateModule: { id: number; code: string; name: string };
    pipelineElement: { id: string } | null;
    createdBy: { id: string; fullName: string | null } | null;
    updateBy: { id: string; fullName: string | null } | null;
  };
};

export type GetRoiMetricListQueryVariables = Exact<{ [key: string]: never }>;

export type GetRoiMetricListQuery = {
  roiMetrics: Array<{
    id: string;
    version: string | null;
    fieldName: string;
    label: string;
    higherIsBetter: boolean;
    createdAt: any;
    updateAt: any;
    diseaseStateModule: { id: number; code: string; name: string };
    pipelineElement: { id: string } | null;
    createdBy: { id: string; fullName: string | null } | null;
    updateBy: { id: string; fullName: string | null } | null;
  }>;
};

export type GetRoiMetricQueryVariables = Exact<{
  roiMetricId: string;
}>;

export type GetRoiMetricQuery = {
  roiMetric: {
    id: string;
    version: string | null;
    fieldName: string;
    label: string;
    higherIsBetter: boolean;
    createdAt: any;
    updateAt: any;
    diseaseStateModule: { id: number; code: string; name: string };
    pipelineElement: { id: string } | null;
    createdBy: { id: string; fullName: string | null } | null;
    updateBy: { id: string; fullName: string | null } | null;
  };
};

export type GetGridViewsQueryVariables = Exact<{
  gridId: string;
}>;

export type GetGridViewsQuery = {
  getGridViews: Array<{
    id: string;
    name: string;
    filterModel: any;
    columnModel: any;
    externalFilters: any;
    scope: Types.Scope;
    tenantId: string | null;
    userId: string | null;
    gridId: string;
    moduleId: string | null;
    careEntityId: string | null;
    default: boolean;
    updatedAt: any;
  }>;
};

export type GetGridViewQueryVariables = Exact<{
  id: string;
}>;

export type GetGridViewQuery = {
  getGridView: {
    id: string;
    name: string;
    filterModel: any;
    columnModel: any;
    externalFilters: any;
    scope: Types.Scope;
    tenantId: string | null;
    userId: string | null;
    gridId: string;
    moduleId: string | null;
    careEntityId: string | null;
    default: boolean;
    updatedAt: any;
  } | null;
};

export type CreateGridViewMutationVariables = Exact<{
  createGridViewInput: Types.CreateGridViewInput;
}>;

export type CreateGridViewMutation = {
  createGridView: {
    id: string;
    name: string;
    filterModel: any;
    columnModel: any;
    externalFilters: any;
    scope: Types.Scope;
    tenantId: string | null;
    userId: string | null;
    gridId: string;
    moduleId: string | null;
    careEntityId: string | null;
    default: boolean;
    updatedAt: any;
  };
};

export type UpdateGridViewMutationVariables = Exact<{
  updateGridViewInput: Types.UpdateGridViewInput;
}>;

export type UpdateGridViewMutation = {
  updateGridView: {
    id: string;
    name: string;
    filterModel: any;
    columnModel: any;
    externalFilters: any;
    scope: Types.Scope;
    tenantId: string | null;
    userId: string | null;
    gridId: string;
    moduleId: string | null;
    careEntityId: string | null;
    default: boolean;
    updatedAt: any;
  };
};

export type CloneGridViewMutationVariables = Exact<{
  id: string;
}>;

export type CloneGridViewMutation = {
  cloneGridView: {
    id: string;
    name: string;
    filterModel: any;
    columnModel: any;
    externalFilters: any;
    scope: Types.Scope;
    tenantId: string | null;
    userId: string | null;
    gridId: string;
    moduleId: string | null;
    careEntityId: string | null;
    default: boolean;
    updatedAt: any;
  };
};

export type RemoveGridViewMutationVariables = Exact<{
  id: string;
}>;

export type RemoveGridViewMutation = { removeGridView: boolean };

export type GetQuestionDetailsQueryVariables = Exact<{
  question: string;
}>;

export type GetQuestionDetailsQuery = { questionDetails: Array<string> };

export type GetCategorizedMeasuresQueryVariables = Exact<{
  question: string;
  details: Array<string> | string;
}>;

export type GetCategorizedMeasuresQuery = {
  categorizedMeasures: Array<{
    measureId: number;
    name: string;
    description: string;
    dsm: string;
    reasoning: string;
    alignmentStrength: string;
    alignmentStrengthCode: number;
  }>;
};

export type CreateDimensionMutationVariables = Exact<{
  createDimensionInput: Types.CreateDimensionInput;
}>;

export type CreateDimensionMutation = {
  createDimension: {
    id: number;
    version: string | null;
    fieldName: string;
    label: string;
    valueMap: any;
    excludeValues: Array<string> | null;
    allMeasures: boolean;
    isGlobal: boolean;
    sourceContinuousField: string | null;
    type: Types.DimensionType;
    priority: number | null;
    class: string;
    multiProcTableId: string | null;
    oeQualifying: boolean;
    aeQualifying: boolean;
    sortOrder: number;
    sortType: Types.SortType;
    description: string | null;
    requirements: string | null;
    createdAt: any;
    updateAt: any;
    multiProcTable: { id: string; tableName: string } | null;
    dimensionValueSortOrder: Array<{
      id: string;
      valueLabel: string;
      sortOrder: number;
    }> | null;
    diseaseStateModule: { id: number; code: string; name: string };
    pipelineElement: { id: string } | null;
    createdBy: { id: string; fullName: string | null } | null;
    updateBy: { id: string; fullName: string | null } | null;
  };
};

export type UpdateDimensionMutationVariables = Exact<{
  updateDimensionInput: Types.UpdateDimensionInput;
}>;

export type UpdateDimensionMutation = {
  updateDimension: {
    id: number;
    fieldName: string;
    label: string;
    valueMap: any;
    excludeValues: Array<string> | null;
    allMeasures: boolean;
    isGlobal: boolean;
    sourceContinuousField: string | null;
    type: Types.DimensionType;
    priority: number | null;
    class: string;
    multiProcTableId: string | null;
    oeQualifying: boolean;
    aeQualifying: boolean;
    sortOrder: number;
    sortType: Types.SortType;
    description: string | null;
    requirements: string | null;
    createdAt: any;
    updateAt: any;
    multiProcTable: { id: string; tableName: string } | null;
    dimensionValueSortOrder: Array<{
      id: string;
      valueLabel: string;
      sortOrder: number;
    }> | null;
    diseaseStateModule: { id: number; code: string; name: string };
    pipelineElement: { id: string } | null;
    updateBy: { id: string; fullName: string | null } | null;
  };
};

export type RemoveDimensionMutationVariables = Exact<{
  dimensionId: number;
}>;

export type RemoveDimensionMutation = { removeDimension: boolean };

export type CreateRoiMetricMutationVariables = Exact<{
  createRoiMetricInput: Types.CreateRoiMetricInput;
}>;

export type CreateRoiMetricMutation = {
  createRoiMetric: {
    id: string;
    version: string | null;
    fieldName: string;
    label: string;
    higherIsBetter: boolean;
    createdAt: any;
    updateAt: any;
    diseaseStateModule: { id: number; code: string; name: string };
    pipelineElement: { id: string } | null;
    createdBy: { id: string; fullName: string | null } | null;
    updateBy: { id: string; fullName: string | null } | null;
  };
};

export type UpdateRoiMetricMutationVariables = Exact<{
  updateRoiMetricInput: Types.UpdateRoiMetricInput;
}>;

export type UpdateRoiMetricMutation = {
  updateRoiMetric: {
    id: string;
    version: string | null;
    fieldName: string;
    label: string;
    higherIsBetter: boolean;
    createdAt: any;
    updateAt: any;
    diseaseStateModule: { id: number; code: string; name: string };
    pipelineElement: { id: string } | null;
    createdBy: { id: string; fullName: string | null } | null;
    updateBy: { id: string; fullName: string | null } | null;
  };
};

export type RemoveRoiMetricMutationVariables = Exact<{
  roiMetricId: string;
}>;

export type RemoveRoiMetricMutation = { removeRoiMetric: boolean };

export type GetAttributesCriteriaQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetAttributesCriteriaQuery = {
  attributesCriteria: Array<{
    dsm: string | null;
    attribute: string;
    description: string;
    source: string;
    criteria: string;
  }>;
};

export type GetPatientListFieldsQueryVariables = Exact<{
  patientListType: string;
}>;

export type GetPatientListFieldsQuery = {
  patientListFields: Array<{
    id: string;
    createdAt: any;
    updateAt: any;
    createdById: string;
    updateById: string;
    name: string;
    displayName: string;
    displayRank: number;
    description: string | null;
    type: string;
    phi: boolean;
    visibility: Types.VisibilityType;
    patientListType: Types.PatientListType;
  }>;
};

export type GetEchoFollowupOptionsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetEchoFollowupOptionsQuery = {
  echoFollowupOptions: Array<{
    id: string;
    createdAt: any;
    updateAt: any;
    updateById: string;
    name: string;
    displayName: string;
    displayRank: number;
    category: string | null;
    isDefault: boolean;
    scope: Types.FollowupOptionScope;
    hide: boolean;
    createdBy: { id: string; fullName: string | null } | null;
    tenant: { id: string; name: string } | null;
    caselistModule: { id: string; name: string; displayName: string };
    careEntities: Array<{
      id: string;
      name: string;
      code: string;
      description: string;
    }> | null;
  }>;
};

export type GetEchoFollowupOptionQueryVariables = Exact<{
  id: string;
}>;

export type GetEchoFollowupOptionQuery = {
  echoFollowupOption: {
    id: string;
    createdAt: any;
    updateAt: any;
    updateById: string;
    name: string;
    displayName: string;
    category: string | null;
    displayRank: number;
    isDefault: boolean;
    scope: Types.FollowupOptionScope;
    hide: boolean;
    createdBy: { id: string; fullName: string | null } | null;
    tenant: { id: string; name: string } | null;
    caselistModule: { id: string; name: string; displayName: string };
    careEntities: Array<{
      id: string;
      name: string;
      code: string;
      description: string;
    }> | null;
  };
};

export type CreateEchoFollowupOptionMutationVariables = Exact<{
  input: Types.EchoFollowupOptionInput;
}>;

export type CreateEchoFollowupOptionMutation = {
  createEchoFollowupOption: {
    id: string;
    createdAt: any;
    updateAt: any;
    updateById: string;
    name: string;
    displayName: string;
    category: string | null;
    displayRank: number;
    isDefault: boolean;
    scope: Types.FollowupOptionScope;
    hide: boolean;
    createdBy: { id: string; fullName: string | null } | null;
    tenant: { id: string; name: string } | null;
    caselistModule: { id: string; name: string; displayName: string };
    careEntities: Array<{
      id: string;
      name: string;
      code: string;
      description: string;
    }> | null;
  };
};

export type UpdateEchoFollowupOptionsMutationVariables = Exact<{
  inputs:
    | Array<Types.UpdateEchoFollowupOptionInput>
    | Types.UpdateEchoFollowupOptionInput;
}>;

export type UpdateEchoFollowupOptionsMutation = {
  updateEchoFollowupOptions: Array<{
    id: string;
    createdAt: any;
    updateAt: any;
    updateById: string;
    name: string;
    displayName: string;
    displayRank: number;
    category: string | null;
    isDefault: boolean;
    scope: Types.FollowupOptionScope;
    hide: boolean;
    createdBy: { id: string; fullName: string | null } | null;
    tenant: { id: string; name: string } | null;
    caselistModule: { id: string; name: string; displayName: string };
    careEntities: Array<{
      id: string;
      name: string;
      code: string;
      description: string;
    }> | null;
  }>;
};

export type GetEchoMessageTemplatesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetEchoMessageTemplatesQuery = {
  echoMessageTemplates: Array<{
    id: string;
    createdAt: any;
    updateAt: any;
    updateById: string;
    name: string;
    common: boolean;
    hide: boolean;
    template: string;
    createdBy: { id: string; fullName: string | null } | null;
    tenant: { id: string; name: string } | null;
  }>;
};

export type GetEchoMessageTemplateQueryVariables = Exact<{
  id: string;
}>;

export type GetEchoMessageTemplateQuery = {
  echoMessageTemplate: {
    id: string;
    createdAt: any;
    updateAt: any;
    updateById: string;
    name: string;
    common: boolean;
    hide: boolean;
    template: string;
    createdBy: { id: string; fullName: string | null } | null;
    tenant: { id: string; name: string } | null;
  };
};

export type CreateEchoMessageTemplateMutationVariables = Exact<{
  input: Types.EchoMessageTemplateInput;
}>;

export type CreateEchoMessageTemplateMutation = {
  createEchoMessageTemplate: {
    id: string;
    createdAt: any;
    updateAt: any;
    updateById: string;
    name: string;
    common: boolean;
    hide: boolean;
    template: string;
    createdBy: { id: string; fullName: string | null } | null;
    tenant: { id: string; name: string } | null;
  };
};

export type UpdateEchoMessageTemplateMutationVariables = Exact<{
  input: Types.UpdateEchoMessageTemplateInput;
}>;

export type UpdateEchoMessageTemplateMutation = {
  updateEchoMessageTemplate: {
    id: string;
    createdAt: any;
    updateAt: any;
    updateById: string;
    name: string;
    common: boolean;
    hide: boolean;
    template: string;
    createdBy: { id: string; fullName: string | null } | null;
    tenant: { id: string; name: string } | null;
  };
};

export type GetEchoReferringProvidersQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetEchoReferringProvidersQuery = {
  echoReferringProviders: Array<{
    id: string;
    name: string;
    priority: boolean;
    contact: string | null;
    tenant: { id: string; name: string } | null;
  }>;
};

export type GetEchoReferringProviderQueryVariables = Exact<{
  id: string;
}>;

export type GetEchoReferringProviderQuery = {
  echoReferringProvider: {
    id: string;
    name: string;
    priority: boolean;
    contact: string | null;
    tenant: { id: string; name: string } | null;
  };
};

export type UpdateEchoReferringProviderMutationVariables = Exact<{
  input: Types.UpdateEchoReferringProviderInput;
}>;

export type UpdateEchoReferringProviderMutation = {
  updateEchoReferringProvider: {
    id: string;
    name: string;
    priority: boolean;
    contact: string | null;
    tenant: { id: string; name: string } | null;
  };
};

export type GetRegistryElementsQueryVariables = Exact<{
  datasetIds?: Array<number> | number | null | undefined;
  type?: Types.DictionaryType | null | undefined;
}>;

export type GetRegistryElementsQuery = {
  dictionaries: Array<{
    id: string;
    type: Types.DictionaryType;
    sections: Array<{
      id: string;
      hideFromReports: boolean;
      sortOrder: number | null;
      sectionDisplayName: string;
      parentId: string | null;
      elements: Array<{
        id: string;
        hideFromReports: boolean;
        code: string | null;
        shortName: string;
        elementReference: string;
        name: string;
        sourceMappings: Array<{
          id: string;
          target: { id: string; shortName: string } | null;
        }> | null;
        referenceTransformations: Array<{
          id: string;
          translation: {
            id: string;
            target: { id: string; shortName: string } | null;
          };
        }> | null;
        derivativeTransformations: Array<{
          id: string;
          translation: {
            id: string;
            target: { id: string; shortName: string } | null;
          };
        }> | null;
      }>;
    }> | null;
  }>;
};

export type GetMeasuresMetadataQueryVariables = Exact<{
  diseaseStateModuleId?: number | null | undefined;
}>;

export type GetMeasuresMetadataQuery = {
  measuresMetadata: Array<{
    id: number;
    hideFromReports: boolean;
    name: string;
    opportunityType: Array<Types.OpportunityType>;
    commonMeasureDisplayName: string;
    publicationSource: Array<Types.PublicationSource> | null;
    outcomeType: Types.MeasureOutcomeType | null;
  }>;
};

export type GetMeasuresByDsmCachedQueryVariables = Exact<{
  diseaseStateModuleId: number;
}>;

export type GetMeasuresByDsmCachedQuery = {
  measuresByDsmCached: Array<{
    id: number;
    name: string;
    commonMeasureDisplayName: string;
  }>;
};

export type GetDimensionsQueryVariables = Exact<{
  diseaseStateModuleId?: number | null | undefined;
}>;

export type GetDimensionsQuery = {
  dimensions: Array<{
    id: number;
    hideFromReports: boolean;
    fieldName: string;
    label: string;
    class: string;
    type: Types.DimensionType;
  }>;
};

export type GetReportAnchorDatesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetReportAnchorDatesQuery = {
  reportAnchorDates: Array<{
    id: string;
    name: string;
    displayName: string;
    displayRank: number;
    isDefault: boolean;
    diseaseStateModuleId: number;
  }>;
};

export type RunReportMutationVariables = Exact<{
  reportId: string;
}>;

export type RunReportMutation = { runReport: boolean };

export type CreateReportMutationVariables = Exact<{
  reportInput: Types.ReportInput;
  startExport: boolean;
}>;

export type CreateReportMutation = {
  createReport: {
    id: string;
    name: string;
    dateColumn: string;
    dateRangeType: Types.DateRangeTypes | null;
    quarters: Array<string> | null;
    startDate: string | null;
    endDate: string | null;
    procedures: Array<string> | null;
    createdAt: any;
    diseaseStateModule: { id: number; name: string; code: string };
    createdBy: { id: string; fullName: string | null } | null;
    registryElements: Array<{
      id: string;
      name: string;
      code: string | null;
      section: {
        id: string;
        sectionDisplayName: string;
        sortOrder: number | null;
      };
    }> | null;
    dimensions: Array<{ id: number; label: string }> | null;
    measures: Array<{ id: number; name: string }> | null;
    tenant: { id: string; name: string; code: string };
    files: Array<{ id: string; createdAt: any; name: string }> | null;
    users: Array<{
      id: string;
      firstName: string;
      lastName: string;
      email: string;
    }> | null;
    distributionLists: Array<{
      id: string;
      name: string;
      users: Array<{
        id: string;
        firstName: string;
        lastName: string;
        email: string;
      }> | null;
    }> | null;
  };
};

export type UpdateReportMutationVariables = Exact<{
  input: Types.UpdateReportInput;
  startExport: boolean;
}>;

export type UpdateReportMutation = {
  updateReport: {
    id: string;
    name: string;
    createdAt: any;
    dateColumn: string;
    dateRangeType: Types.DateRangeTypes | null;
    quarters: Array<string> | null;
    startDate: string | null;
    endDate: string | null;
    procedures: Array<string> | null;
    diseaseStateModule: { id: number; name: string; code: string };
    createdBy: { id: string; fullName: string | null } | null;
    files: Array<{ id: string; createdAt: any; name: string }> | null;
    registryElements: Array<{
      id: string;
      name: string;
      code: string | null;
      section: {
        id: string;
        sectionDisplayName: string;
        sortOrder: number | null;
      };
    }> | null;
    dimensions: Array<{ id: number; label: string }> | null;
    measures: Array<{ id: number; name: string }> | null;
    tenant: { id: string; name: string; code: string };
    users: Array<{
      id: string;
      firstName: string;
      lastName: string;
      email: string;
    }> | null;
    distributionLists: Array<{
      id: string;
      name: string;
      users: Array<{
        id: string;
        firstName: string;
        lastName: string;
        email: string;
      }> | null;
    }> | null;
  };
};

export type GetReportQueryVariables = Exact<{
  reportId: string;
}>;

export type GetReportQuery = {
  report: {
    id: string;
    name: string;
    createdAt: any;
    dateColumn: string;
    dateRangeType: Types.DateRangeTypes | null;
    quarters: Array<string> | null;
    startDate: string | null;
    endDate: string | null;
    procedures: Array<string> | null;
    diseaseStateModule: { id: number; name: string; code: string };
    createdBy: { id: string; fullName: string | null } | null;
    files: Array<{
      id: string;
      createdAt: any;
      name: string;
      phi: boolean | null;
    }> | null;
    registryElements: Array<{
      id: string;
      name: string;
      code: string | null;
      section: {
        id: string;
        sectionDisplayName: string;
        sortOrder: number | null;
      };
    }> | null;
    dimensions: Array<{ id: number; label: string }> | null;
    measures: Array<{ id: number; name: string }> | null;
    tenant: { id: string; name: string; code: string };
    users: Array<{
      id: string;
      firstName: string;
      lastName: string;
      email: string;
    }> | null;
    distributionLists: Array<{
      id: string;
      name: string;
      users: Array<{
        id: string;
        firstName: string;
        lastName: string;
        email: string;
      }> | null;
    }> | null;
  };
};

export type GetReportsQueryVariables = Exact<{ [key: string]: never }>;

export type GetReportsQuery = {
  reports: Array<{
    id: string;
    name: string;
    createdAt: any;
    dateColumn: string;
    dateRangeType: Types.DateRangeTypes | null;
    quarters: Array<string> | null;
    startDate: string | null;
    endDate: string | null;
    procedures: Array<string> | null;
    diseaseStateModule: { id: number; name: string; code: string };
    createdBy: { id: string; fullName: string | null } | null;
    files: Array<{ id: string; createdAt: any; name: string }> | null;
    tenant: { id: string; name: string; code: string };
    users: Array<{
      id: string;
      firstName: string;
      lastName: string;
      email: string;
    }> | null;
    distributionLists: Array<{
      id: string;
      name: string;
      users: Array<{
        id: string;
        firstName: string;
        lastName: string;
        email: string;
      }> | null;
    }> | null;
  }>;
};

export type DeleteReportMutationVariables = Exact<{
  reportId: string;
}>;

export type DeleteReportMutation = { deleteReport: boolean };

export type GetCompassDataQueryVariables = Exact<{
  careEntityCodes: Array<string> | string;
  dsmCodes?: Array<string> | string | null | undefined;
  measureIds?: Array<number> | number | null | undefined;
  cohortIds?: Array<number> | number | null | undefined;
  publicationSources?:
    Array<Types.PublicationSource> | Types.PublicationSource | null | undefined;
  opportunityTypes?:
    Array<Types.OpportunityType> | Types.OpportunityType | null | undefined;
  dimensionFilter?: Types.DimensionFilter | null | undefined;
  dimensionType?: Types.DimensionType | null | undefined;
  dimensionClass?: string | null | undefined;
  summaryInitiativeMeasure?: boolean | null | undefined;
  srogBuckets?: Array<Types.SrogBucket> | Types.SrogBucket | null | undefined;
  limit?: number | null | undefined;
  sortBy?: Types.CompassSortBy | null | undefined;
  topN?: number | null | undefined;
  collapseCohorts?: boolean | null | undefined;
  preferredCohortIds?: Array<number> | number | null | undefined;
}>;

export type GetCompassDataQuery = {
  compassData: {
    Strength: Array<{
      measureId: number | null;
      name: string;
      hospital: string;
      registry: string;
      cohortId: number | null;
      srogStrength: number | null;
      trendToUse: Types.OpportunityTrend | null;
      atBestPerformance: boolean | null;
      numerator: number | null;
      numeratorIfBest: number | null;
      averageROI: number | null;
      bestROI: number | null;
      srogBucket: Types.SrogBucket;
      systemSortOrder: number | null;
      totalChildCareEntities: number | null;
      dimType: Types.DimType;
      cohortName: string | null;
      numeratorImpactIfAverage: number | null;
      numeratorImpactIfBest: number | null;
      formattedPerformance: string | null;
      aggregated: boolean | null;
      opportunities: Array<{
        at: number;
        numerator: number | null;
        performance: boolean | null;
        roi: number | null;
        summedRoi: number | null;
        los: number | null;
        distanceFrom: number | null;
      }> | null;
      measure: {
        name: string;
        opportunityType: Array<Types.OpportunityType>;
        numeratorUnit: string;
        publicationSource: Array<Types.PublicationSource> | null;
      } | null;
    }>;
    Regression: Array<{
      measureId: number | null;
      name: string;
      hospital: string;
      registry: string;
      cohortId: number | null;
      srogStrength: number | null;
      trendToUse: Types.OpportunityTrend | null;
      atBestPerformance: boolean | null;
      numerator: number | null;
      numeratorIfBest: number | null;
      averageROI: number | null;
      bestROI: number | null;
      srogBucket: Types.SrogBucket;
      rareEvent: number | null;
      systemSortOrder: number | null;
      totalChildCareEntities: number | null;
      dimType: Types.DimType;
      cohortName: string | null;
      numeratorImpactIfAverage: number | null;
      numeratorImpactIfBest: number | null;
      formattedPerformance: string | null;
      aggregated: boolean | null;
      opportunities: Array<{
        at: number;
        numerator: number | null;
        performance: boolean | null;
        roi: number | null;
        summedRoi: number | null;
        los: number | null;
        distanceFrom: number | null;
      }> | null;
      measure: {
        name: string;
        opportunityType: Array<Types.OpportunityType>;
        numeratorUnit: string;
        publicationSource: Array<Types.PublicationSource> | null;
      } | null;
    }>;
    Opportunity: Array<{
      measureId: number | null;
      name: string;
      hospital: string;
      registry: string;
      cohortId: number | null;
      srogStrength: number | null;
      trendToUse: Types.OpportunityTrend | null;
      atBestPerformance: boolean | null;
      numerator: number | null;
      numeratorIfBest: number | null;
      averageROI: number | null;
      bestROI: number | null;
      srogBucket: Types.SrogBucket;
      rareEvent: number | null;
      systemSortOrder: number | null;
      totalChildCareEntities: number | null;
      dimType: Types.DimType;
      cohortName: string | null;
      numeratorImpactIfAverage: number | null;
      numeratorImpactIfBest: number | null;
      formattedPerformance: string | null;
      aggregated: boolean | null;
      opportunities: Array<{
        at: number;
        numerator: number | null;
        performance: boolean | null;
        roi: number | null;
        summedRoi: number | null;
        los: number | null;
        distanceFrom: number | null;
      }> | null;
      measure: {
        name: string;
        opportunityType: Array<Types.OpportunityType>;
        numeratorUnit: string;
        publicationSource: Array<Types.PublicationSource> | null;
      } | null;
    }>;
    Gain: Array<{
      measureId: number | null;
      name: string;
      hospital: string;
      registry: string;
      cohortId: number | null;
      srogStrength: number | null;
      trendToUse: Types.OpportunityTrend | null;
      atBestPerformance: boolean | null;
      numerator: number | null;
      numeratorIfBest: number | null;
      averageROI: number | null;
      bestROI: number | null;
      srogBucket: Types.SrogBucket;
      rareEvent: number | null;
      systemSortOrder: number | null;
      totalChildCareEntities: number | null;
      dimType: Types.DimType;
      cohortName: string | null;
      numeratorImpactIfAverage: number | null;
      numeratorImpactIfBest: number | null;
      formattedPerformance: string | null;
      aggregated: boolean | null;
      opportunities: Array<{
        at: number;
        numerator: number | null;
        performance: boolean | null;
        roi: number | null;
        summedRoi: number | null;
        los: number | null;
        distanceFrom: number | null;
      }> | null;
      measure: {
        name: string;
        opportunityType: Array<Types.OpportunityType>;
        numeratorUnit: string;
        publicationSource: Array<Types.PublicationSource> | null;
      } | null;
    }>;
  };
};

export type GetSubmissionInquiriesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetSubmissionInquiriesQuery = {
  submissionInquiries: Array<{
    id: number;
    title: string;
    subject: string;
    message: string;
  }>;
};

export type GetSubmissionInquiryQueryVariables = Exact<{
  id: number;
}>;

export type GetSubmissionInquiryQuery = {
  submissionInquiry: {
    id: number;
    title: string;
    subject: string;
    message: string;
  };
};

export type SendInquiryMutationVariables = Exact<{
  input: Types.SendInquiryInput;
}>;

export type SendInquiryMutation = {
  sendInquiry: { success: boolean; supportEmailId: string | null };
};

export type GetCommentsByThreadQueryVariables = Exact<{
  threadId: string;
}>;

export type GetCommentsByThreadQuery = {
  commentsByThread: Array<{
    id: string;
    content: string;
    internal: boolean;
    isEdited: boolean;
    createdAt: any;
    updateAt: any;
    threadId: string;
    parentId: string | null;
    repliesCount: number | null;
    reactionsCount: number | null;
    createdBy: { id: string; firstName: string; lastName: string } | null;
    updateBy: { id: string; firstName: string; lastName: string } | null;
  }>;
};

export type CreateCommentMutationVariables = Exact<{
  input: Types.CreateCommentInput;
}>;

export type CreateCommentMutation = {
  createComment: {
    id: string;
    content: string;
    internal: boolean;
    isEdited: boolean;
    createdAt: any;
    updateAt: any;
    threadId: string;
    parentId: string | null;
    repliesCount: number | null;
    reactionsCount: number | null;
    createdBy: { id: string; firstName: string; lastName: string } | null;
    updateBy: { id: string; firstName: string; lastName: string } | null;
  };
};

export type UpdateCommentMutationVariables = Exact<{
  input: Types.UpdateCommentInput;
}>;

export type UpdateCommentMutation = {
  updateComment: {
    id: string;
    content: string;
    internal: boolean;
    isEdited: boolean;
    createdAt: any;
    updateAt: any;
    threadId: string;
    parentId: string | null;
    repliesCount: number | null;
    reactionsCount: number | null;
    createdBy: { id: string; firstName: string; lastName: string } | null;
    updateBy: { id: string; firstName: string; lastName: string } | null;
  };
};

export type RemoveCommentMutationVariables = Exact<{
  id: string | number;
}>;

export type RemoveCommentMutation = { removeComment: boolean };

export type GetThreadByEntityQueryVariables = Exact<{
  entityType: string;
  entityId: string;
}>;

export type GetThreadByEntityQuery = {
  threadByEntity: {
    id: string;
    title: string;
    description: string | null;
    isPrivate: boolean;
    isLocked: boolean;
    commentsCount: number;
    entityType: string;
    entityId: string;
    createdAt: any;
    createdById: string | null;
    updateAt: any;
    updateById: string | null;
  } | null;
};

export type GetThreadQueryVariables = Exact<{
  id: string | number;
}>;

export type GetThreadQuery = {
  thread: {
    id: string;
    title: string;
    description: string | null;
    isPrivate: boolean;
    isLocked: boolean;
    commentsCount: number;
    entityType: string;
    entityId: string;
    createdAt: any;
    createdById: string | null;
    updateAt: any;
    updateById: string | null;
  };
};

export type CreateThreadMutationVariables = Exact<{
  input: Types.CreateThreadInput;
}>;

export type CreateThreadMutation = {
  createThread: {
    id: string;
    title: string;
    description: string | null;
    isPrivate: boolean;
    isLocked: boolean;
    commentsCount: number;
    entityType: string;
    entityId: string;
    createdAt: any;
    createdById: string | null;
    updateAt: any;
    updateById: string | null;
  };
};

export type UpdateThreadMutationVariables = Exact<{
  input: Types.UpdateThreadInput;
}>;

export type UpdateThreadMutation = {
  updateThread: {
    id: string;
    title: string;
    description: string | null;
    isPrivate: boolean;
    isLocked: boolean;
    commentsCount: number;
    entityType: string;
    entityId: string;
    createdAt: any;
    createdById: string | null;
    updateAt: any;
    updateById: string | null;
  };
};

export type RemoveThreadMutationVariables = Exact<{
  id: string | number;
}>;

export type RemoveThreadMutation = { removeThread: boolean };

export type CancelPresentationJobMutationVariables = Exact<{
  jobId: string;
}>;

export type CancelPresentationJobMutation = { cancelPresentationJob: boolean };

export type GetObjectivesQueryVariables = Exact<{ [key: string]: never }>;

export type GetObjectivesQuery = {
  objectives: Array<{
    id: string;
    name: string;
    tags: Array<string> | null;
    hiddenStrategyCount: number | null;
    careEntityId: string | null;
    cohortIds: Array<number> | null;
    initiativeId: number | null;
    createdAt: any;
    updateAt: any;
    tenant: { id: string; name: string };
    measures: Array<{
      id: number;
      name: string;
      outcomeType: Types.MeasureOutcomeType | null;
    }> | null;
    diseaseStateModule: {
      id: number;
      code: string;
      name: string;
      summaryCohortId: number | null;
    } | null;
    careEntity: { id: string; name: string; code: string } | null;
    createdBy: { id: string; fullName: string | null; username: string } | null;
    updateBy: { id: string; fullName: string | null; username: string } | null;
    processSponsors: Array<{
      id: string;
      externalUsername: string | null;
      user: {
        id: string;
        username: string;
        fullName: string | null;
        email: string;
      } | null;
    }> | null;
    physicianChampions: Array<{
      id: string;
      externalUsername: string | null;
      user: {
        id: string;
        username: string;
        fullName: string | null;
        email: string;
      } | null;
    }> | null;
    strategies: Array<{
      id: string;
      careEntityId: string | null;
      diseaseStateModuleId: number | null;
      name: string;
      description: string | null;
      createdAt: any;
      templateId: string | null;
      associations: string | null;
      updateAt: any;
      status: Types.ObjectiveStrategyStatus;
      checkpointDate: any;
      showInPerformanceMonitor: boolean;
      associatedObjectiveCount: number;
      createdBy: {
        id: string;
        fullName: string | null;
        username: string;
      } | null;
      updateBy: {
        id: string;
        fullName: string | null;
        username: string;
      } | null;
      associatedObjectives: Array<{ id: string; name: string }>;
      resources: Array<{
        id: string;
        url: string;
        displayText: string | null;
      }> | null;
      processSponsors: Array<{
        id: string;
        externalUsername: string | null;
        user: {
          id: string;
          username: string;
          fullName: string | null;
          email: string;
        } | null;
      }> | null;
      physicianChampions: Array<{
        id: string;
        externalUsername: string | null;
        user: {
          id: string;
          username: string;
          fullName: string | null;
          email: string;
        } | null;
      }> | null;
    }> | null;
  }>;
};

export type GetObjectiveQueryVariables = Exact<{
  objectiveId: string | number;
}>;

export type GetObjectiveQuery = {
  objective: {
    id: string;
    name: string;
    tags: Array<string> | null;
    hiddenStrategyCount: number | null;
    cohortIds: Array<number> | null;
    careEntityId: string | null;
    initiativeId: number | null;
    createdAt: any;
    updateAt: any;
    tenant: { id: string; name: string };
    measures: Array<{
      id: number;
      name: string;
      outcomeType: Types.MeasureOutcomeType | null;
    }> | null;
    diseaseStateModule: {
      id: number;
      code: string;
      name: string;
      summaryCohortId: number | null;
    } | null;
    careEntity: { id: string; name: string; code: string } | null;
    processSponsors: Array<{
      id: string;
      externalUsername: string | null;
      user: {
        id: string;
        username: string;
        fullName: string | null;
        email: string;
      } | null;
    }> | null;
    physicianChampions: Array<{
      id: string;
      externalUsername: string | null;
      user: {
        id: string;
        username: string;
        fullName: string | null;
        email: string;
      } | null;
    }> | null;
    strategies: Array<{
      id: string;
      careEntityId: string | null;
      diseaseStateModuleId: number | null;
      name: string;
      description: string | null;
      createdAt: any;
      templateId: string | null;
      associations: string | null;
      checkpointDate: any;
      showInPerformanceMonitor: boolean;
      associatedObjectiveCount: number;
      updateAt: any;
      status: Types.ObjectiveStrategyStatus;
      associatedObjectives: Array<{ id: string; name: string }>;
      createdBy: {
        id: string;
        fullName: string | null;
        username: string;
      } | null;
      updateBy: {
        id: string;
        fullName: string | null;
        username: string;
      } | null;
      resources: Array<{
        id: string;
        url: string;
        displayText: string | null;
      }> | null;
      processSponsors: Array<{
        id: string;
        externalUsername: string | null;
        user: {
          id: string;
          username: string;
          fullName: string | null;
          email: string;
        } | null;
      }> | null;
      physicianChampions: Array<{
        id: string;
        externalUsername: string | null;
        user: {
          id: string;
          username: string;
          fullName: string | null;
          email: string;
        } | null;
      }> | null;
    }> | null;
    createdBy: { id: string; fullName: string | null; username: string } | null;
    updateBy: { id: string; fullName: string | null; username: string } | null;
  };
};

export type CreateObjectiveMutationVariables = Exact<{
  createObjectiveInput: Types.CreateObjectiveInput;
}>;

export type CreateObjectiveMutation = {
  createObjective: {
    id: string;
    name: string;
    tags: Array<string> | null;
    cohortIds: Array<number> | null;
    careEntityId: string | null;
    initiativeId: number | null;
    performanceManagerSyncFailed: boolean | null;
    hiddenStrategyCount: number | null;
    createdAt: any;
    updateAt: any;
    tenant: { id: string; name: string };
    measures: Array<{ id: number; name: string }> | null;
    diseaseStateModule: {
      id: number;
      code: string;
      name: string;
      summaryCohortId: number | null;
    } | null;
    careEntity: { id: string; name: string; code: string } | null;
    processSponsors: Array<{
      id: string;
      externalUsername: string | null;
      user: {
        id: string;
        username: string;
        fullName: string | null;
        email: string;
      } | null;
    }> | null;
    physicianChampions: Array<{
      id: string;
      externalUsername: string | null;
      user: {
        id: string;
        username: string;
        fullName: string | null;
        email: string;
      } | null;
    }> | null;
    strategies: Array<{
      id: string;
      name: string;
      description: string | null;
      checkpointDate: any;
      showInPerformanceMonitor: boolean;
      associatedObjectiveCount: number;
      associations: string | null;
      templateId: string | null;
      status: Types.ObjectiveStrategyStatus;
      associatedObjectives: Array<{ id: string; name: string }>;
      resources: Array<{ url: string; displayText: string | null }> | null;
      processSponsors: Array<{
        id: string;
        externalUsername: string | null;
        user: {
          id: string;
          username: string;
          fullName: string | null;
          email: string;
        } | null;
      }> | null;
      physicianChampions: Array<{
        id: string;
        externalUsername: string | null;
        user: {
          id: string;
          username: string;
          fullName: string | null;
          email: string;
        } | null;
      }> | null;
    }> | null;
    createdBy: { id: string; fullName: string | null; username: string } | null;
    updateBy: { id: string; fullName: string | null; username: string } | null;
  };
};

export type UpdateObjectiveMutationVariables = Exact<{
  updateObjectiveInput: Types.UpdateObjectiveInput;
}>;

export type UpdateObjectiveMutation = {
  updateObjective: {
    id: string;
    name: string;
    tags: Array<string> | null;
    cohortIds: Array<number> | null;
    careEntityId: string | null;
    initiativeId: number | null;
    performanceManagerSyncFailed: boolean | null;
    hiddenStrategyCount: number | null;
    createdAt: any;
    updateAt: any;
    tenant: { id: string; name: string };
    measures: Array<{ id: number; name: string }> | null;
    diseaseStateModule: {
      id: number;
      code: string;
      name: string;
      summaryCohortId: number | null;
    } | null;
    careEntity: { id: string; name: string; code: string } | null;
    createdBy: { id: string; fullName: string | null; username: string } | null;
    updateBy: { id: string; fullName: string | null; username: string } | null;
    processSponsors: Array<{
      id: string;
      externalUsername: string | null;
      user: {
        id: string;
        username: string;
        fullName: string | null;
        email: string;
      } | null;
    }> | null;
    physicianChampions: Array<{
      id: string;
      externalUsername: string | null;
      user: {
        id: string;
        username: string;
        fullName: string | null;
        email: string;
      } | null;
    }> | null;
    strategies: Array<{
      id: string;
      careEntityId: string | null;
      diseaseStateModuleId: number | null;
      name: string;
      description: string | null;
      templateId: string | null;
      createdAt: any;
      updateAt: any;
      status: Types.ObjectiveStrategyStatus;
      checkpointDate: any;
      showInPerformanceMonitor: boolean;
      associatedObjectiveCount: number;
      createdBy: { id: string; fullName: string | null } | null;
      updateBy: { id: string; fullName: string | null } | null;
      associatedObjectives: Array<{ id: string; name: string }>;
      processSponsors: Array<{
        id: string;
        externalUsername: string | null;
        user: {
          id: string;
          username: string;
          fullName: string | null;
          email: string;
        } | null;
      }> | null;
      physicianChampions: Array<{
        id: string;
        externalUsername: string | null;
        user: {
          id: string;
          username: string;
          fullName: string | null;
          email: string;
        } | null;
      }> | null;
    }> | null;
  };
};

export type ArchiveObjectiveMutationVariables = Exact<{
  id: string | number;
}>;

export type ArchiveObjectiveMutation = { archiveObjective: boolean };

export type RemoveObjectiveMutationVariables = Exact<{
  id: string | number;
}>;

export type RemoveObjectiveMutation = { removeObjective: boolean };

export type ObjectiveStrategiesQueryVariables = Exact<{
  objectiveId: string | number;
}>;

export type ObjectiveStrategiesQuery = {
  objectiveStrategies: Array<{
    id: string;
    careEntityId: string | null;
    diseaseStateModuleId: number | null;
    createdAt: any;
    updateAt: any;
    name: string;
    templateId: string | null;
    description: string | null;
    associations: string | null;
    status: Types.ObjectiveStrategyStatus;
    checkpointDate: any;
    showInPerformanceMonitor: boolean;
    createdBy: { id: string; fullName: string | null } | null;
    updateBy: { id: string; fullName: string | null } | null;
    resources: Array<{
      id: string;
      url: string;
      displayText: string | null;
    }> | null;
  }>;
};

export type ObjectiveStrategyQueryVariables = Exact<{
  id: string | number;
}>;

export type ObjectiveStrategyQuery = {
  objectiveStrategy: {
    id: string;
    careEntityId: string | null;
    diseaseStateModuleId: number | null;
    createdAt: any;
    updateAt: any;
    name: string;
    templateId: string | null;
    description: string | null;
    associations: string | null;
    status: Types.ObjectiveStrategyStatus;
    checkpointDate: any;
    showInPerformanceMonitor: boolean;
    associatedObjectiveCount: number;
    createdBy: { id: string; fullName: string | null } | null;
    updateBy: { id: string; fullName: string | null } | null;
    associatedObjectives: Array<{
      id: string;
      name: string;
      careEntity: { id: string; name: string } | null;
      diseaseStateModule: { id: number; name: string } | null;
      createdBy: { id: string; fullName: string | null } | null;
    }>;
    resources: Array<{
      id: string;
      url: string;
      displayText: string | null;
    }> | null;
    processSponsors: Array<{
      id: string;
      externalUsername: string | null;
      user: {
        id: string;
        username: string;
        fullName: string | null;
        email: string;
      } | null;
    }> | null;
    physicianChampions: Array<{
      id: string;
      externalUsername: string | null;
      user: {
        id: string;
        username: string;
        fullName: string | null;
        email: string;
      } | null;
    }> | null;
  };
};

export type ObjectiveStrategyAssociatedObjectivesQueryVariables = Exact<{
  id: string | number;
}>;

export type ObjectiveStrategyAssociatedObjectivesQuery = {
  objectiveStrategy: {
    id: string;
    associatedObjectiveCount: number;
    associatedObjectives: Array<{ id: string; name: string }>;
  };
};

export type CreateObjectiveStrategyMutationVariables = Exact<{
  createObjectiveStrategyInput: Types.CreateObjectiveStrategyInput;
}>;

export type CreateObjectiveStrategyMutation = {
  createObjectiveStrategy: {
    id: string;
    careEntityId: string | null;
    diseaseStateModuleId: number | null;
    createdAt: any;
    updateAt: any;
    templateId: string | null;
    name: string;
    description: string | null;
    associations: string | null;
    status: Types.ObjectiveStrategyStatus;
    checkpointDate: any;
    showInPerformanceMonitor: boolean;
    performanceManagerSyncFailed: boolean | null;
    createdBy: { id: string; fullName: string | null } | null;
    updateBy: { id: string; fullName: string | null } | null;
    resources: Array<{
      id: string;
      url: string;
      displayText: string | null;
    }> | null;
    processSponsors: Array<{
      id: string;
      externalUsername: string | null;
      user: {
        id: string;
        username: string;
        fullName: string | null;
        email: string;
      } | null;
    }> | null;
    physicianChampions: Array<{
      id: string;
      externalUsername: string | null;
      user: {
        id: string;
        username: string;
        fullName: string | null;
        email: string;
      } | null;
    }> | null;
    template: { id: string; name: string } | null;
  };
};

export type UpdateObjectiveStrategyMutationVariables = Exact<{
  updateObjectiveStrategyInput: Types.UpdateObjectiveStrategyInput;
}>;

export type UpdateObjectiveStrategyMutation = {
  updateObjectiveStrategy: {
    id: string;
    careEntityId: string | null;
    diseaseStateModuleId: number | null;
    createdAt: any;
    updateAt: any;
    templateId: string | null;
    name: string;
    description: string | null;
    associations: string | null;
    status: Types.ObjectiveStrategyStatus;
    checkpointDate: any;
    showInPerformanceMonitor: boolean;
    performanceManagerSyncFailed: boolean | null;
    createdBy: { id: string; fullName: string | null } | null;
    updateBy: { id: string; fullName: string | null } | null;
    resources: Array<{
      id: string;
      url: string;
      displayText: string | null;
    }> | null;
    processSponsors: Array<{
      id: string;
      externalUsername: string | null;
      user: {
        id: string;
        username: string;
        fullName: string | null;
        email: string;
      } | null;
    }> | null;
    physicianChampions: Array<{
      id: string;
      externalUsername: string | null;
      user: {
        id: string;
        username: string;
        fullName: string | null;
        email: string;
      } | null;
    }> | null;
    template: { id: string; name: string } | null;
  };
};

export type ArchiveObjectiveStrategyMutationVariables = Exact<{
  id: string | number;
}>;

export type ArchiveObjectiveStrategyMutation = {
  archiveObjectiveStrategy: boolean;
};

export type RemoveObjectiveStrategyMutationVariables = Exact<{
  id: string | number;
}>;

export type RemoveObjectiveStrategyMutation = {
  removeObjectiveStrategy: boolean;
};

export type UnlinkObjectiveStrategyMutationVariables = Exact<{
  id: string | number;
  objectiveId: string | number;
}>;

export type UnlinkObjectiveStrategyMutation = {
  unlinkObjectiveStrategy: boolean;
};

export type ObjectiveAttachPreviewQueryVariables = Exact<{
  input: Types.ObjectiveAttachPreviewInput;
}>;

export type ObjectiveAttachPreviewQuery = {
  objectiveAttachPreview: Array<{ id: string; name: string | null }>;
};

export type CanCreatePerformanceManagerStrategyQueryVariables = Exact<{
  careEntity: string;
  registry: string;
}>;

export type CanCreatePerformanceManagerStrategyQuery = {
  canCreatePerformanceManagerStrategy: boolean;
};

export type PerformanceManagerStrategiesQueryVariables = Exact<{
  initiativeId: number;
  careEntity: string;
  registry: string;
}>;

export type PerformanceManagerStrategiesQuery = {
  performanceManagerStrategies: Array<{
    id: string;
    name: string;
    checkpointDate: any;
    canEdit: boolean;
    floating: boolean;
    objectives: Array<{ id: string; name: string }>;
    strategy: {
      id: string;
      createdAt: any;
      updateAt: any;
      name: string;
      description: string | null;
      status: Types.ObjectiveStrategyStatus;
      checkpointDate: any;
      associatedObjectiveCount: number;
      createdBy: { id: string } | null;
      updateBy: { id: string } | null;
      processSponsors: Array<{
        id: string;
        externalUsername: string | null;
        user: {
          id: string;
          username: string;
          fullName: string | null;
          email: string;
        } | null;
      }> | null;
      physicianChampions: Array<{
        id: string;
        externalUsername: string | null;
        user: {
          id: string;
          username: string;
          fullName: string | null;
          email: string;
        } | null;
      }> | null;
    } | null;
  }>;
};

export type PerformanceManagerStrategyInitiativesQueryVariables = Exact<{
  initiativeId: number;
  careEntity: string;
  registry: string;
}>;

export type PerformanceManagerStrategyInitiativesQuery = {
  performanceManagerStrategies: Array<{
    id: string;
    initiatives: Array<{ initiativeId: number; monitoredCareEntity: string }>;
  }>;
};

export type CreatePerformanceManagerStrategyMutationVariables = Exact<{
  input: Types.CreatePerformanceManagerStrategyInput;
}>;

export type CreatePerformanceManagerStrategyMutation = {
  createPerformanceManagerStrategy: {
    id: string;
    performanceManagerSyncFailed: boolean | null;
  };
};

export type ObjectiveStrategyTemplateQueryVariables = Exact<{
  id: string | number;
}>;

export type ObjectiveStrategyTemplateQuery = {
  objectiveStrategyTemplate: {
    id: string;
    createdAt: any;
    updateAt: any;
    name: string;
    description: string | null;
    allMeasures: boolean;
    allDiseaseStateModules: boolean;
    createdBy: { id: string; fullName: string | null } | null;
    updateBy: { id: string; fullName: string | null } | null;
    measures: Array<{ id: number; name: string }> | null;
    diseaseStateModule: { id: number; name: string } | null;
    resources: Array<{
      id: string;
      url: string;
      displayText: string | null;
    }> | null;
  };
};

export type ObjectiveStrategyTemplatesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ObjectiveStrategyTemplatesQuery = {
  objectiveStrategyTemplates: Array<{
    id: string;
    createdAt: any;
    updateAt: any;
    name: string;
    description: string | null;
    allMeasures: boolean;
    allDiseaseStateModules: boolean;
    createdBy: { id: string; fullName: string | null } | null;
    updateBy: { id: string; fullName: string | null } | null;
    measures: Array<{ id: number; name: string }> | null;
    diseaseStateModule: { id: number; name: string } | null;
    resources: Array<{
      id: string;
      url: string;
      displayText: string | null;
    }> | null;
  }>;
};

export type CreateObjectiveStrategyTemplateMutationVariables = Exact<{
  createObjectiveStrategyTemplateInput: Types.CreateObjectiveStrategyTemplateInput;
}>;

export type CreateObjectiveStrategyTemplateMutation = {
  createObjectiveStrategyTemplate: {
    id: string;
    createdAt: any;
    updateAt: any;
    name: string;
    description: string | null;
    allMeasures: boolean;
    allDiseaseStateModules: boolean;
    createdBy: { id: string; fullName: string | null } | null;
    updateBy: { id: string; fullName: string | null } | null;
    measures: Array<{ id: number; name: string }> | null;
    diseaseStateModule: { id: number; name: string } | null;
    strategies: Array<{
      id: string;
      name: string;
      description: string | null;
    }> | null;
    resources: Array<{
      id: string;
      url: string;
      displayText: string | null;
    }> | null;
  };
};

export type UpdateObjectiveStrategyTemplateMutationVariables = Exact<{
  updateObjectiveStrategyTemplateInput: Types.UpdateObjectiveStrategyTemplateInput;
}>;

export type UpdateObjectiveStrategyTemplateMutation = {
  updateObjectiveStrategyTemplate: {
    id: string;
    createdAt: any;
    updateAt: any;
    name: string;
    description: string | null;
    allMeasures: boolean;
    allDiseaseStateModules: boolean;
    createdBy: { id: string; fullName: string | null } | null;
    updateBy: { id: string; fullName: string | null } | null;
    measures: Array<{ id: number; name: string }> | null;
    diseaseStateModule: { id: number; name: string } | null;
    strategies: Array<{
      id: string;
      name: string;
      description: string | null;
    }> | null;
    resources: Array<{
      id: string;
      url: string;
      displayText: string | null;
    }> | null;
  };
};

export type ArchiveObjectiveStrategyTemplateMutationVariables = Exact<{
  id: string | number;
}>;

export type ArchiveObjectiveStrategyTemplateMutation = {
  archiveObjectiveStrategyTemplate: boolean;
};

export type RemoveObjectiveStrategyTemplateMutationVariables = Exact<{
  id: string | number;
}>;

export type RemoveObjectiveStrategyTemplateMutation = {
  removeObjectiveStrategyTemplate: boolean;
};

export type ObjectiveTemplateQueryVariables = Exact<{
  id: string | number;
}>;

export type ObjectiveTemplateQuery = {
  objectiveTemplate: {
    id: string;
    createdAt: any;
    updateAt: any;
    name: string;
    tags: Array<string> | null;
    cohortIds: Array<number> | null;
    createdBy: { id: string; fullName: string | null } | null;
    updateBy: { id: string; fullName: string | null } | null;
    diseaseStateModule: { id: number; code: string; name: string } | null;
    measures: Array<{ id: number; name: string }> | null;
    linkedStrategyTemplates: Array<{
      id: string;
      name: string;
      description: string | null;
      allMeasures: boolean;
      allDiseaseStateModules: boolean;
      diseaseStateModule: { id: number; name: string } | null;
      measures: Array<{ id: number; name: string }> | null;
      resources: Array<{
        id: string;
        url: string;
        displayText: string | null;
      }> | null;
    }> | null;
  };
};

export type ObjectiveTemplatesQueryVariables = Exact<{ [key: string]: never }>;

export type ObjectiveTemplatesQuery = {
  objectiveTemplates: Array<{
    id: string;
    createdAt: any;
    updateAt: any;
    name: string;
    tags: Array<string> | null;
    cohortIds: Array<number> | null;
    createdBy: { id: string; fullName: string | null } | null;
    updateBy: { id: string; fullName: string | null } | null;
    diseaseStateModule: { id: number; code: string; name: string } | null;
    measures: Array<{ id: number; name: string }> | null;
    linkedStrategyTemplates: Array<{
      id: string;
      name: string;
      description: string | null;
      allMeasures: boolean;
      allDiseaseStateModules: boolean;
      diseaseStateModule: { id: number; name: string } | null;
      measures: Array<{ id: number; name: string }> | null;
      resources: Array<{
        id: string;
        url: string;
        displayText: string | null;
      }> | null;
    }> | null;
  }>;
};

export type CreateObjectiveTemplateMutationVariables = Exact<{
  createObjectiveTemplateInput: Types.CreateObjectiveTemplateInput;
}>;

export type CreateObjectiveTemplateMutation = {
  createObjectiveTemplate: {
    id: string;
    createdAt: any;
    updateAt: any;
    name: string;
    tags: Array<string> | null;
    cohortIds: Array<number> | null;
    createdBy: { id: string; fullName: string | null } | null;
    updateBy: { id: string; fullName: string | null } | null;
    diseaseStateModule: { id: number; code: string; name: string } | null;
    measures: Array<{ id: number; name: string }> | null;
    linkedStrategyTemplates: Array<{
      id: string;
      name: string;
      description: string | null;
      allMeasures: boolean;
      allDiseaseStateModules: boolean;
      diseaseStateModule: { id: number; name: string } | null;
      measures: Array<{ id: number; name: string }> | null;
      resources: Array<{
        id: string;
        url: string;
        displayText: string | null;
      }> | null;
    }> | null;
  };
};

export type UpdateObjectiveTemplateMutationVariables = Exact<{
  updateObjectiveTemplateInput: Types.UpdateObjectiveTemplateInput;
}>;

export type UpdateObjectiveTemplateMutation = {
  updateObjectiveTemplate: {
    id: string;
    createdAt: any;
    updateAt: any;
    name: string;
    tags: Array<string> | null;
    cohortIds: Array<number> | null;
    createdBy: { id: string; fullName: string | null } | null;
    updateBy: { id: string; fullName: string | null } | null;
    diseaseStateModule: { id: number; code: string; name: string } | null;
    measures: Array<{ id: number; name: string }> | null;
    linkedStrategyTemplates: Array<{
      id: string;
      name: string;
      description: string | null;
      allMeasures: boolean;
      allDiseaseStateModules: boolean;
      diseaseStateModule: { id: number; name: string } | null;
      measures: Array<{ id: number; name: string }> | null;
      resources: Array<{
        id: string;
        url: string;
        displayText: string | null;
      }> | null;
    }> | null;
  };
};

export type ArchiveObjectiveTemplateMutationVariables = Exact<{
  id: string | number;
}>;

export type ArchiveObjectiveTemplateMutation = {
  archiveObjectiveTemplate: boolean;
};

export type ObjectiveStrategyAttachmentsQueryVariables = Exact<{
  id: string | number;
}>;

export type ObjectiveStrategyAttachmentsQuery = {
  objectiveStrategy: {
    id: string;
    attachments: Array<{
      id: string;
      name: string;
      extension: string;
      mimeType: string;
      createdAt: any;
    }> | null;
  };
};

export type ObjectiveStrategyTemplateAttachmentsQueryVariables = Exact<{
  id: string | number;
}>;

export type ObjectiveStrategyTemplateAttachmentsQuery = {
  objectiveStrategyTemplate: {
    id: string;
    attachments: Array<{
      id: string;
      name: string;
      extension: string;
      mimeType: string;
      createdAt: any;
    }> | null;
  };
};

export type RemoveStrategyAttachmentMutationVariables = Exact<{
  id: string | number;
}>;

export type RemoveStrategyAttachmentMutation = {
  removeStrategyAttachment: boolean;
};

export type DownloadStrategyAttachmentMutationVariables = Exact<{
  id: string | number;
}>;

export type DownloadStrategyAttachmentMutation = {
  downloadStrategyAttachment: { id: string; name: string; url: string };
};

export type GetTableauViewsForApolloQueryVariables = Exact<{
  measureIds?: Array<number> | number | null | undefined;
}>;

export type GetTableauViewsForApolloQuery = {
  tableauViews: Array<{ id: number; name: string }>;
};

export type GetDimensionClassesQueryVariables = Exact<{ [key: string]: never }>;

export type GetDimensionClassesQuery = { dimensionClasses: Array<string> };

export type GetDictionaryElementQueryVariables = Exact<{
  elementId: string;
}>;

export type GetDictionaryElementQuery = {
  element: {
    id: string;
    elementReference: string;
    shortName: string;
    name: string;
    codingInstructions: string | null;
    targetValue: string | null;
    dbDataType: string | null;
    dataType: Types.ElementDataType | null;
    precision: string | null;
    unitOfMeasure: string | null;
    selectionType: Types.ElementSelectionType | null;
    defaultValue: string | null;
    code: string | null;
    codeSystemName: string | null;
    vendorInstruction: string | null;
    section: { sectionDisplayName: string };
    selections: Array<{
      id: string;
      code: string | null;
      codeSystemName: string | null;
      selectionName: string;
      selectionDefinition: string | null;
    }> | null;
    definition: {
      id: string;
      title: string | null;
      definition: string;
      source: string | null;
    } | null;
    parentChildValidations: Array<{
      id: string;
      parentElementSelectionName: string | null;
      parent: {
        id: string;
        shortName: string;
        sourceMappings: Array<{
          id: string;
          target: { id: string; shortName: string } | null;
        }> | null;
        referenceTransformations: Array<{
          id: string;
          translation: {
            id: string;
            target: { id: string; shortName: string } | null;
          };
        }> | null;
        derivativeTransformations: Array<{
          id: string;
          translation: {
            id: string;
            target: { id: string; shortName: string } | null;
          };
        }> | null;
      };
      parentSelection: { id: string; selectionName: string } | null;
    }> | null;
    sourceMappings: Array<{
      id: string;
      valueMap: any;
      target: {
        id: string;
        shortName: string;
        name: string;
        pipelineElements: Array<{
          id: string;
          numeratorMeasures: Array<{ id: number; name: string }> | null;
          denominatorMeasures: Array<{ id: number; name: string }> | null;
          includeMeasures: Array<{ id: number; name: string }> | null;
        }>;
      } | null;
    }> | null;
    targetMappings: Array<{
      id: string;
      valueMap: any;
      source: { id: string; shortName: string } | null;
      transformation: {
        id: string;
        valueMap: any;
        reference: { id: string; shortName: string } | null;
        derivative: { id: string; shortName: string } | null;
      } | null;
    }> | null;
    referenceTransformations: Array<{
      id: string;
      valueMap: any;
      translation: {
        id: string;
        target: {
          id: string;
          shortName: string;
          pipelineElements: Array<{
            id: string;
            numeratorMeasures: Array<{ id: number; name: string }> | null;
            denominatorMeasures: Array<{ id: number; name: string }> | null;
            includeMeasures: Array<{ id: number; name: string }> | null;
          }>;
        } | null;
      };
      derivative: { id: string; shortName: string } | null;
    }> | null;
    derivativeTransformations: Array<{
      id: string;
      valueMap: any;
      translation: {
        id: string;
        target: {
          id: string;
          shortName: string;
          pipelineElements: Array<{
            id: string;
            numeratorMeasures: Array<{ id: number; name: string }> | null;
            denominatorMeasures: Array<{ id: number; name: string }> | null;
            includeMeasures: Array<{ id: number; name: string }> | null;
          }>;
        } | null;
      };
      reference: { id: string; shortName: string } | null;
    }> | null;
  };
};

export type GetReportAttributesQueryVariables = Exact<{
  diseaseStateModuleId: number;
  dateColumn: string;
}>;

export type GetReportAttributesQuery = {
  reportAttributes: {
    maxDate: any;
    minDate: any;
    refreshDate: any;
    procedures: Array<string> | null;
    defaultProcedures: Array<string> | null;
  };
};

export type DevelopmentDimensionQueryVariables = Exact<{
  dimensionId: number;
}>;

export type DevelopmentDimensionQuery = {
  developmentDimension: {
    id: string;
    dimensionId: number;
    active: boolean;
    label: string;
    fieldName: string;
    description: string | null;
    requirements: string | null;
    type: Types.DimensionType;
    class: string;
    priority: number | null;
    sortOrder: number;
    oeQualifying: boolean;
    aeQualifying: boolean;
    allMeasures: boolean;
    isGlobal: boolean;
    sourceContinuousField: string | null;
    multiProcTableId: string | null;
    excludeValues: Array<string> | null;
    valueMap: any;
    state: Types.EntityState;
    status: Types.EntityStatus;
    jiraLink: string | null;
    codeVersion: string | null;
    stateHistory: any;
    documentation: any;
    createdAt: any;
    updateAt: any;
    multiProcTable: { id: string; tableName: string } | null;
    diseaseStateModule: { id: number; name: string };
  };
};

export type DevelopmentDimensionsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type DevelopmentDimensionsQuery = {
  developmentDimensions: Array<{
    id: string;
    dimensionId: number;
    active: boolean;
    label: string;
    fieldName: string;
    description: string | null;
    requirements: string | null;
    type: Types.DimensionType;
    class: string;
    priority: number | null;
    sortOrder: number;
    oeQualifying: boolean;
    aeQualifying: boolean;
    allMeasures: boolean;
    isGlobal: boolean;
    sourceContinuousField: string | null;
    multiProcTableId: string | null;
    excludeValues: Array<string> | null;
    valueMap: any;
    state: Types.EntityState;
    status: Types.EntityStatus;
    jiraLink: string | null;
    codeVersion: string | null;
    stateHistory: any;
    documentation: any;
    createdAt: any;
    updateAt: any;
    multiProcTable: { id: string; tableName: string } | null;
    diseaseStateModule: { id: number; name: string };
  }>;
};

export type DevelopmentDimensionHistoryQueryVariables = Exact<{
  dimensionId: number;
}>;

export type DevelopmentDimensionHistoryQuery = {
  developmentDimensionHistory: Array<{
    id: string;
    dimensionId: number;
    active: boolean;
    label: string;
    description: string | null;
    state: Types.EntityState;
    status: Types.EntityStatus;
    jiraLink: string | null;
    codeVersion: string | null;
    stateHistory: any;
    documentation: any;
    createdAt: any;
    updateAt: any;
  }>;
};

export type RequestDimensionUpdateMutationVariables = Exact<{
  dimensionId: number;
}>;

export type RequestDimensionUpdateMutation = {
  requestDimensionUpdate: {
    id: string;
    dimensionId: number;
    active: boolean;
    label: string;
    description: string | null;
    state: Types.EntityState;
    status: Types.EntityStatus;
    jiraLink: string | null;
    codeVersion: string | null;
    stateHistory: any;
    documentation: any;
    createdAt: any;
    updateAt: any;
  };
};

export type RequestSmeReviewDimensionMutationVariables = Exact<{
  dimensionId: number;
  comment?: string | null | undefined;
}>;

export type RequestSmeReviewDimensionMutation = {
  requestSmeReviewForDimension: boolean;
};

export type ApproveSmeReviewDimensionMutationVariables = Exact<{
  dimensionId: number;
}>;

export type ApproveSmeReviewDimensionMutation = {
  approveSmeReviewForDimension: boolean;
};

export type RejectSmeReviewDimensionMutationVariables = Exact<{
  dimensionId: number;
  comment: string;
}>;

export type RejectSmeReviewDimensionMutation = {
  rejectSmeReviewForDimension: boolean;
};

export type CancelDevelopmentDimensionMutationVariables = Exact<{
  dimensionId: number;
  comment?: string | null | undefined;
}>;

export type CancelDevelopmentDimensionMutation = {
  cancelDevelopmentDimension: {
    id: string;
    dimensionId: number;
    active: boolean;
    label: string;
    description: string | null;
    state: Types.EntityState;
    status: Types.EntityStatus;
    jiraLink: string | null;
    codeVersion: string | null;
    stateHistory: any;
    documentation: any;
    createdAt: any;
    updateAt: any;
  };
};

export type CreateDevelopmentDimensionMutationVariables = Exact<{
  input: Types.CreateDevelopmentDimensionInput;
}>;

export type CreateDevelopmentDimensionMutation = {
  createDevelopmentDimension: {
    id: string;
    dimensionId: number;
    active: boolean;
    label: string;
    description: string | null;
    state: Types.EntityState;
    status: Types.EntityStatus;
    jiraLink: string | null;
    codeVersion: string | null;
    stateHistory: any;
    documentation: any;
    createdAt: any;
    updateAt: any;
  };
};

export type DevelopmentMeasureQueryVariables = Exact<{
  measureId: number;
}>;

export type DevelopmentMeasureQuery = {
  developmentMeasure: {
    id: string;
    measureId: number;
    active: boolean;
    name: string;
    ncdrMeasureName: string | null;
    description: string | null;
    commonMeasureDisplayName: string;
    numeratorUnit: string;
    accessCategory: Types.AccessCategory;
    opportunityType: Array<Types.OpportunityType>;
    publicationSource: Array<Types.PublicationSource> | null;
    summaryInitiativeMeasure: boolean;
    rareEvent: boolean;
    requirements: string | null;
    testCapture: string | null;
    registryMeasureId: number | null;
    validationSource: string | null;
    benchmarkExtraction: boolean;
    reportRowId: number | null;
    tableName: string | null;
    isBenchmark: boolean | null;
    summaryCohortId: number | null;
    excludedCohortIds: Array<number> | null;
    unit: string | null;
    numeratorColumnName: string | null;
    includeColumnName: string | null;
    denominatorColumnName: string | null;
    riskAdjusted: boolean;
    riskMetricId: string | null;
    aggregationFn: Array<string> | null;
    aggregationType: Types.SummaryCalculationType | null;
    outcomeType: Types.MeasureOutcomeType | null;
    roiCalcType: Types.SummaryCalculationType | null;
    higherIsBetter: boolean | null;
    dataTypeRequired: Types.MeasureInputDataType | null;
    losROIQualifying: boolean | null;
    adjustment: Array<string> | null;
    commonMeasureQualifying: boolean | null;
    costComponentMeasure: boolean | null;
    volumeMeasure: boolean | null;
    annualMeasureBaseId: string | null;
    state: Types.EntityState;
    status: Types.EntityStatus;
    jiraLink: string | null;
    codeVersion: string | null;
    stateHistory: any;
    numeratorDocumentation: any;
    denominatorDocumentation: any;
    includeDocumentation: any;
    riskMetricDocumentation: any;
    createdAt: any;
    updateAt: any;
    diseaseStateModule: { id: number; name: string };
  };
};

export type DevelopmentMeasuresQueryVariables = Exact<{ [key: string]: never }>;

export type DevelopmentMeasuresQuery = {
  developmentMeasures: Array<{
    id: string;
    measureId: number;
    active: boolean;
    name: string;
    ncdrMeasureName: string | null;
    description: string | null;
    commonMeasureDisplayName: string;
    numeratorUnit: string;
    accessCategory: Types.AccessCategory;
    opportunityType: Array<Types.OpportunityType>;
    publicationSource: Array<Types.PublicationSource> | null;
    summaryInitiativeMeasure: boolean;
    rareEvent: boolean;
    requirements: string | null;
    testCapture: string | null;
    registryMeasureId: number | null;
    validationSource: string | null;
    benchmarkExtraction: boolean;
    reportRowId: number | null;
    tableName: string | null;
    isBenchmark: boolean | null;
    summaryCohortId: number | null;
    excludedCohortIds: Array<number> | null;
    unit: string | null;
    numeratorColumnName: string | null;
    includeColumnName: string | null;
    denominatorColumnName: string | null;
    riskAdjusted: boolean;
    riskMetricId: string | null;
    aggregationFn: Array<string> | null;
    aggregationType: Types.SummaryCalculationType | null;
    outcomeType: Types.MeasureOutcomeType | null;
    roiCalcType: Types.SummaryCalculationType | null;
    higherIsBetter: boolean | null;
    dataTypeRequired: Types.MeasureInputDataType | null;
    losROIQualifying: boolean | null;
    adjustment: Array<string> | null;
    commonMeasureQualifying: boolean | null;
    costComponentMeasure: boolean | null;
    volumeMeasure: boolean | null;
    annualMeasureBaseId: string | null;
    state: Types.EntityState;
    status: Types.EntityStatus;
    jiraLink: string | null;
    codeVersion: string | null;
    stateHistory: any;
    numeratorDocumentation: any;
    denominatorDocumentation: any;
    includeDocumentation: any;
    riskMetricDocumentation: any;
    createdAt: any;
    updateAt: any;
    diseaseStateModule: { id: number; name: string };
  }>;
};

export type DevelopmentMeasureHistoryQueryVariables = Exact<{
  measureId: number;
}>;

export type DevelopmentMeasureHistoryQuery = {
  developmentMeasureHistory: Array<{
    id: string;
    measureId: number;
    active: boolean;
    name: string;
    description: string | null;
    state: Types.EntityState;
    status: Types.EntityStatus;
    jiraLink: string | null;
    codeVersion: string | null;
    stateHistory: any;
    numeratorDocumentation: any;
    denominatorDocumentation: any;
    includeDocumentation: any;
    riskMetricDocumentation: any;
    createdAt: any;
    updateAt: any;
  }>;
};

export type RequestMeasureUpdateMutationVariables = Exact<{
  measureId: number;
}>;

export type RequestMeasureUpdateMutation = {
  requestMeasureUpdate: {
    id: string;
    measureId: number;
    active: boolean;
    name: string;
    description: string | null;
    state: Types.EntityState;
    status: Types.EntityStatus;
    jiraLink: string | null;
    codeVersion: string | null;
    stateHistory: any;
    numeratorDocumentation: any;
    denominatorDocumentation: any;
    includeDocumentation: any;
    riskMetricDocumentation: any;
    createdAt: any;
    updateAt: any;
  };
};

export type RequestSmeReviewMeasureMutationVariables = Exact<{
  measureId: number;
  comment?: string | null | undefined;
}>;

export type RequestSmeReviewMeasureMutation = {
  requestSmeReviewForMeasure: boolean;
};

export type ApproveSmeReviewMeasureMutationVariables = Exact<{
  measureId: number;
}>;

export type ApproveSmeReviewMeasureMutation = {
  approveSmeReviewForMeasure: boolean;
};

export type RejectSmeReviewMeasureMutationVariables = Exact<{
  measureId: number;
  comment: string;
}>;

export type RejectSmeReviewMeasureMutation = {
  rejectSmeReviewForMeasure: boolean;
};

export type CancelDevelopmentMeasureMutationVariables = Exact<{
  measureId: number;
  comment?: string | null | undefined;
}>;

export type CancelDevelopmentMeasureMutation = {
  cancelDevelopmentMeasure: {
    id: string;
    measureId: number;
    active: boolean;
    name: string;
    description: string | null;
    state: Types.EntityState;
    status: Types.EntityStatus;
    jiraLink: string | null;
    codeVersion: string | null;
    stateHistory: any;
    numeratorDocumentation: any;
    denominatorDocumentation: any;
    includeDocumentation: any;
    riskMetricDocumentation: any;
    createdAt: any;
    updateAt: any;
  };
};

export type CreateDevelopmentMeasureMutationVariables = Exact<{
  input: Types.CreateDevelopmentMeasureInput;
}>;

export type CreateDevelopmentMeasureMutation = {
  createDevelopmentMeasure: {
    id: string;
    measureId: number;
    active: boolean;
    name: string;
    description: string | null;
    state: Types.EntityState;
    status: Types.EntityStatus;
    jiraLink: string | null;
    codeVersion: string | null;
    stateHistory: any;
    numeratorDocumentation: any;
    denominatorDocumentation: any;
    includeDocumentation: any;
    riskMetricDocumentation: any;
    createdAt: any;
    updateAt: any;
  };
};

export type DevelopmentRoiMetricQueryVariables = Exact<{
  roiMetricId: string;
}>;

export type DevelopmentRoiMetricQuery = {
  developmentRoiMetric: {
    id: string;
    roiMetricId: string;
    active: boolean;
    label: string;
    fieldName: string;
    legacyDescription: string | null;
    higherIsBetter: boolean;
    state: Types.EntityState;
    status: Types.EntityStatus;
    jiraLink: string | null;
    codeVersion: string | null;
    stateHistory: any;
    documentation: any;
    createdAt: any;
    updateAt: any;
    diseaseStateModule: { id: number; name: string };
  };
};

export type DevelopmentRoiMetricsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type DevelopmentRoiMetricsQuery = {
  developmentRoiMetrics: Array<{
    id: string;
    roiMetricId: string;
    active: boolean;
    label: string;
    fieldName: string;
    legacyDescription: string | null;
    higherIsBetter: boolean;
    state: Types.EntityState;
    status: Types.EntityStatus;
    jiraLink: string | null;
    codeVersion: string | null;
    stateHistory: any;
    documentation: any;
    createdAt: any;
    updateAt: any;
    diseaseStateModule: { id: number; name: string };
  }>;
};

export type DevelopmentRoiMetricHistoryQueryVariables = Exact<{
  roiMetricId: string;
}>;

export type DevelopmentRoiMetricHistoryQuery = {
  developmentRoiMetricHistory: Array<{
    id: string;
    roiMetricId: string;
    active: boolean;
    state: Types.EntityState;
    status: Types.EntityStatus;
    jiraLink: string | null;
    codeVersion: string | null;
    stateHistory: any;
    documentation: any;
    createdAt: any;
    updateAt: any;
  }>;
};

export type RequestRoiMetricUpdateMutationVariables = Exact<{
  roiMetricId: string;
}>;

export type RequestRoiMetricUpdateMutation = {
  requestRoiMetricUpdate: {
    id: string;
    roiMetricId: string;
    active: boolean;
    state: Types.EntityState;
    status: Types.EntityStatus;
    jiraLink: string | null;
    codeVersion: string | null;
    stateHistory: any;
    documentation: any;
    createdAt: any;
    updateAt: any;
  };
};

export type RequestSmeReviewRoiMetricMutationVariables = Exact<{
  roiMetricId: string;
  comment?: string | null | undefined;
}>;

export type RequestSmeReviewRoiMetricMutation = {
  requestSmeReviewForRoiMetric: boolean;
};

export type ApproveSmeReviewRoiMetricMutationVariables = Exact<{
  roiMetricId: string;
}>;

export type ApproveSmeReviewRoiMetricMutation = {
  approveSmeReviewForRoiMetric: boolean;
};

export type RejectSmeReviewRoiMetricMutationVariables = Exact<{
  roiMetricId: string;
  comment: string;
}>;

export type RejectSmeReviewRoiMetricMutation = {
  rejectSmeReviewForRoiMetric: boolean;
};

export type CancelDevelopmentRoiMetricMutationVariables = Exact<{
  roiMetricId: string;
  comment?: string | null | undefined;
}>;

export type CancelDevelopmentRoiMetricMutation = {
  cancelDevelopmentRoiMetric: {
    id: string;
    roiMetricId: string;
    active: boolean;
    state: Types.EntityState;
    status: Types.EntityStatus;
    jiraLink: string | null;
    codeVersion: string | null;
    stateHistory: any;
    documentation: any;
    createdAt: any;
    updateAt: any;
  };
};

export type CreateDevelopmentRoiMetricMutationVariables = Exact<{
  input: Types.CreateDevelopmentRoiMetricInput;
}>;

export type CreateDevelopmentRoiMetricMutation = {
  createDevelopmentRoiMetric: {
    id: string;
    roiMetricId: string;
    active: boolean;
    state: Types.EntityState;
    status: Types.EntityStatus;
    jiraLink: string | null;
    codeVersion: string | null;
    stateHistory: any;
    documentation: any;
    createdAt: any;
    updateAt: any;
  };
};

export type MeasureMetadataHistoryQueryVariables = Exact<{
  id: number;
  version: string;
}>;

export type MeasureMetadataHistoryQuery = {
  measureMetadataHistory: {
    id: string;
    name: string;
    commonMeasureDisplayName: string;
    summaryInitiativeMeasure: boolean;
    rareEvent: boolean;
    accessCategory: Types.AccessCategory;
    opportunityType: Array<Types.OpportunityType>;
    version: string | null;
    description: string | null;
    numeratorUnit: string | null;
    publicationSource: Array<Types.PublicationSource> | null;
    tableName: string | null;
    diseaseStateModule: any;
    isBenchmark: boolean | null;
    dimensionSets: any;
    summaryCohortId: number | null;
    excludedCohortIds: Array<number> | null;
    unit: string | null;
    numeratorColumnName: string | null;
    includeColumnName: string | null;
    denominatorColumnName: string | null;
    riskMetricId: string | null;
    aggregationFn: Array<string> | null;
    aggregationType: Types.SummaryCalculationType | null;
    outcomeType: Types.MeasureOutcomeType | null;
    roiCalcType: Types.SummaryCalculationType | null;
    higherIsBetter: boolean | null;
    dataTypeRequired: Types.MeasureInputDataType | null;
    roiMetrics: any;
    losROIQualifying: boolean | null;
    adjustment: Array<string> | null;
    commonMeasureQualifying: boolean | null;
    costComponentMeasure: boolean | null;
    createdAt: any;
    updateAt: any;
    createdBy: { fullName: string | null } | null;
    updateBy: { fullName: string | null } | null;
  };
};

export type DimensionHistoryQueryVariables = Exact<{
  id: number;
  version: string;
}>;

export type DimensionHistoryQuery = {
  dimensionHistory: {
    id: string;
    dimensionId: number;
    version: string;
    label: string;
    fieldName: string;
    description: string | null;
    requirements: string | null;
    legacyDescription: string | null;
    type: Types.DimensionType;
    class: string;
    sortOrder: number;
    priority: number | null;
    sourceContinuousField: string | null;
    multiProcTableName: string | null;
    oeQualifying: boolean;
    aeQualifying: boolean;
    allMeasures: boolean;
    hideFromReports: boolean;
    isGlobal: boolean;
    valueMap: any;
    excludeValues: Array<string> | null;
    pipelineElementId: string | null;
    diseaseStateModuleId: number;
    createdAt: any;
    updateAt: any;
  };
};

export type RoiMetricHistoryQueryVariables = Exact<{
  id: string;
  version: string;
}>;

export type RoiMetricHistoryQuery = {
  roiMetricHistory: {
    id: string;
    roiMetricId: string;
    version: string;
    fieldName: string;
    label: string;
    legacyDescription: string | null;
    higherIsBetter: boolean;
    pipelineElementId: string | null;
    createdAt: any;
    updateAt: any;
    createdBy: { fullName: string | null } | null;
    updateBy: { fullName: string | null } | null;
  };
};

export type UpdateDevelopmentDimensionMutationVariables = Exact<{
  input: Types.UpdateDevelopmentDimensionInput;
}>;

export type UpdateDevelopmentDimensionMutation = {
  updateDevelopmentDimension: {
    id: string;
    dimensionId: number;
    active: boolean;
    label: string;
    description: string | null;
    state: Types.EntityState;
    status: Types.EntityStatus;
    jiraLink: string | null;
    codeVersion: string | null;
    stateHistory: any;
    documentation: any;
    createdAt: any;
    updateAt: any;
  };
};

export type UpdateDevelopmentMeasureMutationVariables = Exact<{
  input: Types.UpdateDevelopmentMeasureInput;
}>;

export type UpdateDevelopmentMeasureMutation = {
  updateDevelopmentMeasure: {
    id: string;
    measureId: number;
    active: boolean;
    name: string;
    description: string | null;
    state: Types.EntityState;
    status: Types.EntityStatus;
    jiraLink: string | null;
    codeVersion: string | null;
    stateHistory: any;
    numeratorDocumentation: any;
    denominatorDocumentation: any;
    includeDocumentation: any;
    riskMetricDocumentation: any;
    createdAt: any;
    updateAt: any;
  };
};

export type UpdateDevelopmentRoiMetricMutationVariables = Exact<{
  input: Types.UpdateDevelopmentRoiMetricInput;
}>;

export type UpdateDevelopmentRoiMetricMutation = {
  updateDevelopmentRoiMetric: {
    id: string;
    roiMetricId: string;
    active: boolean;
    label: string;
    state: Types.EntityState;
    status: Types.EntityStatus;
    jiraLink: string | null;
    codeVersion: string | null;
    stateHistory: any;
    documentation: any;
    createdAt: any;
    updateAt: any;
  };
};

export type GetDsmDimensionsQueryVariables = Exact<{
  diseaseStateModuleId: number;
  type?: Types.DimensionType | null | undefined;
  aeQualifying?: boolean | null | undefined;
}>;

export type GetDsmDimensionsQuery = {
  dimensions: Array<{
    id: number;
    label: string;
    sortOrder: number;
    type: Types.DimensionType;
    fieldName: string;
  }>;
};

export type GetRlsAllowedContextsQueryVariables = Exact<{
  diseaseStateModuleId: number;
}>;

export type GetRlsAllowedContextsQuery = {
  rlsAllowedContexts: Array<Types.RlsUserContextType>;
};

export type GetRlsAllowedCareEntityCodesQueryVariables = Exact<{
  diseaseStateModuleId: number;
  type?: Types.CareEntityType | null | undefined;
}>;

export type GetRlsAllowedCareEntityCodesQuery = {
  rlsAllowedCareEntityCodes: Array<string>;
};

export type TenantOffboardingJobFieldsFragment = {
  id: string;
  tenantId: string | null;
  tenantCode: string;
  status: Types.TenantOffboardingJobStatus;
  approvalTicketUrl: string | null;
  latestVersion: number | null;
  tenantWasActive: boolean | null;
  isCascade: boolean;
  deletionStarted: boolean;
  createdAt: any;
  cancelledAt: any;
  owner: { id: string; fullName: string | null; email: string } | null;
  cancelledBy: { id: string; fullName: string | null } | null;
  approvers: Array<{
    id: string;
    approverId: string | null;
    status: Types.TenantOffboardingApproverStatus;
    approvedVersion: number | null;
    reason: string | null;
    decidedAt: any;
    approver: { id: string; fullName: string | null; email: string } | null;
  }>;
  latestDiscovery: {
    id: string;
    jobId: string | null;
    trigger: Types.TenantOffboardingDiscoveryTrigger;
    status: Types.TenantOffboardingDiscoveryStatus;
    resultVersion: number | null;
    goneCount: number;
    error: string | null;
    createdAt: any;
    completedAt: any;
    triggeredById: string | null;
    triggeredBy: { id: string; fullName: string | null } | null;
  } | null;
  latestDeletion: {
    id: string;
    jobId: string | null;
    version: number;
    outcome: Types.TenantOffboardingDeletionOutcome;
    createdAt: any;
    completedAt: any;
    startedBy: { id: string; fullName: string | null } | null;
    keptSources: Array<{
      key: string;
      reason: string;
      leaf: string;
      name: string;
      target: string;
      container: string | null;
      path: string | null;
      datasource: string | null;
    }>;
    validationFindings: Array<{
      category: string;
      subStep: string;
      target: string;
      error: string;
      leftoverCount: number | null;
    }>;
  } | null;
};

export type TenantOffboardingDeletionFieldsFragment = {
  id: string;
  jobId: string | null;
  version: number;
  outcome: Types.TenantOffboardingDeletionOutcome;
  createdAt: any;
  completedAt: any;
  startedBy: { id: string; fullName: string | null } | null;
  keptSources: Array<{
    key: string;
    reason: string;
    leaf: string;
    name: string;
    target: string;
    container: string | null;
    path: string | null;
    datasource: string | null;
  }>;
  validationFindings: Array<{
    category: string;
    subStep: string;
    target: string;
    error: string;
    leftoverCount: number | null;
  }>;
};

export type TenantOffboardingDiscoveryFieldsFragment = {
  id: string;
  jobId: string | null;
  trigger: Types.TenantOffboardingDiscoveryTrigger;
  status: Types.TenantOffboardingDiscoveryStatus;
  resultVersion: number | null;
  goneCount: number;
  error: string | null;
  createdAt: any;
  completedAt: any;
  triggeredById: string | null;
  triggeredBy: { id: string; fullName: string | null } | null;
};

export type GetTenantOffboardingJobQueryVariables = Exact<{
  tenantId: string;
}>;

export type GetTenantOffboardingJobQuery = {
  tenantOffboardingJob: {
    id: string;
    tenantId: string | null;
    tenantCode: string;
    status: Types.TenantOffboardingJobStatus;
    approvalTicketUrl: string | null;
    latestVersion: number | null;
    tenantWasActive: boolean | null;
    isCascade: boolean;
    deletionStarted: boolean;
    createdAt: any;
    cancelledAt: any;
    owner: { id: string; fullName: string | null; email: string } | null;
    cancelledBy: { id: string; fullName: string | null } | null;
    approvers: Array<{
      id: string;
      approverId: string | null;
      status: Types.TenantOffboardingApproverStatus;
      approvedVersion: number | null;
      reason: string | null;
      decidedAt: any;
      approver: { id: string; fullName: string | null; email: string } | null;
    }>;
    latestDiscovery: {
      id: string;
      jobId: string | null;
      trigger: Types.TenantOffboardingDiscoveryTrigger;
      status: Types.TenantOffboardingDiscoveryStatus;
      resultVersion: number | null;
      goneCount: number;
      error: string | null;
      createdAt: any;
      completedAt: any;
      triggeredById: string | null;
      triggeredBy: { id: string; fullName: string | null } | null;
    } | null;
    latestDeletion: {
      id: string;
      jobId: string | null;
      version: number;
      outcome: Types.TenantOffboardingDeletionOutcome;
      createdAt: any;
      completedAt: any;
      startedBy: { id: string; fullName: string | null } | null;
      keptSources: Array<{
        key: string;
        reason: string;
        leaf: string;
        name: string;
        target: string;
        container: string | null;
        path: string | null;
        datasource: string | null;
      }>;
      validationFindings: Array<{
        category: string;
        subStep: string;
        target: string;
        error: string;
        leftoverCount: number | null;
      }>;
    } | null;
  } | null;
};

export type GetTenantOffboardingJobByIdQueryVariables = Exact<{
  id: string;
}>;

export type GetTenantOffboardingJobByIdQuery = {
  tenantOffboardingJobById: {
    id: string;
    tenantId: string | null;
    tenantCode: string;
    status: Types.TenantOffboardingJobStatus;
    approvalTicketUrl: string | null;
    latestVersion: number | null;
    tenantWasActive: boolean | null;
    isCascade: boolean;
    deletionStarted: boolean;
    createdAt: any;
    cancelledAt: any;
    owner: { id: string; fullName: string | null; email: string } | null;
    cancelledBy: { id: string; fullName: string | null } | null;
    approvers: Array<{
      id: string;
      approverId: string | null;
      status: Types.TenantOffboardingApproverStatus;
      approvedVersion: number | null;
      reason: string | null;
      decidedAt: any;
      approver: { id: string; fullName: string | null; email: string } | null;
    }>;
    latestDiscovery: {
      id: string;
      jobId: string | null;
      trigger: Types.TenantOffboardingDiscoveryTrigger;
      status: Types.TenantOffboardingDiscoveryStatus;
      resultVersion: number | null;
      goneCount: number;
      error: string | null;
      createdAt: any;
      completedAt: any;
      triggeredById: string | null;
      triggeredBy: { id: string; fullName: string | null } | null;
    } | null;
    latestDeletion: {
      id: string;
      jobId: string | null;
      version: number;
      outcome: Types.TenantOffboardingDeletionOutcome;
      createdAt: any;
      completedAt: any;
      startedBy: { id: string; fullName: string | null } | null;
      keptSources: Array<{
        key: string;
        reason: string;
        leaf: string;
        name: string;
        target: string;
        container: string | null;
        path: string | null;
        datasource: string | null;
      }>;
      validationFindings: Array<{
        category: string;
        subStep: string;
        target: string;
        error: string;
        leftoverCount: number | null;
      }>;
    } | null;
  };
};

export type GetTenantOffboardingManifestQueryVariables = Exact<{
  id: string;
  version: number;
  compareTo?: number | null | undefined;
  discoveryId?: string | null | undefined;
}>;

export type GetTenantOffboardingManifestQuery = {
  tenantOffboardingManifest: {
    version: number;
    createdAt: any;
    comparedToVersion: number | null;
    newCount: number | null;
    goneCount: number | null;
    entries: Array<{
      key: string;
      treePath: Array<string>;
      leaf: string;
      category: string;
      name: string;
      datasource: string | null;
      container: string | null;
      target: string;
      path: string | null;
      count: number | null;
      change: Types.ManifestEntryChange | null;
    }>;
  };
};

export type GetTenantOffboardingVersionsQueryVariables = Exact<{
  id: string;
}>;

export type GetTenantOffboardingVersionsQuery = {
  tenantOffboardingVersions: Array<{
    version: number;
    createdAt: any;
    entryCount: number;
    comparedToVersion: number | null;
    newCount: number | null;
    goneCount: number | null;
    trigger: Types.TenantOffboardingDiscoveryTrigger | null;
    triggeredBy: { id: string; fullName: string | null } | null;
  }>;
};

export type GetTenantOffboardingDiscoveryQueryVariables = Exact<{
  id: string;
}>;

export type GetTenantOffboardingDiscoveryQuery = {
  tenantOffboardingDiscovery: {
    id: string;
    jobId: string | null;
    trigger: Types.TenantOffboardingDiscoveryTrigger;
    status: Types.TenantOffboardingDiscoveryStatus;
    resultVersion: number | null;
    goneCount: number;
    error: string | null;
    createdAt: any;
    completedAt: any;
    triggeredById: string | null;
    triggeredBy: { id: string; fullName: string | null } | null;
  };
};

export type StartTenantOffboardingApprovalDiscoveryMutationVariables = Exact<{
  id: string;
}>;

export type StartTenantOffboardingApprovalDiscoveryMutation = {
  startTenantOffboardingApprovalDiscovery: {
    id: string;
    jobId: string | null;
    trigger: Types.TenantOffboardingDiscoveryTrigger;
    status: Types.TenantOffboardingDiscoveryStatus;
    resultVersion: number | null;
    goneCount: number;
    error: string | null;
    createdAt: any;
    completedAt: any;
    triggeredById: string | null;
    triggeredBy: { id: string; fullName: string | null } | null;
  };
};

export type RediscoverTenantOffboardingMutationVariables = Exact<{
  id: string;
}>;

export type RediscoverTenantOffboardingMutation = {
  rediscoverTenantOffboarding: {
    id: string;
    tenantId: string | null;
    tenantCode: string;
    status: Types.TenantOffboardingJobStatus;
    approvalTicketUrl: string | null;
    latestVersion: number | null;
    tenantWasActive: boolean | null;
    isCascade: boolean;
    deletionStarted: boolean;
    createdAt: any;
    cancelledAt: any;
    owner: { id: string; fullName: string | null; email: string } | null;
    cancelledBy: { id: string; fullName: string | null } | null;
    approvers: Array<{
      id: string;
      approverId: string | null;
      status: Types.TenantOffboardingApproverStatus;
      approvedVersion: number | null;
      reason: string | null;
      decidedAt: any;
      approver: { id: string; fullName: string | null; email: string } | null;
    }>;
    latestDiscovery: {
      id: string;
      jobId: string | null;
      trigger: Types.TenantOffboardingDiscoveryTrigger;
      status: Types.TenantOffboardingDiscoveryStatus;
      resultVersion: number | null;
      goneCount: number;
      error: string | null;
      createdAt: any;
      completedAt: any;
      triggeredById: string | null;
      triggeredBy: { id: string; fullName: string | null } | null;
    } | null;
    latestDeletion: {
      id: string;
      jobId: string | null;
      version: number;
      outcome: Types.TenantOffboardingDeletionOutcome;
      createdAt: any;
      completedAt: any;
      startedBy: { id: string; fullName: string | null } | null;
      keptSources: Array<{
        key: string;
        reason: string;
        leaf: string;
        name: string;
        target: string;
        container: string | null;
        path: string | null;
        datasource: string | null;
      }>;
      validationFindings: Array<{
        category: string;
        subStep: string;
        target: string;
        error: string;
        leftoverCount: number | null;
      }>;
    } | null;
  };
};

export type GetTenantOffboardingEligibleApproversQueryVariables = Exact<{
  tenantId: string;
}>;

export type GetTenantOffboardingEligibleApproversQuery = {
  tenantOffboardingEligibleApprovers: Array<{
    id: string;
    fullName: string | null;
    email: string;
  }>;
};

export type RequestTenantOffboardingMutationVariables = Exact<{
  input: Types.RequestTenantOffboardingInput;
}>;

export type RequestTenantOffboardingMutation = {
  requestTenantOffboarding: {
    id: string;
    tenantId: string | null;
    tenantCode: string;
    status: Types.TenantOffboardingJobStatus;
    approvalTicketUrl: string | null;
    latestVersion: number | null;
    tenantWasActive: boolean | null;
    isCascade: boolean;
    deletionStarted: boolean;
    createdAt: any;
    cancelledAt: any;
    owner: { id: string; fullName: string | null; email: string } | null;
    cancelledBy: { id: string; fullName: string | null } | null;
    approvers: Array<{
      id: string;
      approverId: string | null;
      status: Types.TenantOffboardingApproverStatus;
      approvedVersion: number | null;
      reason: string | null;
      decidedAt: any;
      approver: { id: string; fullName: string | null; email: string } | null;
    }>;
    latestDiscovery: {
      id: string;
      jobId: string | null;
      trigger: Types.TenantOffboardingDiscoveryTrigger;
      status: Types.TenantOffboardingDiscoveryStatus;
      resultVersion: number | null;
      goneCount: number;
      error: string | null;
      createdAt: any;
      completedAt: any;
      triggeredById: string | null;
      triggeredBy: { id: string; fullName: string | null } | null;
    } | null;
    latestDeletion: {
      id: string;
      jobId: string | null;
      version: number;
      outcome: Types.TenantOffboardingDeletionOutcome;
      createdAt: any;
      completedAt: any;
      startedBy: { id: string; fullName: string | null } | null;
      keptSources: Array<{
        key: string;
        reason: string;
        leaf: string;
        name: string;
        target: string;
        container: string | null;
        path: string | null;
        datasource: string | null;
      }>;
      validationFindings: Array<{
        category: string;
        subStep: string;
        target: string;
        error: string;
        leftoverCount: number | null;
      }>;
    } | null;
  };
};

export type ApproveTenantOffboardingMutationVariables = Exact<{
  id: string;
  version: number;
  discoveryId: string;
}>;

export type ApproveTenantOffboardingMutation = {
  approveTenantOffboarding: {
    id: string;
    tenantId: string | null;
    tenantCode: string;
    status: Types.TenantOffboardingJobStatus;
    approvalTicketUrl: string | null;
    latestVersion: number | null;
    tenantWasActive: boolean | null;
    isCascade: boolean;
    deletionStarted: boolean;
    createdAt: any;
    cancelledAt: any;
    owner: { id: string; fullName: string | null; email: string } | null;
    cancelledBy: { id: string; fullName: string | null } | null;
    approvers: Array<{
      id: string;
      approverId: string | null;
      status: Types.TenantOffboardingApproverStatus;
      approvedVersion: number | null;
      reason: string | null;
      decidedAt: any;
      approver: { id: string; fullName: string | null; email: string } | null;
    }>;
    latestDiscovery: {
      id: string;
      jobId: string | null;
      trigger: Types.TenantOffboardingDiscoveryTrigger;
      status: Types.TenantOffboardingDiscoveryStatus;
      resultVersion: number | null;
      goneCount: number;
      error: string | null;
      createdAt: any;
      completedAt: any;
      triggeredById: string | null;
      triggeredBy: { id: string; fullName: string | null } | null;
    } | null;
    latestDeletion: {
      id: string;
      jobId: string | null;
      version: number;
      outcome: Types.TenantOffboardingDeletionOutcome;
      createdAt: any;
      completedAt: any;
      startedBy: { id: string; fullName: string | null } | null;
      keptSources: Array<{
        key: string;
        reason: string;
        leaf: string;
        name: string;
        target: string;
        container: string | null;
        path: string | null;
        datasource: string | null;
      }>;
      validationFindings: Array<{
        category: string;
        subStep: string;
        target: string;
        error: string;
        leftoverCount: number | null;
      }>;
    } | null;
  };
};

export type RejectTenantOffboardingMutationVariables = Exact<{
  id: string;
  reason: string;
}>;

export type RejectTenantOffboardingMutation = {
  rejectTenantOffboarding: {
    id: string;
    tenantId: string | null;
    tenantCode: string;
    status: Types.TenantOffboardingJobStatus;
    approvalTicketUrl: string | null;
    latestVersion: number | null;
    tenantWasActive: boolean | null;
    isCascade: boolean;
    deletionStarted: boolean;
    createdAt: any;
    cancelledAt: any;
    owner: { id: string; fullName: string | null; email: string } | null;
    cancelledBy: { id: string; fullName: string | null } | null;
    approvers: Array<{
      id: string;
      approverId: string | null;
      status: Types.TenantOffboardingApproverStatus;
      approvedVersion: number | null;
      reason: string | null;
      decidedAt: any;
      approver: { id: string; fullName: string | null; email: string } | null;
    }>;
    latestDiscovery: {
      id: string;
      jobId: string | null;
      trigger: Types.TenantOffboardingDiscoveryTrigger;
      status: Types.TenantOffboardingDiscoveryStatus;
      resultVersion: number | null;
      goneCount: number;
      error: string | null;
      createdAt: any;
      completedAt: any;
      triggeredById: string | null;
      triggeredBy: { id: string; fullName: string | null } | null;
    } | null;
    latestDeletion: {
      id: string;
      jobId: string | null;
      version: number;
      outcome: Types.TenantOffboardingDeletionOutcome;
      createdAt: any;
      completedAt: any;
      startedBy: { id: string; fullName: string | null } | null;
      keptSources: Array<{
        key: string;
        reason: string;
        leaf: string;
        name: string;
        target: string;
        container: string | null;
        path: string | null;
        datasource: string | null;
      }>;
      validationFindings: Array<{
        category: string;
        subStep: string;
        target: string;
        error: string;
        leftoverCount: number | null;
      }>;
    } | null;
  };
};

export type CancelTenantOffboardingMutationVariables = Exact<{
  id: string;
}>;

export type CancelTenantOffboardingMutation = {
  cancelTenantOffboarding: {
    id: string;
    tenantId: string | null;
    tenantCode: string;
    status: Types.TenantOffboardingJobStatus;
    approvalTicketUrl: string | null;
    latestVersion: number | null;
    tenantWasActive: boolean | null;
    isCascade: boolean;
    deletionStarted: boolean;
    createdAt: any;
    cancelledAt: any;
    owner: { id: string; fullName: string | null; email: string } | null;
    cancelledBy: { id: string; fullName: string | null } | null;
    approvers: Array<{
      id: string;
      approverId: string | null;
      status: Types.TenantOffboardingApproverStatus;
      approvedVersion: number | null;
      reason: string | null;
      decidedAt: any;
      approver: { id: string; fullName: string | null; email: string } | null;
    }>;
    latestDiscovery: {
      id: string;
      jobId: string | null;
      trigger: Types.TenantOffboardingDiscoveryTrigger;
      status: Types.TenantOffboardingDiscoveryStatus;
      resultVersion: number | null;
      goneCount: number;
      error: string | null;
      createdAt: any;
      completedAt: any;
      triggeredById: string | null;
      triggeredBy: { id: string; fullName: string | null } | null;
    } | null;
    latestDeletion: {
      id: string;
      jobId: string | null;
      version: number;
      outcome: Types.TenantOffboardingDeletionOutcome;
      createdAt: any;
      completedAt: any;
      startedBy: { id: string; fullName: string | null } | null;
      keptSources: Array<{
        key: string;
        reason: string;
        leaf: string;
        name: string;
        target: string;
        container: string | null;
        path: string | null;
        datasource: string | null;
      }>;
      validationFindings: Array<{
        category: string;
        subStep: string;
        target: string;
        error: string;
        leftoverCount: number | null;
      }>;
    } | null;
  };
};

export type RetryTenantOffboardingDiscoveryMutationVariables = Exact<{
  id: string;
}>;

export type RetryTenantOffboardingDiscoveryMutation = {
  retryTenantOffboardingDiscovery: {
    id: string;
    tenantId: string | null;
    tenantCode: string;
    status: Types.TenantOffboardingJobStatus;
    approvalTicketUrl: string | null;
    latestVersion: number | null;
    tenantWasActive: boolean | null;
    isCascade: boolean;
    deletionStarted: boolean;
    createdAt: any;
    cancelledAt: any;
    owner: { id: string; fullName: string | null; email: string } | null;
    cancelledBy: { id: string; fullName: string | null } | null;
    approvers: Array<{
      id: string;
      approverId: string | null;
      status: Types.TenantOffboardingApproverStatus;
      approvedVersion: number | null;
      reason: string | null;
      decidedAt: any;
      approver: { id: string; fullName: string | null; email: string } | null;
    }>;
    latestDiscovery: {
      id: string;
      jobId: string | null;
      trigger: Types.TenantOffboardingDiscoveryTrigger;
      status: Types.TenantOffboardingDiscoveryStatus;
      resultVersion: number | null;
      goneCount: number;
      error: string | null;
      createdAt: any;
      completedAt: any;
      triggeredById: string | null;
      triggeredBy: { id: string; fullName: string | null } | null;
    } | null;
    latestDeletion: {
      id: string;
      jobId: string | null;
      version: number;
      outcome: Types.TenantOffboardingDeletionOutcome;
      createdAt: any;
      completedAt: any;
      startedBy: { id: string; fullName: string | null } | null;
      keptSources: Array<{
        key: string;
        reason: string;
        leaf: string;
        name: string;
        target: string;
        container: string | null;
        path: string | null;
        datasource: string | null;
      }>;
      validationFindings: Array<{
        category: string;
        subStep: string;
        target: string;
        error: string;
        leftoverCount: number | null;
      }>;
    } | null;
  };
};

export type DeleteTenantOffboardingMutationVariables = Exact<{
  input: Types.DeleteTenantOffboardingInput;
}>;

export type DeleteTenantOffboardingMutation = {
  deleteTenantOffboarding: {
    id: string;
    tenantId: string | null;
    tenantCode: string;
    status: Types.TenantOffboardingJobStatus;
    approvalTicketUrl: string | null;
    latestVersion: number | null;
    tenantWasActive: boolean | null;
    isCascade: boolean;
    deletionStarted: boolean;
    createdAt: any;
    cancelledAt: any;
    owner: { id: string; fullName: string | null; email: string } | null;
    cancelledBy: { id: string; fullName: string | null } | null;
    approvers: Array<{
      id: string;
      approverId: string | null;
      status: Types.TenantOffboardingApproverStatus;
      approvedVersion: number | null;
      reason: string | null;
      decidedAt: any;
      approver: { id: string; fullName: string | null; email: string } | null;
    }>;
    latestDiscovery: {
      id: string;
      jobId: string | null;
      trigger: Types.TenantOffboardingDiscoveryTrigger;
      status: Types.TenantOffboardingDiscoveryStatus;
      resultVersion: number | null;
      goneCount: number;
      error: string | null;
      createdAt: any;
      completedAt: any;
      triggeredById: string | null;
      triggeredBy: { id: string; fullName: string | null } | null;
    } | null;
    latestDeletion: {
      id: string;
      jobId: string | null;
      version: number;
      outcome: Types.TenantOffboardingDeletionOutcome;
      createdAt: any;
      completedAt: any;
      startedBy: { id: string; fullName: string | null } | null;
      keptSources: Array<{
        key: string;
        reason: string;
        leaf: string;
        name: string;
        target: string;
        container: string | null;
        path: string | null;
        datasource: string | null;
      }>;
      validationFindings: Array<{
        category: string;
        subStep: string;
        target: string;
        error: string;
        leftoverCount: number | null;
      }>;
    } | null;
  };
};

export const TenantFieldsFragmentDoc = gql`
  fragment tenantFields on Tenant {
    id
  }
`;
export const JobListFieldsFragmentDoc = gql`
  fragment jobListFields on Job {
    id
    jobType
    status
    createdBy {
      fullName
    }
    createdAt
    statusTime
    parentId
    additionalInfo
    hasProgressTree
    events {
      id
      occuredAt
      eventType
      message
    }
  }
`;
export const JobProgressSummaryFieldsFragmentDoc = gql`
  fragment jobProgressSummaryFields on JobProgressSummary {
    jobId
    overallPercent
    stepsCompleted
    stepsTotal
    status
  }
`;
export const JobProgressNodeFieldsFragmentDoc = gql`
  fragment jobProgressNodeFields on JobProgressNode {
    id
    jobId
    parentStepId
    key
    label
    order
    type
    status
    childJobId
    weight
    completedUnits
    totalUnits
    message
    error
    startedAt
    endedAt
  }
`;
export const JobProgressChildTreeFieldsFragmentDoc = gql`
  fragment jobProgressChildTreeFields on JobProgressTree {
    summary {
      ...jobProgressSummaryFields
    }
    nodes {
      ...jobProgressNodeFields
      children {
        ...jobProgressNodeFields
        children {
          ...jobProgressNodeFields
        }
      }
    }
  }
  ${JobProgressSummaryFieldsFragmentDoc}
  ${JobProgressNodeFieldsFragmentDoc}
`;
export const JobProgressNestedTreeFieldsFragmentDoc = gql`
  fragment jobProgressNestedTreeFields on JobProgressTree {
    summary {
      ...jobProgressSummaryFields
    }
    nodes {
      ...jobProgressNodeFields
      childJob {
        ...jobProgressChildTreeFields
      }
      children {
        ...jobProgressNodeFields
        childJob {
          ...jobProgressChildTreeFields
        }
        children {
          ...jobProgressNodeFields
          childJob {
            ...jobProgressChildTreeFields
          }
        }
      }
    }
  }
  ${JobProgressSummaryFieldsFragmentDoc}
  ${JobProgressNodeFieldsFragmentDoc}
  ${JobProgressChildTreeFieldsFragmentDoc}
`;
export const TenantOffboardingDiscoveryFieldsFragmentDoc = gql`
  fragment tenantOffboardingDiscoveryFields on TenantOffboardingDiscovery {
    id
    jobId
    trigger
    status
    resultVersion
    goneCount
    error
    createdAt
    completedAt
    triggeredById
    triggeredBy {
      id
      fullName
    }
  }
`;
export const TenantOffboardingDeletionFieldsFragmentDoc = gql`
  fragment tenantOffboardingDeletionFields on TenantOffboardingDeletion {
    id
    jobId
    version
    outcome
    createdAt
    completedAt
    startedBy {
      id
      fullName
    }
    keptSources {
      key
      reason
      leaf
      name
      target
      container
      path
      datasource
    }
    validationFindings {
      category
      subStep
      target
      error
      leftoverCount
    }
  }
`;

export const TenantOffboardingJobFieldsFragmentDoc = gql`
  fragment tenantOffboardingJobFields on TenantOffboardingJob {
    id
    tenantId
    tenantCode
    status
    approvalTicketUrl
    latestVersion
    tenantWasActive
    isCascade
    deletionStarted
    createdAt
    cancelledAt
    owner {
      id
      fullName
      email
    }
    cancelledBy {
      id
      fullName
    }
    approvers {
      id
      approverId
      status
      approvedVersion
      reason
      decidedAt
      approver {
        id
        fullName
        email
      }
    }
    latestDiscovery {
      ...tenantOffboardingDiscoveryFields
    }
    latestDeletion {
      ...tenantOffboardingDeletionFields
    }
  }
  ${TenantOffboardingDiscoveryFieldsFragmentDoc}
  ${TenantOffboardingDeletionFieldsFragmentDoc}
`;
export const GetVideoGuidesDocument = gql`
  query getVideoGuides($maxResults: Float, $pageToken: String) {
    videoGuides(maxResults: $maxResults, pageToken: $pageToken) {
      videos {
        id
        title
        description
        thumbnailUrl
      }
      nextPageToken
      prevPageToken
      totalResults
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetVideoGuidesGQL extends Apollo.Query<
  GetVideoGuidesQuery,
  GetVideoGuidesQueryVariables
> {
  document = GetVideoGuidesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetConfluencePageOverviewDocument = gql`
  query getConfluencePageOverview {
    confluencePageOverview {
      id
      title
      body
      relatedPages {
        id
        title
        body
        relatedPages {
          id
          title
          body
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetConfluencePageOverviewGQL extends Apollo.Query<
  GetConfluencePageOverviewQuery,
  GetConfluencePageOverviewQueryVariables
> {
  document = GetConfluencePageOverviewDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetConfluencePageDetailDocument = gql`
  query getConfluencePageDetail($pageDetailId: String!) {
    confluencePageDetail(id: $pageDetailId) {
      id
      title
      body
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetConfluencePageDetailGQL extends Apollo.Query<
  GetConfluencePageDetailQuery,
  GetConfluencePageDetailQueryVariables
> {
  document = GetConfluencePageDetailDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetAdUsersDocument = gql`
  query getAdUsers {
    adUsers {
      username
      commonName
      company
      distinguishedName
      givenName
      lastLogon
      lastLogonTimestamp
      lockoutTime
      mail
      surname
      telephoneNumber
      title
      userPrincipalName
      enabled
      locked
      userAccountControl
      passwordNeverExpires
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetAdUsersGQL extends Apollo.Query<
  GetAdUsersQuery,
  GetAdUsersQueryVariables
> {
  document = GetAdUsersDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ValidateUsernameDocument = gql`
  query validateUsername($username: String!) {
    validateUsername(username: $username)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ValidateUsernameGQL extends Apollo.Query<
  ValidateUsernameQuery,
  ValidateUsernameQueryVariables
> {
  document = ValidateUsernameDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ValidateEmailDocument = gql`
  query validateEmail($email: String!) {
    validateEmail(email: $email)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ValidateEmailGQL extends Apollo.Query<
  ValidateEmailQuery,
  ValidateEmailQueryVariables
> {
  document = ValidateEmailDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetAdUserGroupsDocument = gql`
  query getAdUserGroups($username: String!) {
    adUserGroups(username: $username) {
      name
      distinguishedName
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetAdUserGroupsGQL extends Apollo.Query<
  GetAdUserGroupsQuery,
  GetAdUserGroupsQueryVariables
> {
  document = GetAdUserGroupsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetAdUserDocument = gql`
  query getAdUser($username: String!) {
    adUser(username: $username) {
      username
      commonName
      company
      distinguishedName
      givenName
      lastLogon
      lastLogonTimestamp
      lockoutTime
      mail
      surname
      telephoneNumber
      title
      userPrincipalName
      enabled
      locked
      userAccountControl
      passwordNeverExpires
      adGroups {
        id
        name
        distinguishedName
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetAdUserGQL extends Apollo.Query<
  GetAdUserQuery,
  GetAdUserQueryVariables
> {
  document = GetAdUserDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateAdUserDocument = gql`
  mutation updateAdUser($updateAdUserInput: UpdateEntraIdUserInput!) {
    updateAdUser(updateAdUserInput: $updateAdUserInput)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateAdUserGQL extends Apollo.Mutation<
  UpdateAdUserMutation,
  UpdateAdUserMutationVariables
> {
  document = UpdateAdUserDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateOrganizationalUnitDocument = gql`
  mutation createOrganizationalUnit($ouName: String!) {
    createOrganizationalUnit(ouName: $ouName)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateOrganizationalUnitGQL extends Apollo.Mutation<
  CreateOrganizationalUnitMutation,
  CreateOrganizationalUnitMutationVariables
> {
  document = CreateOrganizationalUnitDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const AssignTenantToBiomeUsersDocument = gql`
  mutation assignTenantToBiomeUsers(
    $tenantId: String!
    $biomeUserRegion: BiomeUserRegion
  ) {
    assignTenantToBiomeUsers(
      tenantId: $tenantId
      biomeUserRegion: $biomeUserRegion
    )
  }
`;

@Injectable({
  providedIn: 'root',
})
export class AssignTenantToBiomeUsersGQL extends Apollo.Mutation<
  AssignTenantToBiomeUsersMutation,
  AssignTenantToBiomeUsersMutationVariables
> {
  document = AssignTenantToBiomeUsersDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RemoveAdUserDocument = gql`
  mutation removeAdUser($username: String!) {
    removeAdUser(username: $username)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RemoveAdUserGQL extends Apollo.Mutation<
  RemoveAdUserMutation,
  RemoveAdUserMutationVariables
> {
  document = RemoveAdUserDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CheckPoliciesDocument = gql`
  query checkPolicies($policyInputs: [PolicyRequest!]!) {
    checkPolicies(policyInputs: $policyInputs) {
      id
      eft
      action
      attribute
      entityId
      dsmId
      resource
      workbookGroupId
      workbookId
      tenantId
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CheckPoliciesGQL extends Apollo.Query<
  CheckPoliciesQuery,
  CheckPoliciesQueryVariables
> {
  document = CheckPoliciesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetIdentityProvidersDocument = gql`
  query getIdentityProviders($identityProviderIds: [ID!]) {
    identityProviders(ids: $identityProviderIds) {
      id
      name
      entityId
      description
      identifierFormat
      firstNameAttribute
      lastNameAttribute
      groupAccessType
      emailAttribute
      provisionUsers
      updateUsers
      securityGroup
      authnContext
      defaultRoles {
        id
        name
      }
      certificate
      certificates {
        id
        validityNotAfter
        active
      }
      entryPoint
      forceAuthentication
      enabled
      logoutUrl
      updateAt
      tenant {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetIdentityProvidersGQL extends Apollo.Query<
  GetIdentityProvidersQuery,
  GetIdentityProvidersQueryVariables
> {
  document = GetIdentityProvidersDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetIdentityProviderDocument = gql`
  query getIdentityProvider($entityId: String!) {
    identityProvider(entityId: $entityId) {
      id
      name
      entityId
      description
      groupAccessType
      identifierFormat
      firstNameAttribute
      lastNameAttribute
      emailAttribute
      provisionUsers
      updateUsers
      securityGroup
      authnContext
      defaultRoles {
        id
        name
      }
      certificate
      certificates {
        id
        validityNotAfter
        active
      }
      entryPoint
      forceAuthentication
      enabled
      logoutUrl
      updateAt
      tenant {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetIdentityProviderGQL extends Apollo.Query<
  GetIdentityProviderQuery,
  GetIdentityProviderQueryVariables
> {
  document = GetIdentityProviderDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateIdentityProviderDocument = gql`
  mutation createIdentityProvider(
    $identityProviderInput: IdentityProviderInput!
  ) {
    createIdentityProvider(identityProviderInput: $identityProviderInput) {
      id
      entityId
      description
      groupAccessType
      identifierFormat
      firstNameAttribute
      lastNameAttribute
      emailAttribute
      updateUsers
      authnContext
      provisionUsers
      securityGroup
      defaultRoles {
        id
        name
      }
      name
      certificate
      certificates {
        id
        validityNotAfter
        active
      }
      entryPoint
      forceAuthentication
      enabled
      logoutUrl
      updateAt
      tenant {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateIdentityProviderGQL extends Apollo.Mutation<
  CreateIdentityProviderMutation,
  CreateIdentityProviderMutationVariables
> {
  document = CreateIdentityProviderDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateIdentityProviderDocument = gql`
  mutation updateIdentityProvider(
    $updateIdentityProviderInput: UpdateIdentityProviderInput!
  ) {
    updateIdentityProvider(
      updateIdentityProviderInput: $updateIdentityProviderInput
    ) {
      id
      entityId
      description
      groupAccessType
      identifierFormat
      firstNameAttribute
      lastNameAttribute
      emailAttribute
      updateUsers
      authnContext
      provisionUsers
      securityGroup
      defaultRoles {
        id
        name
      }
      name
      certificate
      certificates {
        id
        validityNotAfter
        active
      }
      entryPoint
      forceAuthentication
      enabled
      logoutUrl
      updateAt
      tenant {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateIdentityProviderGQL extends Apollo.Mutation<
  UpdateIdentityProviderMutation,
  UpdateIdentityProviderMutationVariables
> {
  document = UpdateIdentityProviderDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetLoginRoutesDocument = gql`
  query getLoginRoutes($identityProvider: ID) {
    loginRoutes(identityProvider: $identityProvider) {
      id
      domain
      enabled
      identityProvider {
        id
        name
      }
      createdAt
      updateAt
      createdById
      updateById
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetLoginRoutesGQL extends Apollo.Query<
  GetLoginRoutesQuery,
  GetLoginRoutesQueryVariables
> {
  document = GetLoginRoutesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetLoginRouteDocument = gql`
  query getLoginRoute($loginRouteId: ID, $username: String) {
    loginRoute(id: $loginRouteId, username: $username) {
      id
      domain
      enabled
      identityProvider {
        id
        name
      }
      createdAt
      updateAt
      createdById
      updateById
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetLoginRouteGQL extends Apollo.Query<
  GetLoginRouteQuery,
  GetLoginRouteQueryVariables
> {
  document = GetLoginRouteDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateLoginRoutesDocument = gql`
  mutation createLoginRoutes($loginInputs: [LoginRouteInput!]!) {
    createLoginRoutes(loginInputs: $loginInputs) {
      id
      domain
      enabled
      identityProvider {
        id
        name
      }
      createdAt
      updateAt
      createdById
      updateById
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateLoginRoutesGQL extends Apollo.Mutation<
  CreateLoginRoutesMutation,
  CreateLoginRoutesMutationVariables
> {
  document = CreateLoginRoutesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateLoginRouteDocument = gql`
  mutation updateLoginRoute($updateLoginRouteInput: UpdateLoginRouteInput!) {
    updateLoginRoute(updateLoginRouteInput: $updateLoginRouteInput) {
      id
      domain
      enabled
      identityProvider {
        id
        name
      }
      createdAt
      updateAt
      createdById
      updateById
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateLoginRouteGQL extends Apollo.Mutation<
  UpdateLoginRouteMutation,
  UpdateLoginRouteMutationVariables
> {
  document = UpdateLoginRouteDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RemoveIdentityProviderDocument = gql`
  mutation removeIdentityProvider($identityProviderId: String!) {
    removeIdentityProvider(id: $identityProviderId)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RemoveIdentityProviderGQL extends Apollo.Mutation<
  RemoveIdentityProviderMutation,
  RemoveIdentityProviderMutationVariables
> {
  document = RemoveIdentityProviderDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetIdpCertificateDocument = gql`
  query getIdpCertificate($identityProviderId: String!) {
    certificate(identityProviderId: $identityProviderId) {
      id
      createdAt
      createdBy {
        firstName
        lastName
        username
      }
      issuer
      serialNumber
      signatureAlgorithm
      subject
      validityNotAfter
      validityNotBefore
      version
      active
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetIdpCertificateGQL extends Apollo.Query<
  GetIdpCertificateQuery,
  GetIdpCertificateQueryVariables
> {
  document = GetIdpCertificateDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ParseAndSaveCertificateDocument = gql`
  mutation parseAndSaveCertificate($idpId: String!) {
    parseAndSaveCertificate(idpId: $idpId) {
      id
      createdAt
      createdBy {
        firstName
        lastName
        username
      }
      issuer
      serialNumber
      signatureAlgorithm
      subject
      validityNotAfter
      validityNotBefore
      version
      active
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ParseAndSaveCertificateGQL extends Apollo.Mutation<
  ParseAndSaveCertificateMutation,
  ParseAndSaveCertificateMutationVariables
> {
  document = ParseAndSaveCertificateDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RemoveLoginRouteDocument = gql`
  mutation removeLoginRoute($loginRouteId: String!) {
    removeLoginRoute(id: $loginRouteId)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RemoveLoginRouteGQL extends Apollo.Mutation<
  RemoveLoginRouteMutation,
  RemoveLoginRouteMutationVariables
> {
  document = RemoveLoginRouteDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateGeneralPoliciesDocument = gql`
  mutation createGeneralPolicies($policies: [GeneralPolicyInput!]!) {
    createGeneralPolicies(policyInputs: $policies)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateGeneralPoliciesGQL extends Apollo.Mutation<
  CreateGeneralPoliciesMutation,
  CreateGeneralPoliciesMutationVariables
> {
  document = CreateGeneralPoliciesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RemoveGeneralPoliciesDocument = gql`
  mutation removeGeneralPolicies(
    $subjectId: String!
    $comment: String!
    $policyInputs: [GeneralPolicyInput!]!
  ) {
    removeGeneralEntityPolicies(
      subjectId: $subjectId
      comment: $comment
      policyInputs: $policyInputs
    )
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RemoveGeneralPoliciesGQL extends Apollo.Mutation<
  RemoveGeneralPoliciesMutation,
  RemoveGeneralPoliciesMutationVariables
> {
  document = RemoveGeneralPoliciesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateCasePoliciesDocument = gql`
  mutation createCasePolicies($policies: [CasePolicyInput!]!) {
    createCasePolicies(policyInputs: $policies)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateCasePoliciesGQL extends Apollo.Mutation<
  CreateCasePoliciesMutation,
  CreateCasePoliciesMutationVariables
> {
  document = CreateCasePoliciesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RemoveCasePoliciesDocument = gql`
  mutation removeCasePolicies(
    $subjectId: String!
    $comment: String!
    $policyInputs: [CasePolicyInput!]
  ) {
    removeCasePolicies(
      subjectId: $subjectId
      comment: $comment
      policyInputs: $policyInputs
    )
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RemoveCasePoliciesGQL extends Apollo.Mutation<
  RemoveCasePoliciesMutation,
  RemoveCasePoliciesMutationVariables
> {
  document = RemoveCasePoliciesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateEntityPoliciesDocument = gql`
  mutation createEntityPolicies($policies: [EntityPolicyInput!]!) {
    createEntityPolicies(policyInputs: $policies)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateEntityPoliciesGQL extends Apollo.Mutation<
  CreateEntityPoliciesMutation,
  CreateEntityPoliciesMutationVariables
> {
  document = CreateEntityPoliciesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RemoveEntityPoliciesDocument = gql`
  mutation removeEntityPolicies(
    $subjectId: String!
    $comment: String!
    $policyInputs: [EntityPolicyInput!]
  ) {
    removeEntityPolicies(
      subjectId: $subjectId
      comment: $comment
      policyInputs: $policyInputs
    )
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RemoveEntityPoliciesGQL extends Apollo.Mutation<
  RemoveEntityPoliciesMutation,
  RemoveEntityPoliciesMutationVariables
> {
  document = RemoveEntityPoliciesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateDsmPoliciesDocument = gql`
  mutation createDsmPolicies($policies: [DsmPolicyInput!]!) {
    createDsmPolicies(policyInputs: $policies)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateDsmPoliciesGQL extends Apollo.Mutation<
  CreateDsmPoliciesMutation,
  CreateDsmPoliciesMutationVariables
> {
  document = CreateDsmPoliciesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreatePatientListPoliciesDocument = gql`
  mutation createPatientListPolicies($policies: [PatientListPolicyInput!]!) {
    createPatientListPolicies(policyInputs: $policies)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreatePatientListPoliciesGQL extends Apollo.Mutation<
  CreatePatientListPoliciesMutation,
  CreatePatientListPoliciesMutationVariables
> {
  document = CreatePatientListPoliciesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateClinicianPoliciesDocument = gql`
  mutation createClinicianPolicies($policies: [ClinicianPolicyInput!]!) {
    createClinicianPolicies(policyInputs: $policies)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateClinicianPoliciesGQL extends Apollo.Mutation<
  CreateClinicianPoliciesMutation,
  CreateClinicianPoliciesMutationVariables
> {
  document = CreateClinicianPoliciesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RemoveDsmPoliciesDocument = gql`
  mutation removeDsmPolicies(
    $subjectId: String!
    $comment: String!
    $policyInputs: [DsmPolicyInput!]
  ) {
    removeDsmPolicies(
      subjectId: $subjectId
      comment: $comment
      policyInputs: $policyInputs
    )
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RemoveDsmPoliciesGQL extends Apollo.Mutation<
  RemoveDsmPoliciesMutation,
  RemoveDsmPoliciesMutationVariables
> {
  document = RemoveDsmPoliciesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RemovePatientListPoliciesDocument = gql`
  mutation removePatientListPolicies(
    $subjectId: String!
    $comment: String!
    $policyInputs: [PatientListPolicyInput!]
  ) {
    removePatientListPolicies(
      subjectId: $subjectId
      comment: $comment
      policyInputs: $policyInputs
    )
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RemovePatientListPoliciesGQL extends Apollo.Mutation<
  RemovePatientListPoliciesMutation,
  RemovePatientListPoliciesMutationVariables
> {
  document = RemovePatientListPoliciesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RemoveClinicianPoliciesDocument = gql`
  mutation removeClinicianPolicies(
    $subjectId: String!
    $comment: String!
    $policyInputs: [ClinicianPolicyInput!]
  ) {
    removeClinicianPolicies(
      subjectId: $subjectId
      comment: $comment
      policyInputs: $policyInputs
    )
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RemoveClinicianPoliciesGQL extends Apollo.Mutation<
  RemoveClinicianPoliciesMutation,
  RemoveClinicianPoliciesMutationVariables
> {
  document = RemoveClinicianPoliciesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateInitiativePoliciesDocument = gql`
  mutation createInitiativePolicies($policies: [InitiativePolicyInput!]!) {
    createInitiativePolicies(policyInputs: $policies)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateInitiativePoliciesGQL extends Apollo.Mutation<
  CreateInitiativePoliciesMutation,
  CreateInitiativePoliciesMutationVariables
> {
  document = CreateInitiativePoliciesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RemoveInitiativePoliciesDocument = gql`
  mutation removeInitiativePolicies(
    $subjectId: String!
    $comment: String!
    $policyInputs: [InitiativePolicyInput!]
  ) {
    removeInitiativePolicies(
      subjectId: $subjectId
      comment: $comment
      policyInputs: $policyInputs
    )
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RemoveInitiativePoliciesGQL extends Apollo.Mutation<
  RemoveInitiativePoliciesMutation,
  RemoveInitiativePoliciesMutationVariables
> {
  document = RemoveInitiativePoliciesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateStrategyBoardPoliciesDocument = gql`
  mutation createStrategyBoardPolicies(
    $policies: [StrategyBoardPolicyInput!]!
  ) {
    createStrategyBoardPolicies(policyInputs: $policies)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateStrategyBoardPoliciesGQL extends Apollo.Mutation<
  CreateStrategyBoardPoliciesMutation,
  CreateStrategyBoardPoliciesMutationVariables
> {
  document = CreateStrategyBoardPoliciesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RemoveStrategyBoardPoliciesDocument = gql`
  mutation removeStrategyBoardPolicies(
    $subjectId: String!
    $comment: String!
    $policyInputs: [StrategyBoardPolicyInput!]
  ) {
    removeStrategyBoardPolicies(
      subjectId: $subjectId
      comment: $comment
      policyInputs: $policyInputs
    )
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RemoveStrategyBoardPoliciesGQL extends Apollo.Mutation<
  RemoveStrategyBoardPoliciesMutation,
  RemoveStrategyBoardPoliciesMutationVariables
> {
  document = RemoveStrategyBoardPoliciesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateDashboardPoliciesDocument = gql`
  mutation createDashboardPolicies($policies: [DashboardPolicyInput!]!) {
    createDashboardPolicies(policyInputs: $policies)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateDashboardPoliciesGQL extends Apollo.Mutation<
  CreateDashboardPoliciesMutation,
  CreateDashboardPoliciesMutationVariables
> {
  document = CreateDashboardPoliciesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RemoveDashboardPoliciesDocument = gql`
  mutation removeDashboardPolicies(
    $subjectId: String!
    $comment: String!
    $policyInputs: [DashboardPolicyInput!]
  ) {
    removeDashboardPolicies(
      subjectId: $subjectId
      comment: $comment
      policyInputs: $policyInputs
    )
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RemoveDashboardPoliciesGQL extends Apollo.Mutation<
  RemoveDashboardPoliciesMutation,
  RemoveDashboardPoliciesMutationVariables
> {
  document = RemoveDashboardPoliciesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateUserPoliciesDocument = gql`
  mutation createUserPolicies($policies: [UserPolicyInput!]!) {
    createUserPolicies(policyInputs: $policies)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateUserPoliciesGQL extends Apollo.Mutation<
  CreateUserPoliciesMutation,
  CreateUserPoliciesMutationVariables
> {
  document = CreateUserPoliciesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RemoveUserPoliciesDocument = gql`
  mutation removeUserPolicies(
    $subjectId: String!
    $comment: String!
    $policyInputs: [UserPolicyInput!]
  ) {
    removeUserPolicies(
      subjectId: $subjectId
      comment: $comment
      policyInputs: $policyInputs
    )
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RemoveUserPoliciesGQL extends Apollo.Mutation<
  RemoveUserPoliciesMutation,
  RemoveUserPoliciesMutationVariables
> {
  document = RemoveUserPoliciesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateAdminPoliciesDocument = gql`
  mutation createAdminPolicies($policyInputs: [AdminPolicyInput!]!) {
    createAdminPolicies(policyInputs: $policyInputs)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateAdminPoliciesGQL extends Apollo.Mutation<
  CreateAdminPoliciesMutation,
  CreateAdminPoliciesMutationVariables
> {
  document = CreateAdminPoliciesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RemoveAdminPoliciesDocument = gql`
  mutation removeAdminPolicies(
    $subjectId: String!
    $comment: String!
    $policyInputs: [AdminPolicyInput!]
  ) {
    removeAdminPolicies(
      subjectId: $subjectId
      comment: $comment
      policyInputs: $policyInputs
    )
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RemoveAdminPoliciesGQL extends Apollo.Mutation<
  RemoveAdminPoliciesMutation,
  RemoveAdminPoliciesMutationVariables
> {
  document = RemoveAdminPoliciesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetPoliciesDocument = gql`
  query getPolicies($enforcerType: String!, $subjects: [String!]!) {
    policies(enforcerType: $enforcerType, subjects: $subjects) {
      action
      eft
      resource
      object
      attribute
      subjectId
      dsmId
      entityId
      tenantId
      workbookId
      workbookGroupId
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetPoliciesGQL extends Apollo.Query<
  GetPoliciesQuery,
  GetPoliciesQueryVariables
> {
  document = GetPoliciesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetCommunicationsDocument = gql`
  query getCommunications(
    $startDate: DateTime
    $endDate: DateTime
    $recipientId: String
    $requesterId: String
  ) {
    outboundMessages(
      startDate: $startDate
      endDate: $endDate
      recipientId: $recipientId
      requesterId: $requesterId
    ) {
      id
      sentDate
      subject
      recipient {
        id
        fullName
        tenant {
          name
        }
      }
      requester {
        id
        fullName
      }
      read
      trigger
      link
      outboundMessageDetails {
        htmlBody
        messageEvents {
          type
          receivedAt
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetCommunicationsGQL extends Apollo.Query<
  GetCommunicationsQuery,
  GetCommunicationsQueryVariables
> {
  document = GetCommunicationsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetCommunicationDocument = gql`
  query getCommunication($outboundMessageId: String!) {
    outboundMessage(id: $outboundMessageId) {
      id
      sentDate
      subject
      recipient {
        id
        fullName
        tenant {
          name
        }
      }
      requester {
        id
        fullName
      }
      read
      trigger
      link
      outboundMessageDetails {
        htmlBody
        messageEvents {
          type
          receivedAt
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetCommunicationGQL extends Apollo.Query<
  GetCommunicationQuery,
  GetCommunicationQueryVariables
> {
  document = GetCommunicationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const MarkAsReadDocument = gql`
  mutation markAsRead($messageIds: [String!]!) {
    markAsRead(messageIds: $messageIds)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class MarkAsReadGQL extends Apollo.Mutation<
  MarkAsReadMutation,
  MarkAsReadMutationVariables
> {
  document = MarkAsReadDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SendMessageDocument = gql`
  mutation sendMessage(
    $subject: String!
    $message: String!
    $recipientIds: [String!]
    $distributionListId: String
  ) {
    sendMessage(
      subject: $subject
      message: $message
      recipientIds: $recipientIds
      distributionListId: $distributionListId
    )
  }
`;

@Injectable({
  providedIn: 'root',
})
export class SendMessageGQL extends Apollo.Mutation<
  SendMessageMutation,
  SendMessageMutationVariables
> {
  document = SendMessageDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetUsersByNotificationTypeDocument = gql`
  query getUsersByNotificationType($notificationType: NotificationType!) {
    usersByNotificationType(notificationType: $notificationType)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetUsersByNotificationTypeGQL extends Apollo.Query<
  GetUsersByNotificationTypeQuery,
  GetUsersByNotificationTypeQueryVariables
> {
  document = GetUsersByNotificationTypeDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetPublicFileDocument = gql`
  query getPublicFile($publicFileId: String!) {
    publicFile(id: $publicFileId) {
      category
      id
      extension
      mimeType
      name
      url
      createdBy {
        id
        fullName
      }
      updateBy {
        id
        fullName
      }
      createdAt
      updateAt
      sharedAt
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetPublicFileGQL extends Apollo.Query<
  GetPublicFileQuery,
  GetPublicFileQueryVariables
> {
  document = GetPublicFileDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetPublicFilesDocument = gql`
  query getPublicFiles {
    publicFiles {
      id
      name
      mimeType
      extension
      url
      category
      createdAt
      updateAt
      createdBy {
        id
        fullName
      }
      updateBy {
        id
        fullName
      }
      sharedAt
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetPublicFilesGQL extends Apollo.Query<
  GetPublicFilesQuery,
  GetPublicFilesQueryVariables
> {
  document = GetPublicFilesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetSharedPublicFilesDocument = gql`
  query getSharedPublicFiles {
    sharedPublicFiles {
      id
      name
      mimeType
      extension
      url
      category
      createdAt
      updateAt
      createdBy {
        id
        fullName
      }
      updateBy {
        id
        fullName
      }
      sharedAt
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetSharedPublicFilesGQL extends Apollo.Query<
  GetSharedPublicFilesQuery,
  GetSharedPublicFilesQueryVariables
> {
  document = GetSharedPublicFilesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RemovePublicFileDocument = gql`
  mutation removePublicFile($removePublicFileId: String!) {
    removePublicFile(id: $removePublicFileId)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RemovePublicFileGQL extends Apollo.Mutation<
  RemovePublicFileMutation,
  RemovePublicFileMutationVariables
> {
  document = RemovePublicFileDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const LogPublicFileAccessDocument = gql`
  mutation logPublicFileAccess($fileId: String!, $fileName: String!) {
    logPublicFileAccess(fileId: $fileId, fileName: $fileName)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class LogPublicFileAccessGQL extends Apollo.Mutation<
  LogPublicFileAccessMutation,
  LogPublicFileAccessMutationVariables
> {
  document = LogPublicFileAccessDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const LogContentAccessDocument = gql`
  mutation logContentAccess(
    $fileName: String!
    $url: String!
    $source: String!
  ) {
    logContentAccess(fileName: $fileName, url: $url, source: $source)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class LogContentAccessGQL extends Apollo.Mutation<
  LogContentAccessMutation,
  LogContentAccessMutationVariables
> {
  document = LogContentAccessDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FindPublicFileAccessLogsDocument = gql`
  query findPublicFileAccessLogs($fileId: String!) {
    publicFileAccessLogs(fileId: $fileId) {
      relatedData
      type
      id
      createdAt
      createdBy {
        id
        fullName
        username
        email
        tenant {
          id
          code
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class FindPublicFileAccessLogsGQL extends Apollo.Query<
  FindPublicFileAccessLogsQuery,
  FindPublicFileAccessLogsQueryVariables
> {
  document = FindPublicFileAccessLogsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetHomepageSectionsDocument = gql`
  query getHomepageSections {
    homepageSections {
      id
      title
      content
      order
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetHomepageSectionsGQL extends Apollo.Query<
  GetHomepageSectionsQuery,
  GetHomepageSectionsQueryVariables
> {
  document = GetHomepageSectionsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetHomepageSectionDocument = gql`
  query getHomepageSection($homepageSectionId: String!) {
    homepageSection(id: $homepageSectionId) {
      id
      title
      content
      order
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetHomepageSectionGQL extends Apollo.Query<
  GetHomepageSectionQuery,
  GetHomepageSectionQueryVariables
> {
  document = GetHomepageSectionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateHomepageSectionDocument = gql`
  mutation createHomepageSection(
    $createHomepageSectionInput: CreateHomepageSectionInput!
  ) {
    createHomepageSection(
      createHomepageSectionInput: $createHomepageSectionInput
    ) {
      id
      title
      content
      order
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateHomepageSectionGQL extends Apollo.Mutation<
  CreateHomepageSectionMutation,
  CreateHomepageSectionMutationVariables
> {
  document = CreateHomepageSectionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateHomepageSectionsDocument = gql`
  mutation updateHomepageSections($inputs: [UpdateHomepageSectionInput!]!) {
    updateHomepageSections(inputs: $inputs) {
      id
      title
      order
      content
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateHomepageSectionsGQL extends Apollo.Mutation<
  UpdateHomepageSectionsMutation,
  UpdateHomepageSectionsMutationVariables
> {
  document = UpdateHomepageSectionsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RemoveHomepageSectionDocument = gql`
  mutation removeHomepageSection($removeHomepageSectionId: String!) {
    removeHomepageSection(id: $removeHomepageSectionId)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RemoveHomepageSectionGQL extends Apollo.Mutation<
  RemoveHomepageSectionMutation,
  RemoveHomepageSectionMutationVariables
> {
  document = RemoveHomepageSectionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetFileDocument = gql`
  query getFile($id: String!) {
    file(id: $id) {
      id
      createdAt
      updateAt
      createdBy {
        id
        username
      }
      updateBy {
        id
        username
      }
      name
      description
      phi
      mimeType
      extension
      category
      url
      fileLabel {
        id
        text
      }
      tenantId
      tenant {
        id
        name
      }
      distributionLists {
        name
        id
      }
      users {
        distributionLists {
          id
          name
        }
        user {
          id
          fullName
          firstName
          username
          email
          enabled
        }
        isDirect
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetFileGQL extends Apollo.Query<
  GetFileQuery,
  GetFileQueryVariables
> {
  document = GetFileDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetFileLabelsDocument = gql`
  query getFileLabels {
    fileLabels {
      id
      text
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetFileLabelsGQL extends Apollo.Query<
  GetFileLabelsQuery,
  GetFileLabelsQueryVariables
> {
  document = GetFileLabelsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetTenantFilesDocument = gql`
  query getTenantFiles($category: FileCategory!, $tenantIds: [String!]) {
    tenantFiles(category: $category, tenantIds: $tenantIds) {
      id
      createdAt
      createdBy {
        id
        username
      }
      updateAt
      updateBy {
        id
        username
      }
      name
      description
      phi
      mimeType
      extension
      category
      url
      tenantId
      tenant {
        id
        name
      }
      fileLabel {
        id
        text
      }
      distributionLists {
        name
        id
      }
      users {
        distributionLists {
          id
          name
        }
        user {
          id
          fullName
          firstName
          username
          email
          enabled
        }
        isDirect
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetTenantFilesGQL extends Apollo.Query<
  GetTenantFilesQuery,
  GetTenantFilesQueryVariables
> {
  document = GetTenantFilesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetUserFilesDocument = gql`
  query getUserFiles($userId: String) {
    userFiles(userId: $userId) {
      id
      name
      phi
      url
      fileShareDate
      createdAt
      description
      category
      fileLabel {
        text
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetUserFilesGQL extends Apollo.Query<
  GetUserFilesQuery,
  GetUserFilesQueryVariables
> {
  document = GetUserFilesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DownloadFileDocument = gql`
  mutation downloadFile($downloadFileId: String!) {
    downloadFile(id: $downloadFileId) {
      id
      url
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DownloadFileGQL extends Apollo.Mutation<
  DownloadFileMutation,
  DownloadFileMutationVariables
> {
  document = DownloadFileDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetFileAccessLogsDocument = gql`
  query getFileAccessLogs($fileId: String!) {
    fileAccessLogs(fileId: $fileId) {
      relatedData
      type
      id
      createdAt
      createdBy {
        id
        fullName
        username
        email
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetFileAccessLogsGQL extends Apollo.Query<
  GetFileAccessLogsQuery,
  GetFileAccessLogsQueryVariables
> {
  document = GetFileAccessLogsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RemoveFileDocument = gql`
  mutation removeFile($removeFileId: String!) {
    removeFile(id: $removeFileId)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RemoveFileGQL extends Apollo.Mutation<
  RemoveFileMutation,
  RemoveFileMutationVariables
> {
  document = RemoveFileDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetDistributionListsDocument = gql`
  query getDistributionLists {
    distributionLists {
      id
      name
      description
      tenant {
        id
        code
      }
      users {
        id
        firstName
        lastName
        username
        email
        enabled
      }
      files {
        id
        name
        description
        tenantId
        category
        phi
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetDistributionListsGQL extends Apollo.Query<
  GetDistributionListsQuery,
  GetDistributionListsQueryVariables
> {
  document = GetDistributionListsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetDistributionListDocument = gql`
  query getDistributionList($distributionListId: String!) {
    distributionList(id: $distributionListId) {
      id
      name
      description
      tenant {
        id
        code
      }
      users {
        id
        firstName
        lastName
        username
        email
        enabled
      }
      files {
        id
        name
        description
        tenantId
        category
        phi
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetDistributionListGQL extends Apollo.Query<
  GetDistributionListQuery,
  GetDistributionListQueryVariables
> {
  document = GetDistributionListDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateDistributionListDocument = gql`
  mutation createDistributionList(
    $createDistributionListInput: CreateDistributionListInput!
  ) {
    createDistributionList(
      createDistributionListInput: $createDistributionListInput
    ) {
      id
      name
      description
      tenant {
        id
        code
      }
      users {
        id
        firstName
        lastName
        username
        email
        enabled
      }
      files {
        id
        name
        description
        tenantId
        category
        phi
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateDistributionListGQL extends Apollo.Mutation<
  CreateDistributionListMutation,
  CreateDistributionListMutationVariables
> {
  document = CreateDistributionListDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateDistributionListDocument = gql`
  mutation updateDistributionList(
    $updateDistributionListInput: UpdateDistributionListInput!
    $fileShareNotification: FileShareNotification
  ) {
    updateDistributionList(
      updateDistributionListInput: $updateDistributionListInput
      fileShareNotification: $fileShareNotification
    ) {
      id
      name
      description
      tenant {
        id
        code
      }
      users {
        id
        firstName
        lastName
        username
        email
        enabled
        distributionLists {
          id
          name
        }
      }
      files {
        id
        name
        description
        tenantId
        category
        phi
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateDistributionListGQL extends Apollo.Mutation<
  UpdateDistributionListMutation,
  UpdateDistributionListMutationVariables
> {
  document = UpdateDistributionListDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ShareFilesWithDistributionListsDocument = gql`
  mutation shareFilesWithDistributionLists(
    $filesShareInput: [UpdateDistributionListInput!]
    $fileShareNotification: FileShareNotification
  ) {
    shareFilesWithDistributionLists(
      filesShareInput: $filesShareInput
      fileShareNotification: $fileShareNotification
    )
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ShareFilesWithDistributionListsGQL extends Apollo.Mutation<
  ShareFilesWithDistributionListsMutation,
  ShareFilesWithDistributionListsMutationVariables
> {
  document = ShareFilesWithDistributionListsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RemoveDistributionListDocument = gql`
  mutation removeDistributionList($id: String!) {
    removeDistributionList(id: $id)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RemoveDistributionListGQL extends Apollo.Mutation<
  RemoveDistributionListMutation,
  RemoveDistributionListMutationVariables
> {
  document = RemoveDistributionListDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetTenantsDocument = gql`
  query getTenants($name: String) {
    tenants(name: $name) {
      id
      code
      name
      active
      subdomain
      disableHomepage
      contractedDisplayPHI
      clinicalOnly
      aggregationTenant
      deliverableBlinded
      rollupMode
      organizationalUnit
      disableBiomedataLogin
      usesAnubisUpload
      itContact
      encryptionKeys
      logo {
        id
        name
        mimeType
        extension
        category
        url
      }
      banner {
        id
        name
        mimeType
        extension
        category
        url
      }
      identityProvider {
        id
        enabled
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetTenantsGQL extends Apollo.Query<
  GetTenantsQuery,
  GetTenantsQueryVariables
> {
  document = GetTenantsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetTenantDocument = gql`
  query getTenant($tenantId: String, $code: String) {
    tenant(id: $tenantId, code: $code) {
      id
      code
      name
      active
      subdomain
      disableHomepage
      contractedDisplayPHI
      clinicalOnly
      aggregationTenant
      deliverableBlinded
      rollupMode
      organizationalUnit
      disableBiomedataLogin
      usesAnubisUpload
      projectSponsorId
      projectSponsor {
        id
        email
        fullName
        username
      }
      itContact
      workbooks {
        id
        name
        description
        active
        diseaseStateModule {
          id
          name
        }
      }
      encryptionKeys
      logo {
        id
        name
        mimeType
        extension
        category
        url
      }
      banner {
        id
        name
        mimeType
        extension
        category
        url
      }
      documents {
        id
        name
        mimeType
        extension
        category
        url
      }
      users {
        id
        fullName
        username
        email
      }
      careEntities {
        id
        name
        code
        description
        isEngagementEntity
        projectSponsor
        physicianChampion
        invoiceMonth
        onboardingCompletedOn
        monthlySponsorTouchbase
        reviewDsms {
          id
          code
          name
        }
        pushOnlyDsms {
          id
          code
          name
        }
      }
      roles {
        id
        name
        description
      }
      echoModules {
        id
        name
        displayName
        description
        active
      }
      offboardingJob {
        id
        status
        deletionStarted
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetTenantGQL extends Apollo.Query<
  GetTenantQuery,
  GetTenantQueryVariables
> {
  document = GetTenantDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetCareEntitiesDocument = gql`
  query getCareEntities($ids: [String!]) {
    careEntities(ids: $ids) {
      id
      name
      shortDisplayName
      code
      supportedApps
      anonymousCode
      description
      type
      usGeoRegion
      street
      city
      state
      zip
      alternateNames
      ids
      noOfBeds
      aggregated
      teaching
      active
      includeInBenchmarks
      cmsId
      cmsIdNotAvailable
      reasonForNoCmsId
      isEngagementEntity
      projectSponsor
      physicianChampion
      invoiceMonth
      onboardingCompletedOn
      monthlySponsorTouchbase
      tenants {
        id
        code
        name
      }
      parents {
        id
        code
        name
        description
      }
      children {
        id
        code
        name
        description
      }
      memberDsms {
        childId
        diseaseStateModules {
          id
          code
          name
        }
      }
      diseaseStateModules {
        id
        code
        name
        description
        supportedApps
        type
        datasets {
          id
          name
        }
      }
      reviewDsms {
        id
        code
        name
      }
      pushOnlyDsms {
        id
        code
        name
      }
      excludedDsms {
        id
        code
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetCareEntitiesGQL extends Apollo.Query<
  GetCareEntitiesQuery,
  GetCareEntitiesQueryVariables
> {
  document = GetCareEntitiesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetCareEntitiesLiveDocument = gql`
  query getCareEntitiesLive($ids: [String!]) {
    careEntitiesLive(ids: $ids) {
      id
      name
      shortDisplayName
      code
      supportedApps
      anonymousCode
      description
      type
      usGeoRegion
      street
      city
      state
      zip
      alternateNames
      ids
      noOfBeds
      aggregated
      teaching
      active
      includeInBenchmarks
      cmsId
      cmsIdNotAvailable
      reasonForNoCmsId
      isEngagementEntity
      projectSponsor
      physicianChampion
      invoiceMonth
      onboardingCompletedOn
      monthlySponsorTouchbase
      tenants {
        id
        code
        name
      }
      parents {
        id
        code
        name
        description
      }
      children {
        id
        code
        name
        description
      }
      memberDsms {
        childId
        diseaseStateModules {
          id
          code
          name
        }
      }
      diseaseStateModules {
        id
        code
        name
        description
        supportedApps
        type
        datasets {
          id
          name
        }
      }
      reviewDsms {
        id
        code
        name
      }
      pushOnlyDsms {
        id
        code
        name
      }
      excludedDsms {
        id
        code
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetCareEntitiesLiveGQL extends Apollo.Query<
  GetCareEntitiesLiveQuery,
  GetCareEntitiesLiveQueryVariables
> {
  document = GetCareEntitiesLiveDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetCareEntityArchivedDsmsDocument = gql`
  query getCareEntityArchivedDsms($ids: [String!]) {
    careEntitiesLive(ids: $ids) {
      id
      archivedDiseaseStateModules {
        id
        code
        name
        description
        deletedAt
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetCareEntityArchivedDsmsGQL extends Apollo.Query<
  GetCareEntityArchivedDsmsQuery,
  GetCareEntityArchivedDsmsQueryVariables
> {
  document = GetCareEntityArchivedDsmsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetCareEntityDocument = gql`
  query getCareEntity(
    $careEntityId: String
    $name: String
    $code: String
    $cmsId: String
  ) {
    careEntity(id: $careEntityId, name: $name, code: $code, cmsId: $cmsId) {
      id
      name
      shortDisplayName
      code
      supportedApps
      anonymousCode
      description
      type
      usGeoRegion
      street
      city
      state
      zip
      alternateNames
      ids
      noOfBeds
      aggregated
      teaching
      active
      includeInBenchmarks
      cmsId
      cmsIdNotAvailable
      reasonForNoCmsId
      isEngagementEntity
      projectSponsor
      physicianChampion
      invoiceMonth
      onboardingCompletedOn
      monthlySponsorTouchbase
      tenants {
        id
        code
        name
      }
      parents {
        id
        code
        name
        description
      }
      children {
        id
        code
        name
        description
      }
      memberDsms {
        childId
        diseaseStateModules {
          id
          code
          name
        }
      }
      diseaseStateModules {
        id
        code
        name
        description
        supportedApps
        type
        datasets {
          id
          name
        }
      }
      reviewDsms {
        id
        code
        name
      }
      pushOnlyDsms {
        id
        code
        name
      }
      excludedDsms {
        id
        code
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetCareEntityGQL extends Apollo.Query<
  GetCareEntityQuery,
  GetCareEntityQueryVariables
> {
  document = GetCareEntityDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ArchiveCareEntityDocument = gql`
  mutation archiveCareEntity($careEntityId: String!) {
    softDeleteCareEntity(id: $careEntityId)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ArchiveCareEntityGQL extends Apollo.Mutation<
  ArchiveCareEntityMutation,
  ArchiveCareEntityMutationVariables
> {
  document = ArchiveCareEntityDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetUsersDocument = gql`
  query getUsers($tenantId: String) {
    tenantUsers(tenantId: $tenantId) {
      id
      username
      firstName
      lastName
      fullName
      email
      disableBiomedataLogin
      phoneNumber
      organizationalUnit
      title
      adGroups
      tenant {
        id
        name
        code
      }
      root
      permanentAccount
      submitsData
      enableSftp
      ccOnboardingEmail
      enabled
      enabledTime
      status
      passwordNeverExpires
      lastLogin
      twoFactor
      createdBy {
        fullName
      }
      createdAt
      updateBy {
        fullName
      }
      updateAt
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetUsersGQL extends Apollo.Query<
  GetUsersQuery,
  GetUsersQueryVariables
> {
  document = GetUsersDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetLastCeDsmRefreshDocument = gql`
  query getLastCeDsmRefresh {
    lastCeDsmRefresh
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetLastCeDsmRefreshGQL extends Apollo.Query<
  GetLastCeDsmRefreshQuery,
  GetLastCeDsmRefreshQueryVariables
> {
  document = GetLastCeDsmRefreshDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetUserAuditDocument = gql`
  query getUserAudit {
    userAudit {
      userId
      username
      fullName
      createdAt
      enabled
      submitsData
      dataRefreshEmailsEnabled
      echoSummaryEmailsEnabled
      riskAuditEmailsEnabled
      lastLoginDate
      lastRefreshedAt
      accessModifiedAt
      roles {
        id
        name
        code
        type
        careEntityIds
        dsmIds
      }
      distributionLists {
        id
        name
      }
      allowedCareEntityDsms {
        dsmId
        careEntityId
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetUserAuditGQL extends Apollo.Query<
  GetUserAuditQuery,
  GetUserAuditQueryVariables
> {
  document = GetUserAuditDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetCurrentUserDocument = gql`
  query getCurrentUser {
    whoami {
      id
      username
      firstName
      lastName
      fullName
      email
      title
      organizationalUnit
      lastLogin
      submitsData
      enableSftp
      ccOnboardingEmail
      root
      permanentAccount
      tenant {
        code
        name
        id
        organizationalUnit
      }
      roles {
        id
        name
        type
      }
      homepage {
        url
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetCurrentUserGQL extends Apollo.Query<
  GetCurrentUserQuery,
  GetCurrentUserQueryVariables
> {
  document = GetCurrentUserDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetAnubisUploadTenantsDocument = gql`
  query getAnubisUploadTenants {
    tenants {
      id
      usesAnubisUpload
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetAnubisUploadTenantsGQL extends Apollo.Query<
  GetAnubisUploadTenantsQuery,
  GetAnubisUploadTenantsQueryVariables
> {
  document = GetAnubisUploadTenantsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetUserAccountDocument = gql`
  query getUserAccount {
    whoami {
      id
      username
      firstName
      lastName
      fullName
      email
      otherEmails {
        email
      }
      phoneNumber
      title
      submitsData
      status
      root
      tenant {
        code
        name
        id
      }
      tokens {
        id
        type
        status
        name
        expiresAt
      }
      roles {
        id
        name
        type
        tenantId
      }
      notifications {
        id
        name
        type
        description
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetUserAccountGQL extends Apollo.Query<
  GetUserAccountQuery,
  GetUserAccountQueryVariables
> {
  document = GetUserAccountDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateUserAccountDocument = gql`
  mutation updateUserAccount($updateUserInput: UpdateUserAccountInput!) {
    updateUserAccount(updateUserInput: $updateUserInput) {
      firstName
      lastName
      title
      username
      email
      otherEmails {
        email
      }
      notifications {
        id
        name
        type
        description
      }
      phoneNumber
      tokens {
        id
        name
        type
        status
        expiresAt
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateUserAccountGQL extends Apollo.Mutation<
  UpdateUserAccountMutation,
  UpdateUserAccountMutationVariables
> {
  document = UpdateUserAccountDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetUserDocument = gql`
  query getUser($userId: String, $username: String) {
    user(id: $userId, username: $username) {
      id
      username
      firstName
      lastName
      fullName
      description
      email
      disableBiomedataLogin
      otherEmails {
        email
      }
      phoneNumber
      organizationalUnit
      title
      adGroups
      tenant {
        id
        name
        code
      }
      roles {
        id
        name
        type
        description
        tenant {
          id
          code
        }
      }
      submissions {
        id
        aggregate
        sendReminders
        daysAfterDeadline
        ccEmails
        userId
        parentId
        cadence
        careEntity {
          id
          code
          shortDisplayName
        }
        dataset {
          id
          name
        }
      }
      root
      permanentAccount
      submitsData
      enableSftp
      careEntityCode
      ccOnboardingEmail
      enabled
      enabledTime
      status
      passwordNeverExpires
      lastLogin
      twoFactor
      createdBy {
        fullName
      }
      createdAt
      updateBy {
        fullName
      }
      updateAt
      tokens {
        id
        type
        status
        name
        expiresAt
      }
      notifications {
        id
        name
        type
        description
      }
      files {
        file {
          id
          name
          description
          tenantId
          phi
          tenant {
            id
            name
          }
        }
        isDirect
        distributionLists {
          id
          name
        }
      }
      distributionLists {
        id
        name
        tenant {
          id
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetUserGQL extends Apollo.Query<
  GetUserQuery,
  GetUserQueryVariables
> {
  document = GetUserDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetIsUserLockedDocument = gql`
  query getIsUserLocked($username: String!) {
    userLocked(username: $username)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetIsUserLockedGQL extends Apollo.Query<
  GetIsUserLockedQuery,
  GetIsUserLockedQueryVariables
> {
  document = GetIsUserLockedDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetRolesDocument = gql`
  query getRoles($ids: [String!]) {
    roles(ids: $ids) {
      id
      name
      code
      description
      type
      tenant {
        id
        code
      }
      users {
        id
        firstName
        lastName
        username
        email
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetRolesGQL extends Apollo.Query<
  GetRolesQuery,
  GetRolesQueryVariables
> {
  document = GetRolesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetRoleDocument = gql`
  query getRole($roleId: String!) {
    role(id: $roleId) {
      id
      name
      code
      description
      type
      tenant {
        id
        code
      }
      users {
        id
        firstName
        lastName
        username
        email
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetRoleGQL extends Apollo.Query<
  GetRoleQuery,
  GetRoleQueryVariables
> {
  document = GetRoleDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetTenantWorkbooksDocument = gql`
  query getTenantWorkbooks($tenantId: String!) {
    tenantWorkbooks(tenantId: $tenantId) {
      id
      name
      active
      workbookGroup {
        id
        name
      }
      diseaseStateModule {
        id
        name
        supportedApps
      }
      tableauViews {
        id
        name
        active
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetTenantWorkbooksGQL extends Apollo.Query<
  GetTenantWorkbooksQuery,
  GetTenantWorkbooksQueryVariables
> {
  document = GetTenantWorkbooksDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetDashboardFinderDataDocument = gql`
  query getDashboardFinderData($tenantId: String!) {
    tenantWorkbooks(tenantId: $tenantId) {
      id
      name
      active
      sortOrder
      diseaseStateModuleId
      workbookGroupId
      measureIds
      tableauViews {
        id
        name
        description
        active
        workbookId
        sortOrder
        renderInMenu
        primaryMeasureIds
        secondaryMeasureIds
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetDashboardFinderDataGQL extends Apollo.Query<
  GetDashboardFinderDataQuery,
  GetDashboardFinderDataQueryVariables
> {
  document = GetDashboardFinderDataDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetTableauWorkbooksDocument = gql`
  query getTableauWorkbooks($ids: [Int!]) {
    workbooks(ids: $ids) {
      id
      tableauUri
      name
      description
      tags
      sortOrder
      active
      measureIds
      diseaseStateModule {
        id
        name
      }
      workbookGroup {
        id
        name
      }
      tenants {
        id
        code
        name
        active
      }
      tableauViews {
        id
        name
        description
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetTableauWorkbooksGQL extends Apollo.Query<
  GetTableauWorkbooksQuery,
  GetTableauWorkbooksQueryVariables
> {
  document = GetTableauWorkbooksDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateWorkbookDocument = gql`
  mutation createWorkbook($createWorkbookInput: CreateWorkbookInput!) {
    createWorkbook(createWorkbookInput: $createWorkbookInput) {
      id
      tableauUri
      name
      description
      tags
      sortOrder
      active
      measureIds
      diseaseStateModule {
        id
        name
      }
      workbookGroup {
        id
        name
      }
      tenants {
        id
        code
        name
        active
      }
      tableauViews {
        id
        name
        description
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateWorkbookGQL extends Apollo.Mutation<
  CreateWorkbookMutation,
  CreateWorkbookMutationVariables
> {
  document = CreateWorkbookDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateWorkbookDocument = gql`
  mutation updateWorkbook($updateWorkbookInput: UpdateWorkbookInput!) {
    updateWorkbook(updateWorkbookInput: $updateWorkbookInput) {
      id
      tableauUri
      name
      description
      tags
      sortOrder
      active
      measureIds
      diseaseStateModule {
        id
        name
      }
      workbookGroup {
        id
        name
      }
      tenants {
        id
        code
        name
        active
      }
      tableauViews {
        id
        name
        description
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateWorkbookGQL extends Apollo.Mutation<
  UpdateWorkbookMutation,
  UpdateWorkbookMutationVariables
> {
  document = UpdateWorkbookDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetWorkbookGroupsDocument = gql`
  query getWorkbookGroups {
    workbookGroups(filterInactive: false) {
      id
      name
      description
      sortOrder
      active
      renderAsLink
      renderInMenu
      diseaseStateModuleId
      diseaseStateModule {
        id
        name
      }
      workbooks {
        id
        name
        description
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetWorkbookGroupsGQL extends Apollo.Query<
  GetWorkbookGroupsQuery,
  GetWorkbookGroupsQueryVariables
> {
  document = GetWorkbookGroupsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetWorkbookGroupDocument = gql`
  query getWorkbookGroup($workbookGroupId: Int!) {
    workbookGroup(id: $workbookGroupId) {
      id
      name
      description
      sortOrder
      active
      renderAsLink
      renderInMenu
      diseaseStateModuleId
      diseaseStateModule {
        id
        name
      }
      workbooks {
        id
        name
        description
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetWorkbookGroupGQL extends Apollo.Query<
  GetWorkbookGroupQuery,
  GetWorkbookGroupQueryVariables
> {
  document = GetWorkbookGroupDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateWorkbookGroupDocument = gql`
  mutation createWorkbookGroup($createGroupInput: CreateWorkbookGroupInput!) {
    createWorkbookGroup(createGroupInput: $createGroupInput) {
      id
      name
      description
      sortOrder
      active
      renderAsLink
      renderInMenu
      diseaseStateModuleId
      diseaseStateModule {
        id
        name
      }
      workbooks {
        id
        name
        description
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateWorkbookGroupGQL extends Apollo.Mutation<
  CreateWorkbookGroupMutation,
  CreateWorkbookGroupMutationVariables
> {
  document = CreateWorkbookGroupDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateWorkbookGroupDocument = gql`
  mutation updateWorkbookGroup($updateGroupInput: UpdateWorkbookGroupInput!) {
    updateWorkbookGroup(updateGroupInput: $updateGroupInput) {
      id
      name
      description
      sortOrder
      active
      renderAsLink
      renderInMenu
      diseaseStateModuleId
      diseaseStateModule {
        id
        name
      }
      workbooks {
        id
        name
        description
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateWorkbookGroupGQL extends Apollo.Mutation<
  UpdateWorkbookGroupMutation,
  UpdateWorkbookGroupMutationVariables
> {
  document = UpdateWorkbookGroupDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetTableauViewDocument = gql`
  query getTableauView($tableauViewId: Int!) {
    tableauView(id: $tableauViewId) {
      id
      name
      workbookId
      sortOrder
      renderInMenu
      workbook {
        measureIds
        diseaseStateModule {
          id
          code
          name
        }
        name
        workbookGroup {
          id
          name
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetTableauViewGQL extends Apollo.Query<
  GetTableauViewQuery,
  GetTableauViewQueryVariables
> {
  document = GetTableauViewDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetAdminTableauViewDocument = gql`
  query getAdminTableauView($tableauViewId: Int!) {
    tableauView(id: $tableauViewId) {
      id
      name
      description
      tags
      primaryMeasureIds
      secondaryMeasureIds
      sortOrder
      active
      renderInMenu
      workbook {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetAdminTableauViewGQL extends Apollo.Query<
  GetAdminTableauViewQuery,
  GetAdminTableauViewQueryVariables
> {
  document = GetAdminTableauViewDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetTableauViewsDocument = gql`
  query getTableauViews {
    tableauViews {
      id
      name
      description
      tags
      primaryMeasureIds
      secondaryMeasureIds
      sortOrder
      active
      renderInMenu
      workbook {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetTableauViewsGQL extends Apollo.Query<
  GetTableauViewsQuery,
  GetTableauViewsQueryVariables
> {
  document = GetTableauViewsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateTableauViewDocument = gql`
  mutation createTableauView($createViewInput: CreateTableauViewInput!) {
    createTableauView(createViewInput: $createViewInput) {
      id
      name
      description
      tags
      primaryMeasureIds
      secondaryMeasureIds
      sortOrder
      active
      renderInMenu
      workbook {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateTableauViewGQL extends Apollo.Mutation<
  CreateTableauViewMutation,
  CreateTableauViewMutationVariables
> {
  document = CreateTableauViewDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateTableauViewDocument = gql`
  mutation updateTableauView($updateViewInput: UpdateTableauViewInput!) {
    updateTableauView(updateViewInput: $updateViewInput)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateTableauViewGQL extends Apollo.Mutation<
  UpdateTableauViewMutation,
  UpdateTableauViewMutationVariables
> {
  document = UpdateTableauViewDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetRelatedDashboardsDocument = gql`
  query getRelatedDashboards($measureIds: [Int!]) {
    tableauViews(measureIds: $measureIds) {
      id
      name
      description
      active
      workbook {
        name
        diseaseStateModule {
          name
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetRelatedDashboardsGQL extends Apollo.Query<
  GetRelatedDashboardsQuery,
  GetRelatedDashboardsQueryVariables
> {
  document = GetRelatedDashboardsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetCitationDashboardDocument = gql`
  query getCitationDashboard($citationDashboardInput: CitationDashboardInput!) {
    citationDashboard(citationDashboardInput: $citationDashboardInput) {
      id
      name
      workbookName
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetCitationDashboardGQL extends Apollo.Query<
  GetCitationDashboardQuery,
  GetCitationDashboardQueryVariables
> {
  document = GetCitationDashboardDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetTenantDashboardsDocument = gql`
  query getTenantDashboards($tenantId: String!) {
    tenantWorkbooks(tenantId: $tenantId) {
      diseaseStateModule {
        id
        code
        name
      }
      active
      tableauViews {
        id
        name
        active
        renderInMenu
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetTenantDashboardsGQL extends Apollo.Query<
  GetTenantDashboardsQuery,
  GetTenantDashboardsQueryVariables
> {
  document = GetTenantDashboardsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetBookmarksDocument = gql`
  query getBookmarks {
    bookmarks {
      id
      name
      createdAt
      description
      url
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetBookmarksGQL extends Apollo.Query<
  GetBookmarksQuery,
  GetBookmarksQueryVariables
> {
  document = GetBookmarksDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetBookmarkDocument = gql`
  query getBookmark($bookmarkId: String!) {
    bookmark(id: $bookmarkId) {
      id
      name
      createdAt
      description
      url
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetBookmarkGQL extends Apollo.Query<
  GetBookmarkQuery,
  GetBookmarkQueryVariables
> {
  document = GetBookmarkDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const AddFavoriteTableauViewDocument = gql`
  mutation addFavoriteTableauView($tenantId: String!, $viewId: Float!) {
    addFavorite(tenantId: $tenantId, viewId: $viewId)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class AddFavoriteTableauViewGQL extends Apollo.Mutation<
  AddFavoriteTableauViewMutation,
  AddFavoriteTableauViewMutationVariables
> {
  document = AddFavoriteTableauViewDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RemoveFavoriteTableauViewDocument = gql`
  mutation removeFavoriteTableauView($tenantId: String!, $viewId: Float!) {
    removeFavorite(tenantId: $tenantId, viewId: $viewId)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RemoveFavoriteTableauViewGQL extends Apollo.Mutation<
  RemoveFavoriteTableauViewMutation,
  RemoveFavoriteTableauViewMutationVariables
> {
  document = RemoveFavoriteTableauViewDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateBookmarkDocument = gql`
  mutation createBookmark($createBookmarkInput: CreateBookmarkInput!) {
    createBookmark(createBookmarkInput: $createBookmarkInput) {
      id
      name
      createdAt
      description
      url
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateBookmarkGQL extends Apollo.Mutation<
  CreateBookmarkMutation,
  CreateBookmarkMutationVariables
> {
  document = CreateBookmarkDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateBookmarkShortUrlDocument = gql`
  mutation createBookmarkShortUrl($originalUrl: String!) {
    createBookmarkShortUrl(originalUrl: $originalUrl)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateBookmarkShortUrlGQL extends Apollo.Mutation<
  CreateBookmarkShortUrlMutation,
  CreateBookmarkShortUrlMutationVariables
> {
  document = CreateBookmarkShortUrlDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateBookmarkDocument = gql`
  mutation updateBookmark($updateBookmarkInput: UpdateBookmarkInput!) {
    updateBookmark(updateBookmarkInput: $updateBookmarkInput) {
      id
      name
      description
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateBookmarkGQL extends Apollo.Mutation<
  UpdateBookmarkMutation,
  UpdateBookmarkMutationVariables
> {
  document = UpdateBookmarkDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RemoveBookmarkDocument = gql`
  mutation removeBookmark($removeBookmarkId: String!) {
    removeBookmark(id: $removeBookmarkId)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RemoveBookmarkGQL extends Apollo.Mutation<
  RemoveBookmarkMutation,
  RemoveBookmarkMutationVariables
> {
  document = RemoveBookmarkDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateRoleDocument = gql`
  mutation createRole($createRoleInput: CreateRoleInput!) {
    createRole(createRoleInput: $createRoleInput) {
      id
      name
      code
      description
      type
      tenant {
        id
        code
      }
      users {
        id
        firstName
        lastName
        username
        email
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateRoleGQL extends Apollo.Mutation<
  CreateRoleMutation,
  CreateRoleMutationVariables
> {
  document = CreateRoleDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateRoleDocument = gql`
  mutation updateRole($updateRoleInput: UpdateRoleInput!) {
    updateRole(updateRoleInput: $updateRoleInput) {
      id
      name
      code
      description
      type
      users {
        id
        firstName
        lastName
        username
        email
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateRoleGQL extends Apollo.Mutation<
  UpdateRoleMutation,
  UpdateRoleMutationVariables
> {
  document = UpdateRoleDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RemoveRolesDocument = gql`
  mutation removeRoles($ids: [String!]!) {
    removeRoles(ids: $ids)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RemoveRolesGQL extends Apollo.Mutation<
  RemoveRolesMutation,
  RemoveRolesMutationVariables
> {
  document = RemoveRolesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateUserDocument = gql`
  mutation createUser($createUserInput: CreateUserInput!) {
    createUser(createUserInput: $createUserInput) {
      id
      username
      firstName
      lastName
      fullName
      email
      description
      disableBiomedataLogin
      otherEmails {
        email
      }
      phoneNumber
      organizationalUnit
      title
      adGroups
      tenant {
        id
        name
        code
      }
      roles {
        id
        name
        type
        description
        tenant {
          id
          code
        }
      }
      submissions {
        id
        aggregate
        sendReminders
        daysAfterDeadline
        ccEmails
        userId
        parentId
        cadence
        careEntity {
          id
          code
          shortDisplayName
        }
        dataset {
          id
          name
        }
      }
      root
      permanentAccount
      submitsData
      enableSftp
      careEntityCode
      ccOnboardingEmail
      enabled
      enabledTime
      status
      passwordNeverExpires
      lastLogin
      twoFactor
      createdBy {
        fullName
      }
      createdAt
      updateBy {
        fullName
      }
      updateAt
      tokens {
        id
        type
        status
        name
        expiresAt
      }
      notifications {
        id
        name
        type
        description
      }
      files {
        file {
          id
          name
          description
          tenantId
          phi
          tenant {
            id
            name
          }
        }
        isDirect
        distributionLists {
          id
          name
        }
      }
      distributionLists {
        id
        name
        tenant {
          id
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateUserGQL extends Apollo.Mutation<
  CreateUserMutation,
  CreateUserMutationVariables
> {
  document = CreateUserDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateUserDocument = gql`
  mutation updateUser(
    $updateUserInput: UpdateUserInput!
    $fileShareNotification: FileShareNotification
  ) {
    updateUser(
      updateUserInput: $updateUserInput
      fileShareNotification: $fileShareNotification
    ) {
      id
      username
      firstName
      lastName
      fullName
      description
      email
      disableBiomedataLogin
      otherEmails {
        email
      }
      phoneNumber
      organizationalUnit
      title
      adGroups
      tenant {
        id
        name
        code
      }
      roles {
        id
        name
        type
        tenant {
          id
          code
        }
      }
      submissions {
        id
        sendReminders
        daysAfterDeadline
        ccEmails
        userId
        cadence
        aggregate
        parentId
        careEntity {
          id
          code
          shortDisplayName
        }
        dataset {
          id
          name
        }
      }
      root
      permanentAccount
      submitsData
      enableSftp
      careEntityCode
      ccOnboardingEmail
      enabled
      enabledTime
      status
      passwordNeverExpires
      lastLogin
      twoFactor
      createdBy {
        fullName
      }
      createdAt
      updateBy {
        fullName
      }
      updateAt
      tokens {
        id
        type
        status
        name
        expiresAt
      }
      notifications {
        id
        name
        type
        description
      }
      files {
        file {
          id
          name
          description
          tenantId
          tenant {
            id
            name
          }
          phi
        }
        isDirect
        distributionLists {
          id
          name
        }
      }
      distributionLists {
        id
        name
        tenant {
          id
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateUserGQL extends Apollo.Mutation<
  UpdateUserMutation,
  UpdateUserMutationVariables
> {
  document = UpdateUserDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ShareFilesWithUsersDocument = gql`
  mutation shareFilesWithUsers(
    $userFileShareInputs: [UpdateUserInput!]!
    $fileShareNotification: FileShareNotification
  ) {
    shareFilesWithUsers(
      userFileShareInputs: $userFileShareInputs
      fileShareNotification: $fileShareNotification
    )
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ShareFilesWithUsersGQL extends Apollo.Mutation<
  ShareFilesWithUsersMutation,
  ShareFilesWithUsersMutationVariables
> {
  document = ShareFilesWithUsersDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateTenantDocument = gql`
  mutation updateTenant($updateTenantInput: UpdateTenantInput!) {
    updateTenant(updateTenantInput: $updateTenantInput) {
      id
      name
      code
      itContact
      workbooks {
        id
        name
        description
        active
        diseaseStateModule {
          id
          name
        }
      }
      encryptionKeys
      active
      subdomain
      disableHomepage
      contractedDisplayPHI
      clinicalOnly
      aggregationTenant
      deliverableBlinded
      rollupMode
      organizationalUnit
      disableBiomedataLogin
      usesAnubisUpload
      projectSponsorId
      projectSponsor {
        id
        email
        fullName
        username
      }
      logo {
        id
        name
        mimeType
        extension
        category
        url
      }
      banner {
        id
        name
        mimeType
        extension
        category
        url
      }
      documents {
        id
        name
        mimeType
        extension
        category
        url
      }
      users {
        id
        fullName
        username
        email
      }
      careEntities {
        id
        name
        code
        description
        isEngagementEntity
        projectSponsor
        physicianChampion
        invoiceMonth
        onboardingCompletedOn
        monthlySponsorTouchbase
        reviewDsms {
          id
          code
          name
        }
        pushOnlyDsms {
          id
          code
          name
        }
      }
      roles {
        id
        name
        description
      }
      echoModules {
        id
        name
        displayName
        description
        active
      }
      offboardingJob {
        id
        status
        deletionStarted
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateTenantGQL extends Apollo.Mutation<
  UpdateTenantMutation,
  UpdateTenantMutationVariables
> {
  document = UpdateTenantDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateTenantDocument = gql`
  mutation createTenant($createTenantInput: CreateTenantInput!) {
    createTenant(createTenantInput: $createTenantInput) {
      id
      name
      code
      itContact
      workbooks {
        id
        name
        description
        active
        diseaseStateModule {
          id
          name
        }
      }
      encryptionKeys
      active
      subdomain
      disableHomepage
      contractedDisplayPHI
      clinicalOnly
      aggregationTenant
      deliverableBlinded
      rollupMode
      organizationalUnit
      disableBiomedataLogin
      usesAnubisUpload
      projectSponsorId
      projectSponsor {
        id
        email
        fullName
        username
      }
      logo {
        id
        name
        mimeType
        extension
        category
        url
      }
      banner {
        id
        name
        mimeType
        extension
        category
        url
      }
      documents {
        id
        name
        mimeType
        extension
        category
        url
      }
      users {
        id
        fullName
        username
        email
      }
      careEntities {
        id
        name
        code
        description
        isEngagementEntity
        projectSponsor
        physicianChampion
        invoiceMonth
        onboardingCompletedOn
        monthlySponsorTouchbase
        reviewDsms {
          id
          code
          name
        }
        pushOnlyDsms {
          id
          code
          name
        }
      }
      roles {
        id
        name
        description
      }
      echoModules {
        id
        name
        displayName
        description
        active
      }
      offboardingJob {
        id
        status
        deletionStarted
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateTenantGQL extends Apollo.Mutation<
  CreateTenantMutation,
  CreateTenantMutationVariables
> {
  document = CreateTenantDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateCareEntityDocument = gql`
  mutation updateCareEntity($updateCareEntityInput: UpdateCareEntityInput!) {
    updateCareEntity(updateCareEntityInput: $updateCareEntityInput) {
      id
      name
      shortDisplayName
      code
      supportedApps
      anonymousCode
      description
      type
      usGeoRegion
      street
      city
      state
      zip
      alternateNames
      ids
      noOfBeds
      aggregated
      teaching
      active
      includeInBenchmarks
      cmsId
      cmsIdNotAvailable
      reasonForNoCmsId
      isEngagementEntity
      projectSponsor
      physicianChampion
      invoiceMonth
      onboardingCompletedOn
      monthlySponsorTouchbase
      tenants {
        id
        code
        name
      }
      parents {
        id
        code
        name
        description
      }
      children {
        id
        code
        name
        description
      }
      memberDsms {
        childId
        diseaseStateModules {
          id
          code
          name
        }
      }
      diseaseStateModules {
        id
        code
        name
        description
        supportedApps
        type
        datasets {
          id
          name
        }
      }
      reviewDsms {
        id
        code
        name
      }
      pushOnlyDsms {
        id
        code
        name
      }
      excludedDsms {
        id
        code
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateCareEntityGQL extends Apollo.Mutation<
  UpdateCareEntityMutation,
  UpdateCareEntityMutationVariables
> {
  document = UpdateCareEntityDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateCareEntityDocument = gql`
  mutation createCareEntity($createCareEntityInput: CreateCareEntityInput!) {
    createCareEntity(createCareEntityInput: $createCareEntityInput) {
      id
      name
      shortDisplayName
      code
      supportedApps
      anonymousCode
      description
      type
      usGeoRegion
      street
      city
      state
      zip
      alternateNames
      ids
      noOfBeds
      aggregated
      teaching
      active
      includeInBenchmarks
      cmsId
      cmsIdNotAvailable
      reasonForNoCmsId
      isEngagementEntity
      projectSponsor
      physicianChampion
      invoiceMonth
      onboardingCompletedOn
      monthlySponsorTouchbase
      tenants {
        id
        code
        name
      }
      parents {
        id
        code
        name
        description
      }
      children {
        id
        code
        name
        description
      }
      memberDsms {
        childId
        diseaseStateModules {
          id
          code
          name
        }
      }
      diseaseStateModules {
        id
        code
        name
        description
        supportedApps
        type
        datasets {
          id
          name
        }
      }
      reviewDsms {
        id
        code
        name
      }
      pushOnlyDsms {
        id
        code
        name
      }
      excludedDsms {
        id
        code
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateCareEntityGQL extends Apollo.Mutation<
  CreateCareEntityMutation,
  CreateCareEntityMutationVariables
> {
  document = CreateCareEntityDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateBulkCareEntitiesDocument = gql`
  mutation createBulkCareEntities($inputs: [CreateBulkCareEntityInput!]!) {
    createBulkCareEntities(inputs: $inputs) {
      id
      name
      shortDisplayName
      code
      supportedApps
      anonymousCode
      description
      type
      usGeoRegion
      street
      city
      state
      zip
      alternateNames
      ids
      noOfBeds
      aggregated
      teaching
      active
      tenants {
        id
        code
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateBulkCareEntitiesGQL extends Apollo.Mutation<
  CreateBulkCareEntitiesMutation,
  CreateBulkCareEntitiesMutationVariables
> {
  document = CreateBulkCareEntitiesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RemoveCareEntityDocument = gql`
  mutation removeCareEntity($removeCareEntityId: String!) {
    removeCareEntity(id: $removeCareEntityId)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RemoveCareEntityGQL extends Apollo.Mutation<
  RemoveCareEntityMutation,
  RemoveCareEntityMutationVariables
> {
  document = RemoveCareEntityDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetCareEntityUpdateImpactDocument = gql`
  query getCareEntityUpdateImpact(
    $updateCareEntityInput: UpdateCareEntityInput!
  ) {
    careEntityUpdateImpact(updateCareEntityInput: $updateCareEntityInput) {
      childrenAdditionImpact
      memberDsmImpact
      usersImpacted {
        username
        email
        id
      }
      childrenRemovalImpact {
        id
        code
      }
      dsmAdditionImpact {
        affectedRoles {
          code
          id
        }
        newRoles
      }
      dsmRemovalImpact {
        submissions {
          id
          user {
            id
            username
            email
          }
        }
        affectedParentRoles {
          id
          code
        }
        removedRoles {
          id
          code
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetCareEntityUpdateImpactGQL extends Apollo.Query<
  GetCareEntityUpdateImpactQuery,
  GetCareEntityUpdateImpactQueryVariables
> {
  document = GetCareEntityUpdateImpactDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetUserRelationshipTablesDocument = gql`
  query getUserRelationshipTables($userId: String!) {
    userRelationshipTables(userId: $userId)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetUserRelationshipTablesGQL extends Apollo.Query<
  GetUserRelationshipTablesQuery,
  GetUserRelationshipTablesQueryVariables
> {
  document = GetUserRelationshipTablesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RemoveUserDocument = gql`
  mutation removeUser($removeUserId: String!) {
    removeUser(id: $removeUserId)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RemoveUserGQL extends Apollo.Mutation<
  RemoveUserMutation,
  RemoveUserMutationVariables
> {
  document = RemoveUserDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SoftDeleteUserDocument = gql`
  mutation softDeleteUser($userId: String!) {
    softDeleteUser(id: $userId)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class SoftDeleteUserGQL extends Apollo.Mutation<
  SoftDeleteUserMutation,
  SoftDeleteUserMutationVariables
> {
  document = SoftDeleteUserDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetDatasetRelationsDocument = gql`
  query getDatasetRelations($datasetRelationsId: Int!) {
    datasetRelations(id: $datasetRelationsId)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetDatasetRelationsGQL extends Apollo.Query<
  GetDatasetRelationsQuery,
  GetDatasetRelationsQueryVariables
> {
  document = GetDatasetRelationsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RemoveDatasetDocument = gql`
  mutation removeDataset($removeDatasetId: Int!) {
    removeDataset(id: $removeDatasetId)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RemoveDatasetGQL extends Apollo.Mutation<
  RemoveDatasetMutation,
  RemoveDatasetMutationVariables
> {
  document = RemoveDatasetDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ArchiveDatasetDocument = gql`
  mutation archiveDataset($archiveDatasetId: Int!) {
    archiveDataset(id: $archiveDatasetId) {
      id
      deletedAt
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ArchiveDatasetGQL extends Apollo.Mutation<
  ArchiveDatasetMutation,
  ArchiveDatasetMutationVariables
> {
  document = ArchiveDatasetDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UnarchiveDatasetDocument = gql`
  mutation unarchiveDataset($unarchiveDatasetId: Int!) {
    unarchiveDataset(id: $unarchiveDatasetId) {
      id
      deletedAt
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UnarchiveDatasetGQL extends Apollo.Mutation<
  UnarchiveDatasetMutation,
  UnarchiveDatasetMutationVariables
> {
  document = UnarchiveDatasetDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetDiseaseStateModuleDocument = gql`
  query getDiseaseStateModule($diseaseStateModuleId: ID!) {
    diseaseStateModule(id: $diseaseStateModuleId) {
      id
      deletedAt
      name
      code
      description
      type
      supportedApps
      primaryDatasetId
      hideRiskAuditCharts
      clinicalProgram {
        id
        name
      }
      datasets {
        id
        code
        name
        managingSociety
        isRegistry
        description
        supportsReportBuilder
      }
      criticalDatasets {
        id
        code
        name
        managingSociety
        isRegistry
        description
      }
      careEntities {
        id
        name
        code
        description
      }
      workbookGroups {
        id
        name
      }
      adjustment
      aggregationFn
      riskMetrics {
        id
        columnName
        displayName
        measureMetadatas {
          id
          name
        }
      }
      tableName
      summaryCohortId
      supportsMultipleProcedures
      multiProcTables {
        id
        tableName
        dimensions {
          id
          label
        }
        developmentDimensions {
          id
          label
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetDiseaseStateModuleGQL extends Apollo.Query<
  GetDiseaseStateModuleQuery,
  GetDiseaseStateModuleQueryVariables
> {
  document = GetDiseaseStateModuleDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetDiseaseStateModulesDocument = gql`
  query getDiseaseStateModules($includeArchived: Boolean) {
    diseaseStateModules(includeArchived: $includeArchived) {
      id
      deletedAt
      name
      code
      description
      type
      supportedApps
      hideRiskAuditCharts
      primaryDatasetId
      clinicalProgram {
        id
        name
      }
      datasets {
        id
        code
        name
        managingSociety
        isRegistry
        description
        supportsReportBuilder
      }
      criticalDatasets {
        id
        code
        name
        managingSociety
        isRegistry
        description
      }
      careEntities {
        id
        name
        code
        description
      }
      workbookGroups {
        id
        name
      }
      adjustment
      aggregationFn
      riskMetrics {
        id
        columnName
        displayName
        measureMetadatas {
          id
          name
        }
      }
      tableName
      summaryCohortId
      supportsMultipleProcedures
      multiProcTables {
        id
        tableName
        dimensions {
          id
          label
        }
        developmentDimensions {
          id
          label
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetDiseaseStateModulesGQL extends Apollo.Query<
  GetDiseaseStateModulesQuery,
  GetDiseaseStateModulesQueryVariables
> {
  document = GetDiseaseStateModulesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetUserDiseaseStateModulesIdsDocument = gql`
  query getUserDiseaseStateModulesIds {
    userDiseaseStateModulesIds
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetUserDiseaseStateModulesIdsGQL extends Apollo.Query<
  GetUserDiseaseStateModulesIdsQuery,
  GetUserDiseaseStateModulesIdsQueryVariables
> {
  document = GetUserDiseaseStateModulesIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateDiseaseStateModuleDocument = gql`
  mutation createDiseaseStateModule(
    $createDiseaseStateModuleInput: CreateDiseaseStateModuleInput!
  ) {
    createDiseaseStateModule(
      createDiseaseStateModuleInput: $createDiseaseStateModuleInput
    ) {
      id
      deletedAt
      name
      code
      description
      type
      supportedApps
      hideRiskAuditCharts
      primaryDatasetId
      clinicalProgram {
        id
        name
      }
      datasets {
        id
        code
        name
        managingSociety
        isRegistry
        description
      }
      criticalDatasets {
        id
        code
        name
        managingSociety
        isRegistry
        description
      }
      careEntities {
        id
        name
        code
        description
      }
      workbookGroups {
        id
        name
      }
      adjustment
      aggregationFn
      riskMetrics {
        id
        columnName
        displayName
        measureMetadatas {
          id
          name
        }
      }
      tableName
      summaryCohortId
      multiProcTables {
        id
        tableName
        dimensions {
          id
          label
        }
        developmentDimensions {
          id
          label
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateDiseaseStateModuleGQL extends Apollo.Mutation<
  CreateDiseaseStateModuleMutation,
  CreateDiseaseStateModuleMutationVariables
> {
  document = CreateDiseaseStateModuleDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateDiseaseStateModuleDocument = gql`
  mutation updateDiseaseStateModule(
    $updateDiseaseStateModuleInput: UpdateDiseaseStateModuleInput!
  ) {
    updateDiseaseStateModule(
      updateDiseaseStateModuleInput: $updateDiseaseStateModuleInput
    ) {
      id
      deletedAt
      name
      code
      description
      type
      supportedApps
      hideRiskAuditCharts
      primaryDatasetId
      clinicalProgram {
        id
        name
      }
      datasets {
        id
        code
        name
        managingSociety
        isRegistry
        description
      }
      criticalDatasets {
        id
        code
        name
        managingSociety
        isRegistry
        description
      }
      careEntities {
        id
        name
        code
        description
      }
      workbookGroups {
        id
        name
      }
      adjustment
      aggregationFn
      riskMetrics {
        id
        columnName
        displayName
        measureMetadatas {
          id
          name
        }
      }
      tableName
      summaryCohortId
      multiProcTables {
        id
        tableName
        dimensions {
          id
          label
        }
        developmentDimensions {
          id
          label
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateDiseaseStateModuleGQL extends Apollo.Mutation<
  UpdateDiseaseStateModuleMutation,
  UpdateDiseaseStateModuleMutationVariables
> {
  document = UpdateDiseaseStateModuleDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ArchiveDiseaseStateModuleDocument = gql`
  mutation archiveDiseaseStateModule($archiveDiseaseStateModuleId: ID!) {
    archiveDiseaseStateModule(id: $archiveDiseaseStateModuleId) {
      id
      deletedAt
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ArchiveDiseaseStateModuleGQL extends Apollo.Mutation<
  ArchiveDiseaseStateModuleMutation,
  ArchiveDiseaseStateModuleMutationVariables
> {
  document = ArchiveDiseaseStateModuleDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UnarchiveDiseaseStateModuleDocument = gql`
  mutation unarchiveDiseaseStateModule($unarchiveDiseaseStateModuleId: ID!) {
    unarchiveDiseaseStateModule(id: $unarchiveDiseaseStateModuleId) {
      id
      deletedAt
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UnarchiveDiseaseStateModuleGQL extends Apollo.Mutation<
  UnarchiveDiseaseStateModuleMutation,
  UnarchiveDiseaseStateModuleMutationVariables
> {
  document = UnarchiveDiseaseStateModuleDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetSubmissionsDocument = gql`
  query getSubmissions {
    submissions {
      id
      cadence
      submitNationalReport
      mrnCrosswalkRequired
      mrnHarvestRequired
      enabled
      ccEmails
      sendReminders
      daysAfterDeadline
      aggregate
      parentId
      dataset {
        id
        name
      }
      careEntity {
        id
        code
        name
        shortDisplayName
        aggregated
        tenants {
          id
        }
      }
      user {
        id
        username
        fullName
        tenant {
          id
          name
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetSubmissionsGQL extends Apollo.Query<
  GetSubmissionsQuery,
  GetSubmissionsQueryVariables
> {
  document = GetSubmissionsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetSubmissionDocument = gql`
  query getSubmission($submissionId: String!) {
    submission(id: $submissionId) {
      id
      cadence
      submitNationalReport
      mrnCrosswalkRequired
      mrnHarvestRequired
      enabled
      ccEmails
      sendReminders
      daysAfterDeadline
      aggregate
      dataset {
        id
        name
      }
      parentId
      children {
        id
        careEntity {
          id
          code
          name
        }
      }
      user {
        id
        username
        fullName
        tenant {
          id
          name
        }
      }
      careEntity {
        id
        code
        name
        shortDisplayName
        aggregated
        tenants {
          id
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetSubmissionGQL extends Apollo.Query<
  GetSubmissionQuery,
  GetSubmissionQueryVariables
> {
  document = GetSubmissionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateSubmissionDocument = gql`
  mutation createSubmission($createSubmissionInput: CreateSubmissionInput!) {
    createSubmission(createSubmissionInput: $createSubmissionInput) {
      id
      cadence
      submitNationalReport
      mrnCrosswalkRequired
      mrnHarvestRequired
      enabled
      ccEmails
      sendReminders
      daysAfterDeadline
      aggregate
      parentId
      user {
        id
        username
        fullName
        tenant {
          id
          name
        }
      }
      dataset {
        id
        name
      }
      children {
        id
        careEntity {
          id
          code
          name
        }
      }
      careEntity {
        id
        code
        name
        shortDisplayName
        aggregated
        tenants {
          id
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateSubmissionGQL extends Apollo.Mutation<
  CreateSubmissionMutation,
  CreateSubmissionMutationVariables
> {
  document = CreateSubmissionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateAggregateSubmissionDocument = gql`
  mutation createAggregateSubmission(
    $createAggregateSubmissionsInput: CreateAggregateSubmissionsInput!
  ) {
    createAggregateSubmission(
      createAggregateSubmissionInput: $createAggregateSubmissionsInput
    ) {
      id
      cadence
      submitNationalReport
      mrnCrosswalkRequired
      mrnHarvestRequired
      enabled
      aggregate
      dataset {
        id
        name
      }
      careEntity {
        id
        code
        name
        shortDisplayName
        aggregated
        tenants {
          id
        }
      }
      sendReminders
      daysAfterDeadline
      ccEmails
      user {
        id
        username
        fullName
        tenant {
          id
          name
        }
      }
      parentId
      children {
        id
        careEntity {
          id
          code
          name
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateAggregateSubmissionGQL extends Apollo.Mutation<
  CreateAggregateSubmissionMutation,
  CreateAggregateSubmissionMutationVariables
> {
  document = CreateAggregateSubmissionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateSubmissionDocument = gql`
  mutation updateSubmission($updateSubmissionInput: UpdateSubmissionInput!) {
    updateSubmission(updateSubmissionInput: $updateSubmissionInput) {
      id
      cadence
      submitNationalReport
      mrnCrosswalkRequired
      mrnHarvestRequired
      enabled
      ccEmails
      sendReminders
      daysAfterDeadline
      aggregate
      parentId
      children {
        id
        careEntity {
          id
          code
          name
        }
      }
      user {
        id
        username
        fullName
        tenant {
          id
          name
        }
      }
      dataset {
        id
        name
      }
      careEntity {
        id
        code
        name
        shortDisplayName
        aggregated
        tenants {
          id
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateSubmissionGQL extends Apollo.Mutation<
  UpdateSubmissionMutation,
  UpdateSubmissionMutationVariables
> {
  document = UpdateSubmissionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RemoveSubmissionDocument = gql`
  mutation removeSubmission($removeSubmissionId: String!) {
    removeSubmission(id: $removeSubmissionId)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RemoveSubmissionGQL extends Apollo.Mutation<
  RemoveSubmissionMutation,
  RemoveSubmissionMutationVariables
> {
  document = RemoveSubmissionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetFavoriteViewsDocument = gql`
  query getFavoriteViews($tenantId: String!) {
    favoriteViews(tenantId: $tenantId) {
      id
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetFavoriteViewsGQL extends Apollo.Query<
  GetFavoriteViewsQuery,
  GetFavoriteViewsQueryVariables
> {
  document = GetFavoriteViewsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetRecentTableauViewsDocument = gql`
  query getRecentTableauViews($tenantId: String!, $take: Int!) {
    recentTableauView(tenantId: $tenantId, take: $take) {
      id
      viewedAt
      tableauView {
        id
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetRecentTableauViewsGQL extends Apollo.Query<
  GetRecentTableauViewsQuery,
  GetRecentTableauViewsQueryVariables
> {
  document = GetRecentTableauViewsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateRecentTableauViewDocument = gql`
  mutation createRecentTableauView(
    $createRecentTableauViewInput: CreateRecentTableauViewInput!
  ) {
    createRecentTableauView(
      createRecentTableauViewInput: $createRecentTableauViewInput
    ) {
      id
      viewedAt
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateRecentTableauViewGQL extends Apollo.Mutation<
  CreateRecentTableauViewMutation,
  CreateRecentTableauViewMutationVariables
> {
  document = CreateRecentTableauViewDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UnlockUserDocument = gql`
  mutation unlockUser($username: String!) {
    unlockUser(username: $username)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UnlockUserGQL extends Apollo.Mutation<
  UnlockUserMutation,
  UnlockUserMutationVariables
> {
  document = UnlockUserDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ChangePasswordDocument = gql`
  mutation changePassword($username: String!, $newPassword: String!) {
    changePassword(username: $username, newPassword: $newPassword)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ChangePasswordGQL extends Apollo.Mutation<
  ChangePasswordMutation,
  ChangePasswordMutationVariables
> {
  document = ChangePasswordDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetOrganizationalUnitsDocument = gql`
  query getOrganizationalUnits {
    organizationalUnits {
      distinguishedName
      subOu {
        distinguishedName
        subOu {
          distinguishedName
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetOrganizationalUnitsGQL extends Apollo.Query<
  GetOrganizationalUnitsQuery,
  GetOrganizationalUnitsQueryVariables
> {
  document = GetOrganizationalUnitsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetClinicalProgramsDocument = gql`
  query getClinicalPrograms {
    clinicalPrograms {
      id
      name
      description
      isAdmin
      diseaseStateModules {
        id
        name
        code
        description
        deletedAt
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetClinicalProgramsGQL extends Apollo.Query<
  GetClinicalProgramsQuery,
  GetClinicalProgramsQueryVariables
> {
  document = GetClinicalProgramsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetClinicalProgramDocument = gql`
  query getClinicalProgram($clinicalProgramId: Int!) {
    clinicalProgram(id: $clinicalProgramId) {
      id
      name
      description
      isAdmin
      diseaseStateModules {
        id
        name
        code
        description
        deletedAt
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetClinicalProgramGQL extends Apollo.Query<
  GetClinicalProgramQuery,
  GetClinicalProgramQueryVariables
> {
  document = GetClinicalProgramDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateClinicalProgramDocument = gql`
  mutation createClinicalProgram(
    $createClinicalProgramInput: CreateClinicalProgramInput!
  ) {
    createClinicalProgram(
      createClinicalProgramInput: $createClinicalProgramInput
    ) {
      id
      name
      description
      isAdmin
      diseaseStateModules {
        id
        name
        code
        description
        deletedAt
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateClinicalProgramGQL extends Apollo.Mutation<
  CreateClinicalProgramMutation,
  CreateClinicalProgramMutationVariables
> {
  document = CreateClinicalProgramDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateClinicalProgramDocument = gql`
  mutation updateClinicalProgram(
    $updateClinicalProgramInput: UpdateClinicalProgramInput!
  ) {
    updateClinicalProgram(
      updateClinicalProgramInput: $updateClinicalProgramInput
    ) {
      id
      name
      description
      isAdmin
      diseaseStateModules {
        id
        name
        code
        description
        deletedAt
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateClinicalProgramGQL extends Apollo.Mutation<
  UpdateClinicalProgramMutation,
  UpdateClinicalProgramMutationVariables
> {
  document = UpdateClinicalProgramDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetDatasetsDocument = gql`
  query getDatasets($includeArchived: Boolean) {
    datasets(includeArchived: $includeArchived) {
      id
      name
      code
      description
      managingSociety
      isRegistry
      isAdmin
      isDropAndLoad
      isTenantLevel
      isCrosswalkSource
      crosswalkRequired
      supportsReportBuilder
      deletedAt
      diseaseStateModules {
        id
        name
        code
        description
        deletedAt
      }
      deadlines {
        id
        quarterIncluded
        quarterSubmissionDeadline
      }
      datasetVersions {
        id
        name
        versionNumber
        description
        startDate
        datasetId
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetDatasetsGQL extends Apollo.Query<
  GetDatasetsQuery,
  GetDatasetsQueryVariables
> {
  document = GetDatasetsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetDatasetVersionsDocument = gql`
  query getDatasetVersions($fieldId: Int) {
    datasetVersions(fieldId: $fieldId) {
      id
      datasetId
      name
      versionNumber
      datasetVersionFields {
        datasetVersionId
        fieldId
        sequenceNumber
      }
      dataset {
        id
        name
        datasetVersions {
          id
          name
          versionNumber
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetDatasetVersionsGQL extends Apollo.Query<
  GetDatasetVersionsQuery,
  GetDatasetVersionsQueryVariables
> {
  document = GetDatasetVersionsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const AddFieldDatasetVersionsDocument = gql`
  mutation addFieldDatasetVersions(
    $datasetVersionFieldInputs: [CreateDatasetVersionFieldInput!]!
  ) {
    addFieldDatasetVersions(
      datasetVersionFieldInputs: $datasetVersionFieldInputs
    )
  }
`;

@Injectable({
  providedIn: 'root',
})
export class AddFieldDatasetVersionsGQL extends Apollo.Mutation<
  AddFieldDatasetVersionsMutation,
  AddFieldDatasetVersionsMutationVariables
> {
  document = AddFieldDatasetVersionsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RemoveFieldDatasetVersionsDocument = gql`
  mutation removeFieldDatasetVersions($fieldId: Int!) {
    removeFieldDatasetVersions(fieldId: $fieldId)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RemoveFieldDatasetVersionsGQL extends Apollo.Mutation<
  RemoveFieldDatasetVersionsMutation,
  RemoveFieldDatasetVersionsMutationVariables
> {
  document = RemoveFieldDatasetVersionsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetDatasetDocument = gql`
  query getDataset($datasetId: Int!) {
    dataset(id: $datasetId) {
      id
      name
      code
      description
      managingSociety
      isRegistry
      isAdmin
      isDropAndLoad
      isTenantLevel
      isCrosswalkSource
      crosswalkRequired
      supportsReportBuilder
      deletedAt
      diseaseStateModules {
        id
        name
        code
        description
        deletedAt
      }
      deadlines {
        id
        quarterIncluded
        quarterSubmissionDeadline
      }
      datasetVersions {
        id
        name
        versionNumber
        description
        startDate
        datasetId
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetDatasetGQL extends Apollo.Query<
  GetDatasetQuery,
  GetDatasetQueryVariables
> {
  document = GetDatasetDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateDatasetDocument = gql`
  mutation createDataset($createDatasetInput: CreateDatasetInput!) {
    createDataset(createDatasetInput: $createDatasetInput) {
      id
      name
      code
      description
      managingSociety
      isRegistry
      isAdmin
      isDropAndLoad
      isTenantLevel
      isCrosswalkSource
      crosswalkRequired
      supportsReportBuilder
      deletedAt
      diseaseStateModules {
        id
        name
        code
        description
        deletedAt
      }
      deadlines {
        id
        quarterIncluded
        quarterSubmissionDeadline
      }
      datasetVersions {
        id
        name
        versionNumber
        description
        startDate
        datasetId
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateDatasetGQL extends Apollo.Mutation<
  CreateDatasetMutation,
  CreateDatasetMutationVariables
> {
  document = CreateDatasetDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateDatasetDocument = gql`
  mutation updateDataset($updateDatasetInput: UpdateDatasetInput!) {
    updateDataset(updateDatasetInput: $updateDatasetInput) {
      id
      name
      code
      description
      managingSociety
      isRegistry
      isAdmin
      isDropAndLoad
      isTenantLevel
      isCrosswalkSource
      crosswalkRequired
      diseaseStateModules {
        id
        name
        code
        description
        deletedAt
      }
      deadlines {
        id
        quarterIncluded
        quarterSubmissionDeadline
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateDatasetGQL extends Apollo.Mutation<
  UpdateDatasetMutation,
  UpdateDatasetMutationVariables
> {
  document = UpdateDatasetDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RevokeTokenDocument = gql`
  mutation revokeToken($revokeTokenId: String!) {
    revokeToken(id: $revokeTokenId)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RevokeTokenGQL extends Apollo.Mutation<
  RevokeTokenMutation,
  RevokeTokenMutationVariables
> {
  document = RevokeTokenDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SetHomepageDocument = gql`
  mutation setHomepage($createBookmarkInput: CreateBookmarkInput!) {
    setHomepage(createBookmarkInput: $createBookmarkInput)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class SetHomepageGQL extends Apollo.Mutation<
  SetHomepageMutation,
  SetHomepageMutationVariables
> {
  document = SetHomepageDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateDeadlineDocument = gql`
  mutation createDeadline($createDeadlineInput: CreateDeadlineInput!) {
    createDeadline(createDeadlineInput: $createDeadlineInput) {
      id
      monthIncluded
      monthSubmissionDeadline
      quarterIncluded
      quarterSubmissionDeadline
      dataset {
        id
        name
        code
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateDeadlineGQL extends Apollo.Mutation<
  CreateDeadlineMutation,
  CreateDeadlineMutationVariables
> {
  document = CreateDeadlineDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateDeadlineDocument = gql`
  mutation updateDeadline($updateDeadlineInput: UpdateDeadlineInput!) {
    updateDeadline(updateDeadlineInput: $updateDeadlineInput)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateDeadlineGQL extends Apollo.Mutation<
  UpdateDeadlineMutation,
  UpdateDeadlineMutationVariables
> {
  document = UpdateDeadlineDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateBulkDeadlinesDocument = gql`
  mutation createBulkDeadlines($createDeadlineInputs: [CreateDeadlineInput!]!) {
    createBulkDeadlines(createDeadlineInputs: $createDeadlineInputs) {
      id
      monthIncluded
      monthSubmissionDeadline
      quarterIncluded
      quarterSubmissionDeadline
      dataset {
        id
        name
        code
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateBulkDeadlinesGQL extends Apollo.Mutation<
  CreateBulkDeadlinesMutation,
  CreateBulkDeadlinesMutationVariables
> {
  document = CreateBulkDeadlinesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetDeadlinesDocument = gql`
  query getDeadlines {
    deadlines {
      id
      monthIncluded
      monthSubmissionDeadline
      quarterIncluded
      quarterSubmissionDeadline
      dataset {
        id
        name
        code
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetDeadlinesGQL extends Apollo.Query<
  GetDeadlinesQuery,
  GetDeadlinesQueryVariables
> {
  document = GetDeadlinesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetDeadlineDocument = gql`
  query getDeadline($deadlineId: String!) {
    deadline(id: $deadlineId) {
      id
      monthIncluded
      monthSubmissionDeadline
      quarterIncluded
      quarterSubmissionDeadline
      dataset {
        id
        name
        code
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetDeadlineGQL extends Apollo.Query<
  GetDeadlineQuery,
  GetDeadlineQueryVariables
> {
  document = GetDeadlineDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RemoveDeadlineDocument = gql`
  mutation removeDeadline($removeDeadlineId: String!) {
    removeDeadline(id: $removeDeadlineId)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RemoveDeadlineGQL extends Apollo.Mutation<
  RemoveDeadlineMutation,
  RemoveDeadlineMutationVariables
> {
  document = RemoveDeadlineDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetExpiringDeadlineForDatasetDocument = gql`
  query getExpiringDeadlineForDataset($datasetId: Int!) {
    expiringDeadlineForDataset(datasetId: $datasetId) {
      datasetId
      maxDeadline
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetExpiringDeadlineForDatasetGQL extends Apollo.Query<
  GetExpiringDeadlineForDatasetQuery,
  GetExpiringDeadlineForDatasetQueryVariables
> {
  document = GetExpiringDeadlineForDatasetDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const EnableUserDocument = gql`
  mutation enableUser(
    $enableUserInput: EnableUserInput!
    $alternativeUserId: String!
  ) {
    enableUser(
      enableUserInput: $enableUserInput
      alternativeUserId: $alternativeUserId
    )
  }
`;

@Injectable({
  providedIn: 'root',
})
export class EnableUserGQL extends Apollo.Mutation<
  EnableUserMutation,
  EnableUserMutationVariables
> {
  document = EnableUserDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetEchoAttributesDocument = gql`
  query getEchoAttributes {
    echoAttributes {
      id
      careEntityId
      caseListModuleName
      maxStudyDate
      count
      echoLatestRefreshDate
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetEchoAttributesGQL extends Apollo.Query<
  GetEchoAttributesQuery,
  GetEchoAttributesQueryVariables
> {
  document = GetEchoAttributesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetEchoFindingsDocument = gql`
  query getEchoFindings(
    $avStenosis: String
    $excludeFromAnalysis: Int
    $latestStudyOnRecord: Int
    $caselistModuleName: String!
    $careEntityId: String
    $endDate: DateTime
    $startDate: DateTime
  ) {
    echoFindings(
      avStenosis: $avStenosis
      excludeFromAnalysis: $excludeFromAnalysis
      latestStudyOnRecord: $latestStudyOnRecord
      caselistModuleName: $caselistModuleName
      careEntityId: $careEntityId
      endDate: $endDate
      startDate: $startDate
    ) {
      biomeEncounterId
      caseId
      mrn
      biomeCaseUid
      biomePatientUid
      patientName
      gender
      race
      age
      orderDt
      procedureDt
      avStenosis
      avStenosisText
      mvRegurgitation
      avRegurgitation
      mvStenosis
      pvStenosis
      tvRegurgitation
      tvStenosis
      echoResultText
      latestStudyOnRecord
      biomeUpdateDt
      biomeImportDt
      caselistModuleName
      careEntityId
      tenantId
      careEntityName
      otherValveDisease
      followups {
        id
        biomeCaseUid
        biomePatientUid
        notes
        statusId
        version
        createdAt
        updateAt
        updateBy {
          fullName
          title
          firstName
          lastName
        }
        latestStudyOnRecord
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetEchoFindingsGQL extends Apollo.Query<
  GetEchoFindingsQuery,
  GetEchoFindingsQueryVariables
> {
  document = GetEchoFindingsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateEchoFindingFollowupDocument = gql`
  mutation createEchoFindingFollowup($input: EchoFindingFollowupInput!) {
    createEchoFindingFollowup(input: $input) {
      id
      biomeCaseUid
      biomePatientUid
      notes
      statusId
      version
      createdAt
      updateAt
      updateBy {
        fullName
        title
        firstName
        lastName
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateEchoFindingFollowupGQL extends Apollo.Mutation<
  CreateEchoFindingFollowupMutation,
  CreateEchoFindingFollowupMutationVariables
> {
  document = CreateEchoFindingFollowupDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetCurrentEchoFollowupOptionsDocument = gql`
  query getCurrentEchoFollowupOptions($caselistModuleName: String) {
    currentEchoFollowupOptions(caselistModuleName: $caselistModuleName) {
      id
      name
      displayName
      displayRank
      isDefault
      scope
      tenantId
      category
      hide
      careEntities {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetCurrentEchoFollowupOptionsGQL extends Apollo.Query<
  GetCurrentEchoFollowupOptionsQuery,
  GetCurrentEchoFollowupOptionsQueryVariables
> {
  document = GetCurrentEchoFollowupOptionsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetEchoFindingFieldsDocument = gql`
  query getEchoFindingFields($caselistModuleName: String) {
    echoFindingFields(caselistModuleName: $caselistModuleName) {
      id
      name
      phi
      type
      visibility
      displayName
      displayRank
      description
      category
      trained
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetEchoFindingFieldsGQL extends Apollo.Query<
  GetEchoFindingFieldsQuery,
  GetEchoFindingFieldsQueryVariables
> {
  document = GetEchoFindingFieldsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetEchoFindingModulesDocument = gql`
  query getEchoFindingModules {
    echoFindingModules {
      id
      displayName
      description
      name
      active
      displayRank
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetEchoFindingModulesGQL extends Apollo.Query<
  GetEchoFindingModulesQuery,
  GetEchoFindingModulesQueryVariables
> {
  document = GetEchoFindingModulesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetTenantEchoFindingModulesDocument = gql`
  query getTenantEchoFindingModules {
    findAllTenantEchoModules {
      id
      displayName
      description
      name
      active
      displayRank
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetTenantEchoFindingModulesGQL extends Apollo.Query<
  GetTenantEchoFindingModulesQuery,
  GetTenantEchoFindingModulesQueryVariables
> {
  document = GetTenantEchoFindingModulesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetRiskAuditsDocument = gql`
  query getRiskAudits(
    $diseaseStateModuleId: Int!
    $careEntityId: String
    $endDate: DateTime
    $startDate: DateTime
    $flagTypes: [FlagType!]
  ) {
    riskAudits(
      diseaseStateModuleId: $diseaseStateModuleId
      careEntityId: $careEntityId
      startDate: $startDate
      endDate: $endDate
      flagTypes: $flagTypes
    ) {
      biomeEncounterId
      auditId
      visitId
      careEntityCode
      region
      encounterId
      mrn
      registryId
      procedure
      arrivalDate
      procedureDate
      dischargeDate
      dischargeYear
      dischargeQuarter
      surgicalYear
      surgicalQuarter
      diagnosisPOACodeList
      visitTiming
      riskValue
      riskReview
      reviewTriggerDescription
      keyField
      keyFieldValue
      volume
      biomeETLVersion
      physician
      mrnOriginal
      procedureGroup
      pciStatus
      pciIndication
      drgCode
      icd10TriggerCode
      directCost
      netRevenue
      trails {
        id
        notes
        status
        version
        latestStudyOnRecord
        updateBy {
          fullName
          title
          firstName
          lastName
        }
        updateAt
      }
      auditFlagSource
      tenantCode
      biomeUpdateDt
      careEntityId
      tenantId
      careEntityName
      diseaseStateModuleId
      flagType
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetRiskAuditsGQL extends Apollo.Query<
  GetRiskAuditsQuery,
  GetRiskAuditsQueryVariables
> {
  document = GetRiskAuditsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetRiskAuditAttributesDocument = gql`
  query getRiskAuditAttributes(
    $diseaseStateModuleId: Int!
    $careEntityId: String
  ) {
    riskAuditAttributes(
      diseaseStateModuleId: $diseaseStateModuleId
      careEntityId: $careEntityId
    ) {
      biomeLatestRefreshDate
      maxStudyDate
      availableQuarters
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetRiskAuditAttributesGQL extends Apollo.Query<
  GetRiskAuditAttributesQuery,
  GetRiskAuditAttributesQueryVariables
> {
  document = GetRiskAuditAttributesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetRiskAuditFieldsDocument = gql`
  query getRiskAuditFields($diseaseStateModuleId: Int!) {
    riskAuditFields(diseaseStateModuleId: $diseaseStateModuleId) {
      id
      name
      phi
      type
      visibility
      displayRank
      displayName
      description
      category
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetRiskAuditFieldsGQL extends Apollo.Query<
  GetRiskAuditFieldsQuery,
  GetRiskAuditFieldsQueryVariables
> {
  document = GetRiskAuditFieldsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetRiskAuditOutcomesDocument = gql`
  query getRiskAuditOutcomes($dsmId: Int!, $careEntityId: String!) {
    riskAuditOutcomes(dsmId: $dsmId, careEntityId: $careEntityId) {
      quarters
      outcomes {
        aggLevel
        auditId
        biomeUpdateDt
        careEntityCode
        measureId
        measureName
        oer
        observed
        expected
        outcomeType
        quarter
        procedure
        recordTiming
        registry
        tenantCode
        tenantId
        careEntityId
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetRiskAuditOutcomesGQL extends Apollo.Query<
  GetRiskAuditOutcomesQuery,
  GetRiskAuditOutcomesQueryVariables
> {
  document = GetRiskAuditOutcomesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetRiskAuditChartsDataDocument = gql`
  query getRiskAuditChartsData(
    $diseaseStateModuleId: Int!
    $careEntityId: String
    $startDate: DateTime
    $endDate: DateTime
    $flagTypes: [FlagType!]
  ) {
    riskAuditChartsData(
      diseaseStateModuleId: $diseaseStateModuleId
      careEntityId: $careEntityId
      startDate: $startDate
      endDate: $endDate
      flagTypes: $flagTypes
    ) {
      auditFlagTypes {
        count
        riskValue
      }
      auditFlagSummary {
        riskValue
        statuses {
          count
          status
        }
        totalCount
      }
      auditStatuses {
        displayRank
        key
        name
        value
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetRiskAuditChartsDataGQL extends Apollo.Query<
  GetRiskAuditChartsDataQuery,
  GetRiskAuditChartsDataQueryVariables
> {
  document = GetRiskAuditChartsDataDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ResetPasswordDocument = gql`
  mutation resetPassword($passwordResetInput: PasswordResetInput!) {
    resetPassword(passwordResetInput: $passwordResetInput)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ResetPasswordGQL extends Apollo.Mutation<
  ResetPasswordMutation,
  ResetPasswordMutationVariables
> {
  document = ResetPasswordDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ResendOnboardingEmailDocument = gql`
  mutation resendOnboardingEmail($userId: String!) {
    resendOnboardingEmail(userId: $userId)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ResendOnboardingEmailGQL extends Apollo.Mutation<
  ResendOnboardingEmailMutation,
  ResendOnboardingEmailMutationVariables
> {
  document = ResendOnboardingEmailDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetAdGroupsDocument = gql`
  query getAdGroups {
    adGroups {
      id
      name
      distinguishedName
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetAdGroupsGQL extends Apollo.Query<
  GetAdGroupsQuery,
  GetAdGroupsQueryVariables
> {
  document = GetAdGroupsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateActivityLogDocument = gql`
  mutation createActivityLog($createActivityLogInput: CreateActivityLogInput!) {
    createActivityLog(createActivityLogInput: $createActivityLogInput)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateActivityLogGQL extends Apollo.Mutation<
  CreateActivityLogMutation,
  CreateActivityLogMutationVariables
> {
  document = CreateActivityLogDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetActivityLogsDocument = gql`
  query getActivityLogs($startDate: DateTime, $endDate: DateTime) {
    activityLogs(startDate: $startDate, endDate: $endDate) {
      id
      createdAt
      createdBy {
        username
        id
      }
      type
      relatedData
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetActivityLogsGQL extends Apollo.Query<
  GetActivityLogsQuery,
  GetActivityLogsQueryVariables
> {
  document = GetActivityLogsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetUserAccessChangesDocument = gql`
  query getUserAccessChanges($userId: ID!) {
    userAccessChanges(userId: $userId) {
      userCreatedAt
      userCreatedByName
      changes {
        id
        event
        comment
        createdAt
        roleNames
        otherAccessFields
        changedByName
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetUserAccessChangesGQL extends Apollo.Query<
  GetUserAccessChangesQuery,
  GetUserAccessChangesQueryVariables
> {
  document = GetUserAccessChangesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetAccessHistoryDocument = gql`
  query getAccessHistory($startDate: DateTime, $endDate: DateTime) {
    accessHistory(startDate: $startDate, endDate: $endDate) {
      id
      event
      comment
      createdBy {
        id
        username
      }
      createdAt
      role {
        name
        id
      }
      subject
      user {
        id
        username
      }
      distributionList {
        id
        name
      }
      current
      previous
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetAccessHistoryGQL extends Apollo.Query<
  GetAccessHistoryQuery,
  GetAccessHistoryQueryVariables
> {
  document = GetAccessHistoryDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetNotificationsDocument = gql`
  query getNotifications {
    notifications {
      id
      name
      type
      description
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetNotificationsGQL extends Apollo.Query<
  GetNotificationsQuery,
  GetNotificationsQueryVariables
> {
  document = GetNotificationsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GenerateStandardRolesDocument = gql`
  mutation generateStandardRoles($input: GenerateStandardRolesInput!) {
    generateStandardRoles(input: $input)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GenerateStandardRolesGQL extends Apollo.Mutation<
  GenerateStandardRolesMutation,
  GenerateStandardRolesMutationVariables
> {
  document = GenerateStandardRolesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RefreshStandardRolesDocument = gql`
  mutation refreshStandardRoles($tenantId: String!, $roleIds: [String!]) {
    refreshStandardRoles(tenantId: $tenantId, roleIds: $roleIds)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RefreshStandardRolesGQL extends Apollo.Mutation<
  RefreshStandardRolesMutation,
  RefreshStandardRolesMutationVariables
> {
  document = RefreshStandardRolesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RetryJobDocument = gql`
  mutation retryJob($jobId: String!) {
    retryJob(jobId: $jobId)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RetryJobGQL extends Apollo.Mutation<
  RetryJobMutation,
  RetryJobMutationVariables
> {
  document = RetryJobDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetJobProgressTreeDocument = gql`
  query getJobProgressTree($jobId: String!) {
    jobProgressTree(jobId: $jobId) {
      summary {
        ...jobProgressSummaryFields
      }
      nodes {
        ...jobProgressNodeFields
        children {
          ...jobProgressNodeFields
          childJob {
            ...jobProgressNestedTreeFields
          }
          children {
            ...jobProgressNodeFields
            childJob {
              ...jobProgressNestedTreeFields
            }
          }
        }
        childJob {
          ...jobProgressNestedTreeFields
        }
      }
    }
  }
  ${JobProgressSummaryFieldsFragmentDoc}
  ${JobProgressNodeFieldsFragmentDoc}
  ${JobProgressNestedTreeFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetJobProgressTreeGQL extends Apollo.Query<
  GetJobProgressTreeQuery,
  GetJobProgressTreeQueryVariables
> {
  document = GetJobProgressTreeDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetJobDocument = gql`
  query getJob($id: String!) {
    job(id: $id) {
      id
      jobType
      status
      createdBy {
        fullName
      }
      createdAt
      statusTime
      parentId
      retriedFromJobId
      hasProgressTree
      additionalInfo
      events {
        id
        occuredAt
        eventType
        message
      }
      retriedAs {
        id
        jobType
        status
        createdAt
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetJobGQL extends Apollo.Query<GetJobQuery, GetJobQueryVariables> {
  document = GetJobDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetDatasetVersionDocument = gql`
  query getDatasetVersion($datasetVersionId: String, $name: String) {
    datasetVersion(id: $datasetVersionId, name: $name) {
      id
      name
      versionNumber
      description
      startDate
      dataset {
        id
        code
        name
      }
      datasetVersionFields {
        fieldId
        sequenceNumber
        datasetVersion {
          id
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetDatasetVersionGQL extends Apollo.Query<
  GetDatasetVersionQuery,
  GetDatasetVersionQueryVariables
> {
  document = GetDatasetVersionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateDatasetVersionDocument = gql`
  mutation createDatasetVersion(
    $createDatasetVersionInput: CreateDatasetVersionInput!
  ) {
    createDatasetVersion(
      createDatasetVersionInput: $createDatasetVersionInput
    ) {
      id
      name
      versionNumber
      description
      startDate
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateDatasetVersionGQL extends Apollo.Mutation<
  CreateDatasetVersionMutation,
  CreateDatasetVersionMutationVariables
> {
  document = CreateDatasetVersionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateDatasetVersionDocument = gql`
  mutation updateDatasetVersion(
    $updateDatasetVersionInput: UpdateDatasetVersionInput!
  ) {
    updateDatasetVersion(updateDatasetVersionInput: $updateDatasetVersionInput)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateDatasetVersionGQL extends Apollo.Mutation<
  UpdateDatasetVersionMutation,
  UpdateDatasetVersionMutationVariables
> {
  document = UpdateDatasetVersionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SyncRoleRowLevelSecurityDocument = gql`
  mutation syncRoleRowLevelSecurity($roleId: String!) {
    syncRoleRowLevelSecurity(roleId: $roleId)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class SyncRoleRowLevelSecurityGQL extends Apollo.Mutation<
  SyncRoleRowLevelSecurityMutation,
  SyncRoleRowLevelSecurityMutationVariables
> {
  document = SyncRoleRowLevelSecurityDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SyncTenantRowLevelSecurityDocument = gql`
  mutation syncTenantRowLevelSecurity($tenantId: String!) {
    syncTenantRowLevelSecurity(tenantId: $tenantId)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class SyncTenantRowLevelSecurityGQL extends Apollo.Mutation<
  SyncTenantRowLevelSecurityMutation,
  SyncTenantRowLevelSecurityMutationVariables
> {
  document = SyncTenantRowLevelSecurityDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SyncUserRowLevelSecurityDocument = gql`
  mutation syncUserRowLevelSecurity($userId: String!) {
    syncUserRowLevelSecurity(userId: $userId)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class SyncUserRowLevelSecurityGQL extends Apollo.Mutation<
  SyncUserRowLevelSecurityMutation,
  SyncUserRowLevelSecurityMutationVariables
> {
  document = SyncUserRowLevelSecurityDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateRiskAuditTrailDocument = gql`
  mutation createRiskAuditTrail($input: RiskAuditTrailInput!) {
    createRiskAuditTrail(input: $input) {
      id
      version
      notes
      status
      latestStudyOnRecord
      updateBy {
        fullName
        title
        firstName
        lastName
      }
      updateAt
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateRiskAuditTrailGQL extends Apollo.Mutation<
  CreateRiskAuditTrailMutation,
  CreateRiskAuditTrailMutationVariables
> {
  document = CreateRiskAuditTrailDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetLatestJobsDocument = gql`
  query getLatestJobs($input: FindLatestJobsInput!) {
    latestJobs(input: $input) {
      id
      jobType
      status
      createdAt
      statusTime
      events {
        eventType
        message
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetLatestJobsGQL extends Apollo.Query<
  GetLatestJobsQuery,
  GetLatestJobsQueryVariables
> {
  document = GetLatestJobsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetSubmissionPresentationsDocument = gql`
  query getSubmissionPresentations($quarters: [String!]!) {
    submissionPresentations(quarters: $quarters) {
      id
      quarter
      careEntityId
      tenantId
      presentation {
        id
        name
        diseaseStateModuleId
        latestJob {
          id
          status
          statusTime
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetSubmissionPresentationsGQL extends Apollo.Query<
  GetSubmissionPresentationsQuery,
  GetSubmissionPresentationsQueryVariables
> {
  document = GetSubmissionPresentationsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetPresentationsDocument = gql`
  query getPresentations($ids: [String!], $tenantId: String) {
    presentations(ids: $ids, tenantId: $tenantId) {
      id
      name
      description
      tenantId
      tenant {
        id
        code
        name
      }
      diseaseStateModuleId
      presentationType
      imagesRefreshedAt
      refreshJob {
        id
        additionalInfo
      }
      latestJob {
        id
        status
      }
      slides {
        id
        title
        subtitle
        shareableLink
        slideType
        imageStatus
        order
        imageFetchedAt
        isNative
        image {
          id
          url
        }
        imageConfig {
          height
          width
          x
          y
        }
        configuredDashboard {
          id
          name
        }
        defaultCropConfig
      }
      createdAt
      updateAt
      clonesGenerated
      createdBy {
        id
        fullName
      }
      cropConfig
      clonedFor
      deletedAt
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetPresentationsGQL extends Apollo.Query<
  GetPresentationsQuery,
  GetPresentationsQueryVariables
> {
  document = GetPresentationsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetPresentationDocument = gql`
  query getPresentation($presentationId: String!) {
    presentation(id: $presentationId) {
      id
      name
      description
      tenantId
      tenant {
        id
        code
        name
      }
      diseaseStateModuleId
      presentationType
      imagesRefreshedAt
      refreshJob {
        id
        additionalInfo
      }
      latestJob {
        id
        status
      }
      slides {
        id
        title
        subtitle
        shareableLink
        slideType
        imageStatus
        order
        imageFetchedAt
        isNative
        image {
          id
          url
        }
        imageConfig {
          height
          width
          x
          y
        }
        configuredDashboard {
          id
          name
        }
        defaultCropConfig
      }
      createdAt
      updateAt
      clonesGenerated
      createdBy {
        id
        fullName
      }
      cropConfig
      clonedFor
      deletedAt
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetPresentationGQL extends Apollo.Query<
  GetPresentationQuery,
  GetPresentationQueryVariables
> {
  document = GetPresentationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreatePresentationDocument = gql`
  mutation createPresentation($input: CreatePresentationInput!) {
    createPresentation(input: $input) {
      id
      name
      description
      tenantId
      tenant {
        id
        code
        name
      }
      diseaseStateModuleId
      presentationType
      imagesRefreshedAt
      refreshJob {
        id
        additionalInfo
      }
      latestJob {
        id
        status
      }
      slides {
        id
        title
        subtitle
        shareableLink
        slideType
        imageStatus
        order
        imageFetchedAt
        isNative
        image {
          id
          url
        }
        imageConfig {
          height
          width
          x
          y
        }
        configuredDashboard {
          id
          name
        }
        defaultCropConfig
      }
      createdAt
      updateAt
      clonesGenerated
      createdBy {
        id
        fullName
      }
      cropConfig
      clonedFor
      deletedAt
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreatePresentationGQL extends Apollo.Mutation<
  CreatePresentationMutation,
  CreatePresentationMutationVariables
> {
  document = CreatePresentationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ClonePresentationForSubmissionDocument = gql`
  mutation clonePresentationForSubmission(
    $input: CreatePresentationSubmissionInput!
    $useCompleteData: Boolean
    $dashboardEntityIds: [String!]
  ) {
    clonePresentationForSubmission(
      input: $input
      useCompleteData: $useCompleteData
      dashboardEntityIds: $dashboardEntityIds
    )
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ClonePresentationForSubmissionGQL extends Apollo.Mutation<
  ClonePresentationForSubmissionMutation,
  ClonePresentationForSubmissionMutationVariables
> {
  document = ClonePresentationForSubmissionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdatePresentationDocument = gql`
  mutation updatePresentation($input: UpdatePresentationInput!) {
    updatePresentation(input: $input)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdatePresentationGQL extends Apollo.Mutation<
  UpdatePresentationMutation,
  UpdatePresentationMutationVariables
> {
  document = UpdatePresentationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeletePresentationDocument = gql`
  mutation deletePresentation($deletePresentationId: String!) {
    deletePresentation(id: $deletePresentationId)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DeletePresentationGQL extends Apollo.Mutation<
  DeletePresentationMutation,
  DeletePresentationMutationVariables
> {
  document = DeletePresentationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SoftDeletePresentationDocument = gql`
  mutation softDeletePresentation($presentationId: String!) {
    softDeletePresentation(id: $presentationId)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class SoftDeletePresentationGQL extends Apollo.Mutation<
  SoftDeletePresentationMutation,
  SoftDeletePresentationMutationVariables
> {
  document = SoftDeletePresentationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RestorePresentationDocument = gql`
  mutation restorePresentation($presentationId: String!) {
    restorePresentation(id: $presentationId)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RestorePresentationGQL extends Apollo.Mutation<
  RestorePresentationMutation,
  RestorePresentationMutationVariables
> {
  document = RestorePresentationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateSlideDocument = gql`
  mutation createSlide($input: CreateSlideInput!) {
    createSlide(input: $input) {
      id
      title
      subtitle
      shareableLink
      slideType
      imageStatus
      order
      imageFetchedAt
      isNative
      configuredDashboard {
        name
        id
      }
      imageConfig {
        width
        height
        x
        y
      }
      presentation {
        id
        name
        tenantId
      }
      image {
        id
        url
      }
      defaultCropConfig
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateSlideGQL extends Apollo.Mutation<
  CreateSlideMutation,
  CreateSlideMutationVariables
> {
  document = CreateSlideDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateSlidesDocument = gql`
  mutation updateSlides(
    $presentationId: String!
    $inputs: [UpdateSlideInput!]!
  ) {
    updateSlides(presentationId: $presentationId, inputs: $inputs)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateSlidesGQL extends Apollo.Mutation<
  UpdateSlidesMutation,
  UpdateSlidesMutationVariables
> {
  document = UpdateSlidesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const BulkGenerateSlidesDocument = gql`
  mutation bulkGenerateSlides(
    $presentationId: String!
    $slidesConfig: [BulkSlidesInput!]!
    $timezone: String
  ) {
    bulkGenerateSlides(
      presentationId: $presentationId
      slidesConfig: $slidesConfig
      timezone: $timezone
    )
  }
`;

@Injectable({
  providedIn: 'root',
})
export class BulkGenerateSlidesGQL extends Apollo.Mutation<
  BulkGenerateSlidesMutation,
  BulkGenerateSlidesMutationVariables
> {
  document = BulkGenerateSlidesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeleteSlidesDocument = gql`
  mutation deleteSlides($deleteSlideIds: [String!]!, $presentationId: String!) {
    deleteSlides(ids: $deleteSlideIds, presentationId: $presentationId)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DeleteSlidesGQL extends Apollo.Mutation<
  DeleteSlidesMutation,
  DeleteSlidesMutationVariables
> {
  document = DeleteSlidesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ClonePresentationDocument = gql`
  mutation clonePresentation(
    $presentationId: String!
    $name: String!
    $inputs: [PresentationCloneInput!]!
    $useCompleteData: Boolean
    $timezone: String
    $quarters: [String!]
    $procedure: [ProcedureInput!]
  ) {
    clonePresentation(
      presentationId: $presentationId
      name: $name
      inputs: $inputs
      useCompleteData: $useCompleteData
      timezone: $timezone
      quarters: $quarters
      procedure: $procedure
    )
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ClonePresentationGQL extends Apollo.Mutation<
  ClonePresentationMutation,
  ClonePresentationMutationVariables
> {
  document = ClonePresentationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RefreshPresentationImagesDocument = gql`
  mutation refreshPresentationImages(
    $presentationId: String!
    $slideIds: [String!]
    $useCompleteData: Boolean
    $timezone: String
    $missingSlidesOnly: Boolean
  ) {
    refreshPresentationImages(
      presentationId: $presentationId
      slideIds: $slideIds
      useCompleteData: $useCompleteData
      timezone: $timezone
      missingSlidesOnly: $missingSlidesOnly
    )
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RefreshPresentationImagesGQL extends Apollo.Mutation<
  RefreshPresentationImagesMutation,
  RefreshPresentationImagesMutationVariables
> {
  document = RefreshPresentationImagesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetDictionariesDocument = gql`
  query getDictionaries {
    dictionaries {
      id
      version
      dataset {
        id
        code
        name
      }
      type
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetDictionariesGQL extends Apollo.Query<
  GetDictionariesQuery,
  GetDictionariesQueryVariables
> {
  document = GetDictionariesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetDictionaryDocument = gql`
  query getDictionary($dictionaryId: String!) {
    dictionary(id: $dictionaryId) {
      id
      dataset {
        id
        code
        name
      }
      version
      type
      sections {
        elements {
          id
          elementReference
          shortName
          name
          code
          codingInstructions
          targetValue
          definition {
            definition
          }
          section {
            sectionDisplayName
          }
          parentChildValidations {
            id
            parent {
              id
              shortName
            }
          }
          sourceMappings {
            id
            target {
              id
              shortName
            }
          }
          referenceTransformations {
            id
            translation {
              id
              target {
                id
                shortName
              }
            }
          }
          derivativeTransformations {
            id
            translation {
              id
              target {
                id
                shortName
              }
            }
          }
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetDictionaryGQL extends Apollo.Query<
  GetDictionaryQuery,
  GetDictionaryQueryVariables
> {
  document = GetDictionaryDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetSrogDocument = gql`
  query getSrog(
    $careEntityCode: String!
    $dsmCode: String
    $searchText: String
    $filter: SrogFilter
    $limit: Float
    $offset: Float
  ) {
    srog(
      careEntityCode: $careEntityCode
      dsmCode: $dsmCode
      searchText: $searchText
      filter: $filter
      limit: $limit
      offset: $offset
    ) {
      Strength {
        measureId
        name
        hospital
        registry
        cohortId
        srogStrength
        trendToUse
        atBestPerformance
        numerator
        numeratorIfBest
        averageROI
        bestROI
        srogBucket
        systemSortOrder
        totalChildCareEntities
        dimType
        cohortName
        aggregated
        opportunities {
          at
          numerator
          performance
          roi
          summedRoi
          los
          distanceFrom
        }
      }
      Regression {
        measureId
        name
        hospital
        registry
        cohortId
        srogStrength
        trendToUse
        atBestPerformance
        numerator
        numeratorIfBest
        averageROI
        bestROI
        srogBucket
        rareEvent
        systemSortOrder
        totalChildCareEntities
        dimType
        cohortName
        aggregated
        opportunities {
          at
          numerator
          performance
          roi
          summedRoi
          los
          distanceFrom
        }
      }
      Opportunity {
        measureId
        name
        hospital
        registry
        cohortId
        srogStrength
        trendToUse
        atBestPerformance
        numerator
        numeratorIfBest
        averageROI
        bestROI
        srogBucket
        rareEvent
        systemSortOrder
        totalChildCareEntities
        dimType
        cohortName
        aggregated
        opportunities {
          at
          numerator
          performance
          roi
          summedRoi
          los
          distanceFrom
        }
      }
      Gain {
        measureId
        name
        hospital
        registry
        cohortId
        srogStrength
        trendToUse
        atBestPerformance
        numerator
        numeratorIfBest
        averageROI
        bestROI
        srogBucket
        rareEvent
        systemSortOrder
        totalChildCareEntities
        dimType
        cohortName
        aggregated
        opportunities {
          at
          numerator
          performance
          roi
          summedRoi
          los
          distanceFrom
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetSrogGQL extends Apollo.Query<
  GetSrogQuery,
  GetSrogQueryVariables
> {
  document = GetSrogDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetMeasuresDocument = gql`
  query getMeasures {
    measuresMetadata {
      id
      name
      description
      ncdrMeasureName
      registryMeasureId
      validationSource
      benchmarkExtraction
      reportRowId
      numeratorUnit
      opportunityType
      publicationSource
      accessCategory
      rareEvent
      summaryInitiativeMeasure
      commonMeasureDisplayName
      diseaseStateModule {
        id
        name
      }
      createdBy {
        id
        fullName
      }
      createdAt
      updateAt
      updateBy {
        id
        fullName
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetMeasuresGQL extends Apollo.Query<
  GetMeasuresQuery,
  GetMeasuresQueryVariables
> {
  document = GetMeasuresDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetPipelineElementsDocument = gql`
  query getPipelineElements($ids: [String!]) {
    pipelineElements(ids: $ids) {
      id
      documentation
      biomeDictionaryElements {
        id
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetPipelineElementsGQL extends Apollo.Query<
  GetPipelineElementsQuery,
  GetPipelineElementsQueryVariables
> {
  document = GetPipelineElementsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetElementsDocument = gql`
  query getElements($ids: [String!]) {
    elements(ids: $ids) {
      id
      shortName
      targetMappings {
        id
        source {
          id
          shortName
          name
          elementReference
          section {
            id
            dictionary {
              id
            }
          }
        }
        transformation {
          id
          reference {
            id
            shortName
            name
            elementReference
            section {
              id
              dictionary {
                id
              }
            }
          }
          referenceCode
          derivative {
            id
            shortName
            name
            elementReference
            section {
              id
              dictionary {
                id
              }
            }
          }
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetElementsGQL extends Apollo.Query<
  GetElementsQuery,
  GetElementsQueryVariables
> {
  document = GetElementsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SearchDictionaryElementsDocument = gql`
  query searchDictionaryElements($dictionaryId: String!, $keyword: String!) {
    searchElements(dictionaryId: $dictionaryId, keyword: $keyword)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class SearchDictionaryElementsGQL extends Apollo.Query<
  SearchDictionaryElementsQuery,
  SearchDictionaryElementsQueryVariables
> {
  document = SearchDictionaryElementsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetCitationMeasureDocument = gql`
  query getCitationMeasure($measureId: Int!) {
    measureMetadata(id: $measureId) {
      id
      name
      summaryCohortId
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetCitationMeasureGQL extends Apollo.Query<
  GetCitationMeasureQuery,
  GetCitationMeasureQueryVariables
> {
  document = GetCitationMeasureDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetCitationDimensionDocument = gql`
  query getCitationDimension($dimensionId: Int!) {
    dimension(id: $dimensionId) {
      id
      kbFieldId
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetCitationDimensionGQL extends Apollo.Query<
  GetCitationDimensionQuery,
  GetCitationDimensionQueryVariables
> {
  document = GetCitationDimensionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetMeasureMetadataDocument = gql`
  query getMeasureMetadata($measureId: Int!) {
    measureMetadata(id: $measureId) {
      id
      version
      history {
        version
        updateAt
      }
      name
      ncdrMeasureName
      registryMeasureId
      validationSource
      benchmarkExtraction
      reportRowId
      description
      numeratorUnit
      accessCategory
      opportunityType
      publicationSource
      commonMeasureDisplayName
      summaryInitiativeMeasure
      rareEvent
      tableName
      requirements
      testCapture
      volumeMeasure
      annualMeasureBaseId
      isBenchmark
      summaryCohortId
      excludedCohortIds
      unit
      numeratorColumnName
      numeratorPipelineElement {
        id
      }
      numeratorLegacyDescription
      denominatorLegacyDescription
      includeColumnName
      includePipelineElement {
        id
      }
      denominatorColumnName
      denominatorPipelineElement {
        id
      }
      riskAdjusted
      riskMetric {
        id
        columnName
        displayName
      }
      riskMetricPipelineElement {
        id
      }
      aggregationFn
      aggregationType
      outcomeType
      roiCalcType
      higherIsBetter
      dataTypeRequired
      losROIQualifying
      adjustment
      commonMeasureQualifying
      costComponentMeasure
      subjects {
        id
        link
        processMeasure
        objectMeasure {
          id
          name
        }
      }
      objects {
        id
        link
        processMeasure
        subjectMeasure {
          id
          name
        }
      }
      roiMetrics {
        id
        fieldName
        label
      }
      diseaseStateModule {
        id
        name
      }
      parent {
        id
        name
      }
      children {
        id
        name
        opportunityType
        commonMeasureDisplayName
        publicationSource
        diseaseStateModule {
          id
          name
        }
      }
      createdBy {
        id
        fullName
      }
      createdAt
      updateAt
      updateBy {
        id
        fullName
      }
      tableauViews {
        isPrimary
        tableauView {
          id
          name
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetMeasureMetadataGQL extends Apollo.Query<
  GetMeasureMetadataQuery,
  GetMeasureMetadataQueryVariables
> {
  document = GetMeasureMetadataDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateMeasureMetaDataDocument = gql`
  mutation updateMeasureMetaData(
    $updateMeasureMetadataInput: UpdateMeasureMetadataInput!
  ) {
    updateMeasureMetadata(
      updateMeasureMetadataInput: $updateMeasureMetadataInput
    ) {
      id
      version
      name
      ncdrMeasureName
      registryMeasureId
      validationSource
      benchmarkExtraction
      reportRowId
      description
      numeratorUnit
      accessCategory
      opportunityType
      publicationSource
      commonMeasureDisplayName
      summaryInitiativeMeasure
      rareEvent
      tableName
      requirements
      testCapture
      volumeMeasure
      annualMeasureBaseId
      isBenchmark
      summaryCohortId
      excludedCohortIds
      unit
      numeratorColumnName
      numeratorPipelineElement {
        id
      }
      includeColumnName
      includePipelineElement {
        id
      }
      denominatorColumnName
      denominatorPipelineElement {
        id
      }
      riskAdjusted
      riskMetric {
        id
        columnName
        displayName
      }
      riskMetricPipelineElement {
        id
      }
      aggregationFn
      aggregationType
      outcomeType
      roiCalcType
      higherIsBetter
      dataTypeRequired
      losROIQualifying
      adjustment
      commonMeasureQualifying
      costComponentMeasure
      subjects {
        id
      }
      objects {
        id
      }
      roiMetrics {
        id
        fieldName
      }
      diseaseStateModule {
        id
        name
      }
      createdBy {
        id
        fullName
      }
      createdAt
      updateAt
      updateBy {
        id
        fullName
      }
      tableauViews {
        isPrimary
        tableauView {
          id
          name
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateMeasureMetaDataGQL extends Apollo.Mutation<
  UpdateMeasureMetaDataMutation,
  UpdateMeasureMetaDataMutationVariables
> {
  document = UpdateMeasureMetaDataDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateMeasureMetadataDocument = gql`
  mutation createMeasureMetadata(
    $createMeasureMetadataInput: CreateMeasureMetadataInput!
  ) {
    createMeasureMetadata(
      createMeasureMetadataInput: $createMeasureMetadataInput
    ) {
      id
      version
      name
      ncdrMeasureName
      registryMeasureId
      validationSource
      benchmarkExtraction
      reportRowId
      description
      numeratorUnit
      accessCategory
      opportunityType
      publicationSource
      commonMeasureDisplayName
      summaryInitiativeMeasure
      rareEvent
      tableName
      requirements
      testCapture
      volumeMeasure
      annualMeasureBaseId
      isBenchmark
      summaryCohortId
      excludedCohortIds
      unit
      numeratorColumnName
      numeratorPipelineElement {
        id
      }
      includeColumnName
      includePipelineElement {
        id
      }
      denominatorColumnName
      denominatorPipelineElement {
        id
      }
      riskAdjusted
      riskMetric {
        id
        columnName
        displayName
      }
      riskMetricPipelineElement {
        id
      }
      aggregationFn
      aggregationType
      outcomeType
      roiCalcType
      higherIsBetter
      dataTypeRequired
      losROIQualifying
      adjustment
      commonMeasureQualifying
      costComponentMeasure
      subjects {
        id
        link
        processMeasure
        objectMeasure {
          id
          name
        }
      }
      objects {
        id
        link
        processMeasure
        subjectMeasure {
          id
          name
        }
      }
      roiMetrics {
        id
        fieldName
      }
      diseaseStateModule {
        id
        name
      }
      createdBy {
        id
        fullName
      }
      createdAt
      updateAt
      updateBy {
        id
        fullName
      }
      tableauViews {
        isPrimary
        tableauView {
          id
          name
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateMeasureMetadataGQL extends Apollo.Mutation<
  CreateMeasureMetadataMutation,
  CreateMeasureMetadataMutationVariables
> {
  document = CreateMeasureMetadataDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetDimensionSetsByMeasureIdDocument = gql`
  query getDimensionSetsByMeasureId($measureId: Float!) {
    dimensionSetsByMeasureId(measureId: $measureId) {
      id
      dimensions {
        id
        fieldName
        label
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetDimensionSetsByMeasureIdGQL extends Apollo.Query<
  GetDimensionSetsByMeasureIdQuery,
  GetDimensionSetsByMeasureIdQueryVariables
> {
  document = GetDimensionSetsByMeasureIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetDimensionListDocument = gql`
  query getDimensionList {
    dimensions {
      id
      fieldName
      label
      valueMap
      excludeValues
      allMeasures
      isGlobal
      sourceContinuousField
      type
      priority
      class
      oeQualifying
      aeQualifying
      sortOrder
      sortType
      diseaseStateModule {
        id
        code
        name
      }
      pipelineElement {
        id
      }
      createdAt
      updateAt
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetDimensionListGQL extends Apollo.Query<
  GetDimensionListQuery,
  GetDimensionListQueryVariables
> {
  document = GetDimensionListDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetDimensionDocument = gql`
  query getDimension($dimensionId: Int!) {
    dimension(id: $dimensionId) {
      id
      version
      fieldName
      label
      valueMap
      excludeValues
      allMeasures
      isGlobal
      sourceContinuousField
      type
      priority
      class
      multiProcTableId
      multiProcTable {
        id
        tableName
      }
      oeQualifying
      aeQualifying
      sortOrder
      sortType
      description
      requirements
      dimensionValueSortOrder {
        id
        valueLabel
        sortOrder
      }
      diseaseStateModule {
        id
        code
        name
      }
      pipelineElement {
        id
      }
      createdBy {
        id
        fullName
      }
      createdAt
      updateAt
      updateBy {
        id
        fullName
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetDimensionGQL extends Apollo.Query<
  GetDimensionQuery,
  GetDimensionQueryVariables
> {
  document = GetDimensionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetRoiMetricListDocument = gql`
  query getRoiMetricList {
    roiMetrics {
      id
      version
      fieldName
      label
      higherIsBetter
      diseaseStateModule {
        id
        code
        name
      }
      pipelineElement {
        id
      }
      createdBy {
        id
        fullName
      }
      createdAt
      updateAt
      updateBy {
        id
        fullName
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetRoiMetricListGQL extends Apollo.Query<
  GetRoiMetricListQuery,
  GetRoiMetricListQueryVariables
> {
  document = GetRoiMetricListDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetRoiMetricDocument = gql`
  query getRoiMetric($roiMetricId: String!) {
    roiMetric(id: $roiMetricId) {
      id
      version
      fieldName
      label
      higherIsBetter
      diseaseStateModule {
        id
        code
        name
      }
      pipelineElement {
        id
      }
      createdBy {
        id
        fullName
      }
      createdAt
      updateAt
      updateBy {
        id
        fullName
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetRoiMetricGQL extends Apollo.Query<
  GetRoiMetricQuery,
  GetRoiMetricQueryVariables
> {
  document = GetRoiMetricDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetGridViewsDocument = gql`
  query getGridViews($gridId: String!) {
    getGridViews(gridId: $gridId) {
      id
      name
      filterModel
      columnModel
      externalFilters
      scope
      tenantId
      userId
      gridId
      moduleId
      careEntityId
      default
      updatedAt
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetGridViewsGQL extends Apollo.Query<
  GetGridViewsQuery,
  GetGridViewsQueryVariables
> {
  document = GetGridViewsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetGridViewDocument = gql`
  query getGridView($id: String!) {
    getGridView(id: $id) {
      id
      name
      filterModel
      columnModel
      externalFilters
      scope
      tenantId
      userId
      gridId
      moduleId
      careEntityId
      default
      updatedAt
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetGridViewGQL extends Apollo.Query<
  GetGridViewQuery,
  GetGridViewQueryVariables
> {
  document = GetGridViewDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateGridViewDocument = gql`
  mutation createGridView($createGridViewInput: CreateGridViewInput!) {
    createGridView(createGridViewInput: $createGridViewInput) {
      id
      name
      filterModel
      columnModel
      externalFilters
      scope
      tenantId
      userId
      gridId
      moduleId
      careEntityId
      default
      updatedAt
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateGridViewGQL extends Apollo.Mutation<
  CreateGridViewMutation,
  CreateGridViewMutationVariables
> {
  document = CreateGridViewDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateGridViewDocument = gql`
  mutation updateGridView($updateGridViewInput: UpdateGridViewInput!) {
    updateGridView(updateGridViewInput: $updateGridViewInput) {
      id
      name
      filterModel
      columnModel
      externalFilters
      scope
      tenantId
      userId
      gridId
      moduleId
      careEntityId
      default
      updatedAt
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateGridViewGQL extends Apollo.Mutation<
  UpdateGridViewMutation,
  UpdateGridViewMutationVariables
> {
  document = UpdateGridViewDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CloneGridViewDocument = gql`
  mutation cloneGridView($id: String!) {
    cloneGridView(id: $id) {
      id
      name
      filterModel
      columnModel
      externalFilters
      scope
      tenantId
      userId
      gridId
      moduleId
      careEntityId
      default
      updatedAt
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CloneGridViewGQL extends Apollo.Mutation<
  CloneGridViewMutation,
  CloneGridViewMutationVariables
> {
  document = CloneGridViewDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RemoveGridViewDocument = gql`
  mutation removeGridView($id: String!) {
    removeGridView(id: $id)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RemoveGridViewGQL extends Apollo.Mutation<
  RemoveGridViewMutation,
  RemoveGridViewMutationVariables
> {
  document = RemoveGridViewDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetQuestionDetailsDocument = gql`
  query getQuestionDetails($question: String!) {
    questionDetails(question: $question)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetQuestionDetailsGQL extends Apollo.Query<
  GetQuestionDetailsQuery,
  GetQuestionDetailsQueryVariables
> {
  document = GetQuestionDetailsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetCategorizedMeasuresDocument = gql`
  query getCategorizedMeasures($question: String!, $details: [String!]!) {
    categorizedMeasures(question: $question, details: $details) {
      measureId
      name
      description
      dsm
      reasoning
      alignmentStrength
      alignmentStrengthCode
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetCategorizedMeasuresGQL extends Apollo.Query<
  GetCategorizedMeasuresQuery,
  GetCategorizedMeasuresQueryVariables
> {
  document = GetCategorizedMeasuresDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateDimensionDocument = gql`
  mutation createDimension($createDimensionInput: CreateDimensionInput!) {
    createDimension(createDimensionInput: $createDimensionInput) {
      id
      version
      fieldName
      label
      valueMap
      excludeValues
      allMeasures
      isGlobal
      sourceContinuousField
      type
      priority
      class
      multiProcTableId
      multiProcTable {
        id
        tableName
      }
      oeQualifying
      aeQualifying
      sortOrder
      sortType
      description
      requirements
      dimensionValueSortOrder {
        id
        valueLabel
        sortOrder
      }
      diseaseStateModule {
        id
        code
        name
      }
      pipelineElement {
        id
      }
      createdBy {
        id
        fullName
      }
      createdAt
      updateAt
      updateBy {
        id
        fullName
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateDimensionGQL extends Apollo.Mutation<
  CreateDimensionMutation,
  CreateDimensionMutationVariables
> {
  document = CreateDimensionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateDimensionDocument = gql`
  mutation updateDimension($updateDimensionInput: UpdateDimensionInput!) {
    updateDimension(updateDimensionInput: $updateDimensionInput) {
      id
      fieldName
      label
      valueMap
      excludeValues
      allMeasures
      isGlobal
      sourceContinuousField
      type
      priority
      class
      multiProcTableId
      multiProcTable {
        id
        tableName
      }
      oeQualifying
      aeQualifying
      sortOrder
      sortType
      description
      requirements
      dimensionValueSortOrder {
        id
        valueLabel
        sortOrder
      }
      diseaseStateModule {
        id
        code
        name
      }
      pipelineElement {
        id
      }
      createdAt
      updateAt
      updateBy {
        id
        fullName
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateDimensionGQL extends Apollo.Mutation<
  UpdateDimensionMutation,
  UpdateDimensionMutationVariables
> {
  document = UpdateDimensionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RemoveDimensionDocument = gql`
  mutation removeDimension($dimensionId: Int!) {
    removeDimension(id: $dimensionId)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RemoveDimensionGQL extends Apollo.Mutation<
  RemoveDimensionMutation,
  RemoveDimensionMutationVariables
> {
  document = RemoveDimensionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateRoiMetricDocument = gql`
  mutation createRoiMetric($createRoiMetricInput: CreateRoiMetricInput!) {
    createRoiMetric(createRoiMetricInput: $createRoiMetricInput) {
      id
      version
      fieldName
      label
      higherIsBetter
      diseaseStateModule {
        id
        code
        name
      }
      pipelineElement {
        id
      }
      createdBy {
        id
        fullName
      }
      createdAt
      updateAt
      updateBy {
        id
        fullName
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateRoiMetricGQL extends Apollo.Mutation<
  CreateRoiMetricMutation,
  CreateRoiMetricMutationVariables
> {
  document = CreateRoiMetricDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateRoiMetricDocument = gql`
  mutation updateRoiMetric($updateRoiMetricInput: UpdateRoiMetricInput!) {
    updateRoiMetric(updateRoiMetricInput: $updateRoiMetricInput) {
      id
      version
      fieldName
      label
      higherIsBetter
      diseaseStateModule {
        id
        code
        name
      }
      pipelineElement {
        id
      }
      createdBy {
        id
        fullName
      }
      createdAt
      updateAt
      updateBy {
        id
        fullName
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateRoiMetricGQL extends Apollo.Mutation<
  UpdateRoiMetricMutation,
  UpdateRoiMetricMutationVariables
> {
  document = UpdateRoiMetricDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RemoveRoiMetricDocument = gql`
  mutation removeRoiMetric($roiMetricId: String!) {
    removeRoiMetric(id: $roiMetricId)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RemoveRoiMetricGQL extends Apollo.Mutation<
  RemoveRoiMetricMutation,
  RemoveRoiMetricMutationVariables
> {
  document = RemoveRoiMetricDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetAttributesCriteriaDocument = gql`
  query getAttributesCriteria {
    attributesCriteria {
      dsm
      attribute
      description
      source
      criteria
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetAttributesCriteriaGQL extends Apollo.Query<
  GetAttributesCriteriaQuery,
  GetAttributesCriteriaQueryVariables
> {
  document = GetAttributesCriteriaDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetPatientListFieldsDocument = gql`
  query getPatientListFields($patientListType: String!) {
    patientListFields(patientListType: $patientListType) {
      id
      createdAt
      updateAt
      createdById
      updateById
      name
      displayName
      displayRank
      description
      type
      phi
      visibility
      patientListType
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetPatientListFieldsGQL extends Apollo.Query<
  GetPatientListFieldsQuery,
  GetPatientListFieldsQueryVariables
> {
  document = GetPatientListFieldsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetEchoFollowupOptionsDocument = gql`
  query getEchoFollowupOptions {
    echoFollowupOptions {
      id
      createdAt
      updateAt
      createdBy {
        id
        fullName
      }
      updateById
      name
      displayName
      displayRank
      category
      isDefault
      tenant {
        id
        name
      }
      scope
      hide
      caselistModule {
        id
        name
        displayName
      }
      careEntities {
        id
        name
        code
        description
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetEchoFollowupOptionsGQL extends Apollo.Query<
  GetEchoFollowupOptionsQuery,
  GetEchoFollowupOptionsQueryVariables
> {
  document = GetEchoFollowupOptionsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetEchoFollowupOptionDocument = gql`
  query getEchoFollowupOption($id: String!) {
    echoFollowupOption(id: $id) {
      id
      createdAt
      updateAt
      createdBy {
        id
        fullName
      }
      updateById
      name
      displayName
      category
      displayRank
      isDefault
      tenant {
        id
        name
      }
      scope
      hide
      caselistModule {
        id
        name
        displayName
      }
      careEntities {
        id
        name
        code
        description
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetEchoFollowupOptionGQL extends Apollo.Query<
  GetEchoFollowupOptionQuery,
  GetEchoFollowupOptionQueryVariables
> {
  document = GetEchoFollowupOptionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateEchoFollowupOptionDocument = gql`
  mutation createEchoFollowupOption($input: EchoFollowupOptionInput!) {
    createEchoFollowupOption(input: $input) {
      id
      createdAt
      updateAt
      createdBy {
        id
        fullName
      }
      updateById
      name
      displayName
      category
      displayRank
      isDefault
      tenant {
        id
        name
      }
      scope
      hide
      caselistModule {
        id
        name
        displayName
      }
      careEntities {
        id
        name
        code
        description
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateEchoFollowupOptionGQL extends Apollo.Mutation<
  CreateEchoFollowupOptionMutation,
  CreateEchoFollowupOptionMutationVariables
> {
  document = CreateEchoFollowupOptionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateEchoFollowupOptionsDocument = gql`
  mutation updateEchoFollowupOptions(
    $inputs: [UpdateEchoFollowupOptionInput!]!
  ) {
    updateEchoFollowupOptions(inputs: $inputs) {
      id
      createdAt
      updateAt
      createdBy {
        id
        fullName
      }
      updateById
      name
      displayName
      displayRank
      category
      isDefault
      tenant {
        id
        name
      }
      scope
      hide
      caselistModule {
        id
        name
        displayName
      }
      careEntities {
        id
        name
        code
        description
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateEchoFollowupOptionsGQL extends Apollo.Mutation<
  UpdateEchoFollowupOptionsMutation,
  UpdateEchoFollowupOptionsMutationVariables
> {
  document = UpdateEchoFollowupOptionsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetEchoMessageTemplatesDocument = gql`
  query getEchoMessageTemplates {
    echoMessageTemplates {
      id
      createdAt
      updateAt
      createdBy {
        id
        fullName
      }
      updateById
      name
      tenant {
        id
        name
      }
      common
      hide
      template
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetEchoMessageTemplatesGQL extends Apollo.Query<
  GetEchoMessageTemplatesQuery,
  GetEchoMessageTemplatesQueryVariables
> {
  document = GetEchoMessageTemplatesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetEchoMessageTemplateDocument = gql`
  query getEchoMessageTemplate($id: String!) {
    echoMessageTemplate(id: $id) {
      id
      createdAt
      updateAt
      createdBy {
        id
        fullName
      }
      updateById
      name
      tenant {
        id
        name
      }
      common
      hide
      template
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetEchoMessageTemplateGQL extends Apollo.Query<
  GetEchoMessageTemplateQuery,
  GetEchoMessageTemplateQueryVariables
> {
  document = GetEchoMessageTemplateDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateEchoMessageTemplateDocument = gql`
  mutation createEchoMessageTemplate($input: EchoMessageTemplateInput!) {
    createEchoMessageTemplate(input: $input) {
      id
      createdAt
      updateAt
      createdBy {
        id
        fullName
      }
      updateById
      name
      tenant {
        id
        name
      }
      common
      hide
      template
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateEchoMessageTemplateGQL extends Apollo.Mutation<
  CreateEchoMessageTemplateMutation,
  CreateEchoMessageTemplateMutationVariables
> {
  document = CreateEchoMessageTemplateDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateEchoMessageTemplateDocument = gql`
  mutation updateEchoMessageTemplate($input: UpdateEchoMessageTemplateInput!) {
    updateEchoMessageTemplate(input: $input) {
      id
      createdAt
      updateAt
      createdBy {
        id
        fullName
      }
      updateById
      name
      tenant {
        id
        name
      }
      common
      hide
      template
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateEchoMessageTemplateGQL extends Apollo.Mutation<
  UpdateEchoMessageTemplateMutation,
  UpdateEchoMessageTemplateMutationVariables
> {
  document = UpdateEchoMessageTemplateDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetEchoReferringProvidersDocument = gql`
  query getEchoReferringProviders {
    echoReferringProviders {
      id
      name
      tenant {
        id
        name
      }
      priority
      contact
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetEchoReferringProvidersGQL extends Apollo.Query<
  GetEchoReferringProvidersQuery,
  GetEchoReferringProvidersQueryVariables
> {
  document = GetEchoReferringProvidersDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetEchoReferringProviderDocument = gql`
  query getEchoReferringProvider($id: String!) {
    echoReferringProvider(id: $id) {
      id
      name
      tenant {
        id
        name
      }
      priority
      contact
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetEchoReferringProviderGQL extends Apollo.Query<
  GetEchoReferringProviderQuery,
  GetEchoReferringProviderQueryVariables
> {
  document = GetEchoReferringProviderDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateEchoReferringProviderDocument = gql`
  mutation updateEchoReferringProvider(
    $input: UpdateEchoReferringProviderInput!
  ) {
    updateEchoReferringProvider(input: $input) {
      id
      name
      tenant {
        id
        name
      }
      priority
      contact
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateEchoReferringProviderGQL extends Apollo.Mutation<
  UpdateEchoReferringProviderMutation,
  UpdateEchoReferringProviderMutationVariables
> {
  document = UpdateEchoReferringProviderDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetRegistryElementsDocument = gql`
  query getRegistryElements($datasetIds: [Int!], $type: DictionaryType) {
    dictionaries(datasetIds: $datasetIds, type: $type) {
      id
      type
      sections {
        id
        hideFromReports
        sortOrder
        sectionDisplayName
        parentId
        elements {
          id
          hideFromReports
          code
          shortName
          elementReference
          sourceMappings {
            id
            target {
              id
              shortName
            }
          }
          referenceTransformations {
            id
            translation {
              id
              target {
                id
                shortName
              }
            }
          }
          derivativeTransformations {
            id
            translation {
              id
              target {
                id
                shortName
              }
            }
          }
          name
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetRegistryElementsGQL extends Apollo.Query<
  GetRegistryElementsQuery,
  GetRegistryElementsQueryVariables
> {
  document = GetRegistryElementsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetMeasuresMetadataDocument = gql`
  query getMeasuresMetadata($diseaseStateModuleId: Int) {
    measuresMetadata(diseaseStateModuleId: $diseaseStateModuleId) {
      id
      hideFromReports
      name
      opportunityType
      commonMeasureDisplayName
      publicationSource
      outcomeType
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetMeasuresMetadataGQL extends Apollo.Query<
  GetMeasuresMetadataQuery,
  GetMeasuresMetadataQueryVariables
> {
  document = GetMeasuresMetadataDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetMeasuresByDsmCachedDocument = gql`
  query getMeasuresByDsmCached($diseaseStateModuleId: Int!) {
    measuresByDsmCached(diseaseStateModuleId: $diseaseStateModuleId) {
      id
      name
      commonMeasureDisplayName
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetMeasuresByDsmCachedGQL extends Apollo.Query<
  GetMeasuresByDsmCachedQuery,
  GetMeasuresByDsmCachedQueryVariables
> {
  document = GetMeasuresByDsmCachedDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetDimensionsDocument = gql`
  query getDimensions($diseaseStateModuleId: Int) {
    dimensions(diseaseStateModuleId: $diseaseStateModuleId) {
      id
      hideFromReports
      fieldName
      label
      class
      type
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetDimensionsGQL extends Apollo.Query<
  GetDimensionsQuery,
  GetDimensionsQueryVariables
> {
  document = GetDimensionsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetReportAnchorDatesDocument = gql`
  query getReportAnchorDates {
    reportAnchorDates {
      id
      name
      displayName
      displayRank
      isDefault
      diseaseStateModuleId
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetReportAnchorDatesGQL extends Apollo.Query<
  GetReportAnchorDatesQuery,
  GetReportAnchorDatesQueryVariables
> {
  document = GetReportAnchorDatesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RunReportDocument = gql`
  mutation runReport($reportId: String!) {
    runReport(reportId: $reportId)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RunReportGQL extends Apollo.Mutation<
  RunReportMutation,
  RunReportMutationVariables
> {
  document = RunReportDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateReportDocument = gql`
  mutation createReport($reportInput: ReportInput!, $startExport: Boolean!) {
    createReport(reportInput: $reportInput, startExport: $startExport) {
      id
      name
      diseaseStateModule {
        id
        name
        code
      }
      dateColumn
      dateRangeType
      quarters
      startDate
      endDate
      procedures
      createdBy {
        id
        fullName
      }
      createdAt
      registryElements {
        id
        name
        code
        section {
          id
          sectionDisplayName
          sortOrder
        }
      }
      dimensions {
        id
        label
      }
      measures {
        id
        name
      }
      tenant {
        id
        name
        code
      }
      files {
        id
        createdAt
        name
      }
      users {
        id
        firstName
        lastName
        email
      }
      distributionLists {
        id
        name
        users {
          id
          firstName
          lastName
          email
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateReportGQL extends Apollo.Mutation<
  CreateReportMutation,
  CreateReportMutationVariables
> {
  document = CreateReportDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateReportDocument = gql`
  mutation updateReport($input: UpdateReportInput!, $startExport: Boolean!) {
    updateReport(reportInput: $input, startExport: $startExport) {
      id
      name
      diseaseStateModule {
        id
        name
        code
      }
      createdBy {
        id
        fullName
      }
      createdAt
      files {
        id
        createdAt
      }
      dateColumn
      dateRangeType
      quarters
      startDate
      endDate
      procedures
      registryElements {
        id
        name
        code
        section {
          id
          sectionDisplayName
          sortOrder
        }
      }
      dimensions {
        id
        label
      }
      measures {
        id
        name
      }
      tenant {
        id
        name
        code
      }
      files {
        id
        name
      }
      users {
        id
        firstName
        lastName
        email
      }
      distributionLists {
        id
        name
        users {
          id
          firstName
          lastName
          email
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateReportGQL extends Apollo.Mutation<
  UpdateReportMutation,
  UpdateReportMutationVariables
> {
  document = UpdateReportDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetReportDocument = gql`
  query getReport($reportId: String!) {
    report(id: $reportId) {
      id
      name
      diseaseStateModule {
        id
        name
        code
      }
      createdBy {
        id
        fullName
      }
      createdAt
      files {
        id
        createdAt
      }
      dateColumn
      dateRangeType
      quarters
      startDate
      endDate
      procedures
      registryElements {
        id
        name
        code
        section {
          id
          sectionDisplayName
          sortOrder
        }
      }
      dimensions {
        id
        label
      }
      measures {
        id
        name
      }
      tenant {
        id
        name
        code
      }
      files {
        id
        name
        createdAt
        phi
      }
      users {
        id
        firstName
        lastName
        email
      }
      distributionLists {
        id
        name
        users {
          id
          firstName
          lastName
          email
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetReportGQL extends Apollo.Query<
  GetReportQuery,
  GetReportQueryVariables
> {
  document = GetReportDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetReportsDocument = gql`
  query getReports {
    reports {
      id
      name
      diseaseStateModule {
        id
        name
        code
      }
      createdBy {
        id
        fullName
      }
      createdAt
      files {
        id
        createdAt
      }
      dateColumn
      dateRangeType
      quarters
      startDate
      endDate
      procedures
      tenant {
        id
        name
        code
      }
      files {
        id
        name
        createdAt
      }
      users {
        id
        firstName
        lastName
        email
      }
      distributionLists {
        id
        name
        users {
          id
          firstName
          lastName
          email
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetReportsGQL extends Apollo.Query<
  GetReportsQuery,
  GetReportsQueryVariables
> {
  document = GetReportsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeleteReportDocument = gql`
  mutation deleteReport($reportId: String!) {
    deleteReport(reportId: $reportId)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DeleteReportGQL extends Apollo.Mutation<
  DeleteReportMutation,
  DeleteReportMutationVariables
> {
  document = DeleteReportDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetCompassDataDocument = gql`
  query getCompassData(
    $careEntityCodes: [String!]!
    $dsmCodes: [String!]
    $measureIds: [Int!]
    $cohortIds: [Float!]
    $publicationSources: [PublicationSource!]
    $opportunityTypes: [OpportunityType!]
    $dimensionFilter: DimensionFilter
    $dimensionType: DimensionType
    $dimensionClass: String
    $summaryInitiativeMeasure: Boolean
    $srogBuckets: [SrogBucket!]
    $limit: Float
    $sortBy: CompassSortBy
    $topN: Int
    $collapseCohorts: Boolean
    $preferredCohortIds: [Float!]
  ) {
    compassData(
      careEntityCodes: $careEntityCodes
      dsmCodes: $dsmCodes
      measureIds: $measureIds
      cohortIds: $cohortIds
      publicationSources: $publicationSources
      opportunityTypes: $opportunityTypes
      dimensionFilter: $dimensionFilter
      dimensionType: $dimensionType
      dimensionClass: $dimensionClass
      summaryInitiativeMeasure: $summaryInitiativeMeasure
      srogBuckets: $srogBuckets
      limit: $limit
      sortBy: $sortBy
      topN: $topN
      collapseCohorts: $collapseCohorts
      preferredCohortIds: $preferredCohortIds
    ) {
      Strength {
        measureId
        name
        hospital
        registry
        cohortId
        srogStrength
        trendToUse
        atBestPerformance
        numerator
        numeratorIfBest
        averageROI
        bestROI
        srogBucket
        systemSortOrder
        totalChildCareEntities
        dimType
        cohortName
        numeratorImpactIfAverage
        numeratorImpactIfBest
        formattedPerformance
        aggregated
        opportunities {
          at
          numerator
          performance
          roi
          summedRoi
          los
          distanceFrom
        }
        measure {
          name
          opportunityType
          numeratorUnit
          publicationSource
        }
      }
      Regression {
        measureId
        name
        hospital
        registry
        cohortId
        srogStrength
        trendToUse
        atBestPerformance
        numerator
        numeratorIfBest
        averageROI
        bestROI
        srogBucket
        rareEvent
        systemSortOrder
        totalChildCareEntities
        dimType
        cohortName
        numeratorImpactIfAverage
        numeratorImpactIfBest
        formattedPerformance
        aggregated
        opportunities {
          at
          numerator
          performance
          roi
          summedRoi
          los
          distanceFrom
        }
        measure {
          name
          opportunityType
          numeratorUnit
          publicationSource
        }
      }
      Opportunity {
        measureId
        name
        hospital
        registry
        cohortId
        srogStrength
        trendToUse
        atBestPerformance
        numerator
        numeratorIfBest
        averageROI
        bestROI
        srogBucket
        rareEvent
        systemSortOrder
        totalChildCareEntities
        dimType
        cohortName
        numeratorImpactIfAverage
        numeratorImpactIfBest
        formattedPerformance
        aggregated
        opportunities {
          at
          numerator
          performance
          roi
          summedRoi
          los
          distanceFrom
        }
        measure {
          name
          opportunityType
          numeratorUnit
          publicationSource
        }
      }
      Gain {
        measureId
        name
        hospital
        registry
        cohortId
        srogStrength
        trendToUse
        atBestPerformance
        numerator
        numeratorIfBest
        averageROI
        bestROI
        srogBucket
        rareEvent
        systemSortOrder
        totalChildCareEntities
        dimType
        cohortName
        numeratorImpactIfAverage
        numeratorImpactIfBest
        formattedPerformance
        aggregated
        opportunities {
          at
          numerator
          performance
          roi
          summedRoi
          los
          distanceFrom
        }
        measure {
          name
          opportunityType
          numeratorUnit
          publicationSource
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetCompassDataGQL extends Apollo.Query<
  GetCompassDataQuery,
  GetCompassDataQueryVariables
> {
  document = GetCompassDataDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetSubmissionInquiriesDocument = gql`
  query getSubmissionInquiries {
    submissionInquiries {
      id
      title
      subject
      message
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetSubmissionInquiriesGQL extends Apollo.Query<
  GetSubmissionInquiriesQuery,
  GetSubmissionInquiriesQueryVariables
> {
  document = GetSubmissionInquiriesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetSubmissionInquiryDocument = gql`
  query getSubmissionInquiry($id: Int!) {
    submissionInquiry(id: $id) {
      id
      title
      subject
      message
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetSubmissionInquiryGQL extends Apollo.Query<
  GetSubmissionInquiryQuery,
  GetSubmissionInquiryQueryVariables
> {
  document = GetSubmissionInquiryDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SendInquiryDocument = gql`
  mutation sendInquiry($input: SendInquiryInput!) {
    sendInquiry(input: $input) {
      success
      supportEmailId
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class SendInquiryGQL extends Apollo.Mutation<
  SendInquiryMutation,
  SendInquiryMutationVariables
> {
  document = SendInquiryDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetCommentsByThreadDocument = gql`
  query getCommentsByThread($threadId: String!) {
    commentsByThread(threadId: $threadId) {
      id
      content
      internal
      isEdited
      createdAt
      updateAt
      threadId
      parentId
      repliesCount
      reactionsCount
      createdBy {
        id
        firstName
        lastName
      }
      updateBy {
        id
        firstName
        lastName
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetCommentsByThreadGQL extends Apollo.Query<
  GetCommentsByThreadQuery,
  GetCommentsByThreadQueryVariables
> {
  document = GetCommentsByThreadDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateCommentDocument = gql`
  mutation createComment($input: CreateCommentInput!) {
    createComment(createCommentInput: $input) {
      id
      content
      internal
      isEdited
      createdAt
      updateAt
      threadId
      parentId
      repliesCount
      reactionsCount
      createdBy {
        id
        firstName
        lastName
      }
      updateBy {
        id
        firstName
        lastName
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateCommentGQL extends Apollo.Mutation<
  CreateCommentMutation,
  CreateCommentMutationVariables
> {
  document = CreateCommentDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateCommentDocument = gql`
  mutation updateComment($input: UpdateCommentInput!) {
    updateComment(updateCommentInput: $input) {
      id
      content
      internal
      isEdited
      createdAt
      updateAt
      threadId
      parentId
      repliesCount
      reactionsCount
      createdBy {
        id
        firstName
        lastName
      }
      updateBy {
        id
        firstName
        lastName
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateCommentGQL extends Apollo.Mutation<
  UpdateCommentMutation,
  UpdateCommentMutationVariables
> {
  document = UpdateCommentDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RemoveCommentDocument = gql`
  mutation removeComment($id: ID!) {
    removeComment(id: $id)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RemoveCommentGQL extends Apollo.Mutation<
  RemoveCommentMutation,
  RemoveCommentMutationVariables
> {
  document = RemoveCommentDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetThreadByEntityDocument = gql`
  query getThreadByEntity($entityType: String!, $entityId: String!) {
    threadByEntity(entityType: $entityType, entityId: $entityId) {
      id
      title
      description
      isPrivate
      isLocked
      commentsCount
      entityType
      entityId
      createdAt
      createdById
      updateAt
      updateById
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetThreadByEntityGQL extends Apollo.Query<
  GetThreadByEntityQuery,
  GetThreadByEntityQueryVariables
> {
  document = GetThreadByEntityDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetThreadDocument = gql`
  query getThread($id: ID!) {
    thread(id: $id) {
      id
      title
      description
      isPrivate
      isLocked
      commentsCount
      entityType
      entityId
      createdAt
      createdById
      updateAt
      updateById
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetThreadGQL extends Apollo.Query<
  GetThreadQuery,
  GetThreadQueryVariables
> {
  document = GetThreadDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateThreadDocument = gql`
  mutation createThread($input: CreateThreadInput!) {
    createThread(createThreadInput: $input) {
      id
      title
      description
      isPrivate
      isLocked
      commentsCount
      entityType
      entityId
      createdAt
      createdById
      updateAt
      updateById
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateThreadGQL extends Apollo.Mutation<
  CreateThreadMutation,
  CreateThreadMutationVariables
> {
  document = CreateThreadDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateThreadDocument = gql`
  mutation updateThread($input: UpdateThreadInput!) {
    updateThread(updateThreadInput: $input) {
      id
      title
      description
      isPrivate
      isLocked
      commentsCount
      entityType
      entityId
      createdAt
      createdById
      updateAt
      updateById
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateThreadGQL extends Apollo.Mutation<
  UpdateThreadMutation,
  UpdateThreadMutationVariables
> {
  document = UpdateThreadDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RemoveThreadDocument = gql`
  mutation removeThread($id: ID!) {
    removeThread(id: $id)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RemoveThreadGQL extends Apollo.Mutation<
  RemoveThreadMutation,
  RemoveThreadMutationVariables
> {
  document = RemoveThreadDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CancelPresentationJobDocument = gql`
  mutation cancelPresentationJob($jobId: String!) {
    cancelPresentationJob(jobId: $jobId)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CancelPresentationJobGQL extends Apollo.Mutation<
  CancelPresentationJobMutation,
  CancelPresentationJobMutationVariables
> {
  document = CancelPresentationJobDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetObjectivesDocument = gql`
  query getObjectives {
    objectives {
      id
      name
      tags
      hiddenStrategyCount
      tenant {
        id
        name
      }
      measures {
        id
        name
        outcomeType
      }
      diseaseStateModule {
        id
        code
        name
        summaryCohortId
      }
      careEntity {
        id
        name
        code
      }
      careEntityId
      cohortIds
      initiativeId
      createdAt
      createdBy {
        id
        fullName
        username
      }
      updateAt
      updateBy {
        id
        fullName
        username
      }
      processSponsors {
        id
        externalUsername
        user {
          id
          username
          fullName
          email
        }
      }
      physicianChampions {
        id
        externalUsername
        user {
          id
          username
          fullName
          email
        }
      }
      strategies {
        id
        careEntityId
        diseaseStateModuleId
        name
        description
        createdAt
        templateId
        associations
        createdBy {
          id
          fullName
          username
        }
        updateAt
        updateBy {
          id
          fullName
          username
        }
        status
        checkpointDate
        showInPerformanceMonitor
        associatedObjectiveCount
        associatedObjectives {
          id
          name
        }
        resources {
          id
          url
          displayText
        }
        processSponsors {
          id
          externalUsername
          user {
            id
            username
            fullName
            email
          }
        }
        physicianChampions {
          id
          externalUsername
          user {
            id
            username
            fullName
            email
          }
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetObjectivesGQL extends Apollo.Query<
  GetObjectivesQuery,
  GetObjectivesQueryVariables
> {
  document = GetObjectivesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetObjectiveDocument = gql`
  query getObjective($objectiveId: ID!) {
    objective(id: $objectiveId) {
      id
      name
      tags
      hiddenStrategyCount
      tenant {
        id
        name
      }
      measures {
        id
        name
        outcomeType
      }
      cohortIds
      diseaseStateModule {
        id
        code
        name
        summaryCohortId
      }
      careEntity {
        id
        name
        code
      }
      careEntityId
      initiativeId
      processSponsors {
        id
        externalUsername
        user {
          id
          username
          fullName
          email
        }
      }
      physicianChampions {
        id
        externalUsername
        user {
          id
          username
          fullName
          email
        }
      }
      strategies {
        id
        careEntityId
        diseaseStateModuleId
        name
        description
        createdAt
        templateId
        associations
        checkpointDate
        showInPerformanceMonitor
        associatedObjectiveCount
        associatedObjectives {
          id
          name
        }
        createdBy {
          id
          fullName
          username
        }
        updateAt
        updateBy {
          id
          fullName
          username
        }
        status
        resources {
          id
          url
          displayText
        }
        processSponsors {
          id
          externalUsername
          user {
            id
            username
            fullName
            email
          }
        }
        physicianChampions {
          id
          externalUsername
          user {
            id
            username
            fullName
            email
          }
        }
      }
      createdAt
      createdBy {
        id
        fullName
        username
      }
      updateAt
      updateBy {
        id
        fullName
        username
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetObjectiveGQL extends Apollo.Query<
  GetObjectiveQuery,
  GetObjectiveQueryVariables
> {
  document = GetObjectiveDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateObjectiveDocument = gql`
  mutation createObjective($createObjectiveInput: CreateObjectiveInput!) {
    createObjective(createObjectiveInput: $createObjectiveInput) {
      id
      name
      tags
      tenant {
        id
        name
      }
      measures {
        id
        name
      }
      cohortIds
      diseaseStateModule {
        id
        code
        name
        summaryCohortId
      }
      careEntity {
        id
        name
        code
      }
      careEntityId
      initiativeId
      performanceManagerSyncFailed
      hiddenStrategyCount
      processSponsors {
        id
        externalUsername
        user {
          id
          username
          fullName
          email
        }
      }
      physicianChampions {
        id
        externalUsername
        user {
          id
          username
          fullName
          email
        }
      }
      strategies {
        id
        name
        description
        checkpointDate
        showInPerformanceMonitor
        associatedObjectiveCount
        associatedObjectives {
          id
          name
        }
        associations
        templateId
        resources {
          url
          displayText
        }
        status
        processSponsors {
          id
          externalUsername
          user {
            id
            username
            fullName
            email
          }
        }
        physicianChampions {
          id
          externalUsername
          user {
            id
            username
            fullName
            email
          }
        }
      }
      createdAt
      createdBy {
        id
        fullName
        username
      }
      updateAt
      updateBy {
        id
        fullName
        username
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateObjectiveGQL extends Apollo.Mutation<
  CreateObjectiveMutation,
  CreateObjectiveMutationVariables
> {
  document = CreateObjectiveDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateObjectiveDocument = gql`
  mutation updateObjective($updateObjectiveInput: UpdateObjectiveInput!) {
    updateObjective(updateObjectiveInput: $updateObjectiveInput) {
      id
      name
      tags
      tenant {
        id
        name
      }
      measures {
        id
        name
      }
      cohortIds
      diseaseStateModule {
        id
        code
        name
        summaryCohortId
      }
      careEntity {
        id
        name
        code
      }
      careEntityId
      initiativeId
      performanceManagerSyncFailed
      hiddenStrategyCount
      createdAt
      createdBy {
        id
        fullName
        username
      }
      updateAt
      updateBy {
        id
        fullName
        username
      }
      processSponsors {
        id
        externalUsername
        user {
          id
          username
          fullName
          email
        }
      }
      physicianChampions {
        id
        externalUsername
        user {
          id
          username
          fullName
          email
        }
      }
      strategies {
        id
        careEntityId
        diseaseStateModuleId
        name
        description
        templateId
        createdAt
        createdBy {
          id
          fullName
        }
        updateAt
        updateBy {
          id
          fullName
        }
        status
        checkpointDate
        showInPerformanceMonitor
        associatedObjectiveCount
        associatedObjectives {
          id
          name
        }
        processSponsors {
          id
          externalUsername
          user {
            id
            username
            fullName
            email
          }
        }
        physicianChampions {
          id
          externalUsername
          user {
            id
            username
            fullName
            email
          }
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateObjectiveGQL extends Apollo.Mutation<
  UpdateObjectiveMutation,
  UpdateObjectiveMutationVariables
> {
  document = UpdateObjectiveDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ArchiveObjectiveDocument = gql`
  mutation archiveObjective($id: ID!) {
    archiveObjective(id: $id)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ArchiveObjectiveGQL extends Apollo.Mutation<
  ArchiveObjectiveMutation,
  ArchiveObjectiveMutationVariables
> {
  document = ArchiveObjectiveDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RemoveObjectiveDocument = gql`
  mutation removeObjective($id: ID!) {
    removeObjective(id: $id)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RemoveObjectiveGQL extends Apollo.Mutation<
  RemoveObjectiveMutation,
  RemoveObjectiveMutationVariables
> {
  document = RemoveObjectiveDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ObjectiveStrategiesDocument = gql`
  query objectiveStrategies($objectiveId: ID!) {
    objectiveStrategies(objectiveId: $objectiveId) {
      id
      careEntityId
      diseaseStateModuleId
      createdAt
      updateAt
      name
      createdBy {
        id
        fullName
      }
      updateBy {
        id
        fullName
      }
      templateId
      description
      associations
      status
      checkpointDate
      showInPerformanceMonitor
      resources {
        id
        url
        displayText
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ObjectiveStrategiesGQL extends Apollo.Query<
  ObjectiveStrategiesQuery,
  ObjectiveStrategiesQueryVariables
> {
  document = ObjectiveStrategiesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ObjectiveStrategyDocument = gql`
  query objectiveStrategy($id: ID!) {
    objectiveStrategy(id: $id) {
      id
      careEntityId
      diseaseStateModuleId
      createdAt
      updateAt
      name
      createdBy {
        id
        fullName
      }
      updateBy {
        id
        fullName
      }
      templateId
      description
      associations
      status
      checkpointDate
      showInPerformanceMonitor
      associatedObjectiveCount
      associatedObjectives {
        id
        name
        careEntity {
          id
          name
        }
        diseaseStateModule {
          id
          name
        }
        createdBy {
          id
          fullName
        }
      }
      resources {
        id
        url
        displayText
      }
      processSponsors {
        id
        externalUsername
        user {
          id
          username
          fullName
          email
        }
      }
      physicianChampions {
        id
        externalUsername
        user {
          id
          username
          fullName
          email
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ObjectiveStrategyGQL extends Apollo.Query<
  ObjectiveStrategyQuery,
  ObjectiveStrategyQueryVariables
> {
  document = ObjectiveStrategyDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ObjectiveStrategyAssociatedObjectivesDocument = gql`
  query objectiveStrategyAssociatedObjectives($id: ID!) {
    objectiveStrategy(id: $id) {
      id
      associatedObjectiveCount
      associatedObjectives {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ObjectiveStrategyAssociatedObjectivesGQL extends Apollo.Query<
  ObjectiveStrategyAssociatedObjectivesQuery,
  ObjectiveStrategyAssociatedObjectivesQueryVariables
> {
  document = ObjectiveStrategyAssociatedObjectivesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateObjectiveStrategyDocument = gql`
  mutation createObjectiveStrategy(
    $createObjectiveStrategyInput: CreateObjectiveStrategyInput!
  ) {
    createObjectiveStrategy(
      createObjectiveStrategyInput: $createObjectiveStrategyInput
    ) {
      id
      careEntityId
      diseaseStateModuleId
      createdAt
      updateAt
      createdBy {
        id
        fullName
      }
      updateBy {
        id
        fullName
      }
      templateId
      name
      description
      associations
      status
      checkpointDate
      showInPerformanceMonitor
      performanceManagerSyncFailed
      resources {
        id
        url
        displayText
      }
      processSponsors {
        id
        externalUsername
        user {
          id
          username
          fullName
          email
        }
      }
      physicianChampions {
        id
        externalUsername
        user {
          id
          username
          fullName
          email
        }
      }
      template {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateObjectiveStrategyGQL extends Apollo.Mutation<
  CreateObjectiveStrategyMutation,
  CreateObjectiveStrategyMutationVariables
> {
  document = CreateObjectiveStrategyDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateObjectiveStrategyDocument = gql`
  mutation updateObjectiveStrategy(
    $updateObjectiveStrategyInput: UpdateObjectiveStrategyInput!
  ) {
    updateObjectiveStrategy(
      updateObjectiveStrategyInput: $updateObjectiveStrategyInput
    ) {
      id
      careEntityId
      diseaseStateModuleId
      createdAt
      updateAt
      createdBy {
        id
        fullName
      }
      updateBy {
        id
        fullName
      }
      templateId
      name
      description
      associations
      status
      checkpointDate
      showInPerformanceMonitor
      performanceManagerSyncFailed
      resources {
        id
        url
        displayText
      }
      processSponsors {
        id
        externalUsername
        user {
          id
          username
          fullName
          email
        }
      }
      physicianChampions {
        id
        externalUsername
        user {
          id
          username
          fullName
          email
        }
      }
      template {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateObjectiveStrategyGQL extends Apollo.Mutation<
  UpdateObjectiveStrategyMutation,
  UpdateObjectiveStrategyMutationVariables
> {
  document = UpdateObjectiveStrategyDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ArchiveObjectiveStrategyDocument = gql`
  mutation archiveObjectiveStrategy($id: ID!) {
    archiveObjectiveStrategy(id: $id)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ArchiveObjectiveStrategyGQL extends Apollo.Mutation<
  ArchiveObjectiveStrategyMutation,
  ArchiveObjectiveStrategyMutationVariables
> {
  document = ArchiveObjectiveStrategyDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RemoveObjectiveStrategyDocument = gql`
  mutation removeObjectiveStrategy($id: ID!) {
    removeObjectiveStrategy(id: $id)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RemoveObjectiveStrategyGQL extends Apollo.Mutation<
  RemoveObjectiveStrategyMutation,
  RemoveObjectiveStrategyMutationVariables
> {
  document = RemoveObjectiveStrategyDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UnlinkObjectiveStrategyDocument = gql`
  mutation unlinkObjectiveStrategy($id: ID!, $objectiveId: ID!) {
    unlinkObjectiveStrategy(id: $id, objectiveId: $objectiveId)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UnlinkObjectiveStrategyGQL extends Apollo.Mutation<
  UnlinkObjectiveStrategyMutation,
  UnlinkObjectiveStrategyMutationVariables
> {
  document = UnlinkObjectiveStrategyDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ObjectiveAttachPreviewDocument = gql`
  query objectiveAttachPreview($input: ObjectiveAttachPreviewInput!) {
    objectiveAttachPreview(input: $input) {
      id
      name
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ObjectiveAttachPreviewGQL extends Apollo.Query<
  ObjectiveAttachPreviewQuery,
  ObjectiveAttachPreviewQueryVariables
> {
  document = ObjectiveAttachPreviewDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CanCreatePerformanceManagerStrategyDocument = gql`
  query canCreatePerformanceManagerStrategy(
    $careEntity: String!
    $registry: String!
  ) {
    canCreatePerformanceManagerStrategy(
      careEntity: $careEntity
      registry: $registry
    )
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CanCreatePerformanceManagerStrategyGQL extends Apollo.Query<
  CanCreatePerformanceManagerStrategyQuery,
  CanCreatePerformanceManagerStrategyQueryVariables
> {
  document = CanCreatePerformanceManagerStrategyDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PerformanceManagerStrategiesDocument = gql`
  query performanceManagerStrategies(
    $initiativeId: Float!
    $careEntity: String!
    $registry: String!
  ) {
    performanceManagerStrategies(
      initiativeId: $initiativeId
      careEntity: $careEntity
      registry: $registry
    ) {
      id
      name
      checkpointDate
      canEdit
      floating
      objectives {
        id
        name
      }
      strategy {
        id
        createdAt
        updateAt
        createdBy {
          id
        }
        updateBy {
          id
        }
        name
        description
        status
        checkpointDate
        associatedObjectiveCount
        processSponsors {
          id
          externalUsername
          user {
            id
            username
            fullName
            email
          }
        }
        physicianChampions {
          id
          externalUsername
          user {
            id
            username
            fullName
            email
          }
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class PerformanceManagerStrategiesGQL extends Apollo.Query<
  PerformanceManagerStrategiesQuery,
  PerformanceManagerStrategiesQueryVariables
> {
  document = PerformanceManagerStrategiesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PerformanceManagerStrategyInitiativesDocument = gql`
  query performanceManagerStrategyInitiatives(
    $initiativeId: Float!
    $careEntity: String!
    $registry: String!
  ) {
    performanceManagerStrategies(
      initiativeId: $initiativeId
      careEntity: $careEntity
      registry: $registry
    ) {
      id
      initiatives {
        initiativeId
        monitoredCareEntity
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class PerformanceManagerStrategyInitiativesGQL extends Apollo.Query<
  PerformanceManagerStrategyInitiativesQuery,
  PerformanceManagerStrategyInitiativesQueryVariables
> {
  document = PerformanceManagerStrategyInitiativesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreatePerformanceManagerStrategyDocument = gql`
  mutation createPerformanceManagerStrategy(
    $input: CreatePerformanceManagerStrategyInput!
  ) {
    createPerformanceManagerStrategy(input: $input) {
      id
      performanceManagerSyncFailed
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreatePerformanceManagerStrategyGQL extends Apollo.Mutation<
  CreatePerformanceManagerStrategyMutation,
  CreatePerformanceManagerStrategyMutationVariables
> {
  document = CreatePerformanceManagerStrategyDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ObjectiveStrategyTemplateDocument = gql`
  query objectiveStrategyTemplate($id: ID!) {
    objectiveStrategyTemplate(id: $id) {
      id
      createdAt
      updateAt
      name
      createdBy {
        id
        fullName
      }
      updateBy {
        id
        fullName
      }
      description
      allMeasures
      allDiseaseStateModules
      measures {
        id
        name
      }
      diseaseStateModule {
        id
        name
      }
      resources {
        id
        url
        displayText
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ObjectiveStrategyTemplateGQL extends Apollo.Query<
  ObjectiveStrategyTemplateQuery,
  ObjectiveStrategyTemplateQueryVariables
> {
  document = ObjectiveStrategyTemplateDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ObjectiveStrategyTemplatesDocument = gql`
  query objectiveStrategyTemplates {
    objectiveStrategyTemplates {
      id
      createdAt
      updateAt
      name
      createdBy {
        id
        fullName
      }
      updateBy {
        id
        fullName
      }
      description
      allMeasures
      allDiseaseStateModules
      measures {
        id
        name
      }
      diseaseStateModule {
        id
        name
      }
      resources {
        id
        url
        displayText
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ObjectiveStrategyTemplatesGQL extends Apollo.Query<
  ObjectiveStrategyTemplatesQuery,
  ObjectiveStrategyTemplatesQueryVariables
> {
  document = ObjectiveStrategyTemplatesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateObjectiveStrategyTemplateDocument = gql`
  mutation createObjectiveStrategyTemplate(
    $createObjectiveStrategyTemplateInput: CreateObjectiveStrategyTemplateInput!
  ) {
    createObjectiveStrategyTemplate(
      createObjectiveStrategyTemplateInput: $createObjectiveStrategyTemplateInput
    ) {
      id
      createdAt
      updateAt
      name
      createdBy {
        id
        fullName
      }
      updateBy {
        id
        fullName
      }
      description
      allMeasures
      allDiseaseStateModules
      measures {
        id
        name
      }
      diseaseStateModule {
        id
        name
      }
      strategies {
        id
        name
        description
      }
      resources {
        id
        url
        displayText
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateObjectiveStrategyTemplateGQL extends Apollo.Mutation<
  CreateObjectiveStrategyTemplateMutation,
  CreateObjectiveStrategyTemplateMutationVariables
> {
  document = CreateObjectiveStrategyTemplateDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateObjectiveStrategyTemplateDocument = gql`
  mutation updateObjectiveStrategyTemplate(
    $updateObjectiveStrategyTemplateInput: UpdateObjectiveStrategyTemplateInput!
  ) {
    updateObjectiveStrategyTemplate(
      updateObjectiveStrategyTemplateInput: $updateObjectiveStrategyTemplateInput
    ) {
      id
      createdAt
      updateAt
      name
      createdBy {
        id
        fullName
      }
      updateBy {
        id
        fullName
      }
      description
      allMeasures
      allDiseaseStateModules
      measures {
        id
        name
      }
      diseaseStateModule {
        id
        name
      }
      strategies {
        id
        name
        description
      }
      resources {
        id
        url
        displayText
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateObjectiveStrategyTemplateGQL extends Apollo.Mutation<
  UpdateObjectiveStrategyTemplateMutation,
  UpdateObjectiveStrategyTemplateMutationVariables
> {
  document = UpdateObjectiveStrategyTemplateDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ArchiveObjectiveStrategyTemplateDocument = gql`
  mutation archiveObjectiveStrategyTemplate($id: ID!) {
    archiveObjectiveStrategyTemplate(id: $id)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ArchiveObjectiveStrategyTemplateGQL extends Apollo.Mutation<
  ArchiveObjectiveStrategyTemplateMutation,
  ArchiveObjectiveStrategyTemplateMutationVariables
> {
  document = ArchiveObjectiveStrategyTemplateDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RemoveObjectiveStrategyTemplateDocument = gql`
  mutation removeObjectiveStrategyTemplate($id: ID!) {
    removeObjectiveStrategyTemplate(id: $id)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RemoveObjectiveStrategyTemplateGQL extends Apollo.Mutation<
  RemoveObjectiveStrategyTemplateMutation,
  RemoveObjectiveStrategyTemplateMutationVariables
> {
  document = RemoveObjectiveStrategyTemplateDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ObjectiveTemplateDocument = gql`
  query objectiveTemplate($id: ID!) {
    objectiveTemplate(id: $id) {
      id
      createdAt
      updateAt
      name
      createdBy {
        id
        fullName
      }
      updateBy {
        id
        fullName
      }
      tags
      cohortIds
      diseaseStateModule {
        id
        code
        name
      }
      measures {
        id
        name
      }
      linkedStrategyTemplates {
        id
        name
        description
        allMeasures
        allDiseaseStateModules
        diseaseStateModule {
          id
          name
        }
        measures {
          id
          name
        }
        resources {
          id
          url
          displayText
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ObjectiveTemplateGQL extends Apollo.Query<
  ObjectiveTemplateQuery,
  ObjectiveTemplateQueryVariables
> {
  document = ObjectiveTemplateDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ObjectiveTemplatesDocument = gql`
  query objectiveTemplates {
    objectiveTemplates {
      id
      createdAt
      updateAt
      name
      createdBy {
        id
        fullName
      }
      updateBy {
        id
        fullName
      }
      tags
      cohortIds
      diseaseStateModule {
        id
        code
        name
      }
      measures {
        id
        name
      }
      linkedStrategyTemplates {
        id
        name
        description
        allMeasures
        allDiseaseStateModules
        diseaseStateModule {
          id
          name
        }
        measures {
          id
          name
        }
        resources {
          id
          url
          displayText
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ObjectiveTemplatesGQL extends Apollo.Query<
  ObjectiveTemplatesQuery,
  ObjectiveTemplatesQueryVariables
> {
  document = ObjectiveTemplatesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateObjectiveTemplateDocument = gql`
  mutation createObjectiveTemplate(
    $createObjectiveTemplateInput: CreateObjectiveTemplateInput!
  ) {
    createObjectiveTemplate(
      createObjectiveTemplateInput: $createObjectiveTemplateInput
    ) {
      id
      createdAt
      updateAt
      name
      createdBy {
        id
        fullName
      }
      updateBy {
        id
        fullName
      }
      tags
      cohortIds
      diseaseStateModule {
        id
        code
        name
      }
      measures {
        id
        name
      }
      linkedStrategyTemplates {
        id
        name
        description
        allMeasures
        allDiseaseStateModules
        diseaseStateModule {
          id
          name
        }
        measures {
          id
          name
        }
        resources {
          id
          url
          displayText
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateObjectiveTemplateGQL extends Apollo.Mutation<
  CreateObjectiveTemplateMutation,
  CreateObjectiveTemplateMutationVariables
> {
  document = CreateObjectiveTemplateDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateObjectiveTemplateDocument = gql`
  mutation updateObjectiveTemplate(
    $updateObjectiveTemplateInput: UpdateObjectiveTemplateInput!
  ) {
    updateObjectiveTemplate(
      updateObjectiveTemplateInput: $updateObjectiveTemplateInput
    ) {
      id
      createdAt
      updateAt
      name
      createdBy {
        id
        fullName
      }
      updateBy {
        id
        fullName
      }
      tags
      cohortIds
      diseaseStateModule {
        id
        code
        name
      }
      measures {
        id
        name
      }
      linkedStrategyTemplates {
        id
        name
        description
        allMeasures
        allDiseaseStateModules
        diseaseStateModule {
          id
          name
        }
        measures {
          id
          name
        }
        resources {
          id
          url
          displayText
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateObjectiveTemplateGQL extends Apollo.Mutation<
  UpdateObjectiveTemplateMutation,
  UpdateObjectiveTemplateMutationVariables
> {
  document = UpdateObjectiveTemplateDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ArchiveObjectiveTemplateDocument = gql`
  mutation archiveObjectiveTemplate($id: ID!) {
    archiveObjectiveTemplate(id: $id)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ArchiveObjectiveTemplateGQL extends Apollo.Mutation<
  ArchiveObjectiveTemplateMutation,
  ArchiveObjectiveTemplateMutationVariables
> {
  document = ArchiveObjectiveTemplateDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ObjectiveStrategyAttachmentsDocument = gql`
  query objectiveStrategyAttachments($id: ID!) {
    objectiveStrategy(id: $id) {
      id
      attachments {
        id
        name
        extension
        mimeType
        createdAt
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ObjectiveStrategyAttachmentsGQL extends Apollo.Query<
  ObjectiveStrategyAttachmentsQuery,
  ObjectiveStrategyAttachmentsQueryVariables
> {
  document = ObjectiveStrategyAttachmentsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ObjectiveStrategyTemplateAttachmentsDocument = gql`
  query objectiveStrategyTemplateAttachments($id: ID!) {
    objectiveStrategyTemplate(id: $id) {
      id
      attachments {
        id
        name
        extension
        mimeType
        createdAt
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ObjectiveStrategyTemplateAttachmentsGQL extends Apollo.Query<
  ObjectiveStrategyTemplateAttachmentsQuery,
  ObjectiveStrategyTemplateAttachmentsQueryVariables
> {
  document = ObjectiveStrategyTemplateAttachmentsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RemoveStrategyAttachmentDocument = gql`
  mutation removeStrategyAttachment($id: ID!) {
    removeStrategyAttachment(id: $id)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RemoveStrategyAttachmentGQL extends Apollo.Mutation<
  RemoveStrategyAttachmentMutation,
  RemoveStrategyAttachmentMutationVariables
> {
  document = RemoveStrategyAttachmentDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DownloadStrategyAttachmentDocument = gql`
  mutation downloadStrategyAttachment($id: ID!) {
    downloadStrategyAttachment(id: $id) {
      id
      name
      url
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DownloadStrategyAttachmentGQL extends Apollo.Mutation<
  DownloadStrategyAttachmentMutation,
  DownloadStrategyAttachmentMutationVariables
> {
  document = DownloadStrategyAttachmentDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetTableauViewsForApolloDocument = gql`
  query getTableauViewsForApollo($measureIds: [Int!]) {
    tableauViews(measureIds: $measureIds) {
      id
      name
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetTableauViewsForApolloGQL extends Apollo.Query<
  GetTableauViewsForApolloQuery,
  GetTableauViewsForApolloQueryVariables
> {
  document = GetTableauViewsForApolloDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetDimensionClassesDocument = gql`
  query getDimensionClasses {
    dimensionClasses
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetDimensionClassesGQL extends Apollo.Query<
  GetDimensionClassesQuery,
  GetDimensionClassesQueryVariables
> {
  document = GetDimensionClassesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetDictionaryElementDocument = gql`
  query getDictionaryElement($elementId: String!) {
    element(id: $elementId) {
      id
      elementReference
      shortName
      name
      codingInstructions
      targetValue
      dbDataType
      dataType
      precision
      unitOfMeasure
      selectionType
      defaultValue
      code
      codeSystemName
      vendorInstruction
      section {
        sectionDisplayName
      }
      selections {
        id
        code
        codeSystemName
        selectionName
        selectionDefinition
      }
      definition {
        id
        title
        definition
        source
      }
      parentChildValidations {
        id
        parent {
          id
          shortName
          sourceMappings {
            id
            target {
              id
              shortName
            }
          }
          referenceTransformations {
            id
            translation {
              id
              target {
                id
                shortName
              }
            }
          }
          derivativeTransformations {
            id
            translation {
              id
              target {
                id
                shortName
              }
            }
          }
        }
        parentSelection {
          id
          selectionName
        }
        parentElementSelectionName
      }
      sourceMappings {
        id
        target {
          id
          shortName
          name
          pipelineElements {
            id
            numeratorMeasures {
              id
              name
            }
            denominatorMeasures {
              id
              name
            }
            includeMeasures {
              id
              name
            }
          }
        }
        valueMap
      }
      targetMappings {
        id
        source {
          id
          shortName
        }
        transformation {
          id
          reference {
            id
            shortName
          }
          derivative {
            id
            shortName
          }
          valueMap
        }
        valueMap
      }
      referenceTransformations {
        id
        translation {
          id
          target {
            id
            shortName
            pipelineElements {
              id
              numeratorMeasures {
                id
                name
              }
              denominatorMeasures {
                id
                name
              }
              includeMeasures {
                id
                name
              }
            }
          }
        }
        derivative {
          id
          shortName
        }
        valueMap
      }
      derivativeTransformations {
        id
        translation {
          id
          target {
            id
            shortName
            pipelineElements {
              id
              numeratorMeasures {
                id
                name
              }
              denominatorMeasures {
                id
                name
              }
              includeMeasures {
                id
                name
              }
            }
          }
        }
        reference {
          id
          shortName
        }
        valueMap
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetDictionaryElementGQL extends Apollo.Query<
  GetDictionaryElementQuery,
  GetDictionaryElementQueryVariables
> {
  document = GetDictionaryElementDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetReportAttributesDocument = gql`
  query getReportAttributes($diseaseStateModuleId: Int!, $dateColumn: String!) {
    reportAttributes(
      diseaseStateModuleId: $diseaseStateModuleId
      dateColumn: $dateColumn
    ) {
      maxDate
      minDate
      refreshDate
      procedures
      defaultProcedures
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetReportAttributesGQL extends Apollo.Query<
  GetReportAttributesQuery,
  GetReportAttributesQueryVariables
> {
  document = GetReportAttributesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DevelopmentDimensionDocument = gql`
  query DevelopmentDimension($dimensionId: Int!) {
    developmentDimension(dimensionId: $dimensionId) {
      id
      dimensionId
      active
      label
      fieldName
      description
      requirements
      type
      class
      priority
      sortOrder
      oeQualifying
      aeQualifying
      allMeasures
      isGlobal
      sourceContinuousField
      multiProcTableId
      multiProcTable {
        id
        tableName
      }
      excludeValues
      valueMap
      diseaseStateModule {
        id
        name
      }
      state
      status
      jiraLink
      codeVersion
      stateHistory
      documentation
      createdAt
      updateAt
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DevelopmentDimensionGQL extends Apollo.Query<
  DevelopmentDimensionQuery,
  DevelopmentDimensionQueryVariables
> {
  document = DevelopmentDimensionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DevelopmentDimensionsDocument = gql`
  query DevelopmentDimensions {
    developmentDimensions {
      id
      dimensionId
      active
      label
      fieldName
      description
      requirements
      type
      class
      priority
      sortOrder
      oeQualifying
      aeQualifying
      allMeasures
      isGlobal
      sourceContinuousField
      multiProcTableId
      multiProcTable {
        id
        tableName
      }
      excludeValues
      valueMap
      diseaseStateModule {
        id
        name
      }
      state
      status
      jiraLink
      codeVersion
      stateHistory
      documentation
      createdAt
      updateAt
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DevelopmentDimensionsGQL extends Apollo.Query<
  DevelopmentDimensionsQuery,
  DevelopmentDimensionsQueryVariables
> {
  document = DevelopmentDimensionsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DevelopmentDimensionHistoryDocument = gql`
  query DevelopmentDimensionHistory($dimensionId: Int!) {
    developmentDimensionHistory(dimensionId: $dimensionId) {
      id
      dimensionId
      active
      label
      description
      state
      status
      jiraLink
      codeVersion
      stateHistory
      documentation
      createdAt
      updateAt
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DevelopmentDimensionHistoryGQL extends Apollo.Query<
  DevelopmentDimensionHistoryQuery,
  DevelopmentDimensionHistoryQueryVariables
> {
  document = DevelopmentDimensionHistoryDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RequestDimensionUpdateDocument = gql`
  mutation RequestDimensionUpdate($dimensionId: Int!) {
    requestDimensionUpdate(dimensionId: $dimensionId) {
      id
      dimensionId
      active
      label
      description
      state
      status
      jiraLink
      codeVersion
      stateHistory
      documentation
      createdAt
      updateAt
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RequestDimensionUpdateGQL extends Apollo.Mutation<
  RequestDimensionUpdateMutation,
  RequestDimensionUpdateMutationVariables
> {
  document = RequestDimensionUpdateDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RequestSmeReviewDimensionDocument = gql`
  mutation RequestSmeReviewDimension($dimensionId: Int!, $comment: String) {
    requestSmeReviewForDimension(dimensionId: $dimensionId, comment: $comment)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RequestSmeReviewDimensionGQL extends Apollo.Mutation<
  RequestSmeReviewDimensionMutation,
  RequestSmeReviewDimensionMutationVariables
> {
  document = RequestSmeReviewDimensionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ApproveSmeReviewDimensionDocument = gql`
  mutation ApproveSmeReviewDimension($dimensionId: Int!) {
    approveSmeReviewForDimension(dimensionId: $dimensionId)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ApproveSmeReviewDimensionGQL extends Apollo.Mutation<
  ApproveSmeReviewDimensionMutation,
  ApproveSmeReviewDimensionMutationVariables
> {
  document = ApproveSmeReviewDimensionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RejectSmeReviewDimensionDocument = gql`
  mutation RejectSmeReviewDimension($dimensionId: Int!, $comment: String!) {
    rejectSmeReviewForDimension(dimensionId: $dimensionId, comment: $comment)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RejectSmeReviewDimensionGQL extends Apollo.Mutation<
  RejectSmeReviewDimensionMutation,
  RejectSmeReviewDimensionMutationVariables
> {
  document = RejectSmeReviewDimensionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CancelDevelopmentDimensionDocument = gql`
  mutation CancelDevelopmentDimension($dimensionId: Int!, $comment: String) {
    cancelDevelopmentDimension(dimensionId: $dimensionId, comment: $comment) {
      id
      dimensionId
      active
      label
      description
      state
      status
      jiraLink
      codeVersion
      stateHistory
      documentation
      createdAt
      updateAt
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CancelDevelopmentDimensionGQL extends Apollo.Mutation<
  CancelDevelopmentDimensionMutation,
  CancelDevelopmentDimensionMutationVariables
> {
  document = CancelDevelopmentDimensionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateDevelopmentDimensionDocument = gql`
  mutation CreateDevelopmentDimension(
    $input: CreateDevelopmentDimensionInput!
  ) {
    createDevelopmentDimension(input: $input) {
      id
      dimensionId
      active
      label
      description
      state
      status
      jiraLink
      codeVersion
      stateHistory
      documentation
      createdAt
      updateAt
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateDevelopmentDimensionGQL extends Apollo.Mutation<
  CreateDevelopmentDimensionMutation,
  CreateDevelopmentDimensionMutationVariables
> {
  document = CreateDevelopmentDimensionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DevelopmentMeasureDocument = gql`
  query DevelopmentMeasure($measureId: Int!) {
    developmentMeasure(measureId: $measureId) {
      id
      measureId
      active
      name
      ncdrMeasureName
      description
      commonMeasureDisplayName
      diseaseStateModule {
        id
        name
      }
      numeratorUnit
      accessCategory
      opportunityType
      publicationSource
      summaryInitiativeMeasure
      rareEvent
      requirements
      testCapture
      registryMeasureId
      validationSource
      benchmarkExtraction
      reportRowId
      tableName
      isBenchmark
      summaryCohortId
      excludedCohortIds
      unit
      numeratorColumnName
      includeColumnName
      denominatorColumnName
      riskAdjusted
      riskMetricId
      aggregationFn
      aggregationType
      outcomeType
      roiCalcType
      higherIsBetter
      dataTypeRequired
      losROIQualifying
      adjustment
      commonMeasureQualifying
      costComponentMeasure
      volumeMeasure
      annualMeasureBaseId
      state
      status
      jiraLink
      codeVersion
      stateHistory
      numeratorDocumentation
      denominatorDocumentation
      includeDocumentation
      riskMetricDocumentation
      createdAt
      updateAt
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DevelopmentMeasureGQL extends Apollo.Query<
  DevelopmentMeasureQuery,
  DevelopmentMeasureQueryVariables
> {
  document = DevelopmentMeasureDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DevelopmentMeasuresDocument = gql`
  query DevelopmentMeasures {
    developmentMeasures {
      id
      measureId
      active
      name
      ncdrMeasureName
      description
      commonMeasureDisplayName
      diseaseStateModule {
        id
        name
      }
      numeratorUnit
      accessCategory
      opportunityType
      publicationSource
      summaryInitiativeMeasure
      rareEvent
      requirements
      testCapture
      registryMeasureId
      validationSource
      benchmarkExtraction
      reportRowId
      tableName
      isBenchmark
      summaryCohortId
      excludedCohortIds
      unit
      numeratorColumnName
      includeColumnName
      denominatorColumnName
      riskAdjusted
      riskMetricId
      aggregationFn
      aggregationType
      outcomeType
      roiCalcType
      higherIsBetter
      dataTypeRequired
      losROIQualifying
      adjustment
      commonMeasureQualifying
      costComponentMeasure
      volumeMeasure
      annualMeasureBaseId
      state
      status
      jiraLink
      codeVersion
      stateHistory
      numeratorDocumentation
      denominatorDocumentation
      includeDocumentation
      riskMetricDocumentation
      createdAt
      updateAt
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DevelopmentMeasuresGQL extends Apollo.Query<
  DevelopmentMeasuresQuery,
  DevelopmentMeasuresQueryVariables
> {
  document = DevelopmentMeasuresDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DevelopmentMeasureHistoryDocument = gql`
  query DevelopmentMeasureHistory($measureId: Int!) {
    developmentMeasureHistory(measureId: $measureId) {
      id
      measureId
      active
      name
      description
      state
      status
      jiraLink
      codeVersion
      stateHistory
      numeratorDocumentation
      denominatorDocumentation
      includeDocumentation
      riskMetricDocumentation
      createdAt
      updateAt
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DevelopmentMeasureHistoryGQL extends Apollo.Query<
  DevelopmentMeasureHistoryQuery,
  DevelopmentMeasureHistoryQueryVariables
> {
  document = DevelopmentMeasureHistoryDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RequestMeasureUpdateDocument = gql`
  mutation RequestMeasureUpdate($measureId: Int!) {
    requestMeasureUpdate(measureId: $measureId) {
      id
      measureId
      active
      name
      description
      state
      status
      jiraLink
      codeVersion
      stateHistory
      numeratorDocumentation
      denominatorDocumentation
      includeDocumentation
      riskMetricDocumentation
      createdAt
      updateAt
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RequestMeasureUpdateGQL extends Apollo.Mutation<
  RequestMeasureUpdateMutation,
  RequestMeasureUpdateMutationVariables
> {
  document = RequestMeasureUpdateDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RequestSmeReviewMeasureDocument = gql`
  mutation RequestSmeReviewMeasure($measureId: Int!, $comment: String) {
    requestSmeReviewForMeasure(measureId: $measureId, comment: $comment)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RequestSmeReviewMeasureGQL extends Apollo.Mutation<
  RequestSmeReviewMeasureMutation,
  RequestSmeReviewMeasureMutationVariables
> {
  document = RequestSmeReviewMeasureDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ApproveSmeReviewMeasureDocument = gql`
  mutation ApproveSmeReviewMeasure($measureId: Int!) {
    approveSmeReviewForMeasure(measureId: $measureId)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ApproveSmeReviewMeasureGQL extends Apollo.Mutation<
  ApproveSmeReviewMeasureMutation,
  ApproveSmeReviewMeasureMutationVariables
> {
  document = ApproveSmeReviewMeasureDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RejectSmeReviewMeasureDocument = gql`
  mutation RejectSmeReviewMeasure($measureId: Int!, $comment: String!) {
    rejectSmeReviewForMeasure(measureId: $measureId, comment: $comment)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RejectSmeReviewMeasureGQL extends Apollo.Mutation<
  RejectSmeReviewMeasureMutation,
  RejectSmeReviewMeasureMutationVariables
> {
  document = RejectSmeReviewMeasureDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CancelDevelopmentMeasureDocument = gql`
  mutation CancelDevelopmentMeasure($measureId: Int!, $comment: String) {
    cancelDevelopmentMeasure(measureId: $measureId, comment: $comment) {
      id
      measureId
      active
      name
      description
      state
      status
      jiraLink
      codeVersion
      stateHistory
      numeratorDocumentation
      denominatorDocumentation
      includeDocumentation
      riskMetricDocumentation
      createdAt
      updateAt
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CancelDevelopmentMeasureGQL extends Apollo.Mutation<
  CancelDevelopmentMeasureMutation,
  CancelDevelopmentMeasureMutationVariables
> {
  document = CancelDevelopmentMeasureDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateDevelopmentMeasureDocument = gql`
  mutation CreateDevelopmentMeasure($input: CreateDevelopmentMeasureInput!) {
    createDevelopmentMeasure(input: $input) {
      id
      measureId
      active
      name
      description
      state
      status
      jiraLink
      codeVersion
      stateHistory
      numeratorDocumentation
      denominatorDocumentation
      includeDocumentation
      riskMetricDocumentation
      createdAt
      updateAt
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateDevelopmentMeasureGQL extends Apollo.Mutation<
  CreateDevelopmentMeasureMutation,
  CreateDevelopmentMeasureMutationVariables
> {
  document = CreateDevelopmentMeasureDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DevelopmentRoiMetricDocument = gql`
  query DevelopmentRoiMetric($roiMetricId: String!) {
    developmentRoiMetric(roiMetricId: $roiMetricId) {
      id
      roiMetricId
      active
      label
      fieldName
      legacyDescription
      higherIsBetter
      diseaseStateModule {
        id
        name
      }
      state
      status
      jiraLink
      codeVersion
      stateHistory
      documentation
      createdAt
      updateAt
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DevelopmentRoiMetricGQL extends Apollo.Query<
  DevelopmentRoiMetricQuery,
  DevelopmentRoiMetricQueryVariables
> {
  document = DevelopmentRoiMetricDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DevelopmentRoiMetricsDocument = gql`
  query DevelopmentRoiMetrics {
    developmentRoiMetrics {
      id
      roiMetricId
      active
      label
      fieldName
      legacyDescription
      higherIsBetter
      diseaseStateModule {
        id
        name
      }
      state
      status
      jiraLink
      codeVersion
      stateHistory
      documentation
      createdAt
      updateAt
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DevelopmentRoiMetricsGQL extends Apollo.Query<
  DevelopmentRoiMetricsQuery,
  DevelopmentRoiMetricsQueryVariables
> {
  document = DevelopmentRoiMetricsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DevelopmentRoiMetricHistoryDocument = gql`
  query DevelopmentRoiMetricHistory($roiMetricId: String!) {
    developmentRoiMetricHistory(roiMetricId: $roiMetricId) {
      id
      roiMetricId
      active
      state
      status
      jiraLink
      codeVersion
      stateHistory
      documentation
      createdAt
      updateAt
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DevelopmentRoiMetricHistoryGQL extends Apollo.Query<
  DevelopmentRoiMetricHistoryQuery,
  DevelopmentRoiMetricHistoryQueryVariables
> {
  document = DevelopmentRoiMetricHistoryDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RequestRoiMetricUpdateDocument = gql`
  mutation RequestRoiMetricUpdate($roiMetricId: String!) {
    requestRoiMetricUpdate(roiMetricId: $roiMetricId) {
      id
      roiMetricId
      active
      state
      status
      jiraLink
      codeVersion
      stateHistory
      documentation
      createdAt
      updateAt
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RequestRoiMetricUpdateGQL extends Apollo.Mutation<
  RequestRoiMetricUpdateMutation,
  RequestRoiMetricUpdateMutationVariables
> {
  document = RequestRoiMetricUpdateDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RequestSmeReviewRoiMetricDocument = gql`
  mutation RequestSmeReviewRoiMetric($roiMetricId: String!, $comment: String) {
    requestSmeReviewForRoiMetric(roiMetricId: $roiMetricId, comment: $comment)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RequestSmeReviewRoiMetricGQL extends Apollo.Mutation<
  RequestSmeReviewRoiMetricMutation,
  RequestSmeReviewRoiMetricMutationVariables
> {
  document = RequestSmeReviewRoiMetricDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ApproveSmeReviewRoiMetricDocument = gql`
  mutation ApproveSmeReviewRoiMetric($roiMetricId: String!) {
    approveSmeReviewForRoiMetric(roiMetricId: $roiMetricId)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ApproveSmeReviewRoiMetricGQL extends Apollo.Mutation<
  ApproveSmeReviewRoiMetricMutation,
  ApproveSmeReviewRoiMetricMutationVariables
> {
  document = ApproveSmeReviewRoiMetricDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RejectSmeReviewRoiMetricDocument = gql`
  mutation RejectSmeReviewRoiMetric($roiMetricId: String!, $comment: String!) {
    rejectSmeReviewForRoiMetric(roiMetricId: $roiMetricId, comment: $comment)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RejectSmeReviewRoiMetricGQL extends Apollo.Mutation<
  RejectSmeReviewRoiMetricMutation,
  RejectSmeReviewRoiMetricMutationVariables
> {
  document = RejectSmeReviewRoiMetricDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CancelDevelopmentRoiMetricDocument = gql`
  mutation CancelDevelopmentRoiMetric($roiMetricId: String!, $comment: String) {
    cancelDevelopmentRoiMetric(roiMetricId: $roiMetricId, comment: $comment) {
      id
      roiMetricId
      active
      state
      status
      jiraLink
      codeVersion
      stateHistory
      documentation
      createdAt
      updateAt
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CancelDevelopmentRoiMetricGQL extends Apollo.Mutation<
  CancelDevelopmentRoiMetricMutation,
  CancelDevelopmentRoiMetricMutationVariables
> {
  document = CancelDevelopmentRoiMetricDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateDevelopmentRoiMetricDocument = gql`
  mutation CreateDevelopmentRoiMetric(
    $input: CreateDevelopmentRoiMetricInput!
  ) {
    createDevelopmentRoiMetric(input: $input) {
      id
      roiMetricId
      active
      state
      status
      jiraLink
      codeVersion
      stateHistory
      documentation
      createdAt
      updateAt
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateDevelopmentRoiMetricGQL extends Apollo.Mutation<
  CreateDevelopmentRoiMetricMutation,
  CreateDevelopmentRoiMetricMutationVariables
> {
  document = CreateDevelopmentRoiMetricDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const MeasureMetadataHistoryDocument = gql`
  query MeasureMetadataHistory($id: Int!, $version: String!) {
    measureMetadataHistory(id: $id, version: $version) {
      id
      name
      commonMeasureDisplayName
      summaryInitiativeMeasure
      rareEvent
      accessCategory
      opportunityType
      version
      description
      numeratorUnit
      publicationSource
      tableName
      diseaseStateModule
      isBenchmark
      dimensionSets
      summaryCohortId
      excludedCohortIds
      unit
      numeratorColumnName
      includeColumnName
      denominatorColumnName
      riskMetricId
      aggregationFn
      aggregationType
      outcomeType
      roiCalcType
      higherIsBetter
      dataTypeRequired
      roiMetrics
      losROIQualifying
      adjustment
      commonMeasureQualifying
      costComponentMeasure
      createdAt
      updateAt
      createdBy {
        fullName
      }
      updateBy {
        fullName
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class MeasureMetadataHistoryGQL extends Apollo.Query<
  MeasureMetadataHistoryQuery,
  MeasureMetadataHistoryQueryVariables
> {
  document = MeasureMetadataHistoryDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DimensionHistoryDocument = gql`
  query DimensionHistory($id: Int!, $version: String!) {
    dimensionHistory(id: $id, version: $version) {
      id
      dimensionId
      version
      label
      fieldName
      description
      requirements
      legacyDescription
      type
      class
      sortOrder
      priority
      sourceContinuousField
      multiProcTableName
      oeQualifying
      aeQualifying
      allMeasures
      hideFromReports
      isGlobal
      valueMap
      excludeValues
      pipelineElementId
      diseaseStateModuleId
      createdAt
      updateAt
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DimensionHistoryGQL extends Apollo.Query<
  DimensionHistoryQuery,
  DimensionHistoryQueryVariables
> {
  document = DimensionHistoryDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RoiMetricHistoryDocument = gql`
  query RoiMetricHistory($id: String!, $version: String!) {
    roiMetricHistory(id: $id, version: $version) {
      id
      roiMetricId
      version
      fieldName
      label
      legacyDescription
      higherIsBetter
      pipelineElementId
      createdAt
      updateAt
      createdBy {
        fullName
      }
      updateBy {
        fullName
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RoiMetricHistoryGQL extends Apollo.Query<
  RoiMetricHistoryQuery,
  RoiMetricHistoryQueryVariables
> {
  document = RoiMetricHistoryDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateDevelopmentDimensionDocument = gql`
  mutation UpdateDevelopmentDimension(
    $input: UpdateDevelopmentDimensionInput!
  ) {
    updateDevelopmentDimension(input: $input) {
      id
      dimensionId
      active
      label
      description
      state
      status
      jiraLink
      codeVersion
      stateHistory
      documentation
      createdAt
      updateAt
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateDevelopmentDimensionGQL extends Apollo.Mutation<
  UpdateDevelopmentDimensionMutation,
  UpdateDevelopmentDimensionMutationVariables
> {
  document = UpdateDevelopmentDimensionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateDevelopmentMeasureDocument = gql`
  mutation UpdateDevelopmentMeasure($input: UpdateDevelopmentMeasureInput!) {
    updateDevelopmentMeasure(input: $input) {
      id
      measureId
      active
      name
      description
      state
      status
      jiraLink
      codeVersion
      stateHistory
      numeratorDocumentation
      denominatorDocumentation
      includeDocumentation
      riskMetricDocumentation
      createdAt
      updateAt
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateDevelopmentMeasureGQL extends Apollo.Mutation<
  UpdateDevelopmentMeasureMutation,
  UpdateDevelopmentMeasureMutationVariables
> {
  document = UpdateDevelopmentMeasureDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateDevelopmentRoiMetricDocument = gql`
  mutation UpdateDevelopmentRoiMetric(
    $input: UpdateDevelopmentRoiMetricInput!
  ) {
    updateDevelopmentRoiMetric(input: $input) {
      id
      roiMetricId
      active
      label
      state
      status
      jiraLink
      codeVersion
      stateHistory
      documentation
      createdAt
      updateAt
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateDevelopmentRoiMetricGQL extends Apollo.Mutation<
  UpdateDevelopmentRoiMetricMutation,
  UpdateDevelopmentRoiMetricMutationVariables
> {
  document = UpdateDevelopmentRoiMetricDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetDsmDimensionsDocument = gql`
  query getDsmDimensions(
    $diseaseStateModuleId: Int!
    $type: DimensionType
    $aeQualifying: Boolean
  ) {
    dimensions(
      diseaseStateModuleId: $diseaseStateModuleId
      type: $type
      aeQualifying: $aeQualifying
    ) {
      id
      label
      sortOrder
      type
      fieldName
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetDsmDimensionsGQL extends Apollo.Query<
  GetDsmDimensionsQuery,
  GetDsmDimensionsQueryVariables
> {
  document = GetDsmDimensionsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetRlsAllowedContextsDocument = gql`
  query getRlsAllowedContexts($diseaseStateModuleId: Int!) {
    rlsAllowedContexts(diseaseStateModuleId: $diseaseStateModuleId)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetRlsAllowedContextsGQL extends Apollo.Query<
  GetRlsAllowedContextsQuery,
  GetRlsAllowedContextsQueryVariables
> {
  document = GetRlsAllowedContextsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetRlsAllowedCareEntityCodesDocument = gql`
  query getRlsAllowedCareEntityCodes(
    $diseaseStateModuleId: Int!
    $type: CareEntityType
  ) {
    rlsAllowedCareEntityCodes(
      diseaseStateModuleId: $diseaseStateModuleId
      type: $type
    )
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetRlsAllowedCareEntityCodesGQL extends Apollo.Query<
  GetRlsAllowedCareEntityCodesQuery,
  GetRlsAllowedCareEntityCodesQueryVariables
> {
  document = GetRlsAllowedCareEntityCodesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetTenantOffboardingJobDocument = gql`
  query getTenantOffboardingJob($tenantId: String!) {
    tenantOffboardingJob(tenantId: $tenantId) {
      ...tenantOffboardingJobFields
    }
  }
  ${TenantOffboardingJobFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetTenantOffboardingJobGQL extends Apollo.Query<
  GetTenantOffboardingJobQuery,
  GetTenantOffboardingJobQueryVariables
> {
  document = GetTenantOffboardingJobDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetTenantOffboardingJobByIdDocument = gql`
  query getTenantOffboardingJobById($id: String!) {
    tenantOffboardingJobById(id: $id) {
      ...tenantOffboardingJobFields
    }
  }
  ${TenantOffboardingJobFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetTenantOffboardingJobByIdGQL extends Apollo.Query<
  GetTenantOffboardingJobByIdQuery,
  GetTenantOffboardingJobByIdQueryVariables
> {
  document = GetTenantOffboardingJobByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const GetTenantOffboardingManifestDocument = gql`
  query getTenantOffboardingManifest(
    $id: String!
    $version: Int!
    $compareTo: Int
    $discoveryId: String
  ) {
    tenantOffboardingManifest(
      id: $id
      version: $version
      compareTo: $compareTo
      discoveryId: $discoveryId
    ) {
      version
      createdAt
      comparedToVersion
      newCount
      goneCount
      entries {
        key
        treePath
        leaf
        category
        name
        datasource
        container
        target
        path
        count
        change
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetTenantOffboardingManifestGQL extends Apollo.Query<
  GetTenantOffboardingManifestQuery,
  GetTenantOffboardingManifestQueryVariables
> {
  document = GetTenantOffboardingManifestDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetTenantOffboardingVersionsDocument = gql`
  query getTenantOffboardingVersions($id: String!) {
    tenantOffboardingVersions(id: $id) {
      version
      createdAt
      entryCount
      comparedToVersion
      newCount
      goneCount
      trigger
      triggeredBy {
        id
        fullName
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetTenantOffboardingVersionsGQL extends Apollo.Query<
  GetTenantOffboardingVersionsQuery,
  GetTenantOffboardingVersionsQueryVariables
> {
  document = GetTenantOffboardingVersionsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetTenantOffboardingDiscoveryDocument = gql`
  query getTenantOffboardingDiscovery($id: String!) {
    tenantOffboardingDiscovery(id: $id) {
      ...tenantOffboardingDiscoveryFields
    }
  }
  ${TenantOffboardingDiscoveryFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetTenantOffboardingDiscoveryGQL extends Apollo.Query<
  GetTenantOffboardingDiscoveryQuery,
  GetTenantOffboardingDiscoveryQueryVariables
> {
  document = GetTenantOffboardingDiscoveryDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const StartTenantOffboardingApprovalDiscoveryDocument = gql`
  mutation startTenantOffboardingApprovalDiscovery($id: String!) {
    startTenantOffboardingApprovalDiscovery(id: $id) {
      ...tenantOffboardingDiscoveryFields
    }
  }
  ${TenantOffboardingDiscoveryFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class StartTenantOffboardingApprovalDiscoveryGQL extends Apollo.Mutation<
  StartTenantOffboardingApprovalDiscoveryMutation,
  StartTenantOffboardingApprovalDiscoveryMutationVariables
> {
  document = StartTenantOffboardingApprovalDiscoveryDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RediscoverTenantOffboardingDocument = gql`
  mutation rediscoverTenantOffboarding($id: String!) {
    rediscoverTenantOffboarding(id: $id) {
      ...tenantOffboardingJobFields
    }
  }
  ${TenantOffboardingJobFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class RediscoverTenantOffboardingGQL extends Apollo.Mutation<
  RediscoverTenantOffboardingMutation,
  RediscoverTenantOffboardingMutationVariables
> {
  document = RediscoverTenantOffboardingDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetTenantOffboardingEligibleApproversDocument = gql`
  query getTenantOffboardingEligibleApprovers($tenantId: String!) {
    tenantOffboardingEligibleApprovers(tenantId: $tenantId) {
      id
      fullName
      email
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetTenantOffboardingEligibleApproversGQL extends Apollo.Query<
  GetTenantOffboardingEligibleApproversQuery,
  GetTenantOffboardingEligibleApproversQueryVariables
> {
  document = GetTenantOffboardingEligibleApproversDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RequestTenantOffboardingDocument = gql`
  mutation requestTenantOffboarding($input: RequestTenantOffboardingInput!) {
    requestTenantOffboarding(input: $input) {
      ...tenantOffboardingJobFields
    }
  }
  ${TenantOffboardingJobFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class RequestTenantOffboardingGQL extends Apollo.Mutation<
  RequestTenantOffboardingMutation,
  RequestTenantOffboardingMutationVariables
> {
  document = RequestTenantOffboardingDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ApproveTenantOffboardingDocument = gql`
  mutation approveTenantOffboarding(
    $id: String!
    $version: Int!
    $discoveryId: String!
  ) {
    approveTenantOffboarding(
      id: $id
      version: $version
      discoveryId: $discoveryId
    ) {
      ...tenantOffboardingJobFields
    }
  }
  ${TenantOffboardingJobFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class ApproveTenantOffboardingGQL extends Apollo.Mutation<
  ApproveTenantOffboardingMutation,
  ApproveTenantOffboardingMutationVariables
> {
  document = ApproveTenantOffboardingDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RejectTenantOffboardingDocument = gql`
  mutation rejectTenantOffboarding($id: String!, $reason: String!) {
    rejectTenantOffboarding(id: $id, reason: $reason) {
      ...tenantOffboardingJobFields
    }
  }
  ${TenantOffboardingJobFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class RejectTenantOffboardingGQL extends Apollo.Mutation<
  RejectTenantOffboardingMutation,
  RejectTenantOffboardingMutationVariables
> {
  document = RejectTenantOffboardingDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CancelTenantOffboardingDocument = gql`
  mutation cancelTenantOffboarding($id: String!) {
    cancelTenantOffboarding(id: $id) {
      ...tenantOffboardingJobFields
    }
  }
  ${TenantOffboardingJobFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class CancelTenantOffboardingGQL extends Apollo.Mutation<
  CancelTenantOffboardingMutation,
  CancelTenantOffboardingMutationVariables
> {
  document = CancelTenantOffboardingDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RetryTenantOffboardingDiscoveryDocument = gql`
  mutation retryTenantOffboardingDiscovery($id: String!) {
    retryTenantOffboardingDiscovery(id: $id) {
      ...tenantOffboardingJobFields
    }
  }
  ${TenantOffboardingJobFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class RetryTenantOffboardingDiscoveryGQL extends Apollo.Mutation<
  RetryTenantOffboardingDiscoveryMutation,
  RetryTenantOffboardingDiscoveryMutationVariables
> {
  document = RetryTenantOffboardingDiscoveryDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeleteTenantOffboardingDocument = gql`
  mutation deleteTenantOffboarding($input: DeleteTenantOffboardingInput!) {
    deleteTenantOffboarding(input: $input) {
      ...tenantOffboardingJobFields
    }
  }
  ${TenantOffboardingJobFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class DeleteTenantOffboardingGQL extends Apollo.Mutation<
  DeleteTenantOffboardingMutation,
  DeleteTenantOffboardingMutationVariables
> {
  document = DeleteTenantOffboardingDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
